/** Internal type. DO NOT USE DIRECTLY. */

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
import type * as Types from './schemaTypes'
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
export * from './schemaTypes'
const defaultOptions = {} as const
export type ICoreAccountRequestFieldsFragment = {
  __typename: 'AccountRequest'
  id: string
  escalatedAt: string | null
  processedAt: string | null
  reviewedAt: string | null
  rejectedAt: string | null
  failedAt: string | null
  priority: Types.OpsAccountRequestPriority
  kind: Types.OpsAccountRequestKind
  errorMessage: string | null
  notes: string | null
  status: Types.OpsAccountRequestStatus
  user: { id: string; fullName: string; email: string }
  escalatedBy: { fullName: string } | null
  processedBy: { fullName: string } | null
  reviewedBy: { fullName: string } | null
  rejectedBy: { fullName: string } | null
  payload:
    | {
        __typename: 'CancelSubscriptionResponsePayload'
        subscriptionId: string
        cancellationType: Types.AccountRequestCancelSubscriptionRequestPayloadCancellationType
        waiveEarlyCancellationFee: boolean
        waiveEarlyCancellationSurcharge: boolean
        cancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason
      }
    | {
        __typename: 'ChangeSubscriptionBillingCycleResponsePayload'
        subscriptionId: string
        billingCycleAnchor: string
      }
    | { __typename: 'CreditResponsePayload'; centsAmount: number }
    | {
        __typename: 'DeleteDuplicateAccountResponsePayload'
        duplicateUserId: string
        creditAmountInCents: number
        replaceWithDuplicateUserEmail: boolean | null
      }
    | { __typename: 'MiscRequestResponsePayload'; requestDetails: string }
    | {
        __typename: 'OneOffAddonResponsePayload'
        product: Types.BillingProduct
        paid: boolean
        discountCentsAmount: number | null
      }
    | {
        __typename: 'PauseSubscriptionResponsePayload'
        subscriptionId: string
        cycleCount: number
        reason: Types.OpsAccountRequestKindsPauseSubscriptionReason
      }
    | {
        __typename: 'RefundResponsePayload'
        chargeId: string
        amountInCents: number
        subscriptionCancellationRequired: boolean
        subscriptionCancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason | null
        refundReason: { journey: string; reasonOne: string; reasonTwo: string } | null
      }
    | { __typename: 'UncancelSubscriptionResponsePayload'; subscriptionId: string }
    | {
        __typename: 'UnpauseSubscriptionResponsePayload'
        subscriptionId: string
        resumeDate: string | null
      }
    | {
        __typename: 'UpdateSubscriptionResponsePayload'
        oldProduct: Types.BillingProduct | null
        nextProduct: Types.BillingProduct
      }
    | {
        __typename: 'UpsertLimitedSupportResponsePayload'
        limitedSupportSubscriptionId: string | null
        limitedSupportCancelAt: string
      }
    | Record<PropertyKey, never>
    | null
}

export type ICancelSubscriptionResponsePayloadFragment = {
  __typename: 'CancelSubscriptionResponsePayload'
  subscriptionId: string
  cancellationType: Types.AccountRequestCancelSubscriptionRequestPayloadCancellationType
  waiveEarlyCancellationFee: boolean
  waiveEarlyCancellationSurcharge: boolean
  cancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason
}

export type IChangeSubscriptionBillingCycleResponsePayloadFragment = {
  __typename: 'ChangeSubscriptionBillingCycleResponsePayload'
  subscriptionId: string
  billingCycleAnchor: string
}

export type ICreditResponsePayloadFragment = {
  __typename: 'CreditResponsePayload'
  centsAmount: number
}

export type IDeleteDuplicateAccountResponsePayloadFragment = {
  __typename: 'DeleteDuplicateAccountResponsePayload'
  duplicateUserId: string
  creditAmountInCents: number
  replaceWithDuplicateUserEmail: boolean | null
}

export type IMiscRequestResponsePayloadFragment = {
  __typename: 'MiscRequestResponsePayload'
  requestDetails: string
}

export type IOneOffAddonResponsePayloadFragment = {
  __typename: 'OneOffAddonResponsePayload'
  product: Types.BillingProduct
  paid: boolean
  discountCentsAmount: number | null
}

export type IPauseSubscriptionResponsePayloadFragment = {
  __typename: 'PauseSubscriptionResponsePayload'
  subscriptionId: string
  cycleCount: number
  reason: Types.OpsAccountRequestKindsPauseSubscriptionReason
}

export type IRefundResponsePayloadFragment = {
  __typename: 'RefundResponsePayload'
  chargeId: string
  amountInCents: number
  subscriptionCancellationRequired: boolean
  subscriptionCancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason | null
  refundReason: { journey: string; reasonOne: string; reasonTwo: string } | null
}

export type IUncancelSubscriptionResponsePayloadFragment = {
  __typename: 'UncancelSubscriptionResponsePayload'
  subscriptionId: string
}

export type IUnpauseSubscriptionResponsePayloadFragment = {
  __typename: 'UnpauseSubscriptionResponsePayload'
  subscriptionId: string
  resumeDate: string | null
}

export type IUpdateSubscriptionResponsePayloadFragment = {
  __typename: 'UpdateSubscriptionResponsePayload'
  oldProduct: Types.BillingProduct | null
  nextProduct: Types.BillingProduct
}

export type IUpsertLimitedSupportResponsePayloadFragment = {
  __typename: 'UpsertLimitedSupportResponsePayload'
  limitedSupportSubscriptionId: string | null
  limitedSupportCancelAt: string
}

export type ICoreAddressFieldsFragment = {
  __typename: 'Address'
  id: string
  name: string
  street: string
  street2: string
  city: string
  state: Types.AddressState | null
  zipCode: string
  country: string | null
}

export type IAllEventsActivityFragment = {
  __typename: 'Activity'
  createdAt: string
  description: string
  endedAt: string
  externalSource: string | null
  favorite: boolean
  id: string
  length: number
  occurredAt: string
  startedAt: string
  status: string | null
  title: string
  type: string
  statistics: {
    aucScore: number | null
    glucose2hrDelta: number | null
    glucoseDelta: number | null
    glucoseMax: string | null
    glucoseMin: string | null
    glucoseScore: number | null
    glucoseScore2hrDelta: number | null
    glucoseScoreAuc: number | null
    glucoseScoreDelta: number | null
    glucoseScorePeak: number | null
  }
}

export type IAllEventsJournalEntryFragment = {
  __typename: 'JournalEntry'
  id: string
  title: string
  body: string
  occurredAt: string
  createdAt: string
  creatorId: string
  score: number | null
  measurements: Array<{
    __typename: 'Measurement'
    createdAt: string
    cumulative: boolean
    description: string
    externalSource: string | null
    id: string
    occurredAt: string
    timestamp: string
    title: string
    type: string
    units: string
    value: number | null
    values: { diastolic: number; systolic: number } | { value: number } | null
    scan: { createdAt: string; id: string } | null
  }> | null
}

export type IAllEventsMealFragment = {
  __typename: 'Meal'
  avatar: string | null
  occurredAt: string
  source: Types.MealSource
  id: string
  readOnly: boolean
  title: string
  kind: Types.MealKind
  updatedAt: string | null
  mealCreatedAt: string | null
  mealDescription: string | null
  mealFavorite: boolean | null
  mealCreatedBy: { id: string } | null
  mealStatistics: {
    aucScore: number | null
    glucose2hrDelta: number | null
    glucoseDelta: number | null
    glucoseMax: string | null
    glucoseMin: string | null
    glucoseScore: number | null
    glucoseScore2hrDelta: number | null
    glucoseScoreAuc: number | null
    glucoseScoreDelta: number | null
    glucoseScorePeak: number | null
  } | null
  ingredients: Array<{
    calories: number
    createdAt: string
    description: string
    id: string
    servingAmount: number
    servingUnits: string
  }> | null
  glucose: {
    range: Array<number>
    healthyRange: Array<number>
    values: Array<{ timestamp: string; value: number | null; displayValue: string | null }>
  } | null
  nutrition: Array<{ key: string; value: number }> | null
}

export type IAllEventsMeasurementFragment = {
  __typename: 'Measurement'
  createdAt: string
  cumulative: boolean
  description: string
  externalSource: string | null
  id: string
  occurredAt: string
  timestamp: string
  title: string
  type: string
  units: string
  value: number | null
  scan: { createdAt: string; id: string } | null
  values: { diastolic: number; systolic: number } | { value: number } | null
}

export type IAllEventsNoteFragment = {
  __typename: 'Note'
  body: string
  createdAt: string
  creatorId: string
  id: string
  occurredAt: string
  title: string
  createdBy: string
}

export type IAppointmentFieldsFragment = {
  __typename: 'HealthPortalEhrAppointment'
  id: string
  getHealthieId: string | null
  category: Types.EhrAppointmentCategory
  kind: Types.EhrAppointmentKind
  meetingAt: string | null
  title: string | null
  getHealthieInstanceKind: Types.EhrGetHealthieInstanceKind
  startUrl: string | null
  joinUrl: string | null
  actualDuration: number | null
  addToGcalLink: string | null
  unauthenticatedIcsLink: string | null
  lastState: {
    id: string
    reason: Types.EhrAppointmentReason
    kind: Types.EhrAppointmentStateKind
    createdAt: string
  }
}

export type IAppointmentAttendanceFieldsFragment = {
  __typename: 'HealthPortalEhrAppointmentAttendance'
  id: string
  createdAt: string
  chargeKind: Types.EhrAppointmentAttendanceChargeKind
  state: Types.EhrAppointmentAttendanceState
  agenda: string | null
  user: { id: string; fullName: string; timeZone: string }
  insurancePolicy: {
    lastState: { id: string; kind: Types.UserInsurancePolicyStateKind } | null
  } | null
}

export type ICoreAuthorizationPolicyFieldsFragment = {
  __typename: 'AuthorizationPolicy'
  name: string
  grants: Array<{ permission: string; resource: string; scope: string | null }>
}

export type ICoreChatConversationFieldsFragment = {
  __typename: 'ChatConversation'
  id: string
  kind: Types.ChatConversationKind
  state: Types.ChatConversationState
  read: boolean
  candidateRead: boolean
  intercomCreatedAt: string
  intercomBackfillState: Types.ChatConversationIntercomBackfillState | null
  lastMessage: { id: string; value: string; sender: { id: string; fullName: string } | null } | null
  user: { id: string; fullName: string }
}

export type ICoreChatbotMessageReportFieldsFragment = {
  __typename: 'ChatbotMessageReport'
  id: string
  reason: Types.ChatbotMessageReportReason
  status: Types.ChatbotMessageReportStatus
  note: string | null
  resolutionNote: string | null
  resolutionRef: string | null
  resolvedAt: string | null
  createdAt: string
  chatbotMessageId: string
  userId: string
  resolvedById: string | null
  botMessageContent: string | null
}

export type ICoreCoachAssignmentFieldsFragment = {
  __typename: 'CoachAssignment'
  id: string
  state: Types.CoachAssignmentState
  last: boolean
  createdAt: string
  assignedAt: string | null
  deactivatedAt: string | null
  kind: Types.CoachAssignmentKind | null
  supportType: Types.CoachAssignmentSupportType
  coach: { id: string; fullName: string } | null
  ehrAppointment: { meetingAt: string | null } | null
  coachingKind: {
    __typename: 'CoachesCoachingKindDef'
    key: Types.CoachesCoachingKind
    coachTitle: string
    shortCoachTitle: string
    hubTitle: string
    shortHubTitle: string
    serviceTitle: string
    clinical: boolean
    insuranceReimbursable: boolean
    primary: boolean
  }
}

export type ICoreCoachBillingInvoiceFieldsFragment = {
  __typename: 'CoachBillingInvoice'
  id: string
  periodStart: string
  periodEnd: string
  number: string
  total: number
  adminTotal: number
  billableTotal: number
  submittedAt: string
  sentAt: string | null
}

export type ICoreCoachBillingInvoiceItemFieldsFragment = {
  __typename: 'CoachBillingInvoiceItem'
  itemKey: string
  kind: Types.CoachesBillingInvoiceItemKind
  date: string
  description: string
  quantity: number
  rate: number
  total: number
  createdAt: string
  billableItem: { stateSnapshotUserId: string } | null
}

export type ICoreCoachBillingInvoiceReviewFieldsFragment = {
  __typename: 'CoachBillingInvoiceReview'
  id: string
  periodStart: string
  periodEnd: string
  kind: Types.CoachesBillingInvoiceReviewKind
  reviewedAt: string | null
  reviewedBy: { id: string; email: string; fullName: string }
}

export type ICoreCoachBillingInvoiceUserFieldsFragment = {
  __typename: 'CoachBillingInvoiceUser'
  id: string
  total: number
  periodStart: string
  periodEnd: string
  billingPeriodState: Types.CoachBillingInvoiceUserBillingPeriodStates
  user: { id: string; fullName: string; email: string }
  lastInvoice: {
    __typename: 'CoachBillingInvoice'
    id: string
    periodStart: string
    periodEnd: string
    number: string
    total: number
    adminTotal: number
    billableTotal: number
    submittedAt: string
    sentAt: string | null
  } | null
  lastCoachReview: {
    __typename: 'CoachBillingInvoiceReview'
    id: string
    periodStart: string
    periodEnd: string
    kind: Types.CoachesBillingInvoiceReviewKind
    reviewedAt: string | null
    reviewedBy: { id: string; email: string; fullName: string }
  } | null
}

export type ICoachBillingRatesFieldsFragment = {
  __typename: 'CoachBillingRates'
  coachId: string
  completedCallRate: number
  incompleteCallRate: number
  asyncSupportRate: number
  mealPlanRate: number
  supplementReviewRate: number
  memberReferralBonusRate: number
  adminTimeRate: number
}

export type ICoreCoachSharedAssetFieldsFragment = {
  __typename: 'CoachSharedAsset'
  id: string
  title: string
  description: string | null
  tags: Array<string>
  category: Types.CoachesSharedAssetCategory
  visibility: Types.CoachesSharedAssetVisibility
  permanentUrl: string
  fileName: string
  fileType: string
  createdAt: string
  createdBy: { id: string }
}

export type ICoachUserFragment = {
  __typename: 'User'
  id: string
  fullName: string
  role: Types.UserRole
  email: string
  coachProfile: {
    bio: string | null
    stressBio: string | null
    getHealthieId: string | null
    startDate: string | null
    endDate: string | null
    schedulingPriority: number | null
    stateLicences: Array<string>
    active: boolean
    outOfOffice: boolean
    premium: boolean
    updatedAt: string
    priorityChangedAt: string | null
    credentials: string | null
    cdrCnsNumber: string | null
    cdrCnsExpirationDate: string | null
    gender: Types.EhrCoachGender | null
    stateOfResidence: string | null
    ethnicity: string | null
    additionalLanguages: string | null
    licenceMode: Types.EhrCoachLicenceMode | null
    stressLicenceMode: Types.EhrCoachLicenceMode | null
    unlimitedChatSupport: boolean
    registrationStatus: Types.EhrCoachRegistrationStatus
    manager: { id: string; fullName: string } | null
    specialties: Array<{ name: string }>
  } | null
  activeCoachingKinds: Array<{ key: Types.CoachesCoachingKind; coachTitle: string }>
}

export type ICoreCoachingKindFieldsFragment = {
  __typename: 'CoachesCoachingKindDef'
  key: Types.CoachesCoachingKind
  coachTitle: string
  shortCoachTitle: string
  hubTitle: string
  shortHubTitle: string
  serviceTitle: string
  clinical: boolean
  insuranceReimbursable: boolean
  primary: boolean
}

export type IUserFragment = {
  __typename: 'User'
  createdAt: string
  email: string
  timeZone: string
  avatar: string | null
  firstName: string
  fullName: string
  id: string
  lastName: string
  role: Types.UserRole
  sex: string | null
  dateOfBirth: string | null
  phoneNumber: string | null
  lastAppVersion: string | null
  lastAppPlatform: string | null
  stripeId: string | null
  berryStreetGetHealthieId: number | null
  kustomerId: string | null
  klaviyoId: string | null
  stripeCreditBalance: number
  kind: Types.UserKind
  age: string | null
  canViewGlucoseGraph: boolean
  isSteloProvisionedUser: boolean
  address: {
    __typename: 'Address'
    id: string
    name: string
    street: string
    street2: string
    city: string
    state: Types.AddressState | null
    zipCode: string
    country: string | null
  } | null
  sensorInfo: { totalCount: number; replacementRequestsCount: number } | null
  settings: {
    id: string
    appVersionReminder: boolean
    dashboardGraph: string
    dexcomSync: boolean
    displayActivityScore: boolean
    displayDailyScore: boolean
    displayMealScore: boolean
    fastingEnd: number
    fastingStart: number
    glucoseHighThreshold: number
    glucoseLowThreshold: number
    googleFitSync: boolean
    healthKitSync: boolean
    ketoMojoSync: boolean
    ketoneHighThreshold: number
    ketoneLowThreshold: number
    reminders: boolean
    showNetCarbs: boolean
    unitSystem: string
    integrationsSyncSettings: {
      lastSyncedHealth: string | null
      lastSyncedDexcom: string | null
      lastSyncedKetoMojo: string | null
    }
    macroGoalsDaily: {
      calories: number
      carbs: number
      fat: number
      netCarbs: number | null
      protein: number
    }
  }
  sensor: {
    activationDate: string
    baselineAdjustment: number
    daysRemaining: number
    expirationDate: string
    expirationTime: string
    expired: boolean
    model: string
    serialNumber: string
    status: string | null
  } | null
  organization: { id: number; name: string }
  ongoingDietitianSubscription: {
    id: string
    dietitianAddOn: boolean
    stripeStatus: string
    status: Types.SubscriptionStatus
    paidMonthsCount: number
    cancelAt: string | null
    startAt: string
    paused: boolean
    resumesAt: string | null
    commitmentEndAt: string | null
    primaryProduct: { key: string; title: string }
  } | null
  ongoingCoreSubscription: {
    id: string
    paidMonthsCount: number
    paused: boolean
    cancelAt: string | null
    commitmentEndAt: string | null
    plans: Array<{ id: string; nickname: string }>
    primaryProduct: { key: string; title: string }
  } | null
  lastDietitianSubscription: {
    stripeStatus: string
    status: Types.SubscriptionStatus
    paused: boolean
    resumesAt: string | null
  } | null
  lastCoreSubscription: {
    id: string
    stripeStatus: string
    status: Types.SubscriptionStatus
    latestInvoice: { latestCharge: { status: string; created: string } | null } | null
  } | null
  lastAsyncChatAssignment: {
    __typename: 'CoachAssignment'
    id: string
    state: Types.CoachAssignmentState
    last: boolean
    createdAt: string
    assignedAt: string | null
    deactivatedAt: string | null
    kind: Types.CoachAssignmentKind | null
    supportType: Types.CoachAssignmentSupportType
    coach: { id: string; fullName: string } | null
    ehrAppointment: { meetingAt: string | null } | null
    coachingKind: {
      __typename: 'CoachesCoachingKindDef'
      key: Types.CoachesCoachingKind
      coachTitle: string
      shortCoachTitle: string
      hubTitle: string
      shortHubTitle: string
      serviceTitle: string
      clinical: boolean
      insuranceReimbursable: boolean
      primary: boolean
    }
  } | null
  lastVideoChatAssignment: {
    __typename: 'CoachAssignment'
    id: string
    state: Types.CoachAssignmentState
    last: boolean
    createdAt: string
    assignedAt: string | null
    deactivatedAt: string | null
    kind: Types.CoachAssignmentKind | null
    supportType: Types.CoachAssignmentSupportType
    coach: { id: string; fullName: string } | null
    ehrAppointment: { meetingAt: string | null } | null
    coachingKind: {
      __typename: 'CoachesCoachingKindDef'
      key: Types.CoachesCoachingKind
      coachTitle: string
      shortCoachTitle: string
      hubTitle: string
      shortHubTitle: string
      serviceTitle: string
      clinical: boolean
      insuranceReimbursable: boolean
      primary: boolean
    }
  } | null
  coachAssignments: Array<{
    id: string
    last: boolean
    supportType: Types.CoachAssignmentSupportType
    coach: { id: string } | null
    coachingKind: { key: Types.CoachesCoachingKind }
  }> | null
  fulfillmentConfiguration: { sensorKind: Types.UserSensorKind }
  uxSensorMode: { syncDescription: string }
  dexcomConnection: {
    status: Types.DexcomConnectionStatus
    accessToken: string
    dexcomUserId: string | null
    createdAt: string
    lastSyncedAt: string | null
  } | null
  dexcomSteloConnection: {
    status: Types.DexcomConnectionStatus
    accessToken: string
    dexcomUserId: string | null
    createdAt: string
    lastSyncedAt: string | null
  } | null
  mntChatConversation: { id: string } | null
  stressChatConversation: { id: string } | null
  primaryGoal: { title: string; kind: Types.UserGoalKind; description: string | null } | null
  goalMetrics: Array<{
    primary: boolean
    kind: Types.UserGoalMetricKind
    lowThresholdValue: number | null
    highThresholdValue: number | null
    section: string
    statKey: string
  }>
  coachProfile: {
    stateLicences: Array<string>
    premium: boolean
    outOfOffice: boolean
    registrationStatus: Types.EhrCoachRegistrationStatus
    pendingRegisterNote: string | null
    credentials: string | null
    bio: string | null
    stressBio: string | null
    gender: Types.EhrCoachGender | null
    stateOfResidence: string | null
    ethnicity: string | null
    additionalLanguages: string | null
    cdrCnsNumber: string | null
    cdrCnsExpirationDate: string | null
    cdrCnsCard: string | null
    photo: string | null
    stateLicenceDetails: Array<{
      state: Types.AddressState
      expirationDate: string
      expirationReminderEnabled: boolean
      document: string | null
    }>
    specialties: Array<{ key: Types.EhrCoachSpecialty; name: string }>
  } | null
  referralPartner: {
    key: Types.UserReferralPartner
    logoUrl: string | null
    requiresProtocol: boolean
    name: string
  }
  ongoingSubscriptions: Array<{ primaryProduct: { key: string; title: string } }>
  paymentMethod: { stripeId: string } | null
  uhcMember: { id: string; uhcId: string } | null
  primaryCoachingKind: {
    __typename: 'CoachesCoachingKindDef'
    key: Types.CoachesCoachingKind
    coachTitle: string
    shortCoachTitle: string
    hubTitle: string
    shortHubTitle: string
    serviceTitle: string
    clinical: boolean
    insuranceReimbursable: boolean
    primary: boolean
  }
  onboardingExperience: {
    kind: Types.UserPropertyOnboardingExperienceKind
    participating: boolean
    baselineWeight: number | null
    desiredWeight: number | null
    fourWeekWeight: number | null
    dateToReachDesiredWeight: string | null
    realisticWeightLoss: boolean | null
    desiredWeightLossAmount: number | null
    weightLossPace: number | null
  } | null
}

export type ICoreDirectUploadFieldsFragment = {
  __typename: 'DirectUpload'
  url: string
  signedId: string
  headers: Array<{ key: string; value: string }>
}

export type ICoreFileFieldsFragment = {
  __typename: 'File'
  id: string
  downloadFileUrl: string
  permanentUrl: string
  fileUrl: string
  fileName: string
  fileType: string
  createdAt: string
}

export type ICoreHealthPortalNotificationFieldsFragment = {
  __typename: 'HealthPortalNotification'
  id: string
  completedAt: string | null
  createdAt: string
  kind: Types.HealthPortalNotificationKind
  requiresAction: boolean
  details: string | null
  actionDetails: string | null
  actionTitle: string | null
  coachAssignment: {
    kind: Types.CoachAssignmentKind | null
    supportType: Types.CoachAssignmentSupportType
    user: {
      id: string
      fullName: string
      ongoingDietitianSubscription: { cancelAt: string | null; resumesAt: string | null } | null
      coachAssignments: Array<{ id: string; kind: Types.CoachAssignmentKind | null }> | null
    }
    ehrAppointment: { meetingAt: string | null } | null
  } | null
  chatConversation: { id: string } | null
  supportTicket: {
    __typename: 'Ticket'
    id: string
    description: string
    externalLink: string | null
    kind: Types.TicketKind
    reason: Types.TicketReason | null
    status: Types.TicketStatus
    priority: Types.TicketPriority
    createdAt: string
    createdBy: { id: string; email: string; fullName: string }
    user: { id: string; email: string; fullName: string }
    assignedTo: { id: string; email: string; fullName: string } | null
  } | null
}

export type ICoreInvoiceOrderFieldsFragment = {
  __typename: 'InvoiceOrder'
  id: string
  quantity: number
  product: string
  productType: string
  processedAt: string | null
  orderId: number | null
  lastProcessingAttemptAt: string | null
  createdAt: string
  updatedAt: string
  state: Types.InvoiceOrderState
  stateReason: string | null
  invoice: { stripeId: string; paidAt: string | null }
  user: {
    id: string
    email: string
    firstName: string
    lastName: string
    fulfillmentConfiguration: { sensorKind: Types.UserSensorKind }
    address: {
      __typename: 'Address'
      id: string
      name: string
      street: string
      street2: string
      city: string
      state: Types.AddressState | null
      zipCode: string
      country: string | null
    } | null
  }
}

export type ICoreKnowledgeAnswerFieldsFragment = {
  __typename: 'KnowledgeAnswer'
  id: string
  title: string
  value: string
  knowledgeQuestions: Array<{ id: string; value: string }>
  knowledgeSources: Array<{ id: string; title: string; url: string }>
}

export type ICoreKnowledgeQuestionFieldsFragment = {
  __typename: 'KnowledgeQuestion'
  id: string
  value: string
  knowledgeAnswers: Array<{
    id: string
    title: string
    value: string
    knowledgeSources: Array<{ id: string; title: string; url: string }>
  }>
  knowledgeTags: Array<{ id: string; value: string }>
}

export type ICoreMeasurementFieldsFragment = {
  __typename: 'Measurement'
  id: string
  type: string
  title: string
  description: string
  value: number | null
  units: string
  occurredAt: string
  createdAt: string
  externalSource: string | null
}

export type ICoreOrderFieldsFragment = {
  __typename: 'Order'
  id: number
  userId: number | null
  product: string
  productType: Types.ShippingOrderProductType
  sensorKind: Types.UserSensorKind | null
  provider: Types.ShippingOrderProvider | null
  quantity: number
  notes: string | null
  createdAt: string
  updatedAt: string
  includable: Types.ShippingOrderIncludable
  invoice: { stripeId: string } | null
  replacementRequest: { replacementReason: Types.ReplacementRequestReplacementReason } | null
}

export type ICoreProductMinFieldsFragment = {
  __typename: 'ProductMin'
  id: string
  key: string
  title: string
  uhc: boolean
  bundledPaidCalls: boolean
  recurring: boolean
  ehrSchedulingRule: {
    appointmentKind: Types.EhrAppointmentKind | null
    chargeKind: Types.EhrAppointmentAttendanceChargeKind | null
    count: number | null
    additionalPaidCallsAllowed: boolean
  }
  includedGoods: Array<{
    id: string
    key: string
    title: string
    uhc: boolean
    recurring: boolean
    ehrSchedulingRule: {
      appointmentKind: Types.EhrAppointmentKind | null
      chargeKind: Types.EhrAppointmentAttendanceChargeKind | null
      count: number | null
      additionalPaidCallsAllowed: boolean
    }
  }>
}

export type IQuestionFieldsFragment = {
  __typename: 'Question'
  key: Types.SurveysQuestionKey
  label: string | null
  note: string | null
  required: boolean
  response: {
    kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseKind
    kindMetadata: any
    answersGroups: Array<{
      answers: Array<{
        label: string
        value: string
        followup: {
          kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswerFollowupKind
          question: {
            key: Types.SurveysQuestionKey
            label: string | null
            note: string | null
            required: boolean
            response: {
              kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseKind
              kindMetadata: any
              answersGroups: Array<{ answers: Array<{ label: string; value: string }> }> | null
            }
          }
        } | null
      }>
    }> | null
  }
}

export type IQuestionItemFieldsFragment = {
  key: Types.SurveysQuestionKey
  label: string | null
  note: string | null
  required: boolean
  response: {
    kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseKind
    kindMetadata: any
    answersGroups: Array<{
      answersOrder: Types.SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswersOrder
      answers: Array<{
        label: string
        value: string
        followups: Array<{
          kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswerFollowupKind
          question: {
            key: Types.SurveysQuestionKey
            label: string | null
            note: string | null
            required: boolean
            response: {
              kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseKind
              kindMetadata: any
              answersGroups: Array<{ answers: Array<{ label: string; value: string }> }> | null
            }
          }
        }>
      }>
    }> | null
  }
}

export type ICoreReplacementRequestFieldsFragment = {
  __typename: 'ReplacementRequest'
  id: string
  userId: string
  createdById: string | null
  chargeAmount: Types.ReplacementRequestChargeAmount
  createdAt: string
  daysWorn: string | null
  dateFellOff: string | null
  dateNotified: string | null
  howItFellOff: string
  notes: string
  replacementReason: Types.ReplacementRequestReplacementReason
  rgaRequired: Types.ReplacementRequestRgaRequired | null
  wearingPatch: Types.ReplacementRequestWearingPatch
  state: Types.ReplacementRequestState
  sensorKind: Types.UserSensorKind | null
  sensor: { id: string; serialNumber: string; model: string } | null
  createdBy: { email: string } | null
  user: { email: string }
  invoice: { stripeId: string } | null
}

export type ICoreScanFieldsFragment = { __typename: 'Scan'; id: string; createdAt: string }

export type ICoreShipmentFieldsFragment = {
  __typename: 'Shipment'
  id: number
  orderId: number
  addressId: number
  status: Types.ShippingShipmentStatus | null
  trackingNumber: string | null
  trackingUrl: string | null
  createdAt: string
  updatedAt: string
  shippedAt: string | null
  deliveredAt: string | null
  canceledAt: string | null
  providerShipmentId: string | null
  providerError: string | null
  providerReceivedAt: string | null
  provider: Types.ShippingOrderProvider | null
  quantity: number
  lotNumber: string | null
}

export type ICoreTicketFieldsFragment = {
  __typename: 'Ticket'
  id: string
  description: string
  externalLink: string | null
  kind: Types.TicketKind
  reason: Types.TicketReason | null
  status: Types.TicketStatus
  priority: Types.TicketPriority
  createdAt: string
  createdBy: { id: string; email: string; fullName: string }
  user: { id: string; email: string; fullName: string }
  assignedTo: { id: string; email: string; fullName: string } | null
}

export type ICoreUserAuthorizationPolicyFieldsFragment = {
  __typename: 'UserAuthorizationPolicy'
  id: string
  kind: Types.UserAuthorizationPolicyKind
  createdAt: string
  policy: {
    __typename: 'AuthorizationPolicy'
    name: string
    grants: Array<{ permission: string; resource: string; scope: string | null }>
  }
}

export type ICreateAccountRequestMutationVariables = Exact<{
  userId?: string | number | null | undefined
  kind?: Types.OpsAccountRequestKind | null | undefined
  priority?: Types.OpsAccountRequestPriority | null | undefined
  notes?: string | null | undefined
  payload?: Types.IAccountRequestPayloadUnionSubmissionType | null | undefined
}>

export type ICreateAccountRequestMutation = {
  createAccountRequest: {
    __typename: 'AccountRequest'
    id: string
    escalatedAt: string | null
    processedAt: string | null
    reviewedAt: string | null
    rejectedAt: string | null
    failedAt: string | null
    priority: Types.OpsAccountRequestPriority
    kind: Types.OpsAccountRequestKind
    errorMessage: string | null
    notes: string | null
    status: Types.OpsAccountRequestStatus
    user: { id: string; fullName: string; email: string }
    escalatedBy: { fullName: string } | null
    processedBy: { fullName: string } | null
    reviewedBy: { fullName: string } | null
    rejectedBy: { fullName: string } | null
    payload:
      | {
          __typename: 'CancelSubscriptionResponsePayload'
          subscriptionId: string
          cancellationType: Types.AccountRequestCancelSubscriptionRequestPayloadCancellationType
          waiveEarlyCancellationFee: boolean
          waiveEarlyCancellationSurcharge: boolean
          cancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason
        }
      | {
          __typename: 'ChangeSubscriptionBillingCycleResponsePayload'
          subscriptionId: string
          billingCycleAnchor: string
        }
      | { __typename: 'CreditResponsePayload'; centsAmount: number }
      | {
          __typename: 'DeleteDuplicateAccountResponsePayload'
          duplicateUserId: string
          creditAmountInCents: number
          replaceWithDuplicateUserEmail: boolean | null
        }
      | { __typename: 'MiscRequestResponsePayload'; requestDetails: string }
      | {
          __typename: 'OneOffAddonResponsePayload'
          product: Types.BillingProduct
          paid: boolean
          discountCentsAmount: number | null
        }
      | {
          __typename: 'PauseSubscriptionResponsePayload'
          subscriptionId: string
          cycleCount: number
          reason: Types.OpsAccountRequestKindsPauseSubscriptionReason
        }
      | {
          __typename: 'RefundResponsePayload'
          chargeId: string
          amountInCents: number
          subscriptionCancellationRequired: boolean
          subscriptionCancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason | null
          refundReason: { journey: string; reasonOne: string; reasonTwo: string } | null
        }
      | { __typename: 'UncancelSubscriptionResponsePayload'; subscriptionId: string }
      | {
          __typename: 'UnpauseSubscriptionResponsePayload'
          subscriptionId: string
          resumeDate: string | null
        }
      | {
          __typename: 'UpdateSubscriptionResponsePayload'
          oldProduct: Types.BillingProduct | null
          nextProduct: Types.BillingProduct
        }
      | {
          __typename: 'UpsertLimitedSupportResponsePayload'
          limitedSupportSubscriptionId: string | null
          limitedSupportCancelAt: string
        }
      | Record<PropertyKey, never>
      | null
  }
}

export type IExportAccountRequestsDataMutationVariables = Exact<{
  status?: Types.OpsAccountRequestStatus | null | undefined
}>

export type IExportAccountRequestsDataMutation = { exportAccountRequestsData: { success: boolean } }

export type ISubmitAccountRequestMutationVariables = Exact<{
  userId?: string | number | null | undefined
  kind?: Types.OpsAccountRequestKind | null | undefined
  priority?: Types.OpsAccountRequestPriority | null | undefined
  notes?: string | null | undefined
  payload?: Types.IAccountRequestPayloadUnionSubmissionType | null | undefined
}>

export type ISubmitAccountRequestMutation = {
  submitAccountRequest: {
    __typename: 'AccountRequest'
    id: string
    escalatedAt: string | null
    processedAt: string | null
    reviewedAt: string | null
    rejectedAt: string | null
    failedAt: string | null
    priority: Types.OpsAccountRequestPriority
    kind: Types.OpsAccountRequestKind
    errorMessage: string | null
    notes: string | null
    status: Types.OpsAccountRequestStatus
    user: { id: string; fullName: string; email: string }
    escalatedBy: { fullName: string } | null
    processedBy: { fullName: string } | null
    reviewedBy: { fullName: string } | null
    rejectedBy: { fullName: string } | null
    payload:
      | {
          __typename: 'CancelSubscriptionResponsePayload'
          subscriptionId: string
          cancellationType: Types.AccountRequestCancelSubscriptionRequestPayloadCancellationType
          waiveEarlyCancellationFee: boolean
          waiveEarlyCancellationSurcharge: boolean
          cancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason
        }
      | {
          __typename: 'ChangeSubscriptionBillingCycleResponsePayload'
          subscriptionId: string
          billingCycleAnchor: string
        }
      | { __typename: 'CreditResponsePayload'; centsAmount: number }
      | {
          __typename: 'DeleteDuplicateAccountResponsePayload'
          duplicateUserId: string
          creditAmountInCents: number
          replaceWithDuplicateUserEmail: boolean | null
        }
      | { __typename: 'MiscRequestResponsePayload'; requestDetails: string }
      | {
          __typename: 'OneOffAddonResponsePayload'
          product: Types.BillingProduct
          paid: boolean
          discountCentsAmount: number | null
        }
      | {
          __typename: 'PauseSubscriptionResponsePayload'
          subscriptionId: string
          cycleCount: number
          reason: Types.OpsAccountRequestKindsPauseSubscriptionReason
        }
      | {
          __typename: 'RefundResponsePayload'
          chargeId: string
          amountInCents: number
          subscriptionCancellationRequired: boolean
          subscriptionCancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason | null
          refundReason: { journey: string; reasonOne: string; reasonTwo: string } | null
        }
      | { __typename: 'UncancelSubscriptionResponsePayload'; subscriptionId: string }
      | {
          __typename: 'UnpauseSubscriptionResponsePayload'
          subscriptionId: string
          resumeDate: string | null
        }
      | {
          __typename: 'UpdateSubscriptionResponsePayload'
          oldProduct: Types.BillingProduct | null
          nextProduct: Types.BillingProduct
        }
      | {
          __typename: 'UpsertLimitedSupportResponsePayload'
          limitedSupportSubscriptionId: string | null
          limitedSupportCancelAt: string
        }
      | Record<PropertyKey, never>
      | null
  }
}

export type IUpdateAccountRequestMutationVariables = Exact<{
  accountRequestId: string | number
  status?: Types.OpsAccountRequestStatus | null | undefined
  notes?: string | null | undefined
}>

export type IUpdateAccountRequestMutation = {
  updateAccountRequest: {
    __typename: 'AccountRequest'
    id: string
    escalatedAt: string | null
    processedAt: string | null
    reviewedAt: string | null
    rejectedAt: string | null
    failedAt: string | null
    priority: Types.OpsAccountRequestPriority
    kind: Types.OpsAccountRequestKind
    errorMessage: string | null
    notes: string | null
    status: Types.OpsAccountRequestStatus
    user: { id: string; fullName: string; email: string }
    escalatedBy: { fullName: string } | null
    processedBy: { fullName: string } | null
    reviewedBy: { fullName: string } | null
    rejectedBy: { fullName: string } | null
    payload:
      | {
          __typename: 'CancelSubscriptionResponsePayload'
          subscriptionId: string
          cancellationType: Types.AccountRequestCancelSubscriptionRequestPayloadCancellationType
          waiveEarlyCancellationFee: boolean
          waiveEarlyCancellationSurcharge: boolean
          cancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason
        }
      | {
          __typename: 'ChangeSubscriptionBillingCycleResponsePayload'
          subscriptionId: string
          billingCycleAnchor: string
        }
      | { __typename: 'CreditResponsePayload'; centsAmount: number }
      | {
          __typename: 'DeleteDuplicateAccountResponsePayload'
          duplicateUserId: string
          creditAmountInCents: number
          replaceWithDuplicateUserEmail: boolean | null
        }
      | { __typename: 'MiscRequestResponsePayload'; requestDetails: string }
      | {
          __typename: 'OneOffAddonResponsePayload'
          product: Types.BillingProduct
          paid: boolean
          discountCentsAmount: number | null
        }
      | {
          __typename: 'PauseSubscriptionResponsePayload'
          subscriptionId: string
          cycleCount: number
          reason: Types.OpsAccountRequestKindsPauseSubscriptionReason
        }
      | {
          __typename: 'RefundResponsePayload'
          chargeId: string
          amountInCents: number
          subscriptionCancellationRequired: boolean
          subscriptionCancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason | null
          refundReason: { journey: string; reasonOne: string; reasonTwo: string } | null
        }
      | { __typename: 'UncancelSubscriptionResponsePayload'; subscriptionId: string }
      | {
          __typename: 'UnpauseSubscriptionResponsePayload'
          subscriptionId: string
          resumeDate: string | null
        }
      | {
          __typename: 'UpdateSubscriptionResponsePayload'
          oldProduct: Types.BillingProduct | null
          nextProduct: Types.BillingProduct
        }
      | {
          __typename: 'UpsertLimitedSupportResponsePayload'
          limitedSupportSubscriptionId: string | null
          limitedSupportCancelAt: string
        }
      | Record<PropertyKey, never>
      | null
  }
}

export type ICreateActionGoalMutationVariables = Exact<{
  kind: Types.ActionGoalKind
  numberDays: number
  metricKind: Types.ActionGoalMetricKind
  metricValue?: number | null | undefined
}>

export type ICreateActionGoalMutation = {
  createActionGoal: {
    id: string
    kind: Types.ActionGoalKind
    numberDays: number
    cadence: Types.ActionGoalCadence
    status: Types.ActionGoalStatus
    startDate: string
    metricKind: Types.ActionGoalMetricKind
    metricValue: number | null
  }
}

export type IDeleteActionGoalMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteActionGoalMutation = {
  deleteActionGoal: { id: string; status: Types.ActionGoalStatus }
}

export type IReplaceActionGoalMutationVariables = Exact<{
  id: string | number
  actionGoal: Types.ICreateActionGoal
}>

export type IReplaceActionGoalMutation = {
  replaceActionGoal: {
    deletedActionGoal: { id: string; status: Types.ActionGoalStatus }
    newActionGoal: {
      id: string
      kind: Types.ActionGoalKind
      numberDays: number
      cadence: Types.ActionGoalCadence
      status: Types.ActionGoalStatus
      startDate: string
      metricKind: Types.ActionGoalMetricKind
      metricValue: number | null
    }
  }
}

export type IAddKnowledgeQuestionTagMutationVariables = Exact<{
  id: string | number
  knowledgeTagId: string | number
}>

export type IAddKnowledgeQuestionTagMutation = {
  addKnowledgeQuestionTag: {
    __typename: 'KnowledgeQuestion'
    id: string
    value: string
    knowledgeAnswers: Array<{
      id: string
      title: string
      value: string
      knowledgeSources: Array<{ id: string; title: string; url: string }>
    }>
    knowledgeTags: Array<{ id: string; value: string }>
  }
}

export type IDeleteEhrAppointmentRecurrenceMutationVariables = Exact<{ [key: string]: never }>

export type IDeleteEhrAppointmentRecurrenceMutation = {
  deleteEhrAppointmentRecurrence: { success: boolean }
}

export type ISendEhrAppointmentSmsReminderMutationVariables = Exact<{
  id: string | number
}>

export type ISendEhrAppointmentSmsReminderMutation = {
  sendEhrAppointmentSmsReminder: { success: boolean }
}

export type IUpdateEhrAppointmentMutationVariables = Exact<{
  id: string | number
  actualDuration?: number | null | undefined
  state?: Types.EhrAppointmentStateKind | null | undefined
}>

export type IUpdateEhrAppointmentMutation = { updateEhrAppointment: { success: boolean } }

export type IAssignAuthorizationPolicyMutationVariables = Exact<{
  userId: string | number
  kind: Types.UserAuthorizationPolicyKind
}>

export type IAssignAuthorizationPolicyMutation = {
  assignAuthorizationPolicy: {
    __typename: 'UserAuthorizationPolicy'
    id: string
    kind: Types.UserAuthorizationPolicyKind
    createdAt: string
    policy: {
      __typename: 'AuthorizationPolicy'
      name: string
      grants: Array<{ permission: string; resource: string; scope: string | null }>
    }
  }
}

export type IBackfillChatConversationMutationVariables = Exact<{
  id: string | number
}>

export type IBackfillChatConversationMutation = {
  backfillChatConversation: {
    __typename: 'ChatConversation'
    id: string
    kind: Types.ChatConversationKind
    state: Types.ChatConversationState
    read: boolean
    candidateRead: boolean
    intercomCreatedAt: string
    intercomBackfillState: Types.ChatConversationIntercomBackfillState | null
    lastMessage: {
      id: string
      value: string
      sender: { id: string; fullName: string } | null
    } | null
    user: { id: string; fullName: string }
  }
}

export type IBulkCoachAssignMutationVariables = Exact<{
  coachAssignments?: Array<Types.ICoachAssign> | Types.ICoachAssign | null | undefined
}>

export type IBulkCoachAssignMutation = {
  bulkCoachAssign: {
    coachAssignments: Array<{
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    }>
  }
}

export type IBulkCreateCoachBillingInvoicesMutationVariables = Exact<{
  coachIds: Array<string | number> | string | number
  periodStart: string
  periodEnd: string
}>

export type IBulkCreateCoachBillingInvoicesMutation = {
  bulkCreateCoachBillingInvoices: { success: boolean }
}

export type IBulkCreateFilesMutationVariables = Exact<{
  userId?: string | number | null | undefined
  urls?: Array<string> | string | null | undefined
}>

export type IBulkCreateFilesMutation = {
  bulkCreateFiles: {
    files: Array<{
      __typename: 'File'
      tag: Types.UserFileTag | null
      id: string
      downloadFileUrl: string
      permanentUrl: string
      fileUrl: string
      fileName: string
      fileType: string
      createdAt: string
    }>
  }
}

export type IBulkCreateShipmentsMutationVariables = Exact<{
  provider: Types.ShippingOrderProvider
  shipmentsAttributes?:
    | Array<Types.IBulkCreateShipment>
    | Types.IBulkCreateShipment
    | null
    | undefined
}>

export type IBulkCreateShipmentsMutation = {
  bulkCreateShipments: {
    totalRecords: number
    shipments: Array<{
      __typename: 'Shipment'
      id: number
      orderId: number
      addressId: number
      status: Types.ShippingShipmentStatus | null
      trackingNumber: string | null
      trackingUrl: string | null
      createdAt: string
      updatedAt: string
      shippedAt: string | null
      deliveredAt: string | null
      canceledAt: string | null
      providerShipmentId: string | null
      providerError: string | null
      providerReceivedAt: string | null
      provider: Types.ShippingOrderProvider | null
      quantity: number
      lotNumber: string | null
      order: {
        id: number
        createdAt: string
        product: string
        productType: Types.ShippingOrderProductType
        sensorKind: Types.UserSensorKind | null
        quantity: number
        invoice: { stripeId: string } | null
      }
      address: {
        __typename: 'Address'
        id: string
        name: string
        street: string
        street2: string
        city: string
        state: Types.AddressState | null
        zipCode: string
        country: string | null
      }
      user: {
        id: string
        email: string
        firstName: string
        lastName: string
        phoneNumber: string | null
        dateOfBirth: string | null
        sex: string | null
        truepillPatientToken: string | null
      } | null
    }>
  }
}

export type IBulkExportUsersDataMutationVariables = Exact<{
  userIds?: Array<string | number> | string | number | null | undefined
}>

export type IBulkExportUsersDataMutation = { bulkExportUsersData: { success: boolean } }

export type IBulkFollowCoachAssignmentsMutationVariables = Exact<{
  coachId: string | number
}>

export type IBulkFollowCoachAssignmentsMutation = {
  bulkFollowCoachAssignments: { success: boolean }
}

export type IBulkSendScheduledMessageMutationVariables = Exact<{
  coachAssignmentIds?: Array<string | number> | string | number | null | undefined
  kind?: Types.ChatConversationMessageTemplateKind | null | undefined
}>

export type IBulkSendScheduledMessageMutation = { bulkSendScheduledMessage: { success: boolean } }

export type IBulkShipOrdersMutationVariables = Exact<{
  ids?: Array<string | number> | string | number | null | undefined
  provider: Types.ShippingOrderProvider
}>

export type IBulkShipOrdersMutation = {
  bulkShipOrders: {
    totalRecords: number
    orders: Array<{
      __typename: 'Order'
      id: number
      userId: number | null
      product: string
      productType: Types.ShippingOrderProductType
      sensorKind: Types.UserSensorKind | null
      provider: Types.ShippingOrderProvider | null
      quantity: number
      notes: string | null
      createdAt: string
      updatedAt: string
      includable: Types.ShippingOrderIncludable
      invoice: { stripeId: string } | null
      replacementRequest: { replacementReason: Types.ReplacementRequestReplacementReason } | null
    }>
  }
}

export type IBulkUnfollowCoachAssignmentsMutationVariables = Exact<{
  coachId: string | number
}>

export type IBulkUnfollowCoachAssignmentsMutation = {
  bulkUnfollowCoachAssignments: { success: boolean }
}

export type IBulkUpdateHealthPortalNotificationsMutationVariables = Exact<{
  healthPortalNotifications?:
    | Array<Types.IUpdateHealthPortalNotification>
    | Types.IUpdateHealthPortalNotification
    | null
    | undefined
}>

export type IBulkUpdateHealthPortalNotificationsMutation = {
  bulkUpdateHealthPortalNotifications: {
    healthPortalNotifications: Array<{
      __typename: 'HealthPortalNotification'
      id: string
      completedAt: string | null
      createdAt: string
      kind: Types.HealthPortalNotificationKind
      requiresAction: boolean
      details: string | null
      actionDetails: string | null
      actionTitle: string | null
      coachAssignment: {
        kind: Types.CoachAssignmentKind | null
        supportType: Types.CoachAssignmentSupportType
        user: {
          id: string
          fullName: string
          ongoingDietitianSubscription: { cancelAt: string | null; resumesAt: string | null } | null
          coachAssignments: Array<{ id: string; kind: Types.CoachAssignmentKind | null }> | null
        }
        ehrAppointment: { meetingAt: string | null } | null
      } | null
      chatConversation: { id: string } | null
      supportTicket: {
        __typename: 'Ticket'
        id: string
        description: string
        externalLink: string | null
        kind: Types.TicketKind
        reason: Types.TicketReason | null
        status: Types.TicketStatus
        priority: Types.TicketPriority
        createdAt: string
        createdBy: { id: string; email: string; fullName: string }
        user: { id: string; email: string; fullName: string }
        assignedTo: { id: string; email: string; fullName: string } | null
      } | null
    }>
  }
}

export type IBulkUpdateCoachProfilesMutationVariables = Exact<{
  coachProfiles?: Array<Types.IUpdateCoachProfile> | Types.IUpdateCoachProfile | null | undefined
}>

export type IBulkUpdateCoachProfilesMutation = {
  bulkUpdateCoachProfiles: {
    coachProfiles: Array<{ fullName: string; startDate: string | null; endDate: string | null }>
  }
}

export type IBulkUpdateShipmentsMutationVariables = Exact<{
  shipmentsIds?: Array<string | number> | string | number | null | undefined
  lotNumber?: string | null | undefined
}>

export type IBulkUpdateShipmentsMutation = {
  bulkUpdateShipments: {
    shipments: Array<{
      __typename: 'Shipment'
      id: number
      orderId: number
      addressId: number
      status: Types.ShippingShipmentStatus | null
      trackingNumber: string | null
      trackingUrl: string | null
      createdAt: string
      updatedAt: string
      shippedAt: string | null
      deliveredAt: string | null
      canceledAt: string | null
      providerShipmentId: string | null
      providerError: string | null
      providerReceivedAt: string | null
      provider: Types.ShippingOrderProvider | null
      quantity: number
      lotNumber: string | null
    }>
  }
}

export type IBulkUpdateUserPropertiesMutationVariables = Exact<{
  userIds?: Array<string | number> | string | number | null | undefined
  kind: Types.UserPropertyKind
  value: string
}>

export type IBulkUpdateUserPropertiesMutation = {
  bulkUpdateUserProperties: {
    userProperties: Array<{
      id: number
      kind: Types.UserPropertyKind
      value: string
      userId: string
    }>
  }
}

export type IChangeUserEmailMutationVariables = Exact<{
  userId: string | number
  email: string
}>

export type IChangeUserEmailMutation = {
  changeUserEmail: {
    __typename: 'User'
    createdAt: string
    email: string
    timeZone: string
    avatar: string | null
    firstName: string
    fullName: string
    id: string
    lastName: string
    role: Types.UserRole
    sex: string | null
    dateOfBirth: string | null
    phoneNumber: string | null
    lastAppVersion: string | null
    lastAppPlatform: string | null
    stripeId: string | null
    berryStreetGetHealthieId: number | null
    kustomerId: string | null
    klaviyoId: string | null
    stripeCreditBalance: number
    kind: Types.UserKind
    age: string | null
    canViewGlucoseGraph: boolean
    isSteloProvisionedUser: boolean
    address: {
      __typename: 'Address'
      id: string
      name: string
      street: string
      street2: string
      city: string
      state: Types.AddressState | null
      zipCode: string
      country: string | null
    } | null
    sensorInfo: { totalCount: number; replacementRequestsCount: number } | null
    settings: {
      id: string
      appVersionReminder: boolean
      dashboardGraph: string
      dexcomSync: boolean
      displayActivityScore: boolean
      displayDailyScore: boolean
      displayMealScore: boolean
      fastingEnd: number
      fastingStart: number
      glucoseHighThreshold: number
      glucoseLowThreshold: number
      googleFitSync: boolean
      healthKitSync: boolean
      ketoMojoSync: boolean
      ketoneHighThreshold: number
      ketoneLowThreshold: number
      reminders: boolean
      showNetCarbs: boolean
      unitSystem: string
      integrationsSyncSettings: {
        lastSyncedHealth: string | null
        lastSyncedDexcom: string | null
        lastSyncedKetoMojo: string | null
      }
      macroGoalsDaily: {
        calories: number
        carbs: number
        fat: number
        netCarbs: number | null
        protein: number
      }
    }
    sensor: {
      activationDate: string
      baselineAdjustment: number
      daysRemaining: number
      expirationDate: string
      expirationTime: string
      expired: boolean
      model: string
      serialNumber: string
      status: string | null
    } | null
    organization: { id: number; name: string }
    ongoingDietitianSubscription: {
      id: string
      dietitianAddOn: boolean
      stripeStatus: string
      status: Types.SubscriptionStatus
      paidMonthsCount: number
      cancelAt: string | null
      startAt: string
      paused: boolean
      resumesAt: string | null
      commitmentEndAt: string | null
      primaryProduct: { key: string; title: string }
    } | null
    ongoingCoreSubscription: {
      id: string
      paidMonthsCount: number
      paused: boolean
      cancelAt: string | null
      commitmentEndAt: string | null
      plans: Array<{ id: string; nickname: string }>
      primaryProduct: { key: string; title: string }
    } | null
    lastDietitianSubscription: {
      stripeStatus: string
      status: Types.SubscriptionStatus
      paused: boolean
      resumesAt: string | null
    } | null
    lastCoreSubscription: {
      id: string
      stripeStatus: string
      status: Types.SubscriptionStatus
      latestInvoice: { latestCharge: { status: string; created: string } | null } | null
    } | null
    lastAsyncChatAssignment: {
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    } | null
    lastVideoChatAssignment: {
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    } | null
    coachAssignments: Array<{
      id: string
      last: boolean
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string } | null
      coachingKind: { key: Types.CoachesCoachingKind }
    }> | null
    fulfillmentConfiguration: { sensorKind: Types.UserSensorKind }
    uxSensorMode: { syncDescription: string }
    dexcomConnection: {
      status: Types.DexcomConnectionStatus
      accessToken: string
      dexcomUserId: string | null
      createdAt: string
      lastSyncedAt: string | null
    } | null
    dexcomSteloConnection: {
      status: Types.DexcomConnectionStatus
      accessToken: string
      dexcomUserId: string | null
      createdAt: string
      lastSyncedAt: string | null
    } | null
    mntChatConversation: { id: string } | null
    stressChatConversation: { id: string } | null
    primaryGoal: { title: string; kind: Types.UserGoalKind; description: string | null } | null
    goalMetrics: Array<{
      primary: boolean
      kind: Types.UserGoalMetricKind
      lowThresholdValue: number | null
      highThresholdValue: number | null
      section: string
      statKey: string
    }>
    coachProfile: {
      stateLicences: Array<string>
      premium: boolean
      outOfOffice: boolean
      registrationStatus: Types.EhrCoachRegistrationStatus
      pendingRegisterNote: string | null
      credentials: string | null
      bio: string | null
      stressBio: string | null
      gender: Types.EhrCoachGender | null
      stateOfResidence: string | null
      ethnicity: string | null
      additionalLanguages: string | null
      cdrCnsNumber: string | null
      cdrCnsExpirationDate: string | null
      cdrCnsCard: string | null
      photo: string | null
      stateLicenceDetails: Array<{
        state: Types.AddressState
        expirationDate: string
        expirationReminderEnabled: boolean
        document: string | null
      }>
      specialties: Array<{ key: Types.EhrCoachSpecialty; name: string }>
    } | null
    referralPartner: {
      key: Types.UserReferralPartner
      logoUrl: string | null
      requiresProtocol: boolean
      name: string
    }
    ongoingSubscriptions: Array<{ primaryProduct: { key: string; title: string } }>
    paymentMethod: { stripeId: string } | null
    uhcMember: { id: string; uhcId: string } | null
    primaryCoachingKind: {
      __typename: 'CoachesCoachingKindDef'
      key: Types.CoachesCoachingKind
      coachTitle: string
      shortCoachTitle: string
      hubTitle: string
      shortHubTitle: string
      serviceTitle: string
      clinical: boolean
      insuranceReimbursable: boolean
      primary: boolean
    }
    onboardingExperience: {
      kind: Types.UserPropertyOnboardingExperienceKind
      participating: boolean
      baselineWeight: number | null
      desiredWeight: number | null
      fourWeekWeight: number | null
      dateToReachDesiredWeight: string | null
      realisticWeightLoss: boolean | null
      desiredWeightLossAmount: number | null
      weightLossPace: number | null
    } | null
  }
}

export type ICreateChatConversationNoteMutationVariables = Exact<{
  conversationId: string | number
  body: string
}>

export type ICreateChatConversationNoteMutation = {
  createChatConversationNote: {
    id: string
    value: string
    createdAt: string
    createdBy: { id: string; fullName: string }
  }
}

export type IUpdateChatConversationNoteMutationVariables = Exact<{
  id: string | number
  body: string
}>

export type IUpdateChatConversationNoteMutation = {
  updateChatConversationNote: {
    id: string
    value: string
    createdAt: string
    createdBy: { id: string; fullName: string }
  }
}

export type IUpdateChatConversationStateMutationVariables = Exact<{
  id: string | number
  state: Types.ChatConversationState
  snoozedUntil?: string | null | undefined
}>

export type IUpdateChatConversationStateMutation = {
  updateChatConversationState: {
    __typename: 'ChatConversation'
    id: string
    kind: Types.ChatConversationKind
    state: Types.ChatConversationState
    read: boolean
    candidateRead: boolean
    intercomCreatedAt: string
    intercomBackfillState: Types.ChatConversationIntercomBackfillState | null
    lastMessage: {
      id: string
      value: string
      sender: { id: string; fullName: string } | null
    } | null
    user: { id: string; fullName: string }
  }
}

export type IUpdateChatbotMessageReportMutationVariables = Exact<{
  id: string | number
  status?: Types.ChatbotMessageReportStatus | null | undefined
  resolutionNote?: string | null | undefined
  resolutionRef?: string | null | undefined
}>

export type IUpdateChatbotMessageReportMutation = {
  updateChatbotMessageReport: {
    __typename: 'ChatbotMessageReport'
    id: string
    reason: Types.ChatbotMessageReportReason
    status: Types.ChatbotMessageReportStatus
    note: string | null
    resolutionNote: string | null
    resolutionRef: string | null
    resolvedAt: string | null
    createdAt: string
    chatbotMessageId: string
    userId: string
    resolvedById: string | null
    botMessageContent: string | null
  }
}

export type IApproveCoachMutationVariables = Exact<{
  userId?: string | number | null | undefined
}>

export type IApproveCoachMutation = {
  approveCoach: { coachId: string; registrationStatus: Types.EhrCoachRegistrationStatus }
}

export type IBulkCreatePendingCoachesMutationVariables = Exact<{
  emails?: Array<string> | string | null | undefined
}>

export type IBulkCreatePendingCoachesMutation = {
  bulkCreatePendingCoaches: {
    createdUsers: Array<{ id: string; email: string }>
    summary: {
      willCreate: number
      skipExistingCoach: number
      skipMalformed: number
      skipNonNutrisenseEmail: number
      errorExistingNonCoachUser: number
    }
  }
}

export type ISendCoachBackToPendingRegisterMutationVariables = Exact<{
  userId?: string | number | null | undefined
  note?: string | null | undefined
}>

export type ISendCoachBackToPendingRegisterMutation = {
  sendCoachBackToPendingRegister: {
    coachId: string
    registrationStatus: Types.EhrCoachRegistrationStatus
    pendingRegisterNote: string | null
  }
}

export type ISubmitCoachProfileMutationVariables = Exact<{ [key: string]: never }>

export type ISubmitCoachProfileMutation = {
  submitCoachProfile: { success: boolean; missingFields: Array<string> }
}

export type IUpsertCoachProfileMutationVariables = Exact<{
  userId?: string | number | null | undefined
  firstName?: string | null | undefined
  lastName?: string | null | undefined
  stateLicences?: Array<string> | string | null | undefined
  stateLicenceDetails?:
    | Array<Types.IStateLicenceDetail>
    | Types.IStateLicenceDetail
    | null
    | undefined
  outOfOffice?: boolean | null | undefined
  premium?: boolean | null | undefined
  credentials?: string | null | undefined
  bio?: string | null | undefined
  gender?: Types.EhrCoachGender | null | undefined
  stateOfResidence?: string | null | undefined
  ethnicity?: string | null | undefined
  additionalLanguages?: string | null | undefined
  cdrCnsNumber?: string | null | undefined
  cdrCnsExpirationDate?: string | null | undefined
  specialties?: Array<Types.EhrCoachSpecialty> | Types.EhrCoachSpecialty | null | undefined
  photo?: unknown
  cdrCnsCard?: unknown
}>

export type IUpsertCoachProfileMutation = {
  upsertCoachProfile: {
    coachId: string
    stateLicences: Array<string>
    outOfOffice: boolean
    premium: boolean
    credentials: string | null
    bio: string | null
    gender: Types.EhrCoachGender | null
    stateOfResidence: string | null
    ethnicity: string | null
    additionalLanguages: string | null
    cdrCnsNumber: string | null
    cdrCnsExpirationDate: string | null
    cdrCnsCard: string | null
    photo: string | null
    registrationStatus: Types.EhrCoachRegistrationStatus
    stateLicenceDetails: Array<{
      state: Types.AddressState
      expirationDate: string
      expirationReminderEnabled: boolean
      document: string | null
    }>
    specialties: Array<{ key: Types.EhrCoachSpecialty; name: string }>
  }
}

export type IUpsertCoachingKindAssignmentMutationVariables = Exact<{
  coachId: string | number
  kind: Types.CoachesCoachingKind
  state: Types.CoachesCoachingKindAssignmentState
}>

export type IUpsertCoachingKindAssignmentMutation = {
  upsertCoachingKindAssignment: {
    id: string
    activeCoachingKinds: Array<{ key: Types.CoachesCoachingKind; coachTitle: string }>
  }
}

export type IValidateCoachInvitesMutationVariables = Exact<{
  emails?: Array<string> | string | null | undefined
}>

export type IValidateCoachInvitesMutation = {
  validateCoachInvites: {
    results: Array<{
      email: string
      classification: Types.EhrCoachesClassifyInvitesServiceClassification
    }>
    summary: {
      willCreate: number
      skipExistingCoach: number
      skipMalformed: number
      skipNonNutrisenseEmail: number
      errorExistingNonCoachUser: number
    }
  }
}

export type ICreateChatConversationMessageTemplateMutationVariables = Exact<{
  name: string
  value: string
  private: boolean
}>

export type ICreateChatConversationMessageTemplateMutation = {
  createChatConversationMessageTemplate: {
    id: string
    name: string
    value: string
    private: boolean
    kind: Types.ChatConversationMessageTemplateKind
  }
}

export type ICreateChatTokenMutationVariables = Exact<{
  userId: string | number
}>

export type ICreateChatTokenMutation = { createChatToken: { value: string } }

export type ICreateChatbotDelimiterMutationVariables = Exact<{
  providerConversationId: string | number
}>

export type ICreateChatbotDelimiterMutation = {
  createChatbotDelimiter: { id: string; createdAt: string }
}

export type ICreateCoachBillingInvoiceMutationVariables = Exact<{
  coachId: string | number
  periodStart: string
  periodEnd: string
}>

export type ICreateCoachBillingInvoiceMutation = {
  createCoachBillingInvoice: {
    id: string
    number: string
    periodStart: string
    periodEnd: string
    submittedAt: string
    createdAt: string
    billableTotal: number
    adminTotal: number
    total: number
    coach: { id: string; email: string; fullName: string }
  }
}

export type ICreateCoachBillingInvoiceItemMutationVariables = Exact<{
  coachId: string | number
  kind: Types.CoachesBillingInvoiceItemKind
  date: string
  description: string
  quantity: number
  rate: number
}>

export type ICreateCoachBillingInvoiceItemMutation = {
  createCoachBillingInvoiceItem: {
    __typename: 'CoachBillingInvoiceItem'
    itemKey: string
    kind: Types.CoachesBillingInvoiceItemKind
    date: string
    description: string
    quantity: number
    rate: number
    total: number
    createdAt: string
    billableItem: { stateSnapshotUserId: string } | null
  }
}

export type ICreateCoachBillingInvoiceReviewMutationVariables = Exact<{
  coachId: string | number
  periodStart: string
  periodEnd: string
  kind: Types.CoachesBillingInvoiceReviewKind
}>

export type ICreateCoachBillingInvoiceReviewMutation = {
  createCoachBillingInvoiceReview: {
    __typename: 'CoachBillingInvoiceReview'
    id: string
    periodStart: string
    periodEnd: string
    kind: Types.CoachesBillingInvoiceReviewKind
    reviewedAt: string | null
    reviewedBy: { id: string; email: string; fullName: string }
  }
}

export type ICreateCoachSharedAssetMutationVariables = Exact<{
  signedId: string
  title: string
  category: Types.CoachesSharedAssetCategory
  description?: string | null | undefined
  tags?: Array<string> | string | null | undefined
  visibility?: Types.CoachesSharedAssetVisibility | null | undefined
}>

export type ICreateCoachSharedAssetMutation = {
  createCoachSharedAsset: {
    __typename: 'CoachSharedAsset'
    id: string
    title: string
    description: string | null
    tags: Array<string>
    category: Types.CoachesSharedAssetCategory
    visibility: Types.CoachesSharedAssetVisibility
    permanentUrl: string
    fileName: string
    fileType: string
    createdAt: string
    createdBy: { id: string }
  }
}

export type ICreateDietitianSessionMutationVariables = Exact<{
  userId?: string | number | null | undefined
  startedAt: string
  endedAt: string
}>

export type ICreateDietitianSessionMutation = {
  createDietitianSession: {
    id: string
    dietitianId: string
    userId: string | null
    startedAt: string
    endedAt: string
    durationInSeconds: number
  }
}

export type ICreateDirectUploadsMutationVariables = Exact<{
  files?: Array<Types.IFileMetadata> | Types.IFileMetadata | null | undefined
  reason?: Types.DirectUploadReason | null | undefined
}>

export type ICreateDirectUploadsMutation = {
  createDirectUploads: {
    directUploads: Array<{
      __typename: 'DirectUpload'
      url: string
      signedId: string
      headers: Array<{ key: string; value: string }>
    }>
  }
}

export type ICreateFilesFromDirectUploadsMutationVariables = Exact<{
  userId: string | number
  signedIds?: Array<string> | string | null | undefined
}>

export type ICreateFilesFromDirectUploadsMutation = {
  createFilesFromDirectUploads: {
    files: Array<{
      __typename: 'File'
      tag: Types.UserFileTag | null
      id: string
      downloadFileUrl: string
      permanentUrl: string
      fileUrl: string
      fileName: string
      fileType: string
      createdAt: string
    }>
  }
}

export type ICreateKnowledgeAnswerMutationVariables = Exact<{
  title: string
  value: string
}>

export type ICreateKnowledgeAnswerMutation = {
  createKnowledgeAnswer: {
    __typename: 'KnowledgeAnswer'
    id: string
    title: string
    value: string
    knowledgeQuestions: Array<{ id: string; value: string }>
    knowledgeSources: Array<{ id: string; title: string; url: string }>
  }
}

export type ICreateKnowledgeQuestionMutationVariables = Exact<{
  value: string
}>

export type ICreateKnowledgeQuestionMutation = {
  createKnowledgeQuestion: { id: string; value: string }
}

export type ICreateKnowledgeSourceMutationVariables = Exact<{
  title: string
  url: string
}>

export type ICreateKnowledgeSourceMutation = {
  createKnowledgeSource: { id: string; title: string; url: string }
}

export type ICreateKnowledgeTagMutationVariables = Exact<{
  value: string
}>

export type ICreateKnowledgeTagMutation = { createKnowledgeTag: { id: string; value: string } }

export type ICreateOrderMutationVariables = Exact<{
  userId: string | number
  product: string
  productType: string
  quantity: number
  sensorKind?: Types.UserSensorKind | null | undefined
  notes?: string | null | undefined
  invoiceOrderId?: string | number | null | undefined
}>

export type ICreateOrderMutation = {
  createOrder: {
    __typename: 'Order'
    id: number
    userId: number | null
    product: string
    productType: Types.ShippingOrderProductType
    sensorKind: Types.UserSensorKind | null
    provider: Types.ShippingOrderProvider | null
    quantity: number
    notes: string | null
    createdAt: string
    updatedAt: string
    includable: Types.ShippingOrderIncludable
    invoice: { stripeId: string } | null
    replacementRequest: { replacementReason: Types.ReplacementRequestReplacementReason } | null
  }
}

export type ICreateReplacementRequestMutationVariables = Exact<{
  chargeAmount: Types.ReplacementRequestChargeAmount
  daysWorn?: number | null | undefined
  dateFellOff: string
  dateNotified: string
  howItFellOff?: string | null | undefined
  notes?: string | null | undefined
  replacementReason: Types.ReplacementRequestReplacementReason
  sensorId?: string | number | null | undefined
  rgaRequired?: Types.ReplacementRequestRgaRequired | null | undefined
  wearingPatch: Types.ReplacementRequestWearingPatch
  sensorKind?: Types.UserSensorKind | null | undefined
}>

export type ICreateReplacementRequestMutation = {
  createReplacementRequest: {
    __typename: 'ReplacementRequest'
    id: string
    userId: string
    createdById: string | null
    chargeAmount: Types.ReplacementRequestChargeAmount
    createdAt: string
    daysWorn: string | null
    dateFellOff: string | null
    dateNotified: string | null
    howItFellOff: string
    notes: string
    replacementReason: Types.ReplacementRequestReplacementReason
    rgaRequired: Types.ReplacementRequestRgaRequired | null
    wearingPatch: Types.ReplacementRequestWearingPatch
    state: Types.ReplacementRequestState
    sensorKind: Types.UserSensorKind | null
    sensor: { id: string; serialNumber: string; model: string } | null
    createdBy: { email: string } | null
    user: { email: string }
    invoice: { stripeId: string } | null
  }
}

export type ICreateReplacementRequestInvoiceMutationVariables = Exact<{
  id?: string | number | null | undefined
}>

export type ICreateReplacementRequestInvoiceMutation = {
  createReplacementRequestInvoice: {
    __typename: 'ReplacementRequest'
    id: string
    userId: string
    createdById: string | null
    chargeAmount: Types.ReplacementRequestChargeAmount
    createdAt: string
    daysWorn: string | null
    dateFellOff: string | null
    dateNotified: string | null
    howItFellOff: string
    notes: string
    replacementReason: Types.ReplacementRequestReplacementReason
    rgaRequired: Types.ReplacementRequestRgaRequired | null
    wearingPatch: Types.ReplacementRequestWearingPatch
    state: Types.ReplacementRequestState
    sensorKind: Types.UserSensorKind | null
    sensor: { id: string; serialNumber: string; model: string } | null
    createdBy: { email: string } | null
    user: { email: string }
    invoice: { stripeId: string } | null
  }
}

export type ICreateShipmentMutationVariables = Exact<{
  orderId: number
  status?: string | null | undefined
  quantity: number
  trackingNumber?: string | null | undefined
  trackingUrl?: string | null | undefined
  lotNumber?: string | null | undefined
  provider?: string | null | undefined
  providerShipmentId?: string | number | null | undefined
  providerReceivedAt?: string | null | undefined
  shippedAt?: string | null | undefined
  deliveredAt?: string | null | undefined
  firstName?: string | null | undefined
  lastName?: string | null | undefined
  street?: string | null | undefined
  street2?: string | null | undefined
  city?: string | null | undefined
  zipCode?: string | null | undefined
  state?: string | null | undefined
  country?: string | null | undefined
}>

export type ICreateShipmentMutation = {
  createShipment: {
    __typename: 'Shipment'
    id: number
    orderId: number
    addressId: number
    status: Types.ShippingShipmentStatus | null
    trackingNumber: string | null
    trackingUrl: string | null
    createdAt: string
    updatedAt: string
    shippedAt: string | null
    deliveredAt: string | null
    canceledAt: string | null
    providerShipmentId: string | null
    providerError: string | null
    providerReceivedAt: string | null
    provider: Types.ShippingOrderProvider | null
    quantity: number
    lotNumber: string | null
    order: {
      id: number
      createdAt: string
      product: string
      productType: Types.ShippingOrderProductType
      sensorKind: Types.UserSensorKind | null
      quantity: number
      invoice: { stripeId: string } | null
    }
    address: {
      __typename: 'Address'
      id: string
      name: string
      street: string
      street2: string
      city: string
      state: Types.AddressState | null
      zipCode: string
      country: string | null
    }
    user: {
      id: string
      email: string
      firstName: string
      lastName: string
      phoneNumber: string | null
      dateOfBirth: string | null
      sex: string | null
      truepillPatientToken: string | null
    } | null
  }
}

export type IDeactivateCoachProfileMutationVariables = Exact<{
  userId: string | number
}>

export type IDeactivateCoachProfileMutation = { deactivateCoachProfile: { active: boolean } }

export type IDeleteChatConversationMessageTemplateMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteChatConversationMessageTemplateMutation = {
  deleteChatConversationMessageTemplate: { success: boolean }
}

export type IDeleteCoachBillingInvoiceItemMutationVariables = Exact<{
  itemKey: string
}>

export type IDeleteCoachBillingInvoiceItemMutation = {
  deleteCoachBillingInvoiceItem: {
    __typename: 'CoachBillingInvoiceItem'
    itemKey: string
    kind: Types.CoachesBillingInvoiceItemKind
    date: string
    description: string
    quantity: number
    rate: number
    total: number
    createdAt: string
    billableItem: { stateSnapshotUserId: string } | null
  }
}

export type IDeleteCoachSharedAssetMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteCoachSharedAssetMutation = { deleteCoachSharedAsset: { id: string } }

export type IDeleteFileMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteFileMutation = {
  deleteFile: {
    __typename: 'File'
    id: string
    downloadFileUrl: string
    permanentUrl: string
    fileUrl: string
    fileName: string
    fileType: string
    createdAt: string
  }
}

export type IDeleteKnowledgeAnswerMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteKnowledgeAnswerMutation = {
  deleteKnowledgeAnswer: { id: string; title: string; value: string }
}

export type IDeleteKnowledgeQuestionMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteKnowledgeQuestionMutation = {
  deleteKnowledgeQuestion: { id: string; value: string }
}

export type IDeleteKnowledgeSourceMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteKnowledgeSourceMutation = { deleteKnowledgeSource: { id: string; url: string } }

export type IDeleteKnowledgeTagMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteKnowledgeTagMutation = { deleteKnowledgeTag: { id: string; value: string } }

export type IDeleteMealMutationVariables = Exact<{
  id?: string | number | null | undefined
}>

export type IDeleteMealMutation = { deleteMeal: { id: string } }

export type IDeleteNoteMutationVariables = Exact<{
  id?: string | number | null | undefined
}>

export type IDeleteNoteMutation = {
  deleteNote: {
    body: string
    createdAt: string
    creatorId: string
    id: string
    occurredAt: string
    title: string
  }
}

export type IDeleteOrderMutationVariables = Exact<{
  id: number
  deletionReason: string
}>

export type IDeleteOrderMutation = {
  deleteOrder: {
    __typename: 'Order'
    id: number
    userId: number | null
    product: string
    productType: Types.ShippingOrderProductType
    sensorKind: Types.UserSensorKind | null
    provider: Types.ShippingOrderProvider | null
    quantity: number
    notes: string | null
    createdAt: string
    updatedAt: string
    includable: Types.ShippingOrderIncludable
    invoice: { stripeId: string } | null
    replacementRequest: { replacementReason: Types.ReplacementRequestReplacementReason } | null
  }
}

export type IDeleteReplacementRequestMutationVariables = Exact<{
  id?: string | number | null | undefined
}>

export type IDeleteReplacementRequestMutation = {
  deleteReplacementRequest: {
    __typename: 'ReplacementRequest'
    id: string
    userId: string
    createdById: string | null
    chargeAmount: Types.ReplacementRequestChargeAmount
    createdAt: string
    daysWorn: string | null
    dateFellOff: string | null
    dateNotified: string | null
    howItFellOff: string
    notes: string
    replacementReason: Types.ReplacementRequestReplacementReason
    rgaRequired: Types.ReplacementRequestRgaRequired | null
    wearingPatch: Types.ReplacementRequestWearingPatch
    state: Types.ReplacementRequestState
    sensorKind: Types.UserSensorKind | null
    sensor: { id: string; serialNumber: string; model: string } | null
    createdBy: { email: string } | null
    user: { email: string }
    invoice: { stripeId: string } | null
  }
}

export type IDeleteShipmentMutationVariables = Exact<{
  id?: number | null | undefined
}>

export type IDeleteShipmentMutation = {
  deleteShipment: {
    __typename: 'Shipment'
    id: number
    orderId: number
    addressId: number
    status: Types.ShippingShipmentStatus | null
    trackingNumber: string | null
    trackingUrl: string | null
    createdAt: string
    updatedAt: string
    shippedAt: string | null
    deliveredAt: string | null
    canceledAt: string | null
    providerShipmentId: string | null
    providerError: string | null
    providerReceivedAt: string | null
    provider: Types.ShippingOrderProvider | null
    quantity: number
    lotNumber: string | null
  }
}

export type IDeleteUserPropertyMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteUserPropertyMutation = {
  deleteUserProperty: { __typename: 'UserProperty'; id: number }
}

export type IRunDexcomConnectionStatusCheckMutationVariables = Exact<{
  userId: string | number
}>

export type IRunDexcomConnectionStatusCheckMutation = {
  runDexcomConnectionStatusCheck: {
    latestGlucoseMeasurementAt: string | null
    connection: {
      status: Types.DexcomConnectionStatus
      kind: Types.DexcomConnectionKind
      lastSyncedAt: string | null
    } | null
  }
}

export type IGenerateHealthDataReportMutationVariables = Exact<{
  userId: string | number
  startDate: string
  endDate: string
  kind: Types.HealthDataReportKind
}>

export type IGenerateHealthDataReportMutation = { generateHealthDataReport: { success: boolean } }

export type IGrantGlucoseFeatureOverrideMutationVariables = Exact<{
  userId: string | number
}>

export type IGrantGlucoseFeatureOverrideMutation = {
  grantGlucoseFeatureOverride: { success: boolean }
}

export type ILinkKnowledgeAnswerMutationVariables = Exact<{
  id: string | number
  knowledgeSourceId: string | number
}>

export type ILinkKnowledgeAnswerMutation = {
  linkKnowledgeAnswer: {
    __typename: 'KnowledgeAnswer'
    id: string
    title: string
    value: string
    knowledgeQuestions: Array<{ id: string; value: string }>
    knowledgeSources: Array<{ id: string; title: string; url: string }>
  }
}

export type ILinkKnowledgeQuestionMutationVariables = Exact<{
  id: string | number
  knowledgeAnswerId: string | number
}>

export type ILinkKnowledgeQuestionMutation = {
  linkKnowledgeQuestion: {
    __typename: 'KnowledgeQuestion'
    id: string
    value: string
    knowledgeAnswers: Array<{
      id: string
      title: string
      value: string
      knowledgeSources: Array<{ id: string; title: string; url: string }>
    }>
    knowledgeTags: Array<{ id: string; value: string }>
  }
}

export type INotifyFeatureFeedbackMutationVariables = Exact<{
  feature: Types.HealthPortalFeature
  message: string
  userId?: string | number | null | undefined
  entityId?: string | number | null | undefined
}>

export type INotifyFeatureFeedbackMutation = { notifyFeatureFeedback: { success: boolean } }

export type IPromoteToCoachChatConversationMutationVariables = Exact<{
  id: string | number
  coachingKind?: Types.CoachesCoachingKind | null | undefined
}>

export type IPromoteToCoachChatConversationMutation = {
  promoteToCoachChatConversation: { success: boolean }
}

export type IRemoveKnowledgeQuestionTagMutationVariables = Exact<{
  id: string | number
  knowledgeTagId: string | number
}>

export type IRemoveKnowledgeQuestionTagMutation = {
  removeKnowledgeQuestionTag: {
    __typename: 'KnowledgeQuestion'
    id: string
    value: string
    knowledgeAnswers: Array<{
      id: string
      title: string
      value: string
      knowledgeSources: Array<{ id: string; title: string; url: string }>
    }>
    knowledgeTags: Array<{ id: string; value: string }>
  }
}

export type IResendMissingPrescriptionsShipmentsMutationVariables = Exact<{ [key: string]: never }>

export type IResendMissingPrescriptionsShipmentsMutation = {
  resendMissingPrescriptionsShipments: {
    totalRecords: number
    shipments: Array<{
      __typename: 'Shipment'
      id: number
      orderId: number
      addressId: number
      status: Types.ShippingShipmentStatus | null
      trackingNumber: string | null
      trackingUrl: string | null
      createdAt: string
      updatedAt: string
      shippedAt: string | null
      deliveredAt: string | null
      canceledAt: string | null
      providerShipmentId: string | null
      providerError: string | null
      providerReceivedAt: string | null
      provider: Types.ShippingOrderProvider | null
      quantity: number
      lotNumber: string | null
    }>
  }
}

export type IResendShipmentMutationVariables = Exact<{
  id?: number | null | undefined
}>

export type IResendShipmentMutation = {
  resendShipment: {
    __typename: 'Shipment'
    id: number
    orderId: number
    addressId: number
    status: Types.ShippingShipmentStatus | null
    trackingNumber: string | null
    trackingUrl: string | null
    createdAt: string
    updatedAt: string
    shippedAt: string | null
    deliveredAt: string | null
    canceledAt: string | null
    providerShipmentId: string | null
    providerError: string | null
    providerReceivedAt: string | null
    provider: Types.ShippingOrderProvider | null
    quantity: number
    lotNumber: string | null
  }
}

export type IResetVideoChatAssignmentMutationVariables = Exact<{
  userId: string | number
  coachingKind?: Types.CoachesCoachingKind | null | undefined
}>

export type IResetVideoChatAssignmentMutation = { resetVideoChatAssignment: { success: boolean } }

export type IRespondToHealthPortalNotificationMutationVariables = Exact<{
  id: string | number
  response: boolean
}>

export type IRespondToHealthPortalNotificationMutation = {
  respondToHealthPortalNotification: { success: boolean }
}

export type IRestartSurveyLinkMutationVariables = Exact<{
  id: string | number
  questionKeys?:
    | Array<Types.RestartSurveyLinkQuestionKeys>
    | Types.RestartSurveyLinkQuestionKeys
    | null
    | undefined
}>

export type IRestartSurveyLinkMutation = {
  restartSurveyLink: { id: string; state: Types.SurveysUserLinkState }
}

export type ISaveHealthDataReportMutationVariables = Exact<{
  id: string | number
  reportData: string
}>

export type ISaveHealthDataReportMutation = { saveHealthDataReport: { success: boolean } }

export type ISendChatConversationMessageMutationVariables = Exact<{
  userId: string | number
  body: string
  conversationId?: string | number | null | undefined
}>

export type ISendChatConversationMessageMutation = {
  sendChatConversationMessage: { success: boolean }
}

export type ISendMfaSmsCodeMutationVariables = Exact<{ [key: string]: never }>

export type ISendMfaSmsCodeMutation = {
  sendMfaSmsCode: { success: boolean; userEmail: string; userMaskedPhoneNumber: string | null }
}

export type IUpdateSupportedSensorMutationVariables = Exact<{
  model: Types.SensorModelsSupportedModelsKind
}>

export type IUpdateSupportedSensorMutation = { updateSupportedSensor: { success: boolean } }

export type ISetPrimaryGoalMetricsMutationVariables = Exact<{
  kinds?: Array<Types.UserGoalMetricKind> | Types.UserGoalMetricKind | null | undefined
}>

export type ISetPrimaryGoalMetricsMutation = {
  setPrimaryGoalMetrics: Array<{
    primary: boolean
    kind: Types.UserGoalMetricKind
    lowThresholdValue: number | null
    highThresholdValue: number | null
    section: string
    statKey: string
  }>
}

export type ISignInThirdPartyUserMutationVariables = Exact<{
  provider: Types.ThirdPartySignInProvider
  providerToken: string
}>

export type ISignInThirdPartyUserMutation = {
  signInThirdPartyUser: {
    role: Types.UserRole | null
    token: string | null
    user: { id: string } | null
  }
}

export type ISignInUserMutationVariables = Exact<{
  email?: string | null | undefined
  password?: string | null | undefined
}>

export type ISignInUserMutation = {
  signInUser: {
    role: Types.UserRole | null
    token: string | null
    user: { id: string; mfaEnabled: boolean } | null
  }
}

export type ISignOutUserMutationVariables = Exact<{ [key: string]: never }>

export type ISignOutUserMutation = { signOutUser: { success: boolean } }

export type ICreateTicketCommentMutationVariables = Exact<{
  ticketId: string | number
  body: string
  mentionedAdminIds?: Array<string | number> | string | number | null | undefined
}>

export type ICreateTicketCommentMutation = {
  createTicketComment: {
    body: string
    createdAt: string
    createdBy: {
      id: string
      fullName: string
      email: string
      phoneNumber: string
      timeZone: string
    }
  }
}

export type ICreateTicketMutationVariables = Exact<{
  userId: string | number
  description: string
  kind: Types.TicketKind
  reason: Types.TicketReason
  priority: Types.TicketPriority
}>

export type ICreateTicketMutation = {
  createTicket: {
    __typename: 'Ticket'
    id: string
    description: string
    externalLink: string | null
    kind: Types.TicketKind
    reason: Types.TicketReason | null
    status: Types.TicketStatus
    priority: Types.TicketPriority
    createdAt: string
    createdBy: { id: string; email: string; fullName: string }
    user: { id: string; email: string; fullName: string }
    assignedTo: { id: string; email: string; fullName: string } | null
  }
}

export type IDeleteTicketMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteTicketMutation = {
  deleteTicket: {
    __typename: 'Ticket'
    id: string
    description: string
    externalLink: string | null
    kind: Types.TicketKind
    reason: Types.TicketReason | null
    status: Types.TicketStatus
    priority: Types.TicketPriority
    createdAt: string
    createdBy: { id: string; email: string; fullName: string }
    user: { id: string; email: string; fullName: string }
    assignedTo: { id: string; email: string; fullName: string } | null
  }
}

export type IUpdateTicketMutationVariables = Exact<{
  id: string | number
  assignedToId?: string | number | null | undefined
  description?: string | null | undefined
  status?: Types.TicketStatus | null | undefined
  priority?: Types.TicketPriority | null | undefined
  externalLink?: string | null | undefined
}>

export type IUpdateTicketMutation = {
  updateTicket: {
    __typename: 'Ticket'
    id: string
    description: string
    externalLink: string | null
    kind: Types.TicketKind
    reason: Types.TicketReason | null
    status: Types.TicketStatus
    priority: Types.TicketPriority
    createdAt: string
    createdBy: { id: string; email: string; fullName: string }
    user: { id: string; email: string; fullName: string }
    assignedTo: { id: string; email: string; fullName: string } | null
  }
}

export type IUnassignAuthorizationPolicyMutationVariables = Exact<{
  id: string | number
}>

export type IUnassignAuthorizationPolicyMutation = {
  unassignAuthorizationPolicy: {
    __typename: 'UserAuthorizationPolicy'
    id: string
    kind: Types.UserAuthorizationPolicyKind
    createdAt: string
    policy: {
      __typename: 'AuthorizationPolicy'
      name: string
      grants: Array<{ permission: string; resource: string; scope: string | null }>
    }
  }
}

export type IUnlinkKnowledgeAnswerMutationVariables = Exact<{
  id: string | number
  knowledgeSourceId: string | number
}>

export type IUnlinkKnowledgeAnswerMutation = {
  unlinkKnowledgeAnswer: {
    __typename: 'KnowledgeAnswer'
    id: string
    title: string
    value: string
    knowledgeQuestions: Array<{ id: string; value: string }>
    knowledgeSources: Array<{ id: string; title: string; url: string }>
  }
}

export type IUnlinkKnowledgeQuestionMutationVariables = Exact<{
  id: string | number
  knowledgeAnswerId: string | number
}>

export type IUnlinkKnowledgeQuestionMutation = {
  unlinkKnowledgeQuestion: {
    __typename: 'KnowledgeQuestion'
    id: string
    value: string
    knowledgeAnswers: Array<{
      id: string
      title: string
      value: string
      knowledgeSources: Array<{ id: string; title: string; url: string }>
    }>
    knowledgeTags: Array<{ id: string; value: string }>
  }
}

export type IUpdateAddressMutationVariables = Exact<{
  id?: string | number | null | undefined
  street?: string | null | undefined
  street2?: string | null | undefined
  city?: string | null | undefined
  name?: string | null | undefined
  state?: Types.AddressState | null | undefined
  country?: Types.AddressCountry | null | undefined
  zipCode?: string | null | undefined
}>

export type IUpdateAddressMutation = {
  updateAddress: {
    __typename: 'Address'
    id: string
    name: string
    street: string
    street2: string
    city: string
    state: Types.AddressState | null
    zipCode: string
    country: string | null
  }
}

export type IUpdateChatConversationMutationVariables = Exact<{
  id?: string | number | null | undefined
  read?: boolean | null | undefined
}>

export type IUpdateChatConversationMutation = {
  updateChatConversation: {
    __typename: 'ChatConversation'
    id: string
    kind: Types.ChatConversationKind
    state: Types.ChatConversationState
    read: boolean
    candidateRead: boolean
    intercomCreatedAt: string
    intercomBackfillState: Types.ChatConversationIntercomBackfillState | null
    lastMessage: {
      id: string
      value: string
      sender: { id: string; fullName: string } | null
    } | null
    user: { id: string; fullName: string }
  }
}

export type IUpdateChatConversationMessageTemplateMutationVariables = Exact<{
  id?: string | number | null | undefined
  name?: string | null | undefined
  value?: string | null | undefined
  private?: boolean | null | undefined
}>

export type IUpdateChatConversationMessageTemplateMutation = {
  updateChatConversationMessageTemplate: {
    id: string
    name: string
    value: string
    private: boolean
    kind: Types.ChatConversationMessageTemplateKind
  }
}

export type IUpdateCoachBillingInvoiceItemMutationVariables = Exact<{
  itemKey: string
  kind?: Types.CoachesBillingInvoiceItemKind | null | undefined
  date?: string | null | undefined
  description?: string | null | undefined
  quantity?: number | null | undefined
  rate?: number | null | undefined
}>

export type IUpdateCoachBillingInvoiceItemMutation = {
  updateCoachBillingInvoiceItem: {
    __typename: 'CoachBillingInvoiceItem'
    itemKey: string
    kind: Types.CoachesBillingInvoiceItemKind
    date: string
    description: string
    quantity: number
    rate: number
    total: number
    createdAt: string
    billableItem: { stateSnapshotUserId: string } | null
  }
}

export type IUpdateCoachBillingRatesMutationVariables = Exact<{
  coachId: string | number
  completedCallRate?: number | null | undefined
  incompleteCallRate?: number | null | undefined
  asyncSupportRate?: number | null | undefined
  mealPlanRate?: number | null | undefined
  supplementReviewRate?: number | null | undefined
  memberReferralBonusRate?: number | null | undefined
  adminTimeRate?: number | null | undefined
}>

export type IUpdateCoachBillingRatesMutation = {
  updateCoachBillingRates: {
    __typename: 'CoachBillingRates'
    coachId: string
    completedCallRate: number
    incompleteCallRate: number
    asyncSupportRate: number
    mealPlanRate: number
    supplementReviewRate: number
    memberReferralBonusRate: number
    adminTimeRate: number
  }
}

export type IUpdateCoachConversationScheduledMessageMutationVariables = Exact<{
  scheduledMessageId: string | number
  state?: Types.CoachesConversationScheduledMessageState | null | undefined
  sendAt?: string | null | undefined
  value?: string | null | undefined
}>

export type IUpdateCoachConversationScheduledMessageMutation = {
  updateCoachConversationScheduledMessage: {
    id: string
    kind: Types.ChatConversationMessageTemplateKind
    state: Types.CoachesConversationScheduledMessageState
    sendAt: string | null
    sentAt: string | null
  }
}

export type IUpdateCoachSharedAssetMutationVariables = Exact<{
  id: string | number
  title?: string | null | undefined
  description?: string | null | undefined
  category?: Types.CoachesSharedAssetCategory | null | undefined
  tags?: Array<string> | string | null | undefined
  visibility?: Types.CoachesSharedAssetVisibility | null | undefined
}>

export type IUpdateCoachSharedAssetMutation = {
  updateCoachSharedAsset: {
    __typename: 'CoachSharedAsset'
    id: string
    title: string
    description: string | null
    tags: Array<string>
    category: Types.CoachesSharedAssetCategory
    visibility: Types.CoachesSharedAssetVisibility
    permanentUrl: string
    fileName: string
    fileType: string
    createdAt: string
    createdBy: { id: string }
  }
}

export type IUpdateGoalMetricMutationVariables = Exact<{
  kind: Types.UserGoalMetricKind
  lowThresholdValue?: number | null | undefined
  highThresholdValue?: number | null | undefined
}>

export type IUpdateGoalMetricMutation = {
  updateGoalMetric: {
    primary: boolean
    kind: Types.UserGoalMetricKind
    lowThresholdValue: number | null
    highThresholdValue: number | null
    section: string
    statKey: string
  }
}

export type IUpdateInvoiceOrderMutationVariables = Exact<{
  id: string | number
  state?: Types.InvoiceOrderState | null | undefined
  stateReason?: string | null | undefined
}>

export type IUpdateInvoiceOrderMutation = {
  updateInvoiceOrder: {
    __typename: 'InvoiceOrder'
    id: string
    quantity: number
    product: string
    productType: string
    processedAt: string | null
    orderId: number | null
    lastProcessingAttemptAt: string | null
    createdAt: string
    updatedAt: string
    state: Types.InvoiceOrderState
    stateReason: string | null
    invoice: { stripeId: string; paidAt: string | null }
    user: {
      id: string
      email: string
      firstName: string
      lastName: string
      fulfillmentConfiguration: { sensorKind: Types.UserSensorKind }
      address: {
        __typename: 'Address'
        id: string
        name: string
        street: string
        street2: string
        city: string
        state: Types.AddressState | null
        zipCode: string
        country: string | null
      } | null
    }
  }
}

export type IUpdateKnowledgeAnswerMutationVariables = Exact<{
  id: string | number
  title?: string | null | undefined
  value?: string | null | undefined
}>

export type IUpdateKnowledgeAnswerMutation = {
  updateKnowledgeAnswer: {
    __typename: 'KnowledgeAnswer'
    id: string
    title: string
    value: string
    knowledgeQuestions: Array<{ id: string; value: string }>
    knowledgeSources: Array<{ id: string; title: string; url: string }>
  }
}

export type IUpdateKnowledgeQuestionMutationVariables = Exact<{
  id: string | number
  value: string
}>

export type IUpdateKnowledgeQuestionMutation = {
  updateKnowledgeQuestion: {
    __typename: 'KnowledgeQuestion'
    id: string
    value: string
    knowledgeAnswers: Array<{
      id: string
      title: string
      value: string
      knowledgeSources: Array<{ id: string; title: string; url: string }>
    }>
    knowledgeTags: Array<{ id: string; value: string }>
  }
}

export type IUpdateKnowledgeSourceMutationVariables = Exact<{
  id: string | number
  title?: string | null | undefined
  url?: string | null | undefined
}>

export type IUpdateKnowledgeSourceMutation = {
  updateKnowledgeSource: { id: string; title: string; url: string }
}

export type IUpdateKnowledgeTagMutationVariables = Exact<{
  id: string | number
  value: string
}>

export type IUpdateKnowledgeTagMutation = { updateKnowledgeTag: { id: string; value: string } }

export type IUpdateOrderMutationVariables = Exact<{
  id: number
  notes?: string | null | undefined
  email?: string | null | undefined
  product?: string | null | undefined
  productType?: string | null | undefined
  sensorKind?: Types.UserSensorKind | null | undefined
  quantity?: number | null | undefined
}>

export type IUpdateOrderMutation = {
  updateOrder: {
    __typename: 'Order'
    id: number
    userId: number | null
    product: string
    productType: Types.ShippingOrderProductType
    sensorKind: Types.UserSensorKind | null
    provider: Types.ShippingOrderProvider | null
    quantity: number
    notes: string | null
    createdAt: string
    updatedAt: string
    includable: Types.ShippingOrderIncludable
    invoice: { stripeId: string } | null
    replacementRequest: { replacementReason: Types.ReplacementRequestReplacementReason } | null
  }
}

export type IUpdateReplacementRequestMutationVariables = Exact<{
  id: string | number
  chargeAmount?: Types.ReplacementRequestChargeAmount | null | undefined
  daysWorn?: number | null | undefined
  dateFellOff?: string | null | undefined
  dateNotified?: string | null | undefined
  howItFellOff?: string | null | undefined
  notes?: string | null | undefined
  replacementReason?: Types.ReplacementRequestReplacementReason | null | undefined
  rgaRequired?: Types.ReplacementRequestRgaRequired | null | undefined
  wearingPatch?: Types.ReplacementRequestWearingPatch | null | undefined
}>

export type IUpdateReplacementRequestMutation = {
  updateReplacementRequest: {
    __typename: 'ReplacementRequest'
    id: string
    userId: string
    createdById: string | null
    chargeAmount: Types.ReplacementRequestChargeAmount
    createdAt: string
    daysWorn: string | null
    dateFellOff: string | null
    dateNotified: string | null
    howItFellOff: string
    notes: string
    replacementReason: Types.ReplacementRequestReplacementReason
    rgaRequired: Types.ReplacementRequestRgaRequired | null
    wearingPatch: Types.ReplacementRequestWearingPatch
    state: Types.ReplacementRequestState
    sensorKind: Types.UserSensorKind | null
    sensor: { id: string; serialNumber: string; model: string } | null
    createdBy: { email: string } | null
    user: { email: string }
    invoice: { stripeId: string } | null
  }
}

export type IUpdateSensorMutationVariables = Exact<{
  baselineAdjustment: number
}>

export type IUpdateSensorMutation = {
  updateSensor: {
    serialNumber: string
    activationDate: string
    expirationDate: string
    expirationTime: string
    daysRemaining: number
    baselineAdjustment: number
  }
}

export type IUpdateShipmentMutationVariables = Exact<{
  id: number
  status?: string | null | undefined
  trackingNumber?: string | null | undefined
  trackingUrl?: string | null | undefined
  lotNumber?: string | null | undefined
  providerShipmentId?: string | number | null | undefined
  provider?: string | null | undefined
  providerReceivedAt?: string | null | undefined
  quantity?: number | null | undefined
  shippedAt?: string | null | undefined
  deliveredAt?: string | null | undefined
}>

export type IUpdateShipmentMutation = {
  updateShipment: {
    __typename: 'Shipment'
    id: number
    orderId: number
    addressId: number
    status: Types.ShippingShipmentStatus | null
    trackingNumber: string | null
    trackingUrl: string | null
    createdAt: string
    updatedAt: string
    shippedAt: string | null
    deliveredAt: string | null
    canceledAt: string | null
    providerShipmentId: string | null
    providerError: string | null
    providerReceivedAt: string | null
    provider: Types.ShippingOrderProvider | null
    quantity: number
    lotNumber: string | null
  }
}

export type IUpdateUserMutationVariables = Exact<{
  id?: string | number | null | undefined
  firstName?: string | null | undefined
  lastName?: string | null | undefined
  kind?: string | null | undefined
  sex?: string | null | undefined
  phoneNumber?: string | null | undefined
  dateOfBirth?: string | null | undefined
  truepillPatientToken?: string | null | undefined
  berryStreetGetHealthieId?: number | null | undefined
}>

export type IUpdateUserMutation = {
  updateUser: {
    __typename: 'User'
    createdAt: string
    email: string
    timeZone: string
    avatar: string | null
    firstName: string
    fullName: string
    id: string
    lastName: string
    role: Types.UserRole
    sex: string | null
    dateOfBirth: string | null
    phoneNumber: string | null
    lastAppVersion: string | null
    lastAppPlatform: string | null
    stripeId: string | null
    berryStreetGetHealthieId: number | null
    kustomerId: string | null
    klaviyoId: string | null
    stripeCreditBalance: number
    kind: Types.UserKind
    age: string | null
    canViewGlucoseGraph: boolean
    isSteloProvisionedUser: boolean
    address: {
      __typename: 'Address'
      id: string
      name: string
      street: string
      street2: string
      city: string
      state: Types.AddressState | null
      zipCode: string
      country: string | null
    } | null
    sensorInfo: { totalCount: number; replacementRequestsCount: number } | null
    settings: {
      id: string
      appVersionReminder: boolean
      dashboardGraph: string
      dexcomSync: boolean
      displayActivityScore: boolean
      displayDailyScore: boolean
      displayMealScore: boolean
      fastingEnd: number
      fastingStart: number
      glucoseHighThreshold: number
      glucoseLowThreshold: number
      googleFitSync: boolean
      healthKitSync: boolean
      ketoMojoSync: boolean
      ketoneHighThreshold: number
      ketoneLowThreshold: number
      reminders: boolean
      showNetCarbs: boolean
      unitSystem: string
      integrationsSyncSettings: {
        lastSyncedHealth: string | null
        lastSyncedDexcom: string | null
        lastSyncedKetoMojo: string | null
      }
      macroGoalsDaily: {
        calories: number
        carbs: number
        fat: number
        netCarbs: number | null
        protein: number
      }
    }
    sensor: {
      activationDate: string
      baselineAdjustment: number
      daysRemaining: number
      expirationDate: string
      expirationTime: string
      expired: boolean
      model: string
      serialNumber: string
      status: string | null
    } | null
    organization: { id: number; name: string }
    ongoingDietitianSubscription: {
      id: string
      dietitianAddOn: boolean
      stripeStatus: string
      status: Types.SubscriptionStatus
      paidMonthsCount: number
      cancelAt: string | null
      startAt: string
      paused: boolean
      resumesAt: string | null
      commitmentEndAt: string | null
      primaryProduct: { key: string; title: string }
    } | null
    ongoingCoreSubscription: {
      id: string
      paidMonthsCount: number
      paused: boolean
      cancelAt: string | null
      commitmentEndAt: string | null
      plans: Array<{ id: string; nickname: string }>
      primaryProduct: { key: string; title: string }
    } | null
    lastDietitianSubscription: {
      stripeStatus: string
      status: Types.SubscriptionStatus
      paused: boolean
      resumesAt: string | null
    } | null
    lastCoreSubscription: {
      id: string
      stripeStatus: string
      status: Types.SubscriptionStatus
      latestInvoice: { latestCharge: { status: string; created: string } | null } | null
    } | null
    lastAsyncChatAssignment: {
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    } | null
    lastVideoChatAssignment: {
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    } | null
    coachAssignments: Array<{
      id: string
      last: boolean
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string } | null
      coachingKind: { key: Types.CoachesCoachingKind }
    }> | null
    fulfillmentConfiguration: { sensorKind: Types.UserSensorKind }
    uxSensorMode: { syncDescription: string }
    dexcomConnection: {
      status: Types.DexcomConnectionStatus
      accessToken: string
      dexcomUserId: string | null
      createdAt: string
      lastSyncedAt: string | null
    } | null
    dexcomSteloConnection: {
      status: Types.DexcomConnectionStatus
      accessToken: string
      dexcomUserId: string | null
      createdAt: string
      lastSyncedAt: string | null
    } | null
    mntChatConversation: { id: string } | null
    stressChatConversation: { id: string } | null
    primaryGoal: { title: string; kind: Types.UserGoalKind; description: string | null } | null
    goalMetrics: Array<{
      primary: boolean
      kind: Types.UserGoalMetricKind
      lowThresholdValue: number | null
      highThresholdValue: number | null
      section: string
      statKey: string
    }>
    coachProfile: {
      stateLicences: Array<string>
      premium: boolean
      outOfOffice: boolean
      registrationStatus: Types.EhrCoachRegistrationStatus
      pendingRegisterNote: string | null
      credentials: string | null
      bio: string | null
      stressBio: string | null
      gender: Types.EhrCoachGender | null
      stateOfResidence: string | null
      ethnicity: string | null
      additionalLanguages: string | null
      cdrCnsNumber: string | null
      cdrCnsExpirationDate: string | null
      cdrCnsCard: string | null
      photo: string | null
      stateLicenceDetails: Array<{
        state: Types.AddressState
        expirationDate: string
        expirationReminderEnabled: boolean
        document: string | null
      }>
      specialties: Array<{ key: Types.EhrCoachSpecialty; name: string }>
    } | null
    referralPartner: {
      key: Types.UserReferralPartner
      logoUrl: string | null
      requiresProtocol: boolean
      name: string
    }
    ongoingSubscriptions: Array<{ primaryProduct: { key: string; title: string } }>
    paymentMethod: { stripeId: string } | null
    uhcMember: { id: string; uhcId: string } | null
    primaryCoachingKind: {
      __typename: 'CoachesCoachingKindDef'
      key: Types.CoachesCoachingKind
      coachTitle: string
      shortCoachTitle: string
      hubTitle: string
      shortHubTitle: string
      serviceTitle: string
      clinical: boolean
      insuranceReimbursable: boolean
      primary: boolean
    }
    onboardingExperience: {
      kind: Types.UserPropertyOnboardingExperienceKind
      participating: boolean
      baselineWeight: number | null
      desiredWeight: number | null
      fourWeekWeight: number | null
      dateToReachDesiredWeight: string | null
      realisticWeightLoss: boolean | null
      desiredWeightLossAmount: number | null
      weightLossPace: number | null
    } | null
  }
}

export type IUpdateUserOrganizationMutationVariables = Exact<{
  id: string | number
  organizationId: number
}>

export type IUpdateUserOrganizationMutation = {
  updateUserOrganization: {
    __typename: 'User'
    createdAt: string
    email: string
    timeZone: string
    avatar: string | null
    firstName: string
    fullName: string
    id: string
    lastName: string
    role: Types.UserRole
    sex: string | null
    dateOfBirth: string | null
    phoneNumber: string | null
    lastAppVersion: string | null
    lastAppPlatform: string | null
    stripeId: string | null
    berryStreetGetHealthieId: number | null
    kustomerId: string | null
    klaviyoId: string | null
    stripeCreditBalance: number
    kind: Types.UserKind
    age: string | null
    canViewGlucoseGraph: boolean
    isSteloProvisionedUser: boolean
    address: {
      __typename: 'Address'
      id: string
      name: string
      street: string
      street2: string
      city: string
      state: Types.AddressState | null
      zipCode: string
      country: string | null
    } | null
    sensorInfo: { totalCount: number; replacementRequestsCount: number } | null
    settings: {
      id: string
      appVersionReminder: boolean
      dashboardGraph: string
      dexcomSync: boolean
      displayActivityScore: boolean
      displayDailyScore: boolean
      displayMealScore: boolean
      fastingEnd: number
      fastingStart: number
      glucoseHighThreshold: number
      glucoseLowThreshold: number
      googleFitSync: boolean
      healthKitSync: boolean
      ketoMojoSync: boolean
      ketoneHighThreshold: number
      ketoneLowThreshold: number
      reminders: boolean
      showNetCarbs: boolean
      unitSystem: string
      integrationsSyncSettings: {
        lastSyncedHealth: string | null
        lastSyncedDexcom: string | null
        lastSyncedKetoMojo: string | null
      }
      macroGoalsDaily: {
        calories: number
        carbs: number
        fat: number
        netCarbs: number | null
        protein: number
      }
    }
    sensor: {
      activationDate: string
      baselineAdjustment: number
      daysRemaining: number
      expirationDate: string
      expirationTime: string
      expired: boolean
      model: string
      serialNumber: string
      status: string | null
    } | null
    organization: { id: number; name: string }
    ongoingDietitianSubscription: {
      id: string
      dietitianAddOn: boolean
      stripeStatus: string
      status: Types.SubscriptionStatus
      paidMonthsCount: number
      cancelAt: string | null
      startAt: string
      paused: boolean
      resumesAt: string | null
      commitmentEndAt: string | null
      primaryProduct: { key: string; title: string }
    } | null
    ongoingCoreSubscription: {
      id: string
      paidMonthsCount: number
      paused: boolean
      cancelAt: string | null
      commitmentEndAt: string | null
      plans: Array<{ id: string; nickname: string }>
      primaryProduct: { key: string; title: string }
    } | null
    lastDietitianSubscription: {
      stripeStatus: string
      status: Types.SubscriptionStatus
      paused: boolean
      resumesAt: string | null
    } | null
    lastCoreSubscription: {
      id: string
      stripeStatus: string
      status: Types.SubscriptionStatus
      latestInvoice: { latestCharge: { status: string; created: string } | null } | null
    } | null
    lastAsyncChatAssignment: {
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    } | null
    lastVideoChatAssignment: {
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    } | null
    coachAssignments: Array<{
      id: string
      last: boolean
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string } | null
      coachingKind: { key: Types.CoachesCoachingKind }
    }> | null
    fulfillmentConfiguration: { sensorKind: Types.UserSensorKind }
    uxSensorMode: { syncDescription: string }
    dexcomConnection: {
      status: Types.DexcomConnectionStatus
      accessToken: string
      dexcomUserId: string | null
      createdAt: string
      lastSyncedAt: string | null
    } | null
    dexcomSteloConnection: {
      status: Types.DexcomConnectionStatus
      accessToken: string
      dexcomUserId: string | null
      createdAt: string
      lastSyncedAt: string | null
    } | null
    mntChatConversation: { id: string } | null
    stressChatConversation: { id: string } | null
    primaryGoal: { title: string; kind: Types.UserGoalKind; description: string | null } | null
    goalMetrics: Array<{
      primary: boolean
      kind: Types.UserGoalMetricKind
      lowThresholdValue: number | null
      highThresholdValue: number | null
      section: string
      statKey: string
    }>
    coachProfile: {
      stateLicences: Array<string>
      premium: boolean
      outOfOffice: boolean
      registrationStatus: Types.EhrCoachRegistrationStatus
      pendingRegisterNote: string | null
      credentials: string | null
      bio: string | null
      stressBio: string | null
      gender: Types.EhrCoachGender | null
      stateOfResidence: string | null
      ethnicity: string | null
      additionalLanguages: string | null
      cdrCnsNumber: string | null
      cdrCnsExpirationDate: string | null
      cdrCnsCard: string | null
      photo: string | null
      stateLicenceDetails: Array<{
        state: Types.AddressState
        expirationDate: string
        expirationReminderEnabled: boolean
        document: string | null
      }>
      specialties: Array<{ key: Types.EhrCoachSpecialty; name: string }>
    } | null
    referralPartner: {
      key: Types.UserReferralPartner
      logoUrl: string | null
      requiresProtocol: boolean
      name: string
    }
    ongoingSubscriptions: Array<{ primaryProduct: { key: string; title: string } }>
    paymentMethod: { stripeId: string } | null
    uhcMember: { id: string; uhcId: string } | null
    primaryCoachingKind: {
      __typename: 'CoachesCoachingKindDef'
      key: Types.CoachesCoachingKind
      coachTitle: string
      shortCoachTitle: string
      hubTitle: string
      shortHubTitle: string
      serviceTitle: string
      clinical: boolean
      insuranceReimbursable: boolean
      primary: boolean
    }
    onboardingExperience: {
      kind: Types.UserPropertyOnboardingExperienceKind
      participating: boolean
      baselineWeight: number | null
      desiredWeight: number | null
      fourWeekWeight: number | null
      dateToReachDesiredWeight: string | null
      realisticWeightLoss: boolean | null
      desiredWeightLossAmount: number | null
      weightLossPace: number | null
    } | null
  }
}

export type IUpdateUserPropertyMutationVariables = Exact<{
  userId?: string | number | null | undefined
  kind: string
  value: string
  id?: string | number | null | undefined
}>

export type IUpdateUserPropertyMutation = {
  updateUserProperty: { id: number; kind: Types.UserPropertyKind; value: string; userId: string }
}

export type IUpdateSettingsMutationVariables = Exact<{
  appVersionReminder?: boolean | null | undefined
  dashboardGraph?: string | null | undefined
  dexcomSync?: boolean | null | undefined
  displayActivityScore?: boolean | null | undefined
  displayDailyScore?: boolean | null | undefined
  displayMealScore?: boolean | null | undefined
  fastingEnd?: number | null | undefined
  fastingStart?: number | null | undefined
  glucoseHighThreshold?: number | null | undefined
  glucoseLowThreshold?: number | null | undefined
  googleFitSync?: boolean | null | undefined
  healthKitSync?: boolean | null | undefined
  ketoMojoSync?: boolean | null | undefined
  ketoneHighThreshold?: number | null | undefined
  ketoneLowThreshold?: number | null | undefined
  macroGoalsDaily?: Types.IMacroGoalsDaily | null | undefined
  reminders?: boolean | null | undefined
  showNetCarbs?: boolean | null | undefined
  unitSystem?: string | null | undefined
}>

export type IUpdateSettingsMutation = {
  updateSettings: {
    id: string
    appVersionReminder: boolean
    dashboardGraph: string
    dexcomSync: boolean
    displayActivityScore: boolean
    displayDailyScore: boolean
    displayMealScore: boolean
    fastingEnd: number
    fastingStart: number
    glucoseHighThreshold: number
    glucoseLowThreshold: number
    googleFitSync: boolean
    healthKitSync: boolean
    ketoMojoSync: boolean
    ketoneHighThreshold: number
    ketoneLowThreshold: number
    reminders: boolean
    showNetCarbs: boolean
    unitSystem: string
    macroGoalsDaily: {
      calories: number
      carbs: number
      fat: number
      netCarbs: number | null
      protein: number
    }
  }
}

export type IUploadHealthDataReportPdfMutationVariables = Exact<{
  id: string | number
  pdf: unknown
}>

export type IUploadHealthDataReportPdfMutation = { uploadHealthDataReportPdf: { success: boolean } }

export type IUpsertMealMutationVariables = Exact<{
  id?: string | number | null | undefined
  kind?: Types.MealKind | null | undefined
  favorite?: boolean | null | undefined
  description: string
  time: string
  ingredients?: Array<Types.IIngredientData> | Types.IIngredientData | null | undefined
}>

export type IUpsertMealMutation = {
  upsertMeal: {
    __typename: 'Meal'
    avatar: string | null
    occurredAt: string
    source: Types.MealSource
    id: string
    readOnly: boolean
    title: string
    kind: Types.MealKind
    updatedAt: string | null
    mealCreatedAt: string | null
    mealDescription: string | null
    mealFavorite: boolean | null
    mealCreatedBy: { id: string } | null
    mealStatistics: {
      aucScore: number | null
      glucose2hrDelta: number | null
      glucoseDelta: number | null
      glucoseMax: string | null
      glucoseMin: string | null
      glucoseScore: number | null
      glucoseScore2hrDelta: number | null
      glucoseScoreAuc: number | null
      glucoseScoreDelta: number | null
      glucoseScorePeak: number | null
    } | null
    ingredients: Array<{
      calories: number
      createdAt: string
      description: string
      id: string
      servingAmount: number
      servingUnits: string
    }> | null
    glucose: {
      range: Array<number>
      healthyRange: Array<number>
      values: Array<{ timestamp: string; value: number | null; displayValue: string | null }>
    } | null
    nutrition: Array<{ key: string; value: number }> | null
  }
}

export type IUpsertNoteMutationVariables = Exact<{
  id?: string | number | null | undefined
  body: string
  time?: string | null | undefined
  kind?: string | null | undefined
  pinned?: boolean | null | undefined
}>

export type IUpsertNoteMutation = {
  upsertNote: {
    id: string
    body: string
    kind: Types.NoteKind
    occurredAt: string
    pinnedAt: string | null
  }
}

export type IUpsertPrimaryGoalMutationVariables = Exact<{
  kind: Types.UserGoalKind
  description?: string | null | undefined
}>

export type IUpsertPrimaryGoalMutation = {
  upsertPrimaryGoal: { title: string; kind: Types.UserGoalKind; description: string | null }
}

export type IUpsertUiStateMutationVariables = Exact<{
  name: Types.UiStateName
  value: boolean
}>

export type IUpsertUiStateMutation = {
  upsertUiState: { __typename: 'PrivateUIState'; name: Types.UiStateName; value: boolean }
}

export type IVerifyMfaSmsCodeMutationVariables = Exact<{
  mfaSmsCode: string
}>

export type IVerifyMfaSmsCodeMutation = { verifyMfaSmsCode: { mfaToken: string } }

export type IAllAccountRequestsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IAccountRequestSort> | Types.IAccountRequestSort | null | undefined
  dynamicFilters?:
    | Array<Types.IAccountRequestDynamicFilterItem>
    | Types.IAccountRequestDynamicFilterItem
    | null
    | undefined
  status?: Types.OpsAccountRequestStatus | null | undefined
}>

export type IAllAccountRequestsQuery = {
  allAccountRequests: {
    totalCount: number
    accountRequests: Array<{
      __typename: 'AccountRequest'
      id: string
      escalatedAt: string | null
      processedAt: string | null
      reviewedAt: string | null
      rejectedAt: string | null
      failedAt: string | null
      priority: Types.OpsAccountRequestPriority
      kind: Types.OpsAccountRequestKind
      errorMessage: string | null
      notes: string | null
      status: Types.OpsAccountRequestStatus
      user: { id: string; fullName: string; email: string }
      escalatedBy: { fullName: string } | null
      processedBy: { fullName: string } | null
      reviewedBy: { fullName: string } | null
      rejectedBy: { fullName: string } | null
      payload:
        | {
            __typename: 'CancelSubscriptionResponsePayload'
            subscriptionId: string
            cancellationType: Types.AccountRequestCancelSubscriptionRequestPayloadCancellationType
            waiveEarlyCancellationFee: boolean
            waiveEarlyCancellationSurcharge: boolean
            cancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason
          }
        | {
            __typename: 'ChangeSubscriptionBillingCycleResponsePayload'
            subscriptionId: string
            billingCycleAnchor: string
          }
        | { __typename: 'CreditResponsePayload'; centsAmount: number }
        | {
            __typename: 'DeleteDuplicateAccountResponsePayload'
            duplicateUserId: string
            creditAmountInCents: number
            replaceWithDuplicateUserEmail: boolean | null
          }
        | { __typename: 'MiscRequestResponsePayload'; requestDetails: string }
        | {
            __typename: 'OneOffAddonResponsePayload'
            product: Types.BillingProduct
            paid: boolean
            discountCentsAmount: number | null
          }
        | {
            __typename: 'PauseSubscriptionResponsePayload'
            subscriptionId: string
            cycleCount: number
            reason: Types.OpsAccountRequestKindsPauseSubscriptionReason
          }
        | {
            __typename: 'RefundResponsePayload'
            chargeId: string
            amountInCents: number
            subscriptionCancellationRequired: boolean
            subscriptionCancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason | null
            refundReason: { journey: string; reasonOne: string; reasonTwo: string } | null
          }
        | { __typename: 'UncancelSubscriptionResponsePayload'; subscriptionId: string }
        | {
            __typename: 'UnpauseSubscriptionResponsePayload'
            subscriptionId: string
            resumeDate: string | null
          }
        | {
            __typename: 'UpdateSubscriptionResponsePayload'
            oldProduct: Types.BillingProduct | null
            nextProduct: Types.BillingProduct
          }
        | {
            __typename: 'UpsertLimitedSupportResponsePayload'
            limitedSupportSubscriptionId: string | null
            limitedSupportCancelAt: string
          }
        | Record<PropertyKey, never>
        | null
    }>
  }
}

export type ICalculateDuplicateAccountCreditQueryVariables = Exact<{
  userId: string | number
}>

export type ICalculateDuplicateAccountCreditQuery = {
  calculateDuplicateAccountCredit: { creditAmountInCents: number }
}

export type IShowAccountRequestsConfigQueryVariables = Exact<{ [key: string]: never }>

export type IShowAccountRequestsConfigQuery = {
  showAccountRequestsConfig: {
    pauseReasons: Array<{ key: Types.OpsAccountRequestKindsPauseSubscriptionReason; copy: string }>
    refundReasons: Array<{ key: Types.OpsAccountRequestKindsRefundReason; description: string }>
  }
}

export type IActionGoalSummariesQueryVariables = Exact<{
  startDate: string
}>

export type IActionGoalSummariesQuery = {
  actionGoalSummaries: {
    startDate: string
    actionGoalSummaries: Array<{
      id: string
      completions: Array<{ date: string }> | null
      actionGoal: {
        id: string
        kind: Types.ActionGoalKind
        numberDays: number
        startDate: string
        metricKind: Types.ActionGoalMetricKind
        metricValue: number | null
        displayUnits: string | null
        title: string
        description: string
        summaryDescription: string
        icon: Types.UiIcon
        category: Types.ActionGoalCategory
        macroGoal: string | null
      }
    }>
  }
}

export type IAdminPanelAllCoachAssignmentsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.ICoachAssignmentSort> | Types.ICoachAssignmentSort | null | undefined
  dynamicFilters?:
    | Array<Types.ICoachAssignmentDynamicFilterItem>
    | Types.ICoachAssignmentDynamicFilterItem
    | null
    | undefined
  last?: boolean | null | undefined
}>

export type IAdminPanelAllCoachAssignmentsQuery = {
  allCoachAssignments: {
    totalCount: number
    coachAssignments: Array<{
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      dietitianMenu: boolean
      coach: { id: string; fullName: string } | null
      user: {
        id: string
        fullName: string
        email: string
        kind: Types.UserKind
        primaryGoal: { title: string; kind: Types.UserGoalKind; description: string | null } | null
        userProperties: {
          testGroup: { id: number; kind: Types.UserPropertyKind; value: string } | null
          oneMonthActiveFeedbackDietitian: {
            id: number
            kind: Types.UserPropertyKind
            value: string
          } | null
          dietitianRequest: { id: number; kind: Types.UserPropertyKind; value: string } | null
          scheduledVideoCallStatus: {
            id: number
            kind: Types.UserPropertyKind
            value: string
          } | null
          healthGoal: { id: number; kind: Types.UserPropertyKind; value: string } | null
          communicationFrequency: { id: number; kind: Types.UserPropertyKind; value: string } | null
          dietitianSensorCountNotes: {
            id: number
            kind: Types.UserPropertyKind
            value: string
          } | null
          nutritionistGroup: { id: number; kind: Types.UserPropertyKind; value: string } | null
        } | null
        lastDietitianSubscription: {
          stripeStatus: string
          status: Types.SubscriptionStatus
          paused: boolean
          resumesAt: string | null
        } | null
        ongoingDietitianSubscription: {
          id: string
          cancelAt: string | null
          stripeStatus: string
          status: Types.SubscriptionStatus
          dietitianAddOn: boolean
          plans: Array<{ nickname: string }>
          primaryProduct: { title: string }
        } | null
        lastCoreSubscription: {
          id: string
          stripeStatus: string
          status: Types.SubscriptionStatus
          latestInvoice: { latestCharge: { status: string; created: string } | null } | null
        } | null
        sensorInfo: {
          totalCount: number
          replacementRequestsCount: number
          firstStartTime: string | null
          lastSensor: { expired: boolean; expirationDate: string } | null
        } | null
        coachAssignments: Array<{
          __typename: 'CoachAssignment'
          id: string
          state: Types.CoachAssignmentState
          last: boolean
          createdAt: string
          assignedAt: string | null
          deactivatedAt: string | null
          kind: Types.CoachAssignmentKind | null
          supportType: Types.CoachAssignmentSupportType
          coach: { id: string; fullName: string } | null
          ehrAppointment: { meetingAt: string | null } | null
          coachingKind: {
            __typename: 'CoachesCoachingKindDef'
            key: Types.CoachesCoachingKind
            coachTitle: string
            shortCoachTitle: string
            hubTitle: string
            shortHubTitle: string
            serviceTitle: string
            clinical: boolean
            insuranceReimbursable: boolean
            primary: boolean
          }
        }> | null
      }
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    }>
  }
}

export type IAdminPanelAllCoachesQueryVariables = Exact<{
  sorts?: Array<Types.IUserSort> | Types.IUserSort | null | undefined
  dynamicFilters?:
    | Array<Types.IUserDynamicFilterItem>
    | Types.IUserDynamicFilterItem
    | null
    | undefined
}>

export type IAdminPanelAllCoachesQuery = {
  allUsers: {
    users: Array<{
      id: string
      fullName: string
      email: string
      coachAssignmentInfo: { activeAssignmentsCount: number }
      activeCoachingKinds: Array<{ key: Types.CoachesCoachingKind; coachTitle: string }>
    }>
  }
}

export type IAllHealthPortalNotificationsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?:
    | Array<Types.IHealthPortalNotificationsSort>
    | Types.IHealthPortalNotificationsSort
    | null
    | undefined
  completed?: boolean | null | undefined
  forReview?: boolean | null | undefined
  kinds?:
    | Array<Types.HealthPortalNotificationKind>
    | Types.HealthPortalNotificationKind
    | null
    | undefined
  userIds?: Array<string | number> | string | number | null | undefined
}>

export type IAllHealthPortalNotificationsQuery = {
  allHealthPortalNotifications: {
    healthPortalNotifications: Array<{
      __typename: 'HealthPortalNotification'
      id: string
      completedAt: string | null
      createdAt: string
      kind: Types.HealthPortalNotificationKind
      requiresAction: boolean
      details: string | null
      actionDetails: string | null
      actionTitle: string | null
      coachAssignment: {
        kind: Types.CoachAssignmentKind | null
        supportType: Types.CoachAssignmentSupportType
        user: {
          id: string
          fullName: string
          ongoingDietitianSubscription: { cancelAt: string | null; resumesAt: string | null } | null
          coachAssignments: Array<{ id: string; kind: Types.CoachAssignmentKind | null }> | null
        }
        ehrAppointment: { meetingAt: string | null } | null
      } | null
      chatConversation: { id: string } | null
      supportTicket: {
        __typename: 'Ticket'
        id: string
        description: string
        externalLink: string | null
        kind: Types.TicketKind
        reason: Types.TicketReason | null
        status: Types.TicketStatus
        priority: Types.TicketPriority
        createdAt: string
        createdBy: { id: string; email: string; fullName: string }
        user: { id: string; email: string; fullName: string }
        assignedTo: { id: string; email: string; fullName: string } | null
      } | null
    }>
  }
}

export type IAdminPanelAllUsersQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IUserSort> | Types.IUserSort | null | undefined
  dynamicFilters?:
    | Array<Types.IUserDynamicFilterItem>
    | Types.IUserDynamicFilterItem
    | null
    | undefined
}>

export type IAdminPanelAllUsersQuery = {
  allUsers: {
    totalCount: number
    users: Array<{
      id: string
      fullName: string
      email: string
      sensorInfo: { totalCount: number } | null
      coachAssignments: Array<{
        __typename: 'CoachAssignment'
        id: string
        state: Types.CoachAssignmentState
        last: boolean
        createdAt: string
        assignedAt: string | null
        deactivatedAt: string | null
        kind: Types.CoachAssignmentKind | null
        supportType: Types.CoachAssignmentSupportType
        coach: { id: string; fullName: string } | null
        ehrAppointment: { meetingAt: string | null } | null
        coachingKind: {
          __typename: 'CoachesCoachingKindDef'
          key: Types.CoachesCoachingKind
          coachTitle: string
          shortCoachTitle: string
          hubTitle: string
          shortHubTitle: string
          serviceTitle: string
          clinical: boolean
          insuranceReimbursable: boolean
          primary: boolean
        }
      }> | null
      ongoingDietitianSubscription: {
        id: string
        cancelAt: string | null
        status: Types.SubscriptionStatus
        plans: Array<{ nickname: string }>
      } | null
      lastDietitianSubscription: {
        id: string
        stripeStatus: string
        status: Types.SubscriptionStatus
      } | null
      primaryGoal: { title: string; kind: Types.UserGoalKind; description: string | null } | null
      userProperties: {
        oneMonthActiveFeedbackDietitian: {
          id: number
          kind: Types.UserPropertyKind
          value: string
        } | null
        dietitianRequest: { id: number; kind: Types.UserPropertyKind; value: string } | null
        scheduledVideoCallStatus: { id: number; kind: Types.UserPropertyKind; value: string } | null
        testGroup: { id: number; kind: Types.UserPropertyKind; value: string } | null
        healthGoal: { id: number; kind: Types.UserPropertyKind; value: string } | null
        videoCallRescheduleFreePassUsed: {
          id: number
          kind: Types.UserPropertyKind
          value: string
        } | null
      } | null
    }>
  }
}

export type IAllAmazonOrdersQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IAmazonOrderSort> | Types.IAmazonOrderSort | null | undefined
  dynamicFilters?:
    | Array<Types.IAmazonOrderDynamicFilterItem>
    | Types.IAmazonOrderDynamicFilterItem
    | null
    | undefined
}>

export type IAllAmazonOrdersQuery = {
  allAmazonOrders: {
    totalCount: number
    orders: Array<{
      id: string
      amazonOrderId: string
      status: Types.ShippingAmazonOrderStatus
      total: number
      phoneNumber: string | null
      purchasedAt: string
      buyer: { emailAlias: string; userId: string | null } | null
      shippingOrder: { id: number } | null
      items: Array<{
        id: string
        asin: string
        sku: string
        amazonOrderItemId: string
        quantity: number
      }>
      address: {
        __typename: 'Address'
        id: string
        name: string
        street: string
        street2: string
        city: string
        state: Types.AddressState | null
        zipCode: string
        country: string | null
      } | null
    }>
  }
}

export type IAllAssignableAuthorizationPoliciesQueryVariables = Exact<{ [key: string]: never }>

export type IAllAssignableAuthorizationPoliciesQuery = {
  allAssignableAuthorizationPolicies: Array<{
    id: string
    kind: Types.UserAuthorizationPolicyKind
    policy: {
      __typename: 'AuthorizationPolicy'
      name: string
      grants: Array<{ permission: string; resource: string; scope: string | null }>
    }
  }>
}

export type IAllChartsQueryVariables = Exact<{
  filter?: Types.IDateFilter | null | undefined
}>

export type IAllChartsQuery = {
  allCharts: {
    charts: Array<{
      type: string
      title: string
      description: string
      xAxis: string
      yAxis: string
      range: {
        min: number | null
        max: number | null
        goal: number | null
        goalMin: number | null
        goalMax: number | null
      }
      meta: { key: string | null; tag: string | null; section: string | null }
      values: Array<
        | { __typename: 'NumericPair'; xNumericPair: number; yNumericPair: number | null }
        | { __typename: 'RangePair'; yRangePair: number; xRangePair: { min: number; max: number } }
        | {
            __typename: 'StringPair'
            name: string | null
            xStringPair: string
            yStringPair: number | null
          }
        | {
            __typename: 'TimePair'
            displayValue: string | null
            interpolated: boolean
            xTimePair: string
            yTimePair: number
          }
      >
    }>
  } | null
}

export type IAllChatConversationMessageTemplateVariablesQueryVariables = Exact<{
  [key: string]: never
}>

export type IAllChatConversationMessageTemplateVariablesQuery = {
  allChatConversationMessageTemplateVariables: {
    chatConversationMessageTemplateVariables: Array<{ id: string; key: string }>
  }
}

export type IAllChatConversationMessageTemplatesQueryVariables = Exact<{
  kinds?:
    | Array<Types.ChatConversationMessageTemplateKind>
    | Types.ChatConversationMessageTemplateKind
    | null
    | undefined
  excludeAutomatic?: boolean | null | undefined
}>

export type IAllChatConversationMessageTemplatesQuery = {
  allChatConversationMessageTemplates: {
    chatConversationMessageTemplates: Array<{
      id: string
      value: string
      kind: Types.ChatConversationMessageTemplateKind
      name: string
      private: boolean
      automatic: boolean
      createdBy: { id: string } | null
    }>
  }
}

export type IAllChatbotConversationsQueryVariables = Exact<{ [key: string]: never }>

export type IAllChatbotConversationsQuery = {
  allChatbotConversations: {
    conversations: Array<{
      id: string
      userId: string
      providerId: string
      createdAt: string
      updatedAt: string
    }>
  }
}

export type IAllCoachBillingInvoiceUsersQueryVariables = Exact<{
  active?: boolean | null | undefined
  periodStart: string
  periodEnd: string
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?:
    | Array<Types.ICoachBillingInvoiceUserSort>
    | Types.ICoachBillingInvoiceUserSort
    | null
    | undefined
  dynamicFilters?:
    | Array<Types.ICoachBillingInvoiceUserDynamicFilterItem>
    | Types.ICoachBillingInvoiceUserDynamicFilterItem
    | null
    | undefined
}>

export type IAllCoachBillingInvoiceUsersQuery = {
  allCoachBillingInvoiceUsers: {
    totalCount: number
    users: Array<{
      __typename: 'CoachBillingInvoiceUser'
      id: string
      total: number
      periodStart: string
      periodEnd: string
      billingPeriodState: Types.CoachBillingInvoiceUserBillingPeriodStates
      user: { id: string; fullName: string; email: string }
      lastInvoice: {
        __typename: 'CoachBillingInvoice'
        id: string
        periodStart: string
        periodEnd: string
        number: string
        total: number
        adminTotal: number
        billableTotal: number
        submittedAt: string
        sentAt: string | null
      } | null
      lastCoachReview: {
        __typename: 'CoachBillingInvoiceReview'
        id: string
        periodStart: string
        periodEnd: string
        kind: Types.CoachesBillingInvoiceReviewKind
        reviewedAt: string | null
        reviewedBy: { id: string; email: string; fullName: string }
      } | null
    }>
  }
}

export type IAllCoachConversationScheduledMessagesQueryVariables = Exact<{
  userId?: string | number | null | undefined
  kinds?:
    | Array<Types.ChatConversationMessageTemplateKind>
    | Types.ChatConversationMessageTemplateKind
    | null
    | undefined
  states?:
    | Array<Types.CoachesConversationScheduledMessageState>
    | Types.CoachesConversationScheduledMessageState
    | null
    | undefined
  sorts?:
    | Array<Types.ICoachConversationScheduledMessageSort>
    | Types.ICoachConversationScheduledMessageSort
    | null
    | undefined
}>

export type IAllCoachConversationScheduledMessagesQuery = {
  allCoachConversationScheduledMessages: {
    coachConversationScheduledMessages: Array<{
      id: string
      kind: Types.ChatConversationMessageTemplateKind
      state: Types.CoachesConversationScheduledMessageState
      sendAt: string | null
      sentAt: string | null
      coachAssignment: {
        id: string
        user: { id: string; fullName: string }
        ehrAppointment: { id: string } | null
      }
    }>
  }
}

export type IAllEventsQueryVariables = Exact<{
  filter?: Types.IDateFilter | null | undefined
  pagination?: Types.IPagination | null | undefined
}>

export type IAllEventsQuery = {
  allEvents: {
    events: {
      events: Array<
        | {
            __typename: 'Activity'
            createdAt: string
            description: string
            endedAt: string
            externalSource: string | null
            favorite: boolean
            id: string
            length: number
            occurredAt: string
            startedAt: string
            status: string | null
            title: string
            type: string
            statistics: {
              aucScore: number | null
              glucose2hrDelta: number | null
              glucoseDelta: number | null
              glucoseMax: string | null
              glucoseMin: string | null
              glucoseScore: number | null
              glucoseScore2hrDelta: number | null
              glucoseScoreAuc: number | null
              glucoseScoreDelta: number | null
              glucoseScorePeak: number | null
            }
          }
        | {
            __typename: 'JournalEntry'
            id: string
            title: string
            body: string
            occurredAt: string
            createdAt: string
            creatorId: string
            score: number | null
            measurements: Array<{
              __typename: 'Measurement'
              createdAt: string
              cumulative: boolean
              description: string
              externalSource: string | null
              id: string
              occurredAt: string
              timestamp: string
              title: string
              type: string
              units: string
              value: number | null
              values: { diastolic: number; systolic: number } | { value: number } | null
              scan: { createdAt: string; id: string } | null
            }> | null
          }
        | {
            __typename: 'Meal'
            avatar: string | null
            occurredAt: string
            source: Types.MealSource
            id: string
            readOnly: boolean
            title: string
            kind: Types.MealKind
            updatedAt: string | null
            mealCreatedAt: string | null
            mealDescription: string | null
            mealFavorite: boolean | null
            mealCreatedBy: { id: string } | null
            mealStatistics: {
              aucScore: number | null
              glucose2hrDelta: number | null
              glucoseDelta: number | null
              glucoseMax: string | null
              glucoseMin: string | null
              glucoseScore: number | null
              glucoseScore2hrDelta: number | null
              glucoseScoreAuc: number | null
              glucoseScoreDelta: number | null
              glucoseScorePeak: number | null
            } | null
            ingredients: Array<{
              calories: number
              createdAt: string
              description: string
              id: string
              servingAmount: number
              servingUnits: string
            }> | null
            glucose: {
              range: Array<number>
              healthyRange: Array<number>
              values: Array<{
                timestamp: string
                value: number | null
                displayValue: string | null
              }>
            } | null
            nutrition: Array<{ key: string; value: number }> | null
          }
        | {
            __typename: 'Measurement'
            createdAt: string
            cumulative: boolean
            description: string
            externalSource: string | null
            id: string
            occurredAt: string
            timestamp: string
            title: string
            type: string
            units: string
            value: number | null
            scan: { createdAt: string; id: string } | null
            values: { diastolic: number; systolic: number } | { value: number } | null
          }
        | {
            __typename: 'Note'
            body: string
            createdAt: string
            creatorId: string
            id: string
            occurredAt: string
            title: string
            createdBy: string
          }
      >
    }
  } | null
}

export type IAllFilesQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IFileSort> | Types.IFileSort | null | undefined
  dynamicFilters?:
    | Array<Types.IFileDynamicFilterItem>
    | Types.IFileDynamicFilterItem
    | null
    | undefined
}>

export type IAllFilesQuery = {
  allFiles: {
    files: Array<{
      __typename: 'File'
      tag: Types.UserFileTag | null
      id: string
      downloadFileUrl: string
      permanentUrl: string
      fileUrl: string
      fileName: string
      fileType: string
      createdAt: string
    }>
  }
}

export type IAllFormulasQueryVariables = Exact<{ [key: string]: never }>

export type IAllFormulasQuery = {
  allFormulas: {
    formulas: Array<{
      operation: string
      className: string
      title: string
      description: string | null
    }>
  }
}

export type IAllHealthDataReportsQueryVariables = Exact<{
  userId: string | number
  sorts?: Array<Types.IHealthDataReportSort> | Types.IHealthDataReportSort | null | undefined
  dynamicFilters?:
    | Array<Types.IHealthDataReportDynamicFilterItem>
    | Types.IHealthDataReportDynamicFilterItem
    | null
    | undefined
}>

export type IAllHealthDataReportsQuery = {
  allHealthDataReports: {
    reports: Array<{
      id: string
      startDate: string
      endDate: string
      kind: Types.HealthDataReportKind
      reportData: string | null
      createdAt: string
      user: { id: string }
      lastState: { kind: Types.HealthDataReportStateKind }
    }>
  }
}

export type IAllHistoryQueryVariables = Exact<{
  filter?: Types.IDateFilter | null | undefined
  pagination?: Types.IPagination | null | undefined
}>

export type IAllHistoryQuery = {
  allEvents: {
    events: {
      events: Array<
        | {
            __typename: 'Activity'
            createdAt: string
            description: string
            endedAt: string
            externalSource: string | null
            favorite: boolean
            id: string
            length: number
            occurredAt: string
            startedAt: string
            status: string | null
            title: string
            type: string
            statistics: {
              aucScore: number | null
              glucose2hrDelta: number | null
              glucoseDelta: number | null
              glucoseMax: string | null
              glucoseMin: string | null
              glucoseScore: number | null
              glucoseScore2hrDelta: number | null
              glucoseScoreAuc: number | null
              glucoseScoreDelta: number | null
              glucoseScorePeak: number | null
            }
          }
        | {
            __typename: 'JournalEntry'
            id: string
            title: string
            body: string
            occurredAt: string
            createdAt: string
            creatorId: string
            score: number | null
            measurements: Array<{
              __typename: 'Measurement'
              createdAt: string
              cumulative: boolean
              description: string
              externalSource: string | null
              id: string
              occurredAt: string
              timestamp: string
              title: string
              type: string
              units: string
              value: number | null
              values: { diastolic: number; systolic: number } | { value: number } | null
              scan: { createdAt: string; id: string } | null
            }> | null
          }
        | {
            __typename: 'Meal'
            avatar: string | null
            occurredAt: string
            source: Types.MealSource
            id: string
            readOnly: boolean
            title: string
            kind: Types.MealKind
            updatedAt: string | null
            mealCreatedAt: string | null
            mealDescription: string | null
            mealFavorite: boolean | null
            mealCreatedBy: { id: string } | null
            mealStatistics: {
              aucScore: number | null
              glucose2hrDelta: number | null
              glucoseDelta: number | null
              glucoseMax: string | null
              glucoseMin: string | null
              glucoseScore: number | null
              glucoseScore2hrDelta: number | null
              glucoseScoreAuc: number | null
              glucoseScoreDelta: number | null
              glucoseScorePeak: number | null
            } | null
            ingredients: Array<{
              calories: number
              createdAt: string
              description: string
              id: string
              servingAmount: number
              servingUnits: string
            }> | null
            glucose: {
              range: Array<number>
              healthyRange: Array<number>
              values: Array<{
                timestamp: string
                value: number | null
                displayValue: string | null
              }>
            } | null
            nutrition: Array<{ key: string; value: number }> | null
          }
        | {
            __typename: 'Measurement'
            createdAt: string
            cumulative: boolean
            description: string
            externalSource: string | null
            id: string
            occurredAt: string
            timestamp: string
            title: string
            type: string
            units: string
            value: number | null
            scan: { createdAt: string; id: string } | null
            values: { diastolic: number; systolic: number } | { value: number } | null
          }
        | {
            __typename: 'Note'
            body: string
            createdAt: string
            creatorId: string
            id: string
            occurredAt: string
            title: string
            createdBy: string
          }
      >
    }
  } | null
}

export type IAllInvoiceOrdersQueryVariables = Exact<{
  page: number
  perPage: number
  sorts?: Array<Types.IInvoiceOrderSort> | Types.IInvoiceOrderSort | null | undefined
  dynamicFilters?:
    | Array<Types.IInvoiceOrderDynamicFilterItem>
    | Types.IInvoiceOrderDynamicFilterItem
    | null
    | undefined
}>

export type IAllInvoiceOrdersQuery = {
  allInvoiceOrders: {
    totalCount: number
    invoiceOrders: Array<{
      __typename: 'InvoiceOrder'
      id: string
      quantity: number
      product: string
      productType: string
      processedAt: string | null
      orderId: number | null
      lastProcessingAttemptAt: string | null
      createdAt: string
      updatedAt: string
      state: Types.InvoiceOrderState
      stateReason: string | null
      invoice: { stripeId: string; paidAt: string | null }
      user: {
        id: string
        email: string
        firstName: string
        lastName: string
        fulfillmentConfiguration: { sensorKind: Types.UserSensorKind }
        address: {
          __typename: 'Address'
          id: string
          name: string
          street: string
          street2: string
          city: string
          state: Types.AddressState | null
          zipCode: string
          country: string | null
        } | null
      }
    }>
  }
}

export type IAllKnowledgeAnswersQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IKnowledgeAnswerSort> | Types.IKnowledgeAnswerSort | null | undefined
  dynamicFilters?:
    | Array<Types.IKnowledgeAnswerDynamicFilterItem>
    | Types.IKnowledgeAnswerDynamicFilterItem
    | null
    | undefined
}>

export type IAllKnowledgeAnswersQuery = {
  allKnowledgeAnswers: {
    totalCount: number
    pageCount: number | null
    knowledgeAnswers: Array<{
      __typename: 'KnowledgeAnswer'
      id: string
      title: string
      value: string
      knowledgeQuestions: Array<{ id: string; value: string }>
      knowledgeSources: Array<{ id: string; title: string; url: string }>
    }>
  }
}

export type IAllKnowledgeQuestionsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IKnowledgeQuestionSort> | Types.IKnowledgeQuestionSort | null | undefined
  dynamicFilters?:
    | Array<Types.IKnowledgeQuestionDynamicFilterItem>
    | Types.IKnowledgeQuestionDynamicFilterItem
    | null
    | undefined
}>

export type IAllKnowledgeQuestionsQuery = {
  allKnowledgeQuestions: {
    totalCount: number
    pageCount: number | null
    knowledgeQuestions: Array<{
      __typename: 'KnowledgeQuestion'
      id: string
      value: string
      knowledgeAnswers: Array<{
        id: string
        title: string
        value: string
        knowledgeSources: Array<{ id: string; title: string; url: string }>
      }>
      knowledgeTags: Array<{ id: string; value: string }>
    }>
  }
}

export type IAllKnowledgeSourcesQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IKnowledgeSourceSort> | Types.IKnowledgeSourceSort | null | undefined
  dynamicFilters?:
    | Array<Types.IKnowledgeSourceDynamicFilterItem>
    | Types.IKnowledgeSourceDynamicFilterItem
    | null
    | undefined
}>

export type IAllKnowledgeSourcesQuery = {
  allKnowledgeSources: {
    totalCount: number
    pageCount: number | null
    knowledgeSources: Array<{
      id: string
      title: string
      url: string
      knowledgeAnswers: Array<{
        id: string
        title: string
        value: string
        knowledgeQuestions: Array<{ id: string; value: string }>
      }>
    }>
  }
}

export type IAllKnowledgeTagsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IKnowledgeTagSort> | Types.IKnowledgeTagSort | null | undefined
  dynamicFilters?:
    | Array<Types.IKnowledgeTagDynamicFilterItem>
    | Types.IKnowledgeTagDynamicFilterItem
    | null
    | undefined
}>

export type IAllKnowledgeTagsQuery = {
  allKnowledgeTags: {
    totalCount: number
    pageCount: number | null
    knowledgeTags: Array<{ id: string; value: string }>
  }
}

export type IAllNotesQueryVariables = Exact<{
  userId: string | number
  sorts?: Array<Types.INoteSort> | Types.INoteSort | null | undefined
  dynamicFilters?:
    | Array<Types.INoteDynamicFilterItem>
    | Types.INoteDynamicFilterItem
    | null
    | undefined
}>

export type IAllNotesQuery = {
  allNotes: {
    notes: Array<{
      id: string
      body: string
      kind: Types.NoteKind
      occurredAt: string
      pinnedAt: string | null
      creator: { id: string; fullName: string }
    }>
  }
}

export type IAllNutritionistMembersQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.ICoachAssignmentSort> | Types.ICoachAssignmentSort | null | undefined
  dynamicFilters?:
    | Array<Types.ICoachAssignmentDynamicFilterItem>
    | Types.ICoachAssignmentDynamicFilterItem
    | null
    | undefined
  last?: boolean | null | undefined
}>

export type IAllNutritionistMembersQuery = {
  allCoachAssignments: {
    totalCount: number
    coachAssignments: Array<{
      id: string
      state: Types.CoachAssignmentState
      lastCoachMessageDate: string | null
      canSendEngagementMessage: boolean
      coach: { id: string; fullName: string } | null
      user: {
        id: string
        fullName: string
        email: string
        lastAppointmentDate: string | null
        nextAppointmentDate: string | null
      }
    }>
  }
}

export type IAllOrdersQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IOrderSort> | Types.IOrderSort | null | undefined
  dynamicFilters?:
    | Array<Types.IOrderDynamicFilterItem>
    | Types.IOrderDynamicFilterItem
    | null
    | undefined
}>

export type IAllOrdersQuery = {
  allOrders: {
    totalRecords: number
    orders: Array<{
      __typename: 'Order'
      id: number
      userId: number | null
      product: string
      productType: Types.ShippingOrderProductType
      sensorKind: Types.UserSensorKind | null
      provider: Types.ShippingOrderProvider | null
      quantity: number
      notes: string | null
      createdAt: string
      updatedAt: string
      includable: Types.ShippingOrderIncludable
      user: {
        id: string
        email: string
        firstName: string
        lastName: string
        phoneNumber: string | null
        dateOfBirth: string | null
        sex: string | null
      } | null
      address: {
        __typename: 'Address'
        id: string
        name: string
        street: string
        street2: string
        city: string
        state: Types.AddressState | null
        zipCode: string
        country: string | null
      } | null
      invoice: { stripeId: string } | null
      replacementRequest: { replacementReason: Types.ReplacementRequestReplacementReason } | null
    }>
  }
}

export type IAllOrganizationsQueryVariables = Exact<{
  name?: string | null | undefined
}>

export type IAllOrganizationsQuery = {
  allOrganizations: { organizations: Array<{ id: number; name: string; isNutrisense: boolean }> }
}

export type IAllReplacementReasonsConfigQueryVariables = Exact<{ [key: string]: never }>

export type IAllReplacementReasonsConfigQuery = {
  allReplacementReasonsConfig: {
    replacementReasons: Array<{ key: string; label: string; description: string }>
  }
}

export type IAllReplacementRequestsQueryVariables = Exact<{
  page: number
  perPage: number
  sorts?: Array<Types.IReplacementRequestSort> | Types.IReplacementRequestSort | null | undefined
  dynamicFilters?:
    | Array<Types.IReplacementRequestDynamicFilterItem>
    | Types.IReplacementRequestDynamicFilterItem
    | null
    | undefined
}>

export type IAllReplacementRequestsQuery = {
  allReplacementRequests: {
    totalCount: number
    replacementRequests: Array<{
      __typename: 'ReplacementRequest'
      id: string
      userId: string
      createdById: string | null
      chargeAmount: Types.ReplacementRequestChargeAmount
      createdAt: string
      daysWorn: string | null
      dateFellOff: string | null
      dateNotified: string | null
      howItFellOff: string
      notes: string
      replacementReason: Types.ReplacementRequestReplacementReason
      rgaRequired: Types.ReplacementRequestRgaRequired | null
      wearingPatch: Types.ReplacementRequestWearingPatch
      state: Types.ReplacementRequestState
      sensorKind: Types.UserSensorKind | null
      sensor: { id: string; serialNumber: string; model: string } | null
      createdBy: { email: string } | null
      user: { email: string }
      invoice: { stripeId: string } | null
    }>
  }
}

export type IAllSensorsQueryVariables = Exact<{ [key: string]: never }>

export type IAllSensorsQuery = {
  allSensors: {
    sensors: Array<{
      activationDate: string
      baselineAdjustment: number
      daysRemaining: number
      expirationDate: string
      expirationTime: string
      expired: boolean
      id: string
      model: string
      serialNumber: string
      status: string | null
      lastStatusChange: { status: Types.SensorStatus; createdAt: string; failure: boolean } | null
    }>
  }
}

export type IAllShipmentsQueryVariables = Exact<{
  page: number
  perPage: number
  sorts?: Array<Types.IShipmentSort> | Types.IShipmentSort | null | undefined
  dynamicFilters?:
    | Array<Types.IShipmentDynamicFilterItem>
    | Types.IShipmentDynamicFilterItem
    | null
    | undefined
}>

export type IAllShipmentsQuery = {
  allShipments: {
    totalRecords: number
    shipments: Array<{
      __typename: 'Shipment'
      eta: string | null
      location: string | null
      id: number
      orderId: number
      addressId: number
      status: Types.ShippingShipmentStatus | null
      trackingNumber: string | null
      trackingUrl: string | null
      createdAt: string
      updatedAt: string
      shippedAt: string | null
      deliveredAt: string | null
      canceledAt: string | null
      providerShipmentId: string | null
      providerError: string | null
      providerReceivedAt: string | null
      provider: Types.ShippingOrderProvider | null
      quantity: number
      lotNumber: string | null
      order: {
        id: number
        createdAt: string
        product: string
        productType: Types.ShippingOrderProductType
        sensorKind: Types.UserSensorKind | null
        quantity: number
        invoice: { stripeId: string } | null
        replacementRequest: {
          rgaRequired: Types.ReplacementRequestRgaRequired | null
          providerCompensation: Types.ReplacementRequestProviderCompensation
        } | null
      }
      address: {
        __typename: 'Address'
        id: string
        name: string
        street: string
        street2: string
        city: string
        state: Types.AddressState | null
        zipCode: string
        country: string | null
      }
      user: {
        id: string
        email: string
        firstName: string
        lastName: string
        phoneNumber: string | null
        dateOfBirth: string | null
        sex: string | null
        truepillPatientToken: string | null
      } | null
    }>
  }
}

export type IAllStatsQueryVariables = Exact<{
  filter?: Types.IDateFilter | null | undefined
}>

export type IAllStatsQuery = {
  allStats: {
    statistics: Array<{
      type: string
      title: string
      description: string
      value: number | null
      displayValue: string | null
      valuePrev: number | null
      change: number | null
      range: {
        min: number | null
        max: number | null
        warning: number | null
        danger: number | null
        reverse: boolean | null
      }
      meta: { key: string; section: string }
    }>
  } | null
}

export type IAllSurveyLinksQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.ISurveyLinkSort> | Types.ISurveyLinkSort | null | undefined
  dynamicFilters?:
    | Array<Types.ISurveyLinkDynamicFilterItem>
    | Types.ISurveyLinkDynamicFilterItem
    | null
    | undefined
}>

export type IAllSurveyLinksQuery = {
  allSurveyLinks: {
    totalCount: number
    pageCount: number | null
    surveyLinks: Array<{
      id: string
      state: Types.SurveysUserLinkState
      finished: boolean
      startedAt: string
      finishedAt: string | null
      survey: { kind: Types.SurveysConfigKind; version: string }
      user: { id: string; fullName: string; email: string } | null
    }>
  }
}

export type IAllUserPropertiesQueryVariables = Exact<{ [key: string]: never }>

export type IAllUserPropertiesQuery = {
  allUserProperties: {
    userProperties: Array<{
      id: number
      kind: Types.UserPropertyKind
      value: string
      userId: string
    }>
  }
}

export type IAllUsersAutocompleteQueryVariables = Exact<{
  query: string
}>

export type IAllUsersAutocompleteQuery = {
  allUsersAutocomplete: {
    users: Array<{
      email: string
      fullName: string
      id: string
      timeZone: string
      phoneNumber: string
    }>
  }
}

export type IEhrAppointmentsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IEhrAppointmentSort> | Types.IEhrAppointmentSort | null | undefined
  dynamicFilters?:
    | Array<Types.IEhrAppointmentDynamicFilterItem>
    | Types.IEhrAppointmentDynamicFilterItem
    | null
    | undefined
  filterKind?: Types.FilterAppointmentsKind | null | undefined
  category: Types.EhrAppointmentCategory
  userId?: string | number | null | undefined
  coachUserId?: string | number | null | undefined
}>

export type IEhrAppointmentsQuery = {
  ehrAppointments: {
    totalCount: number
    appointments: Array<{
      __typename: 'HealthPortalEhrAppointment'
      id: string
      getHealthieId: string | null
      category: Types.EhrAppointmentCategory
      kind: Types.EhrAppointmentKind
      meetingAt: string | null
      title: string | null
      getHealthieInstanceKind: Types.EhrGetHealthieInstanceKind
      startUrl: string | null
      joinUrl: string | null
      actualDuration: number | null
      addToGcalLink: string | null
      unauthenticatedIcsLink: string | null
      attendances: Array<{
        __typename: 'HealthPortalEhrAppointmentAttendance'
        id: string
        createdAt: string
        chargeKind: Types.EhrAppointmentAttendanceChargeKind
        state: Types.EhrAppointmentAttendanceState
        agenda: string | null
        user: { id: string; fullName: string; timeZone: string }
        insurancePolicy: {
          lastState: { id: string; kind: Types.UserInsurancePolicyStateKind } | null
        } | null
      }>
      lastState: {
        id: string
        reason: Types.EhrAppointmentReason
        kind: Types.EhrAppointmentStateKind
        createdAt: string
      }
    }>
  }
}

export type IEhrAppointmentQueryVariables = Exact<{
  id: string | number
}>

export type IEhrAppointmentQuery = {
  ehrAppointment: {
    __typename: 'HealthPortalEhrAppointment'
    createdAt: string
    coachingKind: Types.CoachesCoachingKind
    recurring: boolean
    coachRating: number | null
    id: string
    getHealthieId: string | null
    category: Types.EhrAppointmentCategory
    kind: Types.EhrAppointmentKind
    meetingAt: string | null
    title: string | null
    getHealthieInstanceKind: Types.EhrGetHealthieInstanceKind
    startUrl: string | null
    joinUrl: string | null
    actualDuration: number | null
    addToGcalLink: string | null
    unauthenticatedIcsLink: string | null
    providers: Array<{
      id: string
      kind: Types.EhrAppointmentProviderKind
      state: Types.EhrAppointmentProviderState
      coach: { id: string; coachId: string; fullName: string } | null
      doctor: { id: string; firstName: string | null; lastName: string | null } | null
    }>
    states: Array<{
      id: string
      kind: Types.EhrAppointmentStateKind
      reason: Types.EhrAppointmentReason
      createdAt: string
      changedByGetHealthieId: number | null
      changedByHealthieUser: { id: string; fullName: string } | null
    }>
    attendances: Array<{
      __typename: 'HealthPortalEhrAppointmentAttendance'
      id: string
      createdAt: string
      chargeKind: Types.EhrAppointmentAttendanceChargeKind
      state: Types.EhrAppointmentAttendanceState
      agenda: string | null
      invoice: {
        id: string
        stripeId: string
        status: Types.InvoiceStatus
        total: number | null
        paidAt: string | null
      } | null
      paidFeeInvoice: {
        id: string
        stripeId: string
        status: Types.InvoiceStatus
        total: number | null
        paidAt: string | null
      } | null
      paymentIntent: {
        id: string
        stripeId: string
        status: Types.BillingPaymentIntentStatus
        captureMethod: Types.BillingPaymentIntentCaptureMethod
        reason: Types.BillingPaymentIntentReason
        amount: number
        createdAt: string
        cancelledAt: string | null
      } | null
      user: { id: string; fullName: string; timeZone: string }
      insurancePolicy: {
        lastState: { id: string; kind: Types.UserInsurancePolicyStateKind } | null
      } | null
    }>
    lastState: {
      id: string
      reason: Types.EhrAppointmentReason
      kind: Types.EhrAppointmentStateKind
      createdAt: string
    }
  }
}

export type IEhrAppointmentRecurrenceQueryVariables = Exact<{ [key: string]: never }>

export type IEhrAppointmentRecurrenceQuery = {
  ehrAppointmentRecurrence: {
    id: string
    appointmentKind: Types.EhrAppointmentKind | null
    cadence: Types.EhrAppointmentRecurrenceCadence
    days: Array<Types.EhrAppointmentRecurrenceDay>
    numberOfCalls: number
    timeSlots: Array<string> | null
  } | null
}

export type IEhrAppointmentRecurrencesQueryVariables = Exact<{ [key: string]: never }>

export type IEhrAppointmentRecurrencesQuery = {
  ehrAppointmentRecurrences: Array<{
    id: string
    appointmentKind: Types.EhrAppointmentKind | null
    cadence: Types.EhrAppointmentRecurrenceCadence
    days: Array<Types.EhrAppointmentRecurrenceDay>
    numberOfCalls: number
    timeSlots: Array<string> | null
  }>
}

export type INextCoachAppointmentQueryVariables = Exact<{ [key: string]: never }>

export type INextCoachAppointmentQuery = {
  nextCoachAppointment: { id: string; meetingAt: string | null } | null
}

export type INextUserEhrAppointmentQueryVariables = Exact<{
  userId: string | number
}>

export type INextUserEhrAppointmentQuery = {
  nextUserEhrAppointment: { id: string; meetingAt: string | null } | null
}

export type IUserAppointmentsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IEhrAppointmentSort> | Types.IEhrAppointmentSort | null | undefined
  dynamicFilters?:
    | Array<Types.IEhrAppointmentDynamicFilterItem>
    | Types.IEhrAppointmentDynamicFilterItem
    | null
    | undefined
  active?: boolean | null | undefined
  filterKind?: Types.FilterAppointmentsKind | null | undefined
  category: Types.EhrAppointmentCategory
  userId?: string | number | null | undefined
  coachUserId?: string | number | null | undefined
}>

export type IUserAppointmentsQuery = {
  userAppointments: {
    totalCount: number
    appointments: Array<{
      id: string
      getHealthieId: string | null
      category: Types.EhrAppointmentCategory
      kind: Types.EhrAppointmentKind
      coachingKind: Types.CoachesCoachingKind
      recurring: boolean
      meetingAt: string | null
      title: string | null
      getHealthieInstanceKind: Types.EhrGetHealthieInstanceKind
      startUrl: string | null
      joinUrl: string | null
      actualDuration: number | null
      addToGcalLink: string | null
      unauthenticatedIcsLink: string | null
      lastState: {
        id: string
        reason: Types.EhrAppointmentReason
        kind: Types.EhrAppointmentStateKind
        createdAt: string
      }
      attendances: Array<{
        id: string
        chargeKind: Types.EhrAppointmentAttendanceChargeKind
        insurancePolicy: {
          lastState: { id: string; kind: Types.UserInsurancePolicyStateKind } | null
        } | null
      }>
      providers: Array<{
        id: string
        state: Types.EhrAppointmentProviderState
        coach: { id: string; coachId: string; fullName: string } | null
      }>
    }>
  }
}

export type IAuthorizationPoliciesQueryVariables = Exact<{
  userId: string | number
}>

export type IAuthorizationPoliciesQuery = {
  authorizationPolicies: {
    rolePolicies: Array<{
      __typename: 'AuthorizationPolicy'
      name: string
      grants: Array<{ permission: string; resource: string; scope: string | null }>
    }>
    additionalPolicies: Array<{
      __typename: 'UserAuthorizationPolicy'
      id: string
      kind: Types.UserAuthorizationPolicyKind
      createdAt: string
      policy: {
        __typename: 'AuthorizationPolicy'
        name: string
        grants: Array<{ permission: string; resource: string; scope: string | null }>
      }
    }>
  }
}

export type IAuthorizedFeaturesQueryVariables = Exact<{ [key: string]: never }>

export type IAuthorizedFeaturesQuery = {
  authorizedFeatures: { features: Array<Types.FeatureGrant> }
}

export type IBillingAllowancesQueryVariables = Exact<{
  userId: string | number
}>

export type IBillingAllowancesQuery = {
  billingAllowances: {
    allowances: Array<{
      id: string
      kind: Types.BillingAllowanceKind
      total: number
      remaining: number
    }>
  }
}

export type IBillingDashboardAllAccountRequestsQueryVariables = Exact<{
  sorts?: Array<Types.IAccountRequestSort> | Types.IAccountRequestSort | null | undefined
  dynamicFilters?:
    | Array<Types.IAccountRequestDynamicFilterItem>
    | Types.IAccountRequestDynamicFilterItem
    | null
    | undefined
}>

export type IBillingDashboardAllAccountRequestsQuery = {
  allAccountRequests: {
    accountRequests: Array<{
      __typename: 'AccountRequest'
      id: string
      escalatedAt: string | null
      processedAt: string | null
      reviewedAt: string | null
      rejectedAt: string | null
      failedAt: string | null
      priority: Types.OpsAccountRequestPriority
      kind: Types.OpsAccountRequestKind
      errorMessage: string | null
      notes: string | null
      status: Types.OpsAccountRequestStatus
      user: { id: string; fullName: string; email: string }
      escalatedBy: { fullName: string } | null
      processedBy: { fullName: string } | null
      reviewedBy: { fullName: string } | null
      rejectedBy: { fullName: string } | null
      payload:
        | {
            __typename: 'CancelSubscriptionResponsePayload'
            subscriptionId: string
            cancellationType: Types.AccountRequestCancelSubscriptionRequestPayloadCancellationType
            waiveEarlyCancellationFee: boolean
            waiveEarlyCancellationSurcharge: boolean
            cancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason
          }
        | {
            __typename: 'ChangeSubscriptionBillingCycleResponsePayload'
            subscriptionId: string
            billingCycleAnchor: string
          }
        | { __typename: 'CreditResponsePayload'; centsAmount: number }
        | {
            __typename: 'DeleteDuplicateAccountResponsePayload'
            duplicateUserId: string
            creditAmountInCents: number
            replaceWithDuplicateUserEmail: boolean | null
          }
        | { __typename: 'MiscRequestResponsePayload'; requestDetails: string }
        | {
            __typename: 'OneOffAddonResponsePayload'
            product: Types.BillingProduct
            paid: boolean
            discountCentsAmount: number | null
          }
        | {
            __typename: 'PauseSubscriptionResponsePayload'
            subscriptionId: string
            cycleCount: number
            reason: Types.OpsAccountRequestKindsPauseSubscriptionReason
          }
        | {
            __typename: 'RefundResponsePayload'
            chargeId: string
            amountInCents: number
            subscriptionCancellationRequired: boolean
            subscriptionCancellationReason: Types.OpsAccountRequestKindsCancelSubscriptionReason | null
            refundReason: { journey: string; reasonOne: string; reasonTwo: string } | null
          }
        | { __typename: 'UncancelSubscriptionResponsePayload'; subscriptionId: string }
        | {
            __typename: 'UnpauseSubscriptionResponsePayload'
            subscriptionId: string
            resumeDate: string | null
          }
        | {
            __typename: 'UpdateSubscriptionResponsePayload'
            oldProduct: Types.BillingProduct | null
            nextProduct: Types.BillingProduct
          }
        | {
            __typename: 'UpsertLimitedSupportResponsePayload'
            limitedSupportSubscriptionId: string | null
            limitedSupportCancelAt: string
          }
        | Record<PropertyKey, never>
        | null
    }>
  }
}

export type IBillingDashboardAllChargesQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IChargeSort> | Types.IChargeSort | null | undefined
  dynamicFilters?:
    | Array<Types.IChargeDynamicFilterItem>
    | Types.IChargeDynamicFilterItem
    | null
    | undefined
}>

export type IBillingDashboardAllChargesQuery = {
  allCharges: {
    totalCount: number
    pageCount: number | null
    charges: Array<{
      id: string
      stripeId: string
      amount: number
      amountCaptured: number | null
      amountRefunded: number
      paid: boolean
      status: string
      disputeStripeId: string | null
      failureMessage: string | null
      disputed: boolean
      refunded: boolean
      created: string
      refundable: boolean
      invoice: { stripeId: string; subscription: { stripeId: string } | null } | null
    }>
  }
}

export type IBillingDashboardAllInvoicesQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IInvoiceSort> | Types.IInvoiceSort | null | undefined
  dynamicFilters?:
    | Array<Types.IInvoiceDynamicFilterItem>
    | Types.IInvoiceDynamicFilterItem
    | null
    | undefined
}>

export type IBillingDashboardAllInvoicesQuery = {
  allInvoices: {
    totalCount: number
    pageCount: number | null
    invoices: Array<{
      id: string
      stripeId: string
      paidAt: string | null
      receiptNumber: string | null
      downloadUrl: string | null
      created: string
      updatedAt: string
      total: number | null
      subscription: { stripeId: string } | null
    }>
  }
}

export type IAllSubscriptionSchedulesQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  dynamicFilters?:
    | Array<Types.ISubscriptionScheduleDynamicFilterItem>
    | Types.ISubscriptionScheduleDynamicFilterItem
    | null
    | undefined
}>

export type IAllSubscriptionSchedulesQuery = {
  allSubscriptionSchedules: {
    totalCount: number
    pageCount: number | null
    schedules: Array<{
      id: string
      stripeId: string
      currentPhaseStartAt: string | null
      currentPhaseEndAt: string | null
      canceledAt: string | null
      completedAt: string | null
      releasedAt: string | null
      createdAt: string
      updatedAt: string
      status: Types.SubscriptionScheduleStatus
      subscription: { id: string; stripeId: string; status: Types.SubscriptionStatus } | null
      user: { id: string; fullName: string; email: string }
      phases: Array<{
        id: string
        description: string | null
        startAt: string
        endAt: string
        createdAt: string
        updatedAt: string
        billingCycleAnchorChange: Types.SubscriptionSchedulePhaseBillingCycleAnchorChange | null
        price: number
        primaryProduct: { id: string; key: string; title: string } | null
      }>
    }>
  }
}

export type IAllSubscriptionsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.ISubscriptionSort> | Types.ISubscriptionSort | null | undefined
  dynamicFilters?:
    | Array<Types.ISubscriptionDynamicFilterItem>
    | Types.ISubscriptionDynamicFilterItem
    | null
    | undefined
}>

export type IAllSubscriptionsQuery = {
  allSubscriptions: {
    totalCount: number
    pageCount: number | null
    subscriptions: Array<{
      id: string
      stripeId: string
      status: Types.SubscriptionStatus
      stripeStatus: string
      paidMonthsCount: number
      pausedMonthsCount: number
      cancelAt: string | null
      canceledAt: string | null
      createdAt: string
      currentPeriodStartAt: string | null
      currentPeriodEndAt: string | null
      endAt: string | null
      resumesAt: string | null
      startAt: string
      subscribedAt: string
      trialEndAt: string | null
      commitmentEndAt: string | null
      updatedAt: string
      paused: boolean
      effectivelyActive: boolean
      plans: Array<{ nickname: string }>
      primaryProduct: {
        __typename: 'ProductMin'
        id: string
        key: string
        title: string
        uhc: boolean
        bundledPaidCalls: boolean
        recurring: boolean
        ehrSchedulingRule: {
          appointmentKind: Types.EhrAppointmentKind | null
          chargeKind: Types.EhrAppointmentAttendanceChargeKind | null
          count: number | null
          additionalPaidCallsAllowed: boolean
        }
        includedGoods: Array<{
          id: string
          key: string
          title: string
          uhc: boolean
          recurring: boolean
          ehrSchedulingRule: {
            appointmentKind: Types.EhrAppointmentKind | null
            chargeKind: Types.EhrAppointmentAttendanceChargeKind | null
            count: number | null
            additionalPaidCallsAllowed: boolean
          }
        }>
      }
    }>
  }
}

export type ICreateSyncRequestMutationVariables = Exact<{
  userId: string | number
}>

export type ICreateSyncRequestMutation = { createSyncRequest: { success: boolean } }

export type ICalendarQueryVariables = Exact<{
  filter?: Types.IDateFilter | null | undefined
}>

export type ICalendarQuery = { calendar: { dates: Array<{ date: string; score: number | null }> } }

export type IAllChatConversationEventsQueryVariables = Exact<{
  conversationId: string | number
  sorts?:
    | Array<Types.IChatConversationEventSort>
    | Types.IChatConversationEventSort
    | null
    | undefined
  page?: number | null | undefined
  perPage?: number | null | undefined
}>

export type IAllChatConversationEventsQuery = {
  allChatConversationEvents: {
    totalCount: number
    pageCount: number | null
    chatConversationEvents: Array<{
      id: string
      kind: Types.ChatConversationEventKind
      occurredAt: string
      snoozedUntil: string | null
      message: {
        id: string
        value: string
        sentAt: string
        senderKind: Types.ChatConversationMessageSenderKind
        sender: {
          id: string
          fullName: string
          avatar: string | null
          coachProfile: { photo: string | null } | null
        } | null
      } | null
      note: {
        id: string
        value: string
        createdAt: string
        createdBy: { id: string; fullName: string; avatar: string | null }
      } | null
      performedBy: { id: string; fullName: string } | null
      assignedTo: { id: string; fullName: string } | null
    }>
  }
}

export type IAllChatConversationsQueryVariables = Exact<{
  kinds?: Array<Types.ChatConversationKind> | Types.ChatConversationKind | null | undefined
  states?: Array<Types.ChatConversationState> | Types.ChatConversationState | null | undefined
  sorts?: Array<Types.IChatConversationSort> | Types.IChatConversationSort | null | undefined
  forCoach?: boolean | null | undefined
  active?: boolean | null | undefined
  userIds?: Array<string | number> | string | number | null | undefined
  page?: number | null | undefined
  perPage?: number | null | undefined
}>

export type IAllChatConversationsQuery = {
  allChatConversations: {
    totalCount: number
    chatConversations: Array<{
      id: string
      kind: Types.ChatConversationKind
      state: Types.ChatConversationState
      read: boolean
      intercomCreatedAt: string
      lastMessage: { id: string; value: string; sentAt: string } | null
      lastNote: { id: string; value: string; createdAt: string } | null
      user: { id: string; fullName: string }
    }>
  }
}

export type IChatConversationQueryVariables = Exact<{
  id: string | number
}>

export type IChatConversationQuery = {
  chatConversation: {
    __typename: 'ChatConversation'
    id: string
    kind: Types.ChatConversationKind
    state: Types.ChatConversationState
    read: boolean
    candidateRead: boolean
    intercomCreatedAt: string
    intercomBackfillState: Types.ChatConversationIntercomBackfillState | null
    lastMessage: {
      id: string
      value: string
      sender: { id: string; fullName: string } | null
    } | null
    user: { id: string; fullName: string }
  }
}

export type IChatbotMessageQueryVariables = Exact<{
  id: string | number
}>

export type IChatbotMessageQuery = {
  chatbotMessage: {
    id: string
    content: string
    userMessage: {
      id: string
      content: string
      knowledgeQuestions: Array<{
        __typename: 'KnowledgeQuestion'
        id: string
        value: string
        knowledgeAnswers: Array<{
          id: string
          title: string
          value: string
          knowledgeSources: Array<{ id: string; title: string; url: string }>
        }>
        knowledgeTags: Array<{ id: string; value: string }>
      }>
    } | null
  }
}

export type IAllChatbotMessageReportsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?:
    | Array<Types.IChatbotMessageReportSort>
    | Types.IChatbotMessageReportSort
    | null
    | undefined
  dynamicFilters?:
    | Array<Types.IChatbotMessageReportDynamicFilterItem>
    | Types.IChatbotMessageReportDynamicFilterItem
    | null
    | undefined
}>

export type IAllChatbotMessageReportsQuery = {
  allChatbotMessageReports: {
    totalCount: number
    pageCount: number | null
    reports: Array<{
      __typename: 'ChatbotMessageReport'
      id: string
      reason: Types.ChatbotMessageReportReason
      status: Types.ChatbotMessageReportStatus
      note: string | null
      resolutionNote: string | null
      resolutionRef: string | null
      resolvedAt: string | null
      createdAt: string
      chatbotMessageId: string
      userId: string
      resolvedById: string | null
      botMessageContent: string | null
    }>
  }
}

export type IClientConfigQueryVariables = Exact<{ [key: string]: never }>

export type IClientConfigQuery = {
  clientConfig: {
    sensorSettings: { baselineAdjustmentOptions: Array<{ text: string; value: number }> }
    score: { warning: number; danger: number; max: number }
    insights: {
      statistics: Array<{
        name: string
        metric: {
          precision: number
          units: string
          ranges: Array<{ from: number | null; to: number | null; type: string; rating: string }>
        }
        imperial: {
          precision: number
          units: string
          ranges: Array<{ from: number | null; to: number | null; type: string; rating: string }>
        }
      }>
    }
    healthSettings: {
      glucoseLowOptions: Array<{ text: string; value: number }>
      glucoseHighOptions: Array<{ text: string; value: number }>
      ketoneLowOptions: Array<{ text: string; value: number }>
      ketoneHighOptions: Array<{ text: string; value: number }>
      macroGoalSettings: {
        caloriesMax: number
        proteinMax: number
        carbsMax: number
        fatMax: number
      }
      unitSystemOptions: Array<{ text: string; value: string }>
      dashboardGraphOptions: Array<{ text: string; value: string }>
    }
    journal: {
      range: { min: number; max: number }
      measurementTypes: Array<{ type: string; reverse: boolean | null }>
    }
    chatbot: { responseTimeoutInSeconds: number }
    goalOptions: Array<{ text: string; value: Types.UserGoalKind }>
    goalMetricOptions: Array<{ text: string; value: Types.UserGoalMetricKind }>
    healthMetrics: Array<{
      key: Types.HealthMetricsParam
      label: string
      unit: string | null
      kind: Types.HealthMetricsKind
    }>
    tickets: {
      reasonDefs: Array<{ key: Types.TicketReason; kind: Types.TicketKind; title: string }>
    }
    actionGoalOptions: Array<{
      kind: Types.ActionGoalKind
      title: string
      description: string
      icon: Types.UiIcon
      category: Types.ActionGoalCategory
      metricOptions: Array<{
        kind: Types.ActionGoalMetricKind
        description: string
        supportsMetricValue: boolean
        valuePrefix: string | null
        infoText: string | null
        metric: { min: number; max: number; increment: number; units: string | null } | null
        imperial: { min: number; max: number; increment: number; units: string | null } | null
      }>
    }>
    appointmentKinds: Array<{
      duration: string
      key: Types.EhrAppointmentKind
      title: string
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    }>
  }
}

export type ICoachBillingInvoiceItemKindsQueryVariables = Exact<{ [key: string]: never }>

export type ICoachBillingInvoiceItemKindsQuery = {
  coachBillingInvoiceItemKinds: {
    kinds: Array<{
      key: Types.CoachesBillingInvoiceItemKind
      name: string
      admin: boolean
      billable: boolean
      selfReportable: boolean
    }>
  }
}

export type ICoachBillingInvoiceItemTotalsQueryVariables = Exact<{
  periodStart: string
  periodEnd: string
  coachId?: string | number | null | undefined
}>

export type ICoachBillingInvoiceItemTotalsQuery = {
  coachBillingInvoiceItemTotals: {
    total: number
    adminTotal: number
    billableTotal: number
    items: Array<{
      kind: Types.CoachesBillingInvoiceItemKind
      total: number
      count: number
      quantity: number
    }>
  }
}

export type ICoachBillingInvoiceItemsQueryVariables = Exact<{
  coachId: string | number
  periodStart: string
  periodEnd: string
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?:
    | Array<Types.ICoachBillingInvoiceItemSort>
    | Types.ICoachBillingInvoiceItemSort
    | null
    | undefined
  dynamicFilters?:
    | Array<Types.ICoachBillingInvoiceItemDynamicFilterItem>
    | Types.ICoachBillingInvoiceItemDynamicFilterItem
    | null
    | undefined
}>

export type ICoachBillingInvoiceItemsQuery = {
  coachBillingInvoiceItems: {
    totalCount: number
    items: Array<{
      __typename: 'CoachBillingInvoiceItem'
      itemKey: string
      kind: Types.CoachesBillingInvoiceItemKind
      date: string
      description: string
      quantity: number
      rate: number
      total: number
      createdAt: string
      billableItem: { stateSnapshotUserId: string } | null
    }>
  }
}

export type ICoachBillingInvoiceReviewsQueryVariables = Exact<{
  coachId: string | number
  periodStart: string
  periodEnd: string
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?:
    | Array<Types.ICoachBillingInvoiceReviewSort>
    | Types.ICoachBillingInvoiceReviewSort
    | null
    | undefined
  dynamicFilters?:
    | Array<Types.ICoachBillingInvoiceReviewDynamicFilterItem>
    | Types.ICoachBillingInvoiceReviewDynamicFilterItem
    | null
    | undefined
}>

export type ICoachBillingInvoiceReviewsQuery = {
  coachBillingInvoiceReviews: {
    totalCount: number
    reviews: Array<{
      __typename: 'CoachBillingInvoiceReview'
      id: string
      periodStart: string
      periodEnd: string
      kind: Types.CoachesBillingInvoiceReviewKind
      reviewedAt: string | null
      reviewedBy: { id: string; email: string; fullName: string }
    }>
  }
}

export type ICoachBillingInvoicesQueryVariables = Exact<{
  coachId: string | number
  periodStart: string
  periodEnd: string
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.ICoachBillingInvoiceSort> | Types.ICoachBillingInvoiceSort | null | undefined
  dynamicFilters?:
    | Array<Types.ICoachBillingInvoiceDynamicFilterItem>
    | Types.ICoachBillingInvoiceDynamicFilterItem
    | null
    | undefined
}>

export type ICoachBillingInvoicesQuery = {
  coachBillingInvoices: {
    totalCount: number
    invoices: Array<{
      __typename: 'CoachBillingInvoice'
      id: string
      periodStart: string
      periodEnd: string
      number: string
      total: number
      adminTotal: number
      billableTotal: number
      submittedAt: string
      sentAt: string | null
    }>
  }
}

export type ICoachBillingRatesQueryVariables = Exact<{
  coachId: string | number
}>

export type ICoachBillingRatesQuery = {
  coachBillingRates: {
    __typename: 'CoachBillingRates'
    coachId: string
    completedCallRate: number
    incompleteCallRate: number
    asyncSupportRate: number
    mealPlanRate: number
    supplementReviewRate: number
    memberReferralBonusRate: number
    adminTimeRate: number
  }
}

export type ICoachSharedAssetsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.ICoachSharedAssetSort> | Types.ICoachSharedAssetSort | null | undefined
  dynamicFilters?:
    | Array<Types.ICoachSharedAssetDynamicFilterItem>
    | Types.ICoachSharedAssetDynamicFilterItem
    | null
    | undefined
  tags?: Array<string> | string | null | undefined
}>

export type ICoachSharedAssetsQuery = {
  coachSharedAssets: {
    totalCount: number
    pageCount: number | null
    coachSharedAssets: Array<{
      __typename: 'CoachSharedAsset'
      id: string
      title: string
      description: string | null
      tags: Array<string>
      category: Types.CoachesSharedAssetCategory
      visibility: Types.CoachesSharedAssetVisibility
      permanentUrl: string
      fileName: string
      fileType: string
      createdAt: string
      createdBy: { id: string }
    }>
  }
}

export type ICoachReviewProfileQueryVariables = Exact<{
  userId: string | number
}>

export type ICoachReviewProfileQuery = {
  user: {
    id: string
    firstName: string
    lastName: string
    fullName: string
    email: string
    avatar: string | null
    coachProfile: {
      registrationStatus: Types.EhrCoachRegistrationStatus
      updatedAt: string
      credentials: string | null
      cdrCnsNumber: string | null
      cdrCnsExpirationDate: string | null
      cdrCnsCard: string | null
      photo: string | null
      gender: Types.EhrCoachGender | null
      stateOfResidence: string | null
      ethnicity: string | null
      additionalLanguages: string | null
      bio: string | null
      stateLicences: Array<string>
      stateLicenceDetails: Array<{
        state: Types.AddressState
        expirationDate: string
        expirationReminderEnabled: boolean
        document: string | null
      }>
      specialties: Array<{ key: Types.EhrCoachSpecialty; name: string }>
    } | null
  }
}

export type ICurrentAdminQueryVariables = Exact<{ [key: string]: never }>

export type ICurrentAdminQuery = {
  currentAdmin: {
    id: string
    firstName: string
    lastName: string
    fullName: string
    email: string
    avatar: string | null
    role: Types.UserRole
    coachProfile: { id: string } | null
    activeCoachingKinds: Array<{ key: Types.CoachesCoachingKind; coachTitle: string }>
  } | null
}

export type ICurrentUserQueryVariables = Exact<{ [key: string]: never }>

export type ICurrentUserQuery = {
  currentUser: {
    __typename: 'User'
    createdAt: string
    email: string
    timeZone: string
    avatar: string | null
    firstName: string
    fullName: string
    id: string
    lastName: string
    role: Types.UserRole
    sex: string | null
    dateOfBirth: string | null
    phoneNumber: string | null
    lastAppVersion: string | null
    lastAppPlatform: string | null
    stripeId: string | null
    berryStreetGetHealthieId: number | null
    kustomerId: string | null
    klaviyoId: string | null
    stripeCreditBalance: number
    kind: Types.UserKind
    age: string | null
    canViewGlucoseGraph: boolean
    isSteloProvisionedUser: boolean
    address: {
      __typename: 'Address'
      id: string
      name: string
      street: string
      street2: string
      city: string
      state: Types.AddressState | null
      zipCode: string
      country: string | null
    } | null
    sensorInfo: { totalCount: number; replacementRequestsCount: number } | null
    settings: {
      id: string
      appVersionReminder: boolean
      dashboardGraph: string
      dexcomSync: boolean
      displayActivityScore: boolean
      displayDailyScore: boolean
      displayMealScore: boolean
      fastingEnd: number
      fastingStart: number
      glucoseHighThreshold: number
      glucoseLowThreshold: number
      googleFitSync: boolean
      healthKitSync: boolean
      ketoMojoSync: boolean
      ketoneHighThreshold: number
      ketoneLowThreshold: number
      reminders: boolean
      showNetCarbs: boolean
      unitSystem: string
      integrationsSyncSettings: {
        lastSyncedHealth: string | null
        lastSyncedDexcom: string | null
        lastSyncedKetoMojo: string | null
      }
      macroGoalsDaily: {
        calories: number
        carbs: number
        fat: number
        netCarbs: number | null
        protein: number
      }
    }
    sensor: {
      activationDate: string
      baselineAdjustment: number
      daysRemaining: number
      expirationDate: string
      expirationTime: string
      expired: boolean
      model: string
      serialNumber: string
      status: string | null
    } | null
    organization: { id: number; name: string }
    ongoingDietitianSubscription: {
      id: string
      dietitianAddOn: boolean
      stripeStatus: string
      status: Types.SubscriptionStatus
      paidMonthsCount: number
      cancelAt: string | null
      startAt: string
      paused: boolean
      resumesAt: string | null
      commitmentEndAt: string | null
      primaryProduct: { key: string; title: string }
    } | null
    ongoingCoreSubscription: {
      id: string
      paidMonthsCount: number
      paused: boolean
      cancelAt: string | null
      commitmentEndAt: string | null
      plans: Array<{ id: string; nickname: string }>
      primaryProduct: { key: string; title: string }
    } | null
    lastDietitianSubscription: {
      stripeStatus: string
      status: Types.SubscriptionStatus
      paused: boolean
      resumesAt: string | null
    } | null
    lastCoreSubscription: {
      id: string
      stripeStatus: string
      status: Types.SubscriptionStatus
      latestInvoice: { latestCharge: { status: string; created: string } | null } | null
    } | null
    lastAsyncChatAssignment: {
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    } | null
    lastVideoChatAssignment: {
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    } | null
    coachAssignments: Array<{
      id: string
      last: boolean
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string } | null
      coachingKind: { key: Types.CoachesCoachingKind }
    }> | null
    fulfillmentConfiguration: { sensorKind: Types.UserSensorKind }
    uxSensorMode: { syncDescription: string }
    dexcomConnection: {
      status: Types.DexcomConnectionStatus
      accessToken: string
      dexcomUserId: string | null
      createdAt: string
      lastSyncedAt: string | null
    } | null
    dexcomSteloConnection: {
      status: Types.DexcomConnectionStatus
      accessToken: string
      dexcomUserId: string | null
      createdAt: string
      lastSyncedAt: string | null
    } | null
    mntChatConversation: { id: string } | null
    stressChatConversation: { id: string } | null
    primaryGoal: { title: string; kind: Types.UserGoalKind; description: string | null } | null
    goalMetrics: Array<{
      primary: boolean
      kind: Types.UserGoalMetricKind
      lowThresholdValue: number | null
      highThresholdValue: number | null
      section: string
      statKey: string
    }>
    coachProfile: {
      stateLicences: Array<string>
      premium: boolean
      outOfOffice: boolean
      registrationStatus: Types.EhrCoachRegistrationStatus
      pendingRegisterNote: string | null
      credentials: string | null
      bio: string | null
      stressBio: string | null
      gender: Types.EhrCoachGender | null
      stateOfResidence: string | null
      ethnicity: string | null
      additionalLanguages: string | null
      cdrCnsNumber: string | null
      cdrCnsExpirationDate: string | null
      cdrCnsCard: string | null
      photo: string | null
      stateLicenceDetails: Array<{
        state: Types.AddressState
        expirationDate: string
        expirationReminderEnabled: boolean
        document: string | null
      }>
      specialties: Array<{ key: Types.EhrCoachSpecialty; name: string }>
    } | null
    referralPartner: {
      key: Types.UserReferralPartner
      logoUrl: string | null
      requiresProtocol: boolean
      name: string
    }
    ongoingSubscriptions: Array<{ primaryProduct: { key: string; title: string } }>
    paymentMethod: { stripeId: string } | null
    uhcMember: { id: string; uhcId: string } | null
    primaryCoachingKind: {
      __typename: 'CoachesCoachingKindDef'
      key: Types.CoachesCoachingKind
      coachTitle: string
      shortCoachTitle: string
      hubTitle: string
      shortHubTitle: string
      serviceTitle: string
      clinical: boolean
      insuranceReimbursable: boolean
      primary: boolean
    }
    onboardingExperience: {
      kind: Types.UserPropertyOnboardingExperienceKind
      participating: boolean
      baselineWeight: number | null
      desiredWeight: number | null
      fourWeekWeight: number | null
      dateToReachDesiredWeight: string | null
      realisticWeightLoss: boolean | null
      desiredWeightLossAmount: number | null
      weightLossPace: number | null
    } | null
  } | null
}

export type IDexcomConnectionStatusQueryVariables = Exact<{
  userId: string | number
}>

export type IDexcomConnectionStatusQuery = {
  dexcomConnectionStatus: {
    status: Types.DexcomConnectionStatus
    kind: Types.DexcomConnectionKind
    lastSyncedAt: string | null
  } | null
}

export type IDistinctUserPropertyValuesQueryVariables = Exact<{
  value: string
  kind: string
  limit?: number | null | undefined
}>

export type IDistinctUserPropertyValuesQuery = { distinctUserPropertyValues: Array<string> }

export type IEligibleProductsQueryVariables = Exact<{
  userId: string | number
  products: Array<Types.BillingProduct> | Types.BillingProduct
}>

export type IEligibleProductsQuery = {
  eligibleProducts: { products: Array<{ id: string; key: string; title: string; price: number }> }
}

export type IEligibleUpdateProductsQueryVariables = Exact<{
  userId: string | number
}>

export type IEligibleUpdateProductsQuery = {
  eligibleUpdateProducts: {
    eligibleUpdateProducts: Array<{
      product: { key: string; title: string }
      feeRules: Array<{ fee: number; paidCyclesCount: number }> | null
    }>
  }
}

export type IFinancialsAllChargesQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IChargeSort> | Types.IChargeSort | null | undefined
  dynamicFilters?:
    | Array<Types.IChargeDynamicFilterItem>
    | Types.IChargeDynamicFilterItem
    | null
    | undefined
}>

export type IFinancialsAllChargesQuery = {
  allCharges: {
    totalCount: number
    pageCount: number | null
    charges: Array<{
      id: string
      stripeId: string
      amount: number
      amountCaptured: number | null
      amountRefunded: number
      paid: boolean
      status: string
      disputeStripeId: string | null
      failureMessage: string | null
      disputed: boolean
      refunded: boolean
      created: string
      refundable: boolean
      invoice: { stripeId: string; subscription: { stripeId: string } | null } | null
      user: { id: string; fullName: string; email: string; phoneNumber: string | null }
    }>
  }
}

export type IFinancialsAllInvoicesQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IInvoiceSort> | Types.IInvoiceSort | null | undefined
  dynamicFilters?:
    | Array<Types.IInvoiceDynamicFilterItem>
    | Types.IInvoiceDynamicFilterItem
    | null
    | undefined
}>

export type IFinancialsAllInvoicesQuery = {
  allInvoices: {
    totalCount: number
    pageCount: number | null
    invoices: Array<{
      id: string
      stripeId: string
      paidAt: string | null
      receiptNumber: string | null
      downloadUrl: string | null
      created: string
      total: number | null
      subscription: { stripeId: string } | null
      user: { id: string; fullName: string; email: string; stripeId: string | null }
    }>
  }
}

export type IFinancialsAllSubscriptionsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.ISubscriptionSort> | Types.ISubscriptionSort | null | undefined
  dynamicFilters?:
    | Array<Types.ISubscriptionDynamicFilterItem>
    | Types.ISubscriptionDynamicFilterItem
    | null
    | undefined
}>

export type IFinancialsAllSubscriptionsQuery = {
  allSubscriptions: {
    totalCount: number
    pageCount: number | null
    subscriptions: Array<{
      id: string
      stripeId: string
      stripeStatus: string
      paidMonthsCount: number
      pausedMonthsCount: number
      cancelAt: string | null
      canceledAt: string | null
      createdAt: string
      currentPeriodEndAt: string | null
      endAt: string | null
      resumesAt: string | null
      startAt: string
      subscribedAt: string
      trialEndAt: string | null
      updatedAt: string
      paused: boolean
      plans: Array<{ nickname: string }>
      user: { id: string; fullName: string; email: string }
    }>
  }
}

export type IFormulaQueryVariables = Exact<{
  operation: string
}>

export type IFormulaQuery = {
  formula: {
    operation: string
    className: string
    title: string
    description: string | null
    inputs: Array<{
      key: string
      graphqlField: string
      graphqlType: string
      required: boolean
      default: string | null
      options: Array<{ label: string; value: string }> | null
    }>
  }
}

export type ICreateHealthMetricMutationVariables = Exact<{
  date: string
  value: number
  kind: Types.HealthDataMetricBiomarker
}>

export type ICreateHealthMetricMutation = {
  createHealthMetric: {
    id: string
    date: string
    value: number
    kind: Types.HealthDataMetricBiomarker
  }
}

export type IDeleteHealthMetricMutationVariables = Exact<{
  id: string | number
}>

export type IDeleteHealthMetricMutation = { deleteHealthMetric: { success: boolean } }

export type IHealthMetricsQueryVariables = Exact<{ [key: string]: never }>

export type IHealthMetricsQuery = {
  healthMetrics: {
    healthMetrics: Array<{
      kind: Types.HealthDataMetricBiomarker
      title: string
      unit: string | null
      data: Array<{ id: string; value: number; date: string }>
    }>
  }
}

export type IUpdateHealthMetricMutationVariables = Exact<{
  id: string | number
  date: string
  value: number
}>

export type IUpdateHealthMetricMutation = {
  updateHealthMetric: {
    id: string
    date: string
    value: number
    kind: Types.HealthDataMetricBiomarker
  }
}

export type IAllNutritionistsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IUserSort> | Types.IUserSort | null | undefined
  dynamicFilters?:
    | Array<Types.IUserDynamicFilterItem>
    | Types.IUserDynamicFilterItem
    | null
    | undefined
}>

export type IAllNutritionistsQuery = {
  allUsers: {
    totalCount: number
    users: Array<{
      __typename: 'User'
      id: string
      fullName: string
      role: Types.UserRole
      email: string
      coachProfile: {
        bio: string | null
        stressBio: string | null
        getHealthieId: string | null
        startDate: string | null
        endDate: string | null
        schedulingPriority: number | null
        stateLicences: Array<string>
        active: boolean
        outOfOffice: boolean
        premium: boolean
        updatedAt: string
        priorityChangedAt: string | null
        credentials: string | null
        cdrCnsNumber: string | null
        cdrCnsExpirationDate: string | null
        gender: Types.EhrCoachGender | null
        stateOfResidence: string | null
        ethnicity: string | null
        additionalLanguages: string | null
        licenceMode: Types.EhrCoachLicenceMode | null
        stressLicenceMode: Types.EhrCoachLicenceMode | null
        unlimitedChatSupport: boolean
        registrationStatus: Types.EhrCoachRegistrationStatus
        manager: { id: string; fullName: string } | null
        specialties: Array<{ name: string }>
      } | null
      activeCoachingKinds: Array<{ key: Types.CoachesCoachingKind; coachTitle: string }>
    }>
  }
}

export type ICoachAvailabilitySnapshotQueryVariables = Exact<{
  snapshotKey: string
}>

export type ICoachAvailabilitySnapshotQuery = {
  coachAvailabilitySnapshot: { snapshotKey: string; data: any }
}

export type IListCoachAvailabilitySnapshotsQueryVariables = Exact<{ [key: string]: never }>

export type IListCoachAvailabilitySnapshotsQuery = {
  listCoachAvailabilitySnapshots: { snapshotKeys: Array<string> }
}

export type IOrderQueryVariables = Exact<{
  id: number
}>

export type IOrderQuery = {
  order: {
    id: number
    quantity: number
    createdAt: string
    invoice: { stripeId: string } | null
    address: {
      __typename: 'Address'
      id: string
      name: string
      street: string
      street2: string
      city: string
      state: Types.AddressState | null
      zipCode: string
      country: string | null
    } | null
  }
}

export type IOrganizationMembersAllUsersQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IUserSort> | Types.IUserSort | null | undefined
  dynamicFilters?:
    | Array<Types.IUserDynamicFilterItem>
    | Types.IUserDynamicFilterItem
    | null
    | undefined
}>

export type IOrganizationMembersAllUsersQuery = {
  allUsers: {
    totalCount: number
    users: Array<{
      id: string
      fullName: string
      email: string
      createdAt: string
      sensorInfo: { lastSensor: { status: string | null; activationDate: string } | null } | null
      ongoingCoreSubscription: { primaryProduct: { title: string } } | null
    }>
  }
}

export type IPreviewCoachConversationMessageQueryVariables = Exact<{
  userId: string | number
  messageTemplateId: string | number
}>

export type IPreviewCoachConversationMessageQuery = {
  previewCoachConversationMessage: { value: string }
}

export type IResetPasswordRequestQueryVariables = Exact<{
  email: string
}>

export type IResetPasswordRequestQuery = { resetPasswordRequest: { success: boolean } }

export type ISupportAllUsersQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.IUserSort> | Types.IUserSort | null | undefined
  dynamicFilters?:
    | Array<Types.IUserDynamicFilterItem>
    | Types.IUserDynamicFilterItem
    | null
    | undefined
}>

export type ISupportAllUsersQuery = {
  allUsers: { totalCount: number; users: Array<{ id: string; fullName: string; email: string }> }
}

export type IAllTicketCommentsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  ticketId: string | number
  sorts?: Array<Types.ITicketCommentSort> | Types.ITicketCommentSort | null | undefined
  dynamicFilters?:
    | Array<Types.ITicketCommentDynamicFilterItem>
    | Types.ITicketCommentDynamicFilterItem
    | null
    | undefined
}>

export type IAllTicketCommentsQuery = {
  allTicketComments: {
    totalCount: number
    pageCount: number | null
    ticketComments: Array<{
      ticketId: string
      id: string
      body: string
      createdAt: string
      createdBy: {
        id: string
        fullName: string
        email: string
        phoneNumber: string
        timeZone: string
      }
    }>
  }
}

export type IAllTicketsQueryVariables = Exact<{
  page?: number | null | undefined
  perPage?: number | null | undefined
  sorts?: Array<Types.ITicketSort> | Types.ITicketSort | null | undefined
  dynamicFilters?:
    | Array<Types.ITicketDynamicFilterItem>
    | Types.ITicketDynamicFilterItem
    | null
    | undefined
}>

export type IAllTicketsQuery = {
  allTickets: {
    totalCount: number
    pageCount: number | null
    tickets: Array<{
      __typename: 'Ticket'
      id: string
      description: string
      externalLink: string | null
      kind: Types.TicketKind
      reason: Types.TicketReason | null
      status: Types.TicketStatus
      priority: Types.TicketPriority
      createdAt: string
      createdBy: { id: string; email: string; fullName: string }
      user: { id: string; email: string; fullName: string }
      assignedTo: { id: string; email: string; fullName: string } | null
    }>
  }
}

export type IUiStatesQueryVariables = Exact<{ [key: string]: never }>

export type IUiStatesQuery = { uiStates: Array<{ name: Types.UiStateNames; value: boolean }> }

export type IUserQueryVariables = Exact<{
  id: string | number
}>

export type IUserQuery = {
  user: {
    __typename: 'User'
    createdAt: string
    email: string
    timeZone: string
    avatar: string | null
    firstName: string
    fullName: string
    id: string
    lastName: string
    role: Types.UserRole
    sex: string | null
    dateOfBirth: string | null
    phoneNumber: string | null
    lastAppVersion: string | null
    lastAppPlatform: string | null
    stripeId: string | null
    berryStreetGetHealthieId: number | null
    kustomerId: string | null
    klaviyoId: string | null
    stripeCreditBalance: number
    kind: Types.UserKind
    age: string | null
    canViewGlucoseGraph: boolean
    isSteloProvisionedUser: boolean
    address: {
      __typename: 'Address'
      name: string
      street: string
      street2: string
      city: string
      state: Types.AddressState | null
      zipCode: string
      id: string
      country: string | null
    } | null
    sensorInfo: { totalCount: number; replacementRequestsCount: number } | null
    settings: {
      id: string
      appVersionReminder: boolean
      dashboardGraph: string
      dexcomSync: boolean
      displayActivityScore: boolean
      displayDailyScore: boolean
      displayMealScore: boolean
      fastingEnd: number
      fastingStart: number
      glucoseHighThreshold: number
      glucoseLowThreshold: number
      googleFitSync: boolean
      healthKitSync: boolean
      ketoMojoSync: boolean
      ketoneHighThreshold: number
      ketoneLowThreshold: number
      reminders: boolean
      showNetCarbs: boolean
      unitSystem: string
      integrationsSyncSettings: {
        lastSyncedHealth: string | null
        lastSyncedDexcom: string | null
        lastSyncedKetoMojo: string | null
      }
      macroGoalsDaily: {
        calories: number
        carbs: number
        fat: number
        netCarbs: number | null
        protein: number
      }
    }
    sensor: {
      activationDate: string
      baselineAdjustment: number
      daysRemaining: number
      expirationDate: string
      expirationTime: string
      expired: boolean
      model: string
      serialNumber: string
      status: string | null
    } | null
    organization: { id: number; name: string }
    ongoingDietitianSubscription: {
      id: string
      dietitianAddOn: boolean
      stripeStatus: string
      status: Types.SubscriptionStatus
      paidMonthsCount: number
      cancelAt: string | null
      startAt: string
      paused: boolean
      resumesAt: string | null
      commitmentEndAt: string | null
      primaryProduct: { key: string; title: string }
    } | null
    ongoingCoreSubscription: {
      id: string
      paidMonthsCount: number
      paused: boolean
      cancelAt: string | null
      commitmentEndAt: string | null
      plans: Array<{ id: string; nickname: string }>
      primaryProduct: { key: string; title: string }
    } | null
    lastDietitianSubscription: {
      stripeStatus: string
      status: Types.SubscriptionStatus
      paused: boolean
      resumesAt: string | null
    } | null
    lastCoreSubscription: {
      id: string
      stripeStatus: string
      status: Types.SubscriptionStatus
      latestInvoice: { latestCharge: { status: string; created: string } | null } | null
    } | null
    lastAsyncChatAssignment: {
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    } | null
    lastVideoChatAssignment: {
      __typename: 'CoachAssignment'
      id: string
      state: Types.CoachAssignmentState
      last: boolean
      createdAt: string
      assignedAt: string | null
      deactivatedAt: string | null
      kind: Types.CoachAssignmentKind | null
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string; fullName: string } | null
      ehrAppointment: { meetingAt: string | null } | null
      coachingKind: {
        __typename: 'CoachesCoachingKindDef'
        key: Types.CoachesCoachingKind
        coachTitle: string
        shortCoachTitle: string
        hubTitle: string
        shortHubTitle: string
        serviceTitle: string
        clinical: boolean
        insuranceReimbursable: boolean
        primary: boolean
      }
    } | null
    coachAssignments: Array<{
      id: string
      last: boolean
      supportType: Types.CoachAssignmentSupportType
      coach: { id: string } | null
      coachingKind: { key: Types.CoachesCoachingKind }
    }> | null
    fulfillmentConfiguration: { sensorKind: Types.UserSensorKind }
    uxSensorMode: { syncDescription: string }
    dexcomConnection: {
      status: Types.DexcomConnectionStatus
      accessToken: string
      dexcomUserId: string | null
      createdAt: string
      lastSyncedAt: string | null
    } | null
    dexcomSteloConnection: {
      status: Types.DexcomConnectionStatus
      accessToken: string
      dexcomUserId: string | null
      createdAt: string
      lastSyncedAt: string | null
    } | null
    mntChatConversation: { id: string } | null
    stressChatConversation: { id: string } | null
    primaryGoal: { title: string; kind: Types.UserGoalKind; description: string | null } | null
    goalMetrics: Array<{
      primary: boolean
      kind: Types.UserGoalMetricKind
      lowThresholdValue: number | null
      highThresholdValue: number | null
      section: string
      statKey: string
    }>
    coachProfile: {
      stateLicences: Array<string>
      premium: boolean
      outOfOffice: boolean
      registrationStatus: Types.EhrCoachRegistrationStatus
      pendingRegisterNote: string | null
      credentials: string | null
      bio: string | null
      stressBio: string | null
      gender: Types.EhrCoachGender | null
      stateOfResidence: string | null
      ethnicity: string | null
      additionalLanguages: string | null
      cdrCnsNumber: string | null
      cdrCnsExpirationDate: string | null
      cdrCnsCard: string | null
      photo: string | null
      stateLicenceDetails: Array<{
        state: Types.AddressState
        expirationDate: string
        expirationReminderEnabled: boolean
        document: string | null
      }>
      specialties: Array<{ key: Types.EhrCoachSpecialty; name: string }>
    } | null
    referralPartner: {
      key: Types.UserReferralPartner
      logoUrl: string | null
      requiresProtocol: boolean
      name: string
    }
    ongoingSubscriptions: Array<{ primaryProduct: { key: string; title: string } }>
    paymentMethod: { stripeId: string } | null
    uhcMember: { id: string; uhcId: string } | null
    primaryCoachingKind: {
      __typename: 'CoachesCoachingKindDef'
      key: Types.CoachesCoachingKind
      coachTitle: string
      shortCoachTitle: string
      hubTitle: string
      shortHubTitle: string
      serviceTitle: string
      clinical: boolean
      insuranceReimbursable: boolean
      primary: boolean
    }
    onboardingExperience: {
      kind: Types.UserPropertyOnboardingExperienceKind
      participating: boolean
      baselineWeight: number | null
      desiredWeight: number | null
      fourWeekWeight: number | null
      dateToReachDesiredWeight: string | null
      realisticWeightLoss: boolean | null
      desiredWeightLossAmount: number | null
      weightLossPace: number | null
    } | null
  }
}

export type IUserInsurancePolicyQueryVariables = Exact<{
  userId: string | number
}>

export type IUserInsurancePolicyQuery = {
  userInsurancePolicy: {
    id: string
    unitsLeft: number | null
    unitsUsed: number | null
    unitsOccurred: number | null
    unitsAuthorized: number | null
    hasUnitsLeft: boolean
    eligible: boolean
    lastState: {
      id: string
      kind: Types.UserInsurancePolicyStateKind
      reason: string | null
      createdAt: string
    } | null
    states: Array<{
      id: string
      kind: Types.UserInsurancePolicyStateKind
      reason: string | null
      createdAt: string
    }> | null
  } | null
}

export type IUserSurveyLinksQueryVariables = Exact<{ [key: string]: never }>

export type IUserSurveyLinksQuery = {
  userSurveyLinks: {
    surveyLinks: Array<{
      id: string
      state: Types.SurveysUserLinkState
      finished: boolean
      responses: Array<{ id: string; questionKey: Types.SurveysQuestionKey; answer: any }>
      survey: {
        kind: Types.SurveysConfigKind
        version: string
        header: string | null
        completedScreen: { header: string; intro: string | null; icon: Types.UiIcon | null } | null
        questionsGroups: Array<{
          introScreen: { header: string; intro: string | null; icon: Types.UiIcon | null } | null
          questions: Array<{
            __typename: 'Question'
            key: Types.SurveysQuestionKey
            label: string | null
            note: string | null
            required: boolean
            response: {
              kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseKind
              kindMetadata: any
              answersGroups: Array<{
                answers: Array<{
                  label: string
                  value: string
                  followup: {
                    kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswerFollowupKind
                    question: {
                      key: Types.SurveysQuestionKey
                      label: string | null
                      note: string | null
                      required: boolean
                      response: {
                        kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseKind
                        kindMetadata: any
                        answersGroups: Array<{
                          answers: Array<{ label: string; value: string }>
                        }> | null
                      }
                    }
                  } | null
                }>
              }> | null
            }
          }>
        }>
      }
      config: {
        items: Array<
          | {
              type: Types.SurveyConfigItem
              key: Types.SurveysQuestionKey
              label: string | null
              note: string | null
              required: boolean
              response: {
                kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseKind
                kindMetadata: any
                answersGroups: Array<{
                  answersOrder: Types.SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswersOrder
                  answers: Array<{
                    label: string
                    value: string
                    followups: Array<{
                      kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseAnswersGroupAnswerFollowupKind
                      question: {
                        key: Types.SurveysQuestionKey
                        label: string | null
                        note: string | null
                        required: boolean
                        response: {
                          kind: Types.SurveysConfigObjectQuestionsGroupQuestionResponseKind
                          kindMetadata: any
                          answersGroups: Array<{
                            answers: Array<{ label: string; value: string }>
                          }> | null
                        }
                      }
                    }>
                  }>
                }> | null
              }
            }
          | Record<PropertyKey, never>
        >
      }
    }>
  }
}

export type INewNoteUpdateFragment = { id: string; body: string }

export const UpdateSubscriptionResponsePayloadFragmentDoc = gql`
  fragment UpdateSubscriptionResponsePayload on UpdateSubscriptionResponsePayload {
    __typename
    oldProduct
    nextProduct
  }
`
export const CancelSubscriptionResponsePayloadFragmentDoc = gql`
  fragment CancelSubscriptionResponsePayload on CancelSubscriptionResponsePayload {
    __typename
    subscriptionId
    cancellationType
    waiveEarlyCancellationFee
    waiveEarlyCancellationSurcharge
    cancellationReason
  }
`
export const RefundResponsePayloadFragmentDoc = gql`
  fragment RefundResponsePayload on RefundResponsePayload {
    __typename
    chargeId
    amountInCents
    refundReason {
      journey
      reasonOne
      reasonTwo
    }
    subscriptionCancellationRequired
    subscriptionCancellationReason
  }
`
export const PauseSubscriptionResponsePayloadFragmentDoc = gql`
  fragment PauseSubscriptionResponsePayload on PauseSubscriptionResponsePayload {
    __typename
    subscriptionId
    cycleCount
    reason
  }
`
export const CreditResponsePayloadFragmentDoc = gql`
  fragment CreditResponsePayload on CreditResponsePayload {
    __typename
    centsAmount
  }
`
export const OneOffAddonResponsePayloadFragmentDoc = gql`
  fragment OneOffAddonResponsePayload on OneOffAddonResponsePayload {
    __typename
    product
    paid
    discountCentsAmount
  }
`
export const ChangeSubscriptionBillingCycleResponsePayloadFragmentDoc = gql`
  fragment ChangeSubscriptionBillingCycleResponsePayload on ChangeSubscriptionBillingCycleResponsePayload {
    __typename
    subscriptionId
    billingCycleAnchor
  }
`
export const MiscRequestResponsePayloadFragmentDoc = gql`
  fragment MiscRequestResponsePayload on MiscRequestResponsePayload {
    __typename
    requestDetails
  }
`
export const DeleteDuplicateAccountResponsePayloadFragmentDoc = gql`
  fragment DeleteDuplicateAccountResponsePayload on DeleteDuplicateAccountResponsePayload {
    __typename
    duplicateUserId
    creditAmountInCents
    replaceWithDuplicateUserEmail
  }
`
export const UnpauseSubscriptionResponsePayloadFragmentDoc = gql`
  fragment UnpauseSubscriptionResponsePayload on UnpauseSubscriptionResponsePayload {
    __typename
    subscriptionId
    resumeDate
  }
`
export const UncancelSubscriptionResponsePayloadFragmentDoc = gql`
  fragment UncancelSubscriptionResponsePayload on UncancelSubscriptionResponsePayload {
    __typename
    subscriptionId
  }
`
export const UpsertLimitedSupportResponsePayloadFragmentDoc = gql`
  fragment UpsertLimitedSupportResponsePayload on UpsertLimitedSupportResponsePayload {
    __typename
    limitedSupportSubscriptionId
    limitedSupportCancelAt
  }
`
export const CoreAccountRequestFieldsFragmentDoc = gql`
  fragment CoreAccountRequestFields on AccountRequest {
    __typename
    id
    user {
      id
      fullName
      email
    }
    escalatedBy {
      fullName
    }
    processedBy {
      fullName
    }
    reviewedBy {
      fullName
    }
    rejectedBy {
      fullName
    }
    escalatedAt
    processedAt
    reviewedAt
    rejectedAt
    failedAt
    priority
    kind
    errorMessage
    payload {
      ...UpdateSubscriptionResponsePayload
      ...CancelSubscriptionResponsePayload
      ...RefundResponsePayload
      ...PauseSubscriptionResponsePayload
      ...CreditResponsePayload
      ...OneOffAddonResponsePayload
      ...ChangeSubscriptionBillingCycleResponsePayload
      ...MiscRequestResponsePayload
      ...DeleteDuplicateAccountResponsePayload
      ...UnpauseSubscriptionResponsePayload
      ...UncancelSubscriptionResponsePayload
      ...UpsertLimitedSupportResponsePayload
    }
    notes
    status
  }
  ${UpdateSubscriptionResponsePayloadFragmentDoc}
  ${CancelSubscriptionResponsePayloadFragmentDoc}
  ${RefundResponsePayloadFragmentDoc}
  ${PauseSubscriptionResponsePayloadFragmentDoc}
  ${CreditResponsePayloadFragmentDoc}
  ${OneOffAddonResponsePayloadFragmentDoc}
  ${ChangeSubscriptionBillingCycleResponsePayloadFragmentDoc}
  ${MiscRequestResponsePayloadFragmentDoc}
  ${DeleteDuplicateAccountResponsePayloadFragmentDoc}
  ${UnpauseSubscriptionResponsePayloadFragmentDoc}
  ${UncancelSubscriptionResponsePayloadFragmentDoc}
  ${UpsertLimitedSupportResponsePayloadFragmentDoc}
`
export const AllEventsActivityFragmentDoc = gql`
  fragment AllEventsActivity on Activity {
    __typename
    createdAt
    description
    endedAt
    externalSource
    favorite
    id
    length
    occurredAt
    startedAt
    statistics {
      aucScore
      glucose2hrDelta
      glucoseDelta
      glucoseMax
      glucoseMin
      glucoseScore
      glucoseScore2hrDelta
      glucoseScoreAuc
      glucoseScoreDelta
      glucoseScorePeak
    }
    status
    title
    type
  }
`
export const AllEventsMeasurementFragmentDoc = gql`
  fragment AllEventsMeasurement on Measurement {
    __typename
    createdAt
    cumulative
    description
    externalSource
    id
    occurredAt
    scan {
      createdAt
      id
    }
    timestamp
    title
    type
    units
    value
    values {
      ... on BloodPressureMeasurement {
        diastolic
        systolic
      }
      ... on SingleValueMeasurement {
        value
      }
    }
  }
`
export const AllEventsJournalEntryFragmentDoc = gql`
  fragment AllEventsJournalEntry on JournalEntry {
    __typename
    id
    title
    body
    occurredAt
    createdAt
    creatorId
    score
    measurements {
      ...AllEventsMeasurement
      values {
        ... on SingleValueMeasurement {
          value
        }
      }
    }
  }
  ${AllEventsMeasurementFragmentDoc}
`
export const AllEventsMealFragmentDoc = gql`
  fragment AllEventsMeal on Meal {
    __typename
    avatar
    occurredAt
    mealCreatedAt: createdAt
    mealDescription: description
    mealFavorite: favorite
    source
    id
    readOnly
    mealCreatedBy: createdBy {
      id
    }
    mealStatistics: statistics {
      aucScore
      glucose2hrDelta
      glucoseDelta
      glucoseMax
      glucoseMin
      glucoseScore
      glucoseScore2hrDelta
      glucoseScoreAuc
      glucoseScoreDelta
      glucoseScorePeak
    }
    ingredients {
      calories
      createdAt
      description
      id
      servingAmount
      servingUnits
    }
    glucose {
      range
      healthyRange
      values {
        timestamp
        value
        displayValue
      }
    }
    nutrition {
      key
      value
    }
    occurredAt
    title
    kind
    updatedAt
  }
`
export const AllEventsNoteFragmentDoc = gql`
  fragment AllEventsNote on Note {
    body
    __typename
    createdAt
    creatorId
    id
    occurredAt
    title
    createdBy
  }
`
export const AppointmentFieldsFragmentDoc = gql`
  fragment AppointmentFields on HealthPortalEhrAppointment {
    __typename
    id
    getHealthieId
    category
    kind
    meetingAt
    title
    getHealthieInstanceKind
    startUrl
    joinUrl
    actualDuration
    addToGcalLink
    unauthenticatedIcsLink
    lastState {
      id
      reason
      kind
      createdAt
    }
  }
`
export const AppointmentAttendanceFieldsFragmentDoc = gql`
  fragment AppointmentAttendanceFields on HealthPortalEhrAppointmentAttendance {
    __typename
    id
    user {
      id
      fullName
      timeZone
    }
    createdAt
    chargeKind
    state
    agenda
    insurancePolicy {
      lastState {
        id
        kind
      }
    }
  }
`
export const CoreChatConversationFieldsFragmentDoc = gql`
  fragment CoreChatConversationFields on ChatConversation {
    __typename
    id
    kind
    state
    read
    candidateRead
    intercomCreatedAt
    intercomBackfillState
    lastMessage {
      id
      value
      sender {
        id
        fullName
      }
    }
    user {
      id
      fullName
    }
  }
`
export const CoreChatbotMessageReportFieldsFragmentDoc = gql`
  fragment CoreChatbotMessageReportFields on ChatbotMessageReport {
    __typename
    id
    reason
    status
    note
    resolutionNote
    resolutionRef
    resolvedAt
    createdAt
    chatbotMessageId
    userId
    resolvedById
    botMessageContent
  }
`
export const CoreCoachBillingInvoiceItemFieldsFragmentDoc = gql`
  fragment CoreCoachBillingInvoiceItemFields on CoachBillingInvoiceItem {
    __typename
    itemKey
    kind
    date
    description
    quantity
    rate
    total
    billableItem {
      stateSnapshotUserId
    }
    createdAt
  }
`
export const CoreCoachBillingInvoiceFieldsFragmentDoc = gql`
  fragment CoreCoachBillingInvoiceFields on CoachBillingInvoice {
    __typename
    id
    periodStart
    periodEnd
    number
    total
    adminTotal
    billableTotal
    submittedAt
    sentAt
  }
`
export const CoreCoachBillingInvoiceReviewFieldsFragmentDoc = gql`
  fragment CoreCoachBillingInvoiceReviewFields on CoachBillingInvoiceReview {
    __typename
    id
    periodStart
    periodEnd
    kind
    reviewedBy {
      id
      email
      fullName
    }
    reviewedAt
  }
`
export const CoreCoachBillingInvoiceUserFieldsFragmentDoc = gql`
  fragment CoreCoachBillingInvoiceUserFields on CoachBillingInvoiceUser {
    __typename
    id
    total
    periodStart
    periodEnd
    billingPeriodState
    user {
      id
      fullName
      email
    }
    lastInvoice {
      ...CoreCoachBillingInvoiceFields
    }
    lastCoachReview {
      ...CoreCoachBillingInvoiceReviewFields
    }
  }
  ${CoreCoachBillingInvoiceFieldsFragmentDoc}
  ${CoreCoachBillingInvoiceReviewFieldsFragmentDoc}
`
export const CoachBillingRatesFieldsFragmentDoc = gql`
  fragment CoachBillingRatesFields on CoachBillingRates {
    __typename
    coachId
    completedCallRate
    incompleteCallRate
    asyncSupportRate
    mealPlanRate
    supplementReviewRate
    memberReferralBonusRate
    adminTimeRate
  }
`
export const CoreCoachSharedAssetFieldsFragmentDoc = gql`
  fragment CoreCoachSharedAssetFields on CoachSharedAsset {
    __typename
    id
    title
    description
    tags
    category
    visibility
    permanentUrl
    fileName
    fileType
    createdAt
    createdBy {
      id
    }
  }
`
export const CoachUserFragmentDoc = gql`
  fragment CoachUser on User {
    __typename
    id
    fullName
    role
    email
    coachProfile {
      bio
      stressBio
      getHealthieId
      manager {
        id
        fullName
      }
      startDate
      endDate
      schedulingPriority
      stateLicences
      specialties {
        name
      }
      active
      outOfOffice
      premium
      updatedAt
      priorityChangedAt
      credentials
      cdrCnsNumber
      cdrCnsExpirationDate
      gender
      stateOfResidence
      ethnicity
      additionalLanguages
      licenceMode
      stressLicenceMode
      unlimitedChatSupport
      registrationStatus
    }
    activeCoachingKinds {
      key
      coachTitle
    }
  }
`
export const CoreAddressFieldsFragmentDoc = gql`
  fragment CoreAddressFields on Address {
    __typename
    id
    name
    street
    street2
    city
    state
    zipCode
    country
  }
`
export const CoreCoachingKindFieldsFragmentDoc = gql`
  fragment CoreCoachingKindFields on CoachesCoachingKindDef {
    __typename
    key
    coachTitle
    shortCoachTitle
    hubTitle
    shortHubTitle
    serviceTitle
    clinical
    insuranceReimbursable
    primary
  }
`
export const CoreCoachAssignmentFieldsFragmentDoc = gql`
  fragment CoreCoachAssignmentFields on CoachAssignment {
    __typename
    id
    coach {
      id
      fullName
    }
    ehrAppointment {
      meetingAt
    }
    state
    last
    createdAt
    assignedAt
    deactivatedAt
    kind
    supportType
    coachingKind {
      ...CoreCoachingKindFields
    }
  }
  ${CoreCoachingKindFieldsFragmentDoc}
`
export const UserFragmentDoc = gql`
  fragment User on User {
    __typename
    createdAt
    email
    timeZone
    avatar
    firstName
    fullName
    id
    lastName
    role
    sex
    dateOfBirth
    phoneNumber
    lastAppVersion
    lastAppPlatform
    stripeId
    berryStreetGetHealthieId
    kustomerId
    klaviyoId
    stripeCreditBalance
    kind
    age
    canViewGlucoseGraph
    isSteloProvisionedUser
    address {
      ...CoreAddressFields
    }
    sensorInfo {
      totalCount
      replacementRequestsCount
    }
    settings {
      id
      appVersionReminder
      dashboardGraph
      dexcomSync
      displayActivityScore
      displayDailyScore
      displayMealScore
      fastingEnd
      fastingStart
      glucoseHighThreshold
      glucoseLowThreshold
      googleFitSync
      healthKitSync
      ketoMojoSync
      ketoneHighThreshold
      ketoneLowThreshold
      integrationsSyncSettings {
        lastSyncedHealth
        lastSyncedDexcom
        lastSyncedKetoMojo
      }
      macroGoalsDaily {
        calories
        carbs
        fat
        netCarbs
        protein
      }
      reminders
      showNetCarbs
      unitSystem
    }
    sensor {
      activationDate
      baselineAdjustment
      daysRemaining
      expirationDate
      expirationTime
      expired
      model
      serialNumber
      status
    }
    organization {
      id
      name
    }
    ongoingDietitianSubscription {
      id
      dietitianAddOn
      stripeStatus
      status
      paidMonthsCount
      cancelAt
      startAt
      paused
      resumesAt
      commitmentEndAt
      primaryProduct {
        key
        title
      }
    }
    ongoingCoreSubscription {
      id
      paidMonthsCount
      paused
      cancelAt
      commitmentEndAt
      plans {
        id
        nickname
      }
      primaryProduct {
        key
        title
      }
    }
    lastDietitianSubscription {
      stripeStatus
      status
      paused
      resumesAt
    }
    lastCoreSubscription {
      id
      stripeStatus
      status
      latestInvoice {
        latestCharge {
          status
          created
        }
      }
    }
    lastAsyncChatAssignment {
      ...CoreCoachAssignmentFields
    }
    lastVideoChatAssignment {
      ...CoreCoachAssignmentFields
    }
    coachAssignments {
      id
      coach {
        id
      }
      last
      supportType
      coachingKind {
        key
      }
    }
    fulfillmentConfiguration {
      sensorKind
    }
    uxSensorMode {
      syncDescription
    }
    dexcomConnection {
      status
      accessToken
      dexcomUserId
      createdAt
      lastSyncedAt
    }
    dexcomSteloConnection {
      status
      accessToken
      dexcomUserId
      createdAt
      lastSyncedAt
    }
    mntChatConversation {
      id
    }
    stressChatConversation {
      id
    }
    primaryGoal {
      title
      kind
      description
    }
    goalMetrics {
      primary
      kind
      lowThresholdValue
      highThresholdValue
      section
      statKey
    }
    coachProfile {
      stateLicences
      stateLicenceDetails {
        state
        expirationDate
        expirationReminderEnabled
        document
      }
      premium
      outOfOffice
      registrationStatus
      pendingRegisterNote
      credentials
      bio
      stressBio
      gender
      stateOfResidence
      ethnicity
      additionalLanguages
      cdrCnsNumber
      cdrCnsExpirationDate
      cdrCnsCard
      photo
      specialties {
        key
        name
      }
    }
    referralPartner {
      key
      logoUrl
      requiresProtocol
      name
    }
    ongoingSubscriptions {
      primaryProduct {
        key
        title
      }
    }
    paymentMethod {
      stripeId
    }
    uhcMember {
      id
      uhcId
    }
    primaryCoachingKind {
      ...CoreCoachingKindFields
    }
    onboardingExperience {
      kind
      participating
      baselineWeight
      desiredWeight
      fourWeekWeight
      dateToReachDesiredWeight
      realisticWeightLoss
      desiredWeightLossAmount
      weightLossPace
    }
  }
  ${CoreAddressFieldsFragmentDoc}
  ${CoreCoachAssignmentFieldsFragmentDoc}
  ${CoreCoachingKindFieldsFragmentDoc}
`
export const CoreDirectUploadFieldsFragmentDoc = gql`
  fragment CoreDirectUploadFields on DirectUpload {
    __typename
    url
    signedId
    headers {
      key
      value
    }
  }
`
export const CoreFileFieldsFragmentDoc = gql`
  fragment CoreFileFields on File {
    __typename
    id
    downloadFileUrl
    permanentUrl
    fileUrl
    fileName
    fileType
    createdAt
  }
`
export const CoreTicketFieldsFragmentDoc = gql`
  fragment CoreTicketFields on Ticket {
    __typename
    id
    description
    externalLink
    kind
    reason
    status
    priority
    createdAt
    createdBy {
      id
      email
      fullName
    }
    user {
      id
      email
      fullName
    }
    assignedTo {
      id
      email
      fullName
    }
  }
`
export const CoreHealthPortalNotificationFieldsFragmentDoc = gql`
  fragment CoreHealthPortalNotificationFields on HealthPortalNotification {
    __typename
    id
    coachAssignment {
      kind
      user {
        id
        fullName
        ongoingDietitianSubscription {
          cancelAt
          resumesAt
        }
        coachAssignments {
          id
          kind
        }
      }
      ehrAppointment {
        meetingAt
      }
      supportType
    }
    chatConversation {
      id
    }
    supportTicket {
      ...CoreTicketFields
    }
    completedAt
    createdAt
    kind
    requiresAction
    details
    actionDetails
    actionTitle
  }
  ${CoreTicketFieldsFragmentDoc}
`
export const CoreInvoiceOrderFieldsFragmentDoc = gql`
  fragment CoreInvoiceOrderFields on InvoiceOrder {
    __typename
    id
    invoice {
      stripeId
      paidAt
    }
    user {
      id
      email
      firstName
      lastName
      fulfillmentConfiguration {
        sensorKind
      }
      address {
        ...CoreAddressFields
      }
    }
    quantity
    product
    productType
    processedAt
    orderId
    lastProcessingAttemptAt
    createdAt
    updatedAt
    state
    stateReason
  }
  ${CoreAddressFieldsFragmentDoc}
`
export const CoreKnowledgeAnswerFieldsFragmentDoc = gql`
  fragment CoreKnowledgeAnswerFields on KnowledgeAnswer {
    __typename
    id
    title
    value
    knowledgeQuestions {
      id
      value
    }
    knowledgeSources {
      id
      title
      url
    }
  }
`
export const CoreKnowledgeQuestionFieldsFragmentDoc = gql`
  fragment CoreKnowledgeQuestionFields on KnowledgeQuestion {
    __typename
    id
    value
    knowledgeAnswers {
      id
      title
      value
      knowledgeSources {
        id
        title
        url
      }
    }
    knowledgeTags {
      id
      value
    }
  }
`
export const CoreMeasurementFieldsFragmentDoc = gql`
  fragment CoreMeasurementFields on Measurement {
    __typename
    id
    type
    title
    description
    value
    units
    occurredAt
    createdAt
    externalSource
  }
`
export const CoreOrderFieldsFragmentDoc = gql`
  fragment CoreOrderFields on Order {
    __typename
    id
    userId
    product
    productType
    sensorKind
    provider
    quantity
    notes
    createdAt
    updatedAt
    invoice {
      stripeId
    }
    replacementRequest {
      replacementReason
    }
    includable
  }
`
export const CoreProductMinFieldsFragmentDoc = gql`
  fragment CoreProductMinFields on ProductMin {
    __typename
    id
    key
    title
    uhc
    bundledPaidCalls
    recurring
    ehrSchedulingRule {
      appointmentKind
      chargeKind
      count
      additionalPaidCallsAllowed
    }
    includedGoods {
      id
      key
      title
      uhc
      recurring
      ehrSchedulingRule {
        appointmentKind
        chargeKind
        count
        additionalPaidCallsAllowed
      }
    }
  }
`
export const QuestionFieldsFragmentDoc = gql`
  fragment QuestionFields on Question {
    __typename
    key
    label
    note
    required
    response {
      kind
      kindMetadata
      answersGroups {
        answers {
          label
          value
          followup {
            kind
            question {
              key
              label
              note
              required
              response {
                kind
                kindMetadata
                answersGroups {
                  answers {
                    label
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export const QuestionItemFieldsFragmentDoc = gql`
  fragment QuestionItemFields on SurveyLinkConfigQuestionItem {
    key
    label
    note
    required
    response {
      kind
      kindMetadata
      answersGroups {
        answersOrder
        answers {
          label
          value
          followups {
            kind
            question {
              key
              label
              note
              required
              response {
                kind
                kindMetadata
                answersGroups {
                  answers {
                    label
                    value
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
export const CoreReplacementRequestFieldsFragmentDoc = gql`
  fragment CoreReplacementRequestFields on ReplacementRequest {
    __typename
    id
    userId
    createdById
    chargeAmount
    createdAt
    daysWorn
    dateFellOff
    dateNotified
    howItFellOff
    notes
    replacementReason
    sensor {
      id
      serialNumber
      model
    }
    rgaRequired
    wearingPatch
    state
    createdBy {
      email
    }
    user {
      email
    }
    invoice {
      stripeId
    }
    sensorKind
  }
`
export const CoreScanFieldsFragmentDoc = gql`
  fragment CoreScanFields on Scan {
    __typename
    id
    createdAt
  }
`
export const CoreShipmentFieldsFragmentDoc = gql`
  fragment CoreShipmentFields on Shipment {
    __typename
    id
    orderId
    addressId
    status
    trackingNumber
    trackingUrl
    createdAt
    updatedAt
    shippedAt
    deliveredAt
    canceledAt
    providerShipmentId
    providerError
    providerReceivedAt
    provider
    quantity
    lotNumber
  }
`
export const CoreAuthorizationPolicyFieldsFragmentDoc = gql`
  fragment CoreAuthorizationPolicyFields on AuthorizationPolicy {
    __typename
    name
    grants {
      permission
      resource
      scope
    }
  }
`
export const CoreUserAuthorizationPolicyFieldsFragmentDoc = gql`
  fragment CoreUserAuthorizationPolicyFields on UserAuthorizationPolicy {
    __typename
    id
    kind
    policy {
      ...CoreAuthorizationPolicyFields
    }
    createdAt
  }
  ${CoreAuthorizationPolicyFieldsFragmentDoc}
`
export const NewNoteUpdateFragmentDoc = gql`
  fragment NewNoteUpdate on Note {
    id
    body
  }
`
export const CreateAccountRequestDocument = gql`
  mutation createAccountRequest(
    $userId: ID
    $kind: OpsAccountRequestKind
    $priority: OpsAccountRequestPriority
    $notes: String
    $payload: AccountRequestPayloadUnionSubmissionType
  ) {
    createAccountRequest(
      userId: $userId
      kind: $kind
      priority: $priority
      notes: $notes
      payload: $payload
    ) {
      ...CoreAccountRequestFields
    }
  }
  ${CoreAccountRequestFieldsFragmentDoc}
`
export type ICreateAccountRequestMutationFn = Apollo.MutationFunction<
  ICreateAccountRequestMutation,
  ICreateAccountRequestMutationVariables
>

/**
 * __useCreateAccountRequestMutation__
 *
 * To run a mutation, you first call `useCreateAccountRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountRequestMutation, { data, loading, error }] = useCreateAccountRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      kind: // value for 'kind'
 *      priority: // value for 'priority'
 *      notes: // value for 'notes'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateAccountRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateAccountRequestMutation,
    ICreateAccountRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateAccountRequestMutation, ICreateAccountRequestMutationVariables>(
    CreateAccountRequestDocument,
    options
  )
}
export type CreateAccountRequestMutationHookResult = ReturnType<
  typeof useCreateAccountRequestMutation
>
export type CreateAccountRequestMutationResult =
  Apollo.MutationResult<ICreateAccountRequestMutation>
export type CreateAccountRequestMutationOptions = Apollo.BaseMutationOptions<
  ICreateAccountRequestMutation,
  ICreateAccountRequestMutationVariables
>
export const ExportAccountRequestsDataDocument = gql`
  mutation exportAccountRequestsData($status: OpsAccountRequestStatus) {
    exportAccountRequestsData(status: $status) {
      success
    }
  }
`
export type IExportAccountRequestsDataMutationFn = Apollo.MutationFunction<
  IExportAccountRequestsDataMutation,
  IExportAccountRequestsDataMutationVariables
>

/**
 * __useExportAccountRequestsDataMutation__
 *
 * To run a mutation, you first call `useExportAccountRequestsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAccountRequestsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAccountRequestsDataMutation, { data, loading, error }] = useExportAccountRequestsDataMutation({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useExportAccountRequestsDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IExportAccountRequestsDataMutation,
    IExportAccountRequestsDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IExportAccountRequestsDataMutation,
    IExportAccountRequestsDataMutationVariables
  >(ExportAccountRequestsDataDocument, options)
}
export type ExportAccountRequestsDataMutationHookResult = ReturnType<
  typeof useExportAccountRequestsDataMutation
>
export type ExportAccountRequestsDataMutationResult =
  Apollo.MutationResult<IExportAccountRequestsDataMutation>
export type ExportAccountRequestsDataMutationOptions = Apollo.BaseMutationOptions<
  IExportAccountRequestsDataMutation,
  IExportAccountRequestsDataMutationVariables
>
export const SubmitAccountRequestDocument = gql`
  mutation submitAccountRequest(
    $userId: ID
    $kind: OpsAccountRequestKind
    $priority: OpsAccountRequestPriority
    $notes: String
    $payload: AccountRequestPayloadUnionSubmissionType
  ) {
    submitAccountRequest(
      userId: $userId
      kind: $kind
      priority: $priority
      notes: $notes
      payload: $payload
    ) {
      ...CoreAccountRequestFields
    }
  }
  ${CoreAccountRequestFieldsFragmentDoc}
`
export type ISubmitAccountRequestMutationFn = Apollo.MutationFunction<
  ISubmitAccountRequestMutation,
  ISubmitAccountRequestMutationVariables
>

/**
 * __useSubmitAccountRequestMutation__
 *
 * To run a mutation, you first call `useSubmitAccountRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAccountRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAccountRequestMutation, { data, loading, error }] = useSubmitAccountRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      kind: // value for 'kind'
 *      priority: // value for 'priority'
 *      notes: // value for 'notes'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSubmitAccountRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISubmitAccountRequestMutation,
    ISubmitAccountRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISubmitAccountRequestMutation, ISubmitAccountRequestMutationVariables>(
    SubmitAccountRequestDocument,
    options
  )
}
export type SubmitAccountRequestMutationHookResult = ReturnType<
  typeof useSubmitAccountRequestMutation
>
export type SubmitAccountRequestMutationResult =
  Apollo.MutationResult<ISubmitAccountRequestMutation>
export type SubmitAccountRequestMutationOptions = Apollo.BaseMutationOptions<
  ISubmitAccountRequestMutation,
  ISubmitAccountRequestMutationVariables
>
export const UpdateAccountRequestDocument = gql`
  mutation updateAccountRequest(
    $accountRequestId: ID!
    $status: OpsAccountRequestStatus
    $notes: String
  ) {
    updateAccountRequest(accountRequestId: $accountRequestId, status: $status, notes: $notes) {
      ...CoreAccountRequestFields
    }
  }
  ${CoreAccountRequestFieldsFragmentDoc}
`
export type IUpdateAccountRequestMutationFn = Apollo.MutationFunction<
  IUpdateAccountRequestMutation,
  IUpdateAccountRequestMutationVariables
>

/**
 * __useUpdateAccountRequestMutation__
 *
 * To run a mutation, you first call `useUpdateAccountRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountRequestMutation, { data, loading, error }] = useUpdateAccountRequestMutation({
 *   variables: {
 *      accountRequestId: // value for 'accountRequestId'
 *      status: // value for 'status'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateAccountRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateAccountRequestMutation,
    IUpdateAccountRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateAccountRequestMutation, IUpdateAccountRequestMutationVariables>(
    UpdateAccountRequestDocument,
    options
  )
}
export type UpdateAccountRequestMutationHookResult = ReturnType<
  typeof useUpdateAccountRequestMutation
>
export type UpdateAccountRequestMutationResult =
  Apollo.MutationResult<IUpdateAccountRequestMutation>
export type UpdateAccountRequestMutationOptions = Apollo.BaseMutationOptions<
  IUpdateAccountRequestMutation,
  IUpdateAccountRequestMutationVariables
>
export const CreateActionGoalDocument = gql`
  mutation createActionGoal(
    $kind: ActionGoalKind!
    $numberDays: Int!
    $metricKind: ActionGoalMetricKind!
    $metricValue: Float
  ) {
    createActionGoal(
      kind: $kind
      numberDays: $numberDays
      metricKind: $metricKind
      metricValue: $metricValue
    ) {
      id
      kind
      numberDays
      cadence
      status
      startDate
      metricKind
      metricValue
    }
  }
`
export type ICreateActionGoalMutationFn = Apollo.MutationFunction<
  ICreateActionGoalMutation,
  ICreateActionGoalMutationVariables
>

/**
 * __useCreateActionGoalMutation__
 *
 * To run a mutation, you first call `useCreateActionGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionGoalMutation, { data, loading, error }] = useCreateActionGoalMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      numberDays: // value for 'numberDays'
 *      metricKind: // value for 'metricKind'
 *      metricValue: // value for 'metricValue'
 *   },
 * });
 */
export function useCreateActionGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateActionGoalMutation,
    ICreateActionGoalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateActionGoalMutation, ICreateActionGoalMutationVariables>(
    CreateActionGoalDocument,
    options
  )
}
export type CreateActionGoalMutationHookResult = ReturnType<typeof useCreateActionGoalMutation>
export type CreateActionGoalMutationResult = Apollo.MutationResult<ICreateActionGoalMutation>
export type CreateActionGoalMutationOptions = Apollo.BaseMutationOptions<
  ICreateActionGoalMutation,
  ICreateActionGoalMutationVariables
>
export const DeleteActionGoalDocument = gql`
  mutation deleteActionGoal($id: ID!) {
    deleteActionGoal(id: $id) {
      id
      status
    }
  }
`
export type IDeleteActionGoalMutationFn = Apollo.MutationFunction<
  IDeleteActionGoalMutation,
  IDeleteActionGoalMutationVariables
>

/**
 * __useDeleteActionGoalMutation__
 *
 * To run a mutation, you first call `useDeleteActionGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionGoalMutation, { data, loading, error }] = useDeleteActionGoalMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteActionGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteActionGoalMutation,
    IDeleteActionGoalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteActionGoalMutation, IDeleteActionGoalMutationVariables>(
    DeleteActionGoalDocument,
    options
  )
}
export type DeleteActionGoalMutationHookResult = ReturnType<typeof useDeleteActionGoalMutation>
export type DeleteActionGoalMutationResult = Apollo.MutationResult<IDeleteActionGoalMutation>
export type DeleteActionGoalMutationOptions = Apollo.BaseMutationOptions<
  IDeleteActionGoalMutation,
  IDeleteActionGoalMutationVariables
>
export const ReplaceActionGoalDocument = gql`
  mutation replaceActionGoal($id: ID!, $actionGoal: CreateActionGoal!) {
    replaceActionGoal(id: $id, actionGoal: $actionGoal) {
      deletedActionGoal {
        id
        status
      }
      newActionGoal {
        id
        kind
        numberDays
        cadence
        status
        startDate
        metricKind
        metricValue
      }
    }
  }
`
export type IReplaceActionGoalMutationFn = Apollo.MutationFunction<
  IReplaceActionGoalMutation,
  IReplaceActionGoalMutationVariables
>

/**
 * __useReplaceActionGoalMutation__
 *
 * To run a mutation, you first call `useReplaceActionGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceActionGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceActionGoalMutation, { data, loading, error }] = useReplaceActionGoalMutation({
 *   variables: {
 *      id: // value for 'id'
 *      actionGoal: // value for 'actionGoal'
 *   },
 * });
 */
export function useReplaceActionGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IReplaceActionGoalMutation,
    IReplaceActionGoalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IReplaceActionGoalMutation, IReplaceActionGoalMutationVariables>(
    ReplaceActionGoalDocument,
    options
  )
}
export type ReplaceActionGoalMutationHookResult = ReturnType<typeof useReplaceActionGoalMutation>
export type ReplaceActionGoalMutationResult = Apollo.MutationResult<IReplaceActionGoalMutation>
export type ReplaceActionGoalMutationOptions = Apollo.BaseMutationOptions<
  IReplaceActionGoalMutation,
  IReplaceActionGoalMutationVariables
>
export const AddKnowledgeQuestionTagDocument = gql`
  mutation addKnowledgeQuestionTag($id: ID!, $knowledgeTagId: ID!) {
    addKnowledgeQuestionTag(id: $id, knowledgeTagId: $knowledgeTagId) {
      ...CoreKnowledgeQuestionFields
    }
  }
  ${CoreKnowledgeQuestionFieldsFragmentDoc}
`
export type IAddKnowledgeQuestionTagMutationFn = Apollo.MutationFunction<
  IAddKnowledgeQuestionTagMutation,
  IAddKnowledgeQuestionTagMutationVariables
>

/**
 * __useAddKnowledgeQuestionTagMutation__
 *
 * To run a mutation, you first call `useAddKnowledgeQuestionTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddKnowledgeQuestionTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addKnowledgeQuestionTagMutation, { data, loading, error }] = useAddKnowledgeQuestionTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      knowledgeTagId: // value for 'knowledgeTagId'
 *   },
 * });
 */
export function useAddKnowledgeQuestionTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IAddKnowledgeQuestionTagMutation,
    IAddKnowledgeQuestionTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IAddKnowledgeQuestionTagMutation,
    IAddKnowledgeQuestionTagMutationVariables
  >(AddKnowledgeQuestionTagDocument, options)
}
export type AddKnowledgeQuestionTagMutationHookResult = ReturnType<
  typeof useAddKnowledgeQuestionTagMutation
>
export type AddKnowledgeQuestionTagMutationResult =
  Apollo.MutationResult<IAddKnowledgeQuestionTagMutation>
export type AddKnowledgeQuestionTagMutationOptions = Apollo.BaseMutationOptions<
  IAddKnowledgeQuestionTagMutation,
  IAddKnowledgeQuestionTagMutationVariables
>
export const DeleteEhrAppointmentRecurrenceDocument = gql`
  mutation deleteEhrAppointmentRecurrence {
    deleteEhrAppointmentRecurrence {
      success
    }
  }
`
export type IDeleteEhrAppointmentRecurrenceMutationFn = Apollo.MutationFunction<
  IDeleteEhrAppointmentRecurrenceMutation,
  IDeleteEhrAppointmentRecurrenceMutationVariables
>

/**
 * __useDeleteEhrAppointmentRecurrenceMutation__
 *
 * To run a mutation, you first call `useDeleteEhrAppointmentRecurrenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEhrAppointmentRecurrenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEhrAppointmentRecurrenceMutation, { data, loading, error }] = useDeleteEhrAppointmentRecurrenceMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteEhrAppointmentRecurrenceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteEhrAppointmentRecurrenceMutation,
    IDeleteEhrAppointmentRecurrenceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteEhrAppointmentRecurrenceMutation,
    IDeleteEhrAppointmentRecurrenceMutationVariables
  >(DeleteEhrAppointmentRecurrenceDocument, options)
}
export type DeleteEhrAppointmentRecurrenceMutationHookResult = ReturnType<
  typeof useDeleteEhrAppointmentRecurrenceMutation
>
export type DeleteEhrAppointmentRecurrenceMutationResult =
  Apollo.MutationResult<IDeleteEhrAppointmentRecurrenceMutation>
export type DeleteEhrAppointmentRecurrenceMutationOptions = Apollo.BaseMutationOptions<
  IDeleteEhrAppointmentRecurrenceMutation,
  IDeleteEhrAppointmentRecurrenceMutationVariables
>
export const SendEhrAppointmentSmsReminderDocument = gql`
  mutation sendEhrAppointmentSmsReminder($id: ID!) {
    sendEhrAppointmentSmsReminder(id: $id) {
      success
    }
  }
`
export type ISendEhrAppointmentSmsReminderMutationFn = Apollo.MutationFunction<
  ISendEhrAppointmentSmsReminderMutation,
  ISendEhrAppointmentSmsReminderMutationVariables
>

/**
 * __useSendEhrAppointmentSmsReminderMutation__
 *
 * To run a mutation, you first call `useSendEhrAppointmentSmsReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEhrAppointmentSmsReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEhrAppointmentSmsReminderMutation, { data, loading, error }] = useSendEhrAppointmentSmsReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendEhrAppointmentSmsReminderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISendEhrAppointmentSmsReminderMutation,
    ISendEhrAppointmentSmsReminderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISendEhrAppointmentSmsReminderMutation,
    ISendEhrAppointmentSmsReminderMutationVariables
  >(SendEhrAppointmentSmsReminderDocument, options)
}
export type SendEhrAppointmentSmsReminderMutationHookResult = ReturnType<
  typeof useSendEhrAppointmentSmsReminderMutation
>
export type SendEhrAppointmentSmsReminderMutationResult =
  Apollo.MutationResult<ISendEhrAppointmentSmsReminderMutation>
export type SendEhrAppointmentSmsReminderMutationOptions = Apollo.BaseMutationOptions<
  ISendEhrAppointmentSmsReminderMutation,
  ISendEhrAppointmentSmsReminderMutationVariables
>
export const UpdateEhrAppointmentDocument = gql`
  mutation updateEhrAppointment($id: ID!, $actualDuration: Int, $state: EhrAppointmentStateKind) {
    updateEhrAppointment(id: $id, actualDuration: $actualDuration, state: $state) {
      success
    }
  }
`
export type IUpdateEhrAppointmentMutationFn = Apollo.MutationFunction<
  IUpdateEhrAppointmentMutation,
  IUpdateEhrAppointmentMutationVariables
>

/**
 * __useUpdateEhrAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateEhrAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEhrAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEhrAppointmentMutation, { data, loading, error }] = useUpdateEhrAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      actualDuration: // value for 'actualDuration'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpdateEhrAppointmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateEhrAppointmentMutation,
    IUpdateEhrAppointmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateEhrAppointmentMutation, IUpdateEhrAppointmentMutationVariables>(
    UpdateEhrAppointmentDocument,
    options
  )
}
export type UpdateEhrAppointmentMutationHookResult = ReturnType<
  typeof useUpdateEhrAppointmentMutation
>
export type UpdateEhrAppointmentMutationResult =
  Apollo.MutationResult<IUpdateEhrAppointmentMutation>
export type UpdateEhrAppointmentMutationOptions = Apollo.BaseMutationOptions<
  IUpdateEhrAppointmentMutation,
  IUpdateEhrAppointmentMutationVariables
>
export const AssignAuthorizationPolicyDocument = gql`
  mutation assignAuthorizationPolicy($userId: ID!, $kind: UserAuthorizationPolicyKind!) {
    assignAuthorizationPolicy(userId: $userId, kind: $kind) {
      ...CoreUserAuthorizationPolicyFields
    }
  }
  ${CoreUserAuthorizationPolicyFieldsFragmentDoc}
`
export type IAssignAuthorizationPolicyMutationFn = Apollo.MutationFunction<
  IAssignAuthorizationPolicyMutation,
  IAssignAuthorizationPolicyMutationVariables
>

/**
 * __useAssignAuthorizationPolicyMutation__
 *
 * To run a mutation, you first call `useAssignAuthorizationPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAuthorizationPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAuthorizationPolicyMutation, { data, loading, error }] = useAssignAuthorizationPolicyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useAssignAuthorizationPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IAssignAuthorizationPolicyMutation,
    IAssignAuthorizationPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IAssignAuthorizationPolicyMutation,
    IAssignAuthorizationPolicyMutationVariables
  >(AssignAuthorizationPolicyDocument, options)
}
export type AssignAuthorizationPolicyMutationHookResult = ReturnType<
  typeof useAssignAuthorizationPolicyMutation
>
export type AssignAuthorizationPolicyMutationResult =
  Apollo.MutationResult<IAssignAuthorizationPolicyMutation>
export type AssignAuthorizationPolicyMutationOptions = Apollo.BaseMutationOptions<
  IAssignAuthorizationPolicyMutation,
  IAssignAuthorizationPolicyMutationVariables
>
export const BackfillChatConversationDocument = gql`
  mutation backfillChatConversation($id: ID!) {
    backfillChatConversation(id: $id) {
      ...CoreChatConversationFields
    }
  }
  ${CoreChatConversationFieldsFragmentDoc}
`
export type IBackfillChatConversationMutationFn = Apollo.MutationFunction<
  IBackfillChatConversationMutation,
  IBackfillChatConversationMutationVariables
>

/**
 * __useBackfillChatConversationMutation__
 *
 * To run a mutation, you first call `useBackfillChatConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackfillChatConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backfillChatConversationMutation, { data, loading, error }] = useBackfillChatConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBackfillChatConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBackfillChatConversationMutation,
    IBackfillChatConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IBackfillChatConversationMutation,
    IBackfillChatConversationMutationVariables
  >(BackfillChatConversationDocument, options)
}
export type BackfillChatConversationMutationHookResult = ReturnType<
  typeof useBackfillChatConversationMutation
>
export type BackfillChatConversationMutationResult =
  Apollo.MutationResult<IBackfillChatConversationMutation>
export type BackfillChatConversationMutationOptions = Apollo.BaseMutationOptions<
  IBackfillChatConversationMutation,
  IBackfillChatConversationMutationVariables
>
export const BulkCoachAssignDocument = gql`
  mutation bulkCoachAssign($coachAssignments: [CoachAssign!]) {
    bulkCoachAssign(coachAssignments: $coachAssignments) {
      coachAssignments {
        ...CoreCoachAssignmentFields
      }
    }
  }
  ${CoreCoachAssignmentFieldsFragmentDoc}
`
export type IBulkCoachAssignMutationFn = Apollo.MutationFunction<
  IBulkCoachAssignMutation,
  IBulkCoachAssignMutationVariables
>

/**
 * __useBulkCoachAssignMutation__
 *
 * To run a mutation, you first call `useBulkCoachAssignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCoachAssignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCoachAssignMutation, { data, loading, error }] = useBulkCoachAssignMutation({
 *   variables: {
 *      coachAssignments: // value for 'coachAssignments'
 *   },
 * });
 */
export function useBulkCoachAssignMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkCoachAssignMutation,
    IBulkCoachAssignMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IBulkCoachAssignMutation, IBulkCoachAssignMutationVariables>(
    BulkCoachAssignDocument,
    options
  )
}
export type BulkCoachAssignMutationHookResult = ReturnType<typeof useBulkCoachAssignMutation>
export type BulkCoachAssignMutationResult = Apollo.MutationResult<IBulkCoachAssignMutation>
export type BulkCoachAssignMutationOptions = Apollo.BaseMutationOptions<
  IBulkCoachAssignMutation,
  IBulkCoachAssignMutationVariables
>
export const BulkCreateCoachBillingInvoicesDocument = gql`
  mutation bulkCreateCoachBillingInvoices(
    $coachIds: [ID!]!
    $periodStart: ISO8601Date!
    $periodEnd: ISO8601Date!
  ) {
    bulkCreateCoachBillingInvoices(
      coachIds: $coachIds
      periodStart: $periodStart
      periodEnd: $periodEnd
    ) {
      success
    }
  }
`
export type IBulkCreateCoachBillingInvoicesMutationFn = Apollo.MutationFunction<
  IBulkCreateCoachBillingInvoicesMutation,
  IBulkCreateCoachBillingInvoicesMutationVariables
>

/**
 * __useBulkCreateCoachBillingInvoicesMutation__
 *
 * To run a mutation, you first call `useBulkCreateCoachBillingInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateCoachBillingInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateCoachBillingInvoicesMutation, { data, loading, error }] = useBulkCreateCoachBillingInvoicesMutation({
 *   variables: {
 *      coachIds: // value for 'coachIds'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *   },
 * });
 */
export function useBulkCreateCoachBillingInvoicesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkCreateCoachBillingInvoicesMutation,
    IBulkCreateCoachBillingInvoicesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IBulkCreateCoachBillingInvoicesMutation,
    IBulkCreateCoachBillingInvoicesMutationVariables
  >(BulkCreateCoachBillingInvoicesDocument, options)
}
export type BulkCreateCoachBillingInvoicesMutationHookResult = ReturnType<
  typeof useBulkCreateCoachBillingInvoicesMutation
>
export type BulkCreateCoachBillingInvoicesMutationResult =
  Apollo.MutationResult<IBulkCreateCoachBillingInvoicesMutation>
export type BulkCreateCoachBillingInvoicesMutationOptions = Apollo.BaseMutationOptions<
  IBulkCreateCoachBillingInvoicesMutation,
  IBulkCreateCoachBillingInvoicesMutationVariables
>
export const BulkCreateFilesDocument = gql`
  mutation BulkCreateFiles($userId: ID, $urls: [String!]) {
    bulkCreateFiles(userId: $userId, urls: $urls) {
      files {
        ...CoreFileFields
        tag
      }
    }
  }
  ${CoreFileFieldsFragmentDoc}
`
export type IBulkCreateFilesMutationFn = Apollo.MutationFunction<
  IBulkCreateFilesMutation,
  IBulkCreateFilesMutationVariables
>

/**
 * __useBulkCreateFilesMutation__
 *
 * To run a mutation, you first call `useBulkCreateFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateFilesMutation, { data, loading, error }] = useBulkCreateFilesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      urls: // value for 'urls'
 *   },
 * });
 */
export function useBulkCreateFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkCreateFilesMutation,
    IBulkCreateFilesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IBulkCreateFilesMutation, IBulkCreateFilesMutationVariables>(
    BulkCreateFilesDocument,
    options
  )
}
export type BulkCreateFilesMutationHookResult = ReturnType<typeof useBulkCreateFilesMutation>
export type BulkCreateFilesMutationResult = Apollo.MutationResult<IBulkCreateFilesMutation>
export type BulkCreateFilesMutationOptions = Apollo.BaseMutationOptions<
  IBulkCreateFilesMutation,
  IBulkCreateFilesMutationVariables
>
export const BulkCreateShipmentsDocument = gql`
  mutation bulkCreateShipments(
    $provider: ShippingOrderProvider!
    $shipmentsAttributes: [BulkCreateShipment!]
  ) {
    bulkCreateShipments(provider: $provider, shipmentsAttributes: $shipmentsAttributes) {
      shipments {
        ...CoreShipmentFields
        order {
          id
          invoice {
            stripeId
          }
          createdAt
          product
          productType
          sensorKind
          quantity
        }
        address {
          ...CoreAddressFields
        }
        user {
          id
          email
          firstName
          lastName
          phoneNumber
          dateOfBirth
          sex
          truepillPatientToken
        }
      }
      totalRecords
    }
  }
  ${CoreShipmentFieldsFragmentDoc}
  ${CoreAddressFieldsFragmentDoc}
`
export type IBulkCreateShipmentsMutationFn = Apollo.MutationFunction<
  IBulkCreateShipmentsMutation,
  IBulkCreateShipmentsMutationVariables
>

/**
 * __useBulkCreateShipmentsMutation__
 *
 * To run a mutation, you first call `useBulkCreateShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateShipmentsMutation, { data, loading, error }] = useBulkCreateShipmentsMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      shipmentsAttributes: // value for 'shipmentsAttributes'
 *   },
 * });
 */
export function useBulkCreateShipmentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkCreateShipmentsMutation,
    IBulkCreateShipmentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IBulkCreateShipmentsMutation, IBulkCreateShipmentsMutationVariables>(
    BulkCreateShipmentsDocument,
    options
  )
}
export type BulkCreateShipmentsMutationHookResult = ReturnType<
  typeof useBulkCreateShipmentsMutation
>
export type BulkCreateShipmentsMutationResult = Apollo.MutationResult<IBulkCreateShipmentsMutation>
export type BulkCreateShipmentsMutationOptions = Apollo.BaseMutationOptions<
  IBulkCreateShipmentsMutation,
  IBulkCreateShipmentsMutationVariables
>
export const BulkExportUsersDataDocument = gql`
  mutation bulkExportUsersData($userIds: [ID!]) {
    bulkExportUsersData(userIds: $userIds) {
      success
    }
  }
`
export type IBulkExportUsersDataMutationFn = Apollo.MutationFunction<
  IBulkExportUsersDataMutation,
  IBulkExportUsersDataMutationVariables
>

/**
 * __useBulkExportUsersDataMutation__
 *
 * To run a mutation, you first call `useBulkExportUsersDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkExportUsersDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkExportUsersDataMutation, { data, loading, error }] = useBulkExportUsersDataMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useBulkExportUsersDataMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkExportUsersDataMutation,
    IBulkExportUsersDataMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IBulkExportUsersDataMutation, IBulkExportUsersDataMutationVariables>(
    BulkExportUsersDataDocument,
    options
  )
}
export type BulkExportUsersDataMutationHookResult = ReturnType<
  typeof useBulkExportUsersDataMutation
>
export type BulkExportUsersDataMutationResult = Apollo.MutationResult<IBulkExportUsersDataMutation>
export type BulkExportUsersDataMutationOptions = Apollo.BaseMutationOptions<
  IBulkExportUsersDataMutation,
  IBulkExportUsersDataMutationVariables
>
export const BulkFollowCoachAssignmentsDocument = gql`
  mutation bulkFollowCoachAssignments($coachId: ID!) {
    bulkFollowCoachAssignments(coachId: $coachId) {
      success
    }
  }
`
export type IBulkFollowCoachAssignmentsMutationFn = Apollo.MutationFunction<
  IBulkFollowCoachAssignmentsMutation,
  IBulkFollowCoachAssignmentsMutationVariables
>

/**
 * __useBulkFollowCoachAssignmentsMutation__
 *
 * To run a mutation, you first call `useBulkFollowCoachAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkFollowCoachAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkFollowCoachAssignmentsMutation, { data, loading, error }] = useBulkFollowCoachAssignmentsMutation({
 *   variables: {
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useBulkFollowCoachAssignmentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkFollowCoachAssignmentsMutation,
    IBulkFollowCoachAssignmentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IBulkFollowCoachAssignmentsMutation,
    IBulkFollowCoachAssignmentsMutationVariables
  >(BulkFollowCoachAssignmentsDocument, options)
}
export type BulkFollowCoachAssignmentsMutationHookResult = ReturnType<
  typeof useBulkFollowCoachAssignmentsMutation
>
export type BulkFollowCoachAssignmentsMutationResult =
  Apollo.MutationResult<IBulkFollowCoachAssignmentsMutation>
export type BulkFollowCoachAssignmentsMutationOptions = Apollo.BaseMutationOptions<
  IBulkFollowCoachAssignmentsMutation,
  IBulkFollowCoachAssignmentsMutationVariables
>
export const BulkSendScheduledMessageDocument = gql`
  mutation bulkSendScheduledMessage(
    $coachAssignmentIds: [ID!]
    $kind: ChatConversationMessageTemplateKind
  ) {
    bulkSendScheduledMessage(coachAssignmentIds: $coachAssignmentIds, kind: $kind) {
      success
    }
  }
`
export type IBulkSendScheduledMessageMutationFn = Apollo.MutationFunction<
  IBulkSendScheduledMessageMutation,
  IBulkSendScheduledMessageMutationVariables
>

/**
 * __useBulkSendScheduledMessageMutation__
 *
 * To run a mutation, you first call `useBulkSendScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkSendScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkSendScheduledMessageMutation, { data, loading, error }] = useBulkSendScheduledMessageMutation({
 *   variables: {
 *      coachAssignmentIds: // value for 'coachAssignmentIds'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useBulkSendScheduledMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkSendScheduledMessageMutation,
    IBulkSendScheduledMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IBulkSendScheduledMessageMutation,
    IBulkSendScheduledMessageMutationVariables
  >(BulkSendScheduledMessageDocument, options)
}
export type BulkSendScheduledMessageMutationHookResult = ReturnType<
  typeof useBulkSendScheduledMessageMutation
>
export type BulkSendScheduledMessageMutationResult =
  Apollo.MutationResult<IBulkSendScheduledMessageMutation>
export type BulkSendScheduledMessageMutationOptions = Apollo.BaseMutationOptions<
  IBulkSendScheduledMessageMutation,
  IBulkSendScheduledMessageMutationVariables
>
export const BulkShipOrdersDocument = gql`
  mutation bulkShipOrders($ids: [ID!], $provider: ShippingOrderProvider!) {
    bulkShipOrders(ids: $ids, provider: $provider) {
      orders {
        ...CoreOrderFields
      }
      totalRecords
    }
  }
  ${CoreOrderFieldsFragmentDoc}
`
export type IBulkShipOrdersMutationFn = Apollo.MutationFunction<
  IBulkShipOrdersMutation,
  IBulkShipOrdersMutationVariables
>

/**
 * __useBulkShipOrdersMutation__
 *
 * To run a mutation, you first call `useBulkShipOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkShipOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkShipOrdersMutation, { data, loading, error }] = useBulkShipOrdersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useBulkShipOrdersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkShipOrdersMutation,
    IBulkShipOrdersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IBulkShipOrdersMutation, IBulkShipOrdersMutationVariables>(
    BulkShipOrdersDocument,
    options
  )
}
export type BulkShipOrdersMutationHookResult = ReturnType<typeof useBulkShipOrdersMutation>
export type BulkShipOrdersMutationResult = Apollo.MutationResult<IBulkShipOrdersMutation>
export type BulkShipOrdersMutationOptions = Apollo.BaseMutationOptions<
  IBulkShipOrdersMutation,
  IBulkShipOrdersMutationVariables
>
export const BulkUnfollowCoachAssignmentsDocument = gql`
  mutation bulkUnfollowCoachAssignments($coachId: ID!) {
    bulkUnfollowCoachAssignments(coachId: $coachId) {
      success
    }
  }
`
export type IBulkUnfollowCoachAssignmentsMutationFn = Apollo.MutationFunction<
  IBulkUnfollowCoachAssignmentsMutation,
  IBulkUnfollowCoachAssignmentsMutationVariables
>

/**
 * __useBulkUnfollowCoachAssignmentsMutation__
 *
 * To run a mutation, you first call `useBulkUnfollowCoachAssignmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUnfollowCoachAssignmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUnfollowCoachAssignmentsMutation, { data, loading, error }] = useBulkUnfollowCoachAssignmentsMutation({
 *   variables: {
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useBulkUnfollowCoachAssignmentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkUnfollowCoachAssignmentsMutation,
    IBulkUnfollowCoachAssignmentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IBulkUnfollowCoachAssignmentsMutation,
    IBulkUnfollowCoachAssignmentsMutationVariables
  >(BulkUnfollowCoachAssignmentsDocument, options)
}
export type BulkUnfollowCoachAssignmentsMutationHookResult = ReturnType<
  typeof useBulkUnfollowCoachAssignmentsMutation
>
export type BulkUnfollowCoachAssignmentsMutationResult =
  Apollo.MutationResult<IBulkUnfollowCoachAssignmentsMutation>
export type BulkUnfollowCoachAssignmentsMutationOptions = Apollo.BaseMutationOptions<
  IBulkUnfollowCoachAssignmentsMutation,
  IBulkUnfollowCoachAssignmentsMutationVariables
>
export const BulkUpdateHealthPortalNotificationsDocument = gql`
  mutation BulkUpdateHealthPortalNotifications(
    $healthPortalNotifications: [UpdateHealthPortalNotification!]
  ) {
    bulkUpdateHealthPortalNotifications(healthPortalNotifications: $healthPortalNotifications) {
      healthPortalNotifications {
        ...CoreHealthPortalNotificationFields
      }
    }
  }
  ${CoreHealthPortalNotificationFieldsFragmentDoc}
`
export type IBulkUpdateHealthPortalNotificationsMutationFn = Apollo.MutationFunction<
  IBulkUpdateHealthPortalNotificationsMutation,
  IBulkUpdateHealthPortalNotificationsMutationVariables
>

/**
 * __useBulkUpdateHealthPortalNotificationsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateHealthPortalNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateHealthPortalNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateHealthPortalNotificationsMutation, { data, loading, error }] = useBulkUpdateHealthPortalNotificationsMutation({
 *   variables: {
 *      healthPortalNotifications: // value for 'healthPortalNotifications'
 *   },
 * });
 */
export function useBulkUpdateHealthPortalNotificationsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkUpdateHealthPortalNotificationsMutation,
    IBulkUpdateHealthPortalNotificationsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IBulkUpdateHealthPortalNotificationsMutation,
    IBulkUpdateHealthPortalNotificationsMutationVariables
  >(BulkUpdateHealthPortalNotificationsDocument, options)
}
export type BulkUpdateHealthPortalNotificationsMutationHookResult = ReturnType<
  typeof useBulkUpdateHealthPortalNotificationsMutation
>
export type BulkUpdateHealthPortalNotificationsMutationResult =
  Apollo.MutationResult<IBulkUpdateHealthPortalNotificationsMutation>
export type BulkUpdateHealthPortalNotificationsMutationOptions = Apollo.BaseMutationOptions<
  IBulkUpdateHealthPortalNotificationsMutation,
  IBulkUpdateHealthPortalNotificationsMutationVariables
>
export const BulkUpdateCoachProfilesDocument = gql`
  mutation bulkUpdateCoachProfiles($coachProfiles: [UpdateCoachProfile!]) {
    bulkUpdateCoachProfiles(coachProfiles: $coachProfiles) {
      coachProfiles {
        fullName
        startDate
        endDate
      }
    }
  }
`
export type IBulkUpdateCoachProfilesMutationFn = Apollo.MutationFunction<
  IBulkUpdateCoachProfilesMutation,
  IBulkUpdateCoachProfilesMutationVariables
>

/**
 * __useBulkUpdateCoachProfilesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateCoachProfilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateCoachProfilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateCoachProfilesMutation, { data, loading, error }] = useBulkUpdateCoachProfilesMutation({
 *   variables: {
 *      coachProfiles: // value for 'coachProfiles'
 *   },
 * });
 */
export function useBulkUpdateCoachProfilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkUpdateCoachProfilesMutation,
    IBulkUpdateCoachProfilesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IBulkUpdateCoachProfilesMutation,
    IBulkUpdateCoachProfilesMutationVariables
  >(BulkUpdateCoachProfilesDocument, options)
}
export type BulkUpdateCoachProfilesMutationHookResult = ReturnType<
  typeof useBulkUpdateCoachProfilesMutation
>
export type BulkUpdateCoachProfilesMutationResult =
  Apollo.MutationResult<IBulkUpdateCoachProfilesMutation>
export type BulkUpdateCoachProfilesMutationOptions = Apollo.BaseMutationOptions<
  IBulkUpdateCoachProfilesMutation,
  IBulkUpdateCoachProfilesMutationVariables
>
export const BulkUpdateShipmentsDocument = gql`
  mutation bulkUpdateShipments($shipmentsIds: [ID!], $lotNumber: String) {
    bulkUpdateShipments(shipmentsIds: $shipmentsIds, lotNumber: $lotNumber) {
      shipments {
        ...CoreShipmentFields
      }
    }
  }
  ${CoreShipmentFieldsFragmentDoc}
`
export type IBulkUpdateShipmentsMutationFn = Apollo.MutationFunction<
  IBulkUpdateShipmentsMutation,
  IBulkUpdateShipmentsMutationVariables
>

/**
 * __useBulkUpdateShipmentsMutation__
 *
 * To run a mutation, you first call `useBulkUpdateShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateShipmentsMutation, { data, loading, error }] = useBulkUpdateShipmentsMutation({
 *   variables: {
 *      shipmentsIds: // value for 'shipmentsIds'
 *      lotNumber: // value for 'lotNumber'
 *   },
 * });
 */
export function useBulkUpdateShipmentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkUpdateShipmentsMutation,
    IBulkUpdateShipmentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IBulkUpdateShipmentsMutation, IBulkUpdateShipmentsMutationVariables>(
    BulkUpdateShipmentsDocument,
    options
  )
}
export type BulkUpdateShipmentsMutationHookResult = ReturnType<
  typeof useBulkUpdateShipmentsMutation
>
export type BulkUpdateShipmentsMutationResult = Apollo.MutationResult<IBulkUpdateShipmentsMutation>
export type BulkUpdateShipmentsMutationOptions = Apollo.BaseMutationOptions<
  IBulkUpdateShipmentsMutation,
  IBulkUpdateShipmentsMutationVariables
>
export const BulkUpdateUserPropertiesDocument = gql`
  mutation bulkUpdateUserProperties($userIds: [ID!], $kind: UserPropertyKind!, $value: String!) {
    bulkUpdateUserProperties(userIds: $userIds, kind: $kind, value: $value) {
      userProperties {
        id
        kind
        value
        userId
      }
    }
  }
`
export type IBulkUpdateUserPropertiesMutationFn = Apollo.MutationFunction<
  IBulkUpdateUserPropertiesMutation,
  IBulkUpdateUserPropertiesMutationVariables
>

/**
 * __useBulkUpdateUserPropertiesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateUserPropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateUserPropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateUserPropertiesMutation, { data, loading, error }] = useBulkUpdateUserPropertiesMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      kind: // value for 'kind'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useBulkUpdateUserPropertiesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkUpdateUserPropertiesMutation,
    IBulkUpdateUserPropertiesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IBulkUpdateUserPropertiesMutation,
    IBulkUpdateUserPropertiesMutationVariables
  >(BulkUpdateUserPropertiesDocument, options)
}
export type BulkUpdateUserPropertiesMutationHookResult = ReturnType<
  typeof useBulkUpdateUserPropertiesMutation
>
export type BulkUpdateUserPropertiesMutationResult =
  Apollo.MutationResult<IBulkUpdateUserPropertiesMutation>
export type BulkUpdateUserPropertiesMutationOptions = Apollo.BaseMutationOptions<
  IBulkUpdateUserPropertiesMutation,
  IBulkUpdateUserPropertiesMutationVariables
>
export const ChangeUserEmailDocument = gql`
  mutation changeUserEmail($userId: ID!, $email: String!) {
    changeUserEmail(userId: $userId, email: $email) {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export type IChangeUserEmailMutationFn = Apollo.MutationFunction<
  IChangeUserEmailMutation,
  IChangeUserEmailMutationVariables
>

/**
 * __useChangeUserEmailMutation__
 *
 * To run a mutation, you first call `useChangeUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserEmailMutation, { data, loading, error }] = useChangeUserEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useChangeUserEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IChangeUserEmailMutation,
    IChangeUserEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IChangeUserEmailMutation, IChangeUserEmailMutationVariables>(
    ChangeUserEmailDocument,
    options
  )
}
export type ChangeUserEmailMutationHookResult = ReturnType<typeof useChangeUserEmailMutation>
export type ChangeUserEmailMutationResult = Apollo.MutationResult<IChangeUserEmailMutation>
export type ChangeUserEmailMutationOptions = Apollo.BaseMutationOptions<
  IChangeUserEmailMutation,
  IChangeUserEmailMutationVariables
>
export const CreateChatConversationNoteDocument = gql`
  mutation createChatConversationNote($conversationId: ID!, $body: String!) {
    createChatConversationNote(conversationId: $conversationId, body: $body) {
      id
      value
      createdAt
      createdBy {
        id
        fullName
      }
    }
  }
`
export type ICreateChatConversationNoteMutationFn = Apollo.MutationFunction<
  ICreateChatConversationNoteMutation,
  ICreateChatConversationNoteMutationVariables
>

/**
 * __useCreateChatConversationNoteMutation__
 *
 * To run a mutation, you first call `useCreateChatConversationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatConversationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatConversationNoteMutation, { data, loading, error }] = useCreateChatConversationNoteMutation({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateChatConversationNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateChatConversationNoteMutation,
    ICreateChatConversationNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateChatConversationNoteMutation,
    ICreateChatConversationNoteMutationVariables
  >(CreateChatConversationNoteDocument, options)
}
export type CreateChatConversationNoteMutationHookResult = ReturnType<
  typeof useCreateChatConversationNoteMutation
>
export type CreateChatConversationNoteMutationResult =
  Apollo.MutationResult<ICreateChatConversationNoteMutation>
export type CreateChatConversationNoteMutationOptions = Apollo.BaseMutationOptions<
  ICreateChatConversationNoteMutation,
  ICreateChatConversationNoteMutationVariables
>
export const UpdateChatConversationNoteDocument = gql`
  mutation updateChatConversationNote($id: ID!, $body: String!) {
    updateChatConversationNote(id: $id, body: $body) {
      id
      value
      createdAt
      createdBy {
        id
        fullName
      }
    }
  }
`
export type IUpdateChatConversationNoteMutationFn = Apollo.MutationFunction<
  IUpdateChatConversationNoteMutation,
  IUpdateChatConversationNoteMutationVariables
>

/**
 * __useUpdateChatConversationNoteMutation__
 *
 * To run a mutation, you first call `useUpdateChatConversationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatConversationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatConversationNoteMutation, { data, loading, error }] = useUpdateChatConversationNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateChatConversationNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateChatConversationNoteMutation,
    IUpdateChatConversationNoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateChatConversationNoteMutation,
    IUpdateChatConversationNoteMutationVariables
  >(UpdateChatConversationNoteDocument, options)
}
export type UpdateChatConversationNoteMutationHookResult = ReturnType<
  typeof useUpdateChatConversationNoteMutation
>
export type UpdateChatConversationNoteMutationResult =
  Apollo.MutationResult<IUpdateChatConversationNoteMutation>
export type UpdateChatConversationNoteMutationOptions = Apollo.BaseMutationOptions<
  IUpdateChatConversationNoteMutation,
  IUpdateChatConversationNoteMutationVariables
>
export const UpdateChatConversationStateDocument = gql`
  mutation updateChatConversationState(
    $id: ID!
    $state: ChatConversationState!
    $snoozedUntil: ISO8601DateTime
  ) {
    updateChatConversationState(id: $id, state: $state, snoozedUntil: $snoozedUntil) {
      ...CoreChatConversationFields
    }
  }
  ${CoreChatConversationFieldsFragmentDoc}
`
export type IUpdateChatConversationStateMutationFn = Apollo.MutationFunction<
  IUpdateChatConversationStateMutation,
  IUpdateChatConversationStateMutationVariables
>

/**
 * __useUpdateChatConversationStateMutation__
 *
 * To run a mutation, you first call `useUpdateChatConversationStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatConversationStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatConversationStateMutation, { data, loading, error }] = useUpdateChatConversationStateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *      snoozedUntil: // value for 'snoozedUntil'
 *   },
 * });
 */
export function useUpdateChatConversationStateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateChatConversationStateMutation,
    IUpdateChatConversationStateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateChatConversationStateMutation,
    IUpdateChatConversationStateMutationVariables
  >(UpdateChatConversationStateDocument, options)
}
export type UpdateChatConversationStateMutationHookResult = ReturnType<
  typeof useUpdateChatConversationStateMutation
>
export type UpdateChatConversationStateMutationResult =
  Apollo.MutationResult<IUpdateChatConversationStateMutation>
export type UpdateChatConversationStateMutationOptions = Apollo.BaseMutationOptions<
  IUpdateChatConversationStateMutation,
  IUpdateChatConversationStateMutationVariables
>
export const UpdateChatbotMessageReportDocument = gql`
  mutation updateChatbotMessageReport(
    $id: ID!
    $status: ChatbotMessageReportStatus
    $resolutionNote: String
    $resolutionRef: String
  ) {
    updateChatbotMessageReport(
      id: $id
      status: $status
      resolutionNote: $resolutionNote
      resolutionRef: $resolutionRef
    ) {
      ...CoreChatbotMessageReportFields
    }
  }
  ${CoreChatbotMessageReportFieldsFragmentDoc}
`
export type IUpdateChatbotMessageReportMutationFn = Apollo.MutationFunction<
  IUpdateChatbotMessageReportMutation,
  IUpdateChatbotMessageReportMutationVariables
>

/**
 * __useUpdateChatbotMessageReportMutation__
 *
 * To run a mutation, you first call `useUpdateChatbotMessageReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatbotMessageReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatbotMessageReportMutation, { data, loading, error }] = useUpdateChatbotMessageReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      resolutionNote: // value for 'resolutionNote'
 *      resolutionRef: // value for 'resolutionRef'
 *   },
 * });
 */
export function useUpdateChatbotMessageReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateChatbotMessageReportMutation,
    IUpdateChatbotMessageReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateChatbotMessageReportMutation,
    IUpdateChatbotMessageReportMutationVariables
  >(UpdateChatbotMessageReportDocument, options)
}
export type UpdateChatbotMessageReportMutationHookResult = ReturnType<
  typeof useUpdateChatbotMessageReportMutation
>
export type UpdateChatbotMessageReportMutationResult =
  Apollo.MutationResult<IUpdateChatbotMessageReportMutation>
export type UpdateChatbotMessageReportMutationOptions = Apollo.BaseMutationOptions<
  IUpdateChatbotMessageReportMutation,
  IUpdateChatbotMessageReportMutationVariables
>
export const ApproveCoachDocument = gql`
  mutation approveCoach($userId: ID) {
    approveCoach(userId: $userId) {
      coachId
      registrationStatus
    }
  }
`
export type IApproveCoachMutationFn = Apollo.MutationFunction<
  IApproveCoachMutation,
  IApproveCoachMutationVariables
>

/**
 * __useApproveCoachMutation__
 *
 * To run a mutation, you first call `useApproveCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveCoachMutation, { data, loading, error }] = useApproveCoachMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useApproveCoachMutation(
  baseOptions?: Apollo.MutationHookOptions<IApproveCoachMutation, IApproveCoachMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IApproveCoachMutation, IApproveCoachMutationVariables>(
    ApproveCoachDocument,
    options
  )
}
export type ApproveCoachMutationHookResult = ReturnType<typeof useApproveCoachMutation>
export type ApproveCoachMutationResult = Apollo.MutationResult<IApproveCoachMutation>
export type ApproveCoachMutationOptions = Apollo.BaseMutationOptions<
  IApproveCoachMutation,
  IApproveCoachMutationVariables
>
export const BulkCreatePendingCoachesDocument = gql`
  mutation bulkCreatePendingCoaches($emails: [String!]) {
    bulkCreatePendingCoaches(emails: $emails) {
      createdUsers {
        id
        email
      }
      summary {
        willCreate
        skipExistingCoach
        skipMalformed
        skipNonNutrisenseEmail
        errorExistingNonCoachUser
      }
    }
  }
`
export type IBulkCreatePendingCoachesMutationFn = Apollo.MutationFunction<
  IBulkCreatePendingCoachesMutation,
  IBulkCreatePendingCoachesMutationVariables
>

/**
 * __useBulkCreatePendingCoachesMutation__
 *
 * To run a mutation, you first call `useBulkCreatePendingCoachesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreatePendingCoachesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreatePendingCoachesMutation, { data, loading, error }] = useBulkCreatePendingCoachesMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useBulkCreatePendingCoachesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IBulkCreatePendingCoachesMutation,
    IBulkCreatePendingCoachesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IBulkCreatePendingCoachesMutation,
    IBulkCreatePendingCoachesMutationVariables
  >(BulkCreatePendingCoachesDocument, options)
}
export type BulkCreatePendingCoachesMutationHookResult = ReturnType<
  typeof useBulkCreatePendingCoachesMutation
>
export type BulkCreatePendingCoachesMutationResult =
  Apollo.MutationResult<IBulkCreatePendingCoachesMutation>
export type BulkCreatePendingCoachesMutationOptions = Apollo.BaseMutationOptions<
  IBulkCreatePendingCoachesMutation,
  IBulkCreatePendingCoachesMutationVariables
>
export const SendCoachBackToPendingRegisterDocument = gql`
  mutation sendCoachBackToPendingRegister($userId: ID, $note: String) {
    sendCoachBackToPendingRegister(userId: $userId, note: $note) {
      coachId
      registrationStatus
      pendingRegisterNote
    }
  }
`
export type ISendCoachBackToPendingRegisterMutationFn = Apollo.MutationFunction<
  ISendCoachBackToPendingRegisterMutation,
  ISendCoachBackToPendingRegisterMutationVariables
>

/**
 * __useSendCoachBackToPendingRegisterMutation__
 *
 * To run a mutation, you first call `useSendCoachBackToPendingRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCoachBackToPendingRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCoachBackToPendingRegisterMutation, { data, loading, error }] = useSendCoachBackToPendingRegisterMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSendCoachBackToPendingRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISendCoachBackToPendingRegisterMutation,
    ISendCoachBackToPendingRegisterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISendCoachBackToPendingRegisterMutation,
    ISendCoachBackToPendingRegisterMutationVariables
  >(SendCoachBackToPendingRegisterDocument, options)
}
export type SendCoachBackToPendingRegisterMutationHookResult = ReturnType<
  typeof useSendCoachBackToPendingRegisterMutation
>
export type SendCoachBackToPendingRegisterMutationResult =
  Apollo.MutationResult<ISendCoachBackToPendingRegisterMutation>
export type SendCoachBackToPendingRegisterMutationOptions = Apollo.BaseMutationOptions<
  ISendCoachBackToPendingRegisterMutation,
  ISendCoachBackToPendingRegisterMutationVariables
>
export const SubmitCoachProfileDocument = gql`
  mutation submitCoachProfile {
    submitCoachProfile {
      success
      missingFields
    }
  }
`
export type ISubmitCoachProfileMutationFn = Apollo.MutationFunction<
  ISubmitCoachProfileMutation,
  ISubmitCoachProfileMutationVariables
>

/**
 * __useSubmitCoachProfileMutation__
 *
 * To run a mutation, you first call `useSubmitCoachProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCoachProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCoachProfileMutation, { data, loading, error }] = useSubmitCoachProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useSubmitCoachProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISubmitCoachProfileMutation,
    ISubmitCoachProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISubmitCoachProfileMutation, ISubmitCoachProfileMutationVariables>(
    SubmitCoachProfileDocument,
    options
  )
}
export type SubmitCoachProfileMutationHookResult = ReturnType<typeof useSubmitCoachProfileMutation>
export type SubmitCoachProfileMutationResult = Apollo.MutationResult<ISubmitCoachProfileMutation>
export type SubmitCoachProfileMutationOptions = Apollo.BaseMutationOptions<
  ISubmitCoachProfileMutation,
  ISubmitCoachProfileMutationVariables
>
export const UpsertCoachProfileDocument = gql`
  mutation upsertCoachProfile(
    $userId: ID
    $firstName: String
    $lastName: String
    $stateLicences: [String!]
    $stateLicenceDetails: [StateLicenceDetail!]
    $outOfOffice: Boolean
    $premium: Boolean
    $credentials: String
    $bio: String
    $gender: EhrCoachGender
    $stateOfResidence: String
    $ethnicity: String
    $additionalLanguages: String
    $cdrCnsNumber: String
    $cdrCnsExpirationDate: ISO8601Date
    $specialties: [EhrCoachSpecialty!]
    $photo: Upload
    $cdrCnsCard: Upload
  ) {
    upsertCoachProfile(
      userId: $userId
      firstName: $firstName
      lastName: $lastName
      stateLicences: $stateLicences
      stateLicenceDetails: $stateLicenceDetails
      outOfOffice: $outOfOffice
      premium: $premium
      credentials: $credentials
      bio: $bio
      gender: $gender
      stateOfResidence: $stateOfResidence
      ethnicity: $ethnicity
      additionalLanguages: $additionalLanguages
      cdrCnsNumber: $cdrCnsNumber
      cdrCnsExpirationDate: $cdrCnsExpirationDate
      specialties: $specialties
      photo: $photo
      cdrCnsCard: $cdrCnsCard
    ) {
      coachId
      stateLicences
      stateLicenceDetails {
        state
        expirationDate
        expirationReminderEnabled
        document
      }
      outOfOffice
      premium
      credentials
      bio
      gender
      stateOfResidence
      ethnicity
      additionalLanguages
      cdrCnsNumber
      cdrCnsExpirationDate
      cdrCnsCard
      photo
      registrationStatus
      specialties {
        key
        name
      }
    }
  }
`
export type IUpsertCoachProfileMutationFn = Apollo.MutationFunction<
  IUpsertCoachProfileMutation,
  IUpsertCoachProfileMutationVariables
>

/**
 * __useUpsertCoachProfileMutation__
 *
 * To run a mutation, you first call `useUpsertCoachProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCoachProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCoachProfileMutation, { data, loading, error }] = useUpsertCoachProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      stateLicences: // value for 'stateLicences'
 *      stateLicenceDetails: // value for 'stateLicenceDetails'
 *      outOfOffice: // value for 'outOfOffice'
 *      premium: // value for 'premium'
 *      credentials: // value for 'credentials'
 *      bio: // value for 'bio'
 *      gender: // value for 'gender'
 *      stateOfResidence: // value for 'stateOfResidence'
 *      ethnicity: // value for 'ethnicity'
 *      additionalLanguages: // value for 'additionalLanguages'
 *      cdrCnsNumber: // value for 'cdrCnsNumber'
 *      cdrCnsExpirationDate: // value for 'cdrCnsExpirationDate'
 *      specialties: // value for 'specialties'
 *      photo: // value for 'photo'
 *      cdrCnsCard: // value for 'cdrCnsCard'
 *   },
 * });
 */
export function useUpsertCoachProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpsertCoachProfileMutation,
    IUpsertCoachProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpsertCoachProfileMutation, IUpsertCoachProfileMutationVariables>(
    UpsertCoachProfileDocument,
    options
  )
}
export type UpsertCoachProfileMutationHookResult = ReturnType<typeof useUpsertCoachProfileMutation>
export type UpsertCoachProfileMutationResult = Apollo.MutationResult<IUpsertCoachProfileMutation>
export type UpsertCoachProfileMutationOptions = Apollo.BaseMutationOptions<
  IUpsertCoachProfileMutation,
  IUpsertCoachProfileMutationVariables
>
export const UpsertCoachingKindAssignmentDocument = gql`
  mutation upsertCoachingKindAssignment(
    $coachId: ID!
    $kind: CoachesCoachingKind!
    $state: CoachesCoachingKindAssignmentState!
  ) {
    upsertCoachingKindAssignment(coachId: $coachId, kind: $kind, state: $state) {
      id
      activeCoachingKinds {
        key
        coachTitle
      }
    }
  }
`
export type IUpsertCoachingKindAssignmentMutationFn = Apollo.MutationFunction<
  IUpsertCoachingKindAssignmentMutation,
  IUpsertCoachingKindAssignmentMutationVariables
>

/**
 * __useUpsertCoachingKindAssignmentMutation__
 *
 * To run a mutation, you first call `useUpsertCoachingKindAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCoachingKindAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCoachingKindAssignmentMutation, { data, loading, error }] = useUpsertCoachingKindAssignmentMutation({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      kind: // value for 'kind'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useUpsertCoachingKindAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpsertCoachingKindAssignmentMutation,
    IUpsertCoachingKindAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpsertCoachingKindAssignmentMutation,
    IUpsertCoachingKindAssignmentMutationVariables
  >(UpsertCoachingKindAssignmentDocument, options)
}
export type UpsertCoachingKindAssignmentMutationHookResult = ReturnType<
  typeof useUpsertCoachingKindAssignmentMutation
>
export type UpsertCoachingKindAssignmentMutationResult =
  Apollo.MutationResult<IUpsertCoachingKindAssignmentMutation>
export type UpsertCoachingKindAssignmentMutationOptions = Apollo.BaseMutationOptions<
  IUpsertCoachingKindAssignmentMutation,
  IUpsertCoachingKindAssignmentMutationVariables
>
export const ValidateCoachInvitesDocument = gql`
  mutation validateCoachInvites($emails: [String!]) {
    validateCoachInvites(emails: $emails) {
      results {
        email
        classification
      }
      summary {
        willCreate
        skipExistingCoach
        skipMalformed
        skipNonNutrisenseEmail
        errorExistingNonCoachUser
      }
    }
  }
`
export type IValidateCoachInvitesMutationFn = Apollo.MutationFunction<
  IValidateCoachInvitesMutation,
  IValidateCoachInvitesMutationVariables
>

/**
 * __useValidateCoachInvitesMutation__
 *
 * To run a mutation, you first call `useValidateCoachInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateCoachInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateCoachInvitesMutation, { data, loading, error }] = useValidateCoachInvitesMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useValidateCoachInvitesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IValidateCoachInvitesMutation,
    IValidateCoachInvitesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IValidateCoachInvitesMutation, IValidateCoachInvitesMutationVariables>(
    ValidateCoachInvitesDocument,
    options
  )
}
export type ValidateCoachInvitesMutationHookResult = ReturnType<
  typeof useValidateCoachInvitesMutation
>
export type ValidateCoachInvitesMutationResult =
  Apollo.MutationResult<IValidateCoachInvitesMutation>
export type ValidateCoachInvitesMutationOptions = Apollo.BaseMutationOptions<
  IValidateCoachInvitesMutation,
  IValidateCoachInvitesMutationVariables
>
export const CreateChatConversationMessageTemplateDocument = gql`
  mutation createChatConversationMessageTemplate(
    $name: String!
    $value: String!
    $private: Boolean!
  ) {
    createChatConversationMessageTemplate(name: $name, value: $value, private: $private) {
      id
      name
      value
      private
      kind
    }
  }
`
export type ICreateChatConversationMessageTemplateMutationFn = Apollo.MutationFunction<
  ICreateChatConversationMessageTemplateMutation,
  ICreateChatConversationMessageTemplateMutationVariables
>

/**
 * __useCreateChatConversationMessageTemplateMutation__
 *
 * To run a mutation, you first call `useCreateChatConversationMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatConversationMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatConversationMessageTemplateMutation, { data, loading, error }] = useCreateChatConversationMessageTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      value: // value for 'value'
 *      private: // value for 'private'
 *   },
 * });
 */
export function useCreateChatConversationMessageTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateChatConversationMessageTemplateMutation,
    ICreateChatConversationMessageTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateChatConversationMessageTemplateMutation,
    ICreateChatConversationMessageTemplateMutationVariables
  >(CreateChatConversationMessageTemplateDocument, options)
}
export type CreateChatConversationMessageTemplateMutationHookResult = ReturnType<
  typeof useCreateChatConversationMessageTemplateMutation
>
export type CreateChatConversationMessageTemplateMutationResult =
  Apollo.MutationResult<ICreateChatConversationMessageTemplateMutation>
export type CreateChatConversationMessageTemplateMutationOptions = Apollo.BaseMutationOptions<
  ICreateChatConversationMessageTemplateMutation,
  ICreateChatConversationMessageTemplateMutationVariables
>
export const CreateChatTokenDocument = gql`
  mutation createChatToken($userId: ID!) {
    createChatToken(userId: $userId) {
      value
    }
  }
`
export type ICreateChatTokenMutationFn = Apollo.MutationFunction<
  ICreateChatTokenMutation,
  ICreateChatTokenMutationVariables
>

/**
 * __useCreateChatTokenMutation__
 *
 * To run a mutation, you first call `useCreateChatTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatTokenMutation, { data, loading, error }] = useCreateChatTokenMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateChatTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateChatTokenMutation,
    ICreateChatTokenMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateChatTokenMutation, ICreateChatTokenMutationVariables>(
    CreateChatTokenDocument,
    options
  )
}
export type CreateChatTokenMutationHookResult = ReturnType<typeof useCreateChatTokenMutation>
export type CreateChatTokenMutationResult = Apollo.MutationResult<ICreateChatTokenMutation>
export type CreateChatTokenMutationOptions = Apollo.BaseMutationOptions<
  ICreateChatTokenMutation,
  ICreateChatTokenMutationVariables
>
export const CreateChatbotDelimiterDocument = gql`
  mutation createChatbotDelimiter($providerConversationId: ID!) {
    createChatbotDelimiter(providerConversationId: $providerConversationId) {
      id
      createdAt
    }
  }
`
export type ICreateChatbotDelimiterMutationFn = Apollo.MutationFunction<
  ICreateChatbotDelimiterMutation,
  ICreateChatbotDelimiterMutationVariables
>

/**
 * __useCreateChatbotDelimiterMutation__
 *
 * To run a mutation, you first call `useCreateChatbotDelimiterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatbotDelimiterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatbotDelimiterMutation, { data, loading, error }] = useCreateChatbotDelimiterMutation({
 *   variables: {
 *      providerConversationId: // value for 'providerConversationId'
 *   },
 * });
 */
export function useCreateChatbotDelimiterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateChatbotDelimiterMutation,
    ICreateChatbotDelimiterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateChatbotDelimiterMutation,
    ICreateChatbotDelimiterMutationVariables
  >(CreateChatbotDelimiterDocument, options)
}
export type CreateChatbotDelimiterMutationHookResult = ReturnType<
  typeof useCreateChatbotDelimiterMutation
>
export type CreateChatbotDelimiterMutationResult =
  Apollo.MutationResult<ICreateChatbotDelimiterMutation>
export type CreateChatbotDelimiterMutationOptions = Apollo.BaseMutationOptions<
  ICreateChatbotDelimiterMutation,
  ICreateChatbotDelimiterMutationVariables
>
export const CreateCoachBillingInvoiceDocument = gql`
  mutation createCoachBillingInvoice(
    $coachId: ID!
    $periodStart: ISO8601Date!
    $periodEnd: ISO8601Date!
  ) {
    createCoachBillingInvoice(coachId: $coachId, periodStart: $periodStart, periodEnd: $periodEnd) {
      id
      number
      periodStart
      periodEnd
      submittedAt
      createdAt
      billableTotal
      adminTotal
      total
      coach {
        id
        email
        fullName
      }
    }
  }
`
export type ICreateCoachBillingInvoiceMutationFn = Apollo.MutationFunction<
  ICreateCoachBillingInvoiceMutation,
  ICreateCoachBillingInvoiceMutationVariables
>

/**
 * __useCreateCoachBillingInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateCoachBillingInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoachBillingInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoachBillingInvoiceMutation, { data, loading, error }] = useCreateCoachBillingInvoiceMutation({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *   },
 * });
 */
export function useCreateCoachBillingInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateCoachBillingInvoiceMutation,
    ICreateCoachBillingInvoiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateCoachBillingInvoiceMutation,
    ICreateCoachBillingInvoiceMutationVariables
  >(CreateCoachBillingInvoiceDocument, options)
}
export type CreateCoachBillingInvoiceMutationHookResult = ReturnType<
  typeof useCreateCoachBillingInvoiceMutation
>
export type CreateCoachBillingInvoiceMutationResult =
  Apollo.MutationResult<ICreateCoachBillingInvoiceMutation>
export type CreateCoachBillingInvoiceMutationOptions = Apollo.BaseMutationOptions<
  ICreateCoachBillingInvoiceMutation,
  ICreateCoachBillingInvoiceMutationVariables
>
export const CreateCoachBillingInvoiceItemDocument = gql`
  mutation createCoachBillingInvoiceItem(
    $coachId: ID!
    $kind: CoachesBillingInvoiceItemKind!
    $date: ISO8601Date!
    $description: String!
    $quantity: Float!
    $rate: Float!
  ) {
    createCoachBillingInvoiceItem(
      coachId: $coachId
      kind: $kind
      date: $date
      description: $description
      quantity: $quantity
      rate: $rate
    ) {
      ...CoreCoachBillingInvoiceItemFields
    }
  }
  ${CoreCoachBillingInvoiceItemFieldsFragmentDoc}
`
export type ICreateCoachBillingInvoiceItemMutationFn = Apollo.MutationFunction<
  ICreateCoachBillingInvoiceItemMutation,
  ICreateCoachBillingInvoiceItemMutationVariables
>

/**
 * __useCreateCoachBillingInvoiceItemMutation__
 *
 * To run a mutation, you first call `useCreateCoachBillingInvoiceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoachBillingInvoiceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoachBillingInvoiceItemMutation, { data, loading, error }] = useCreateCoachBillingInvoiceItemMutation({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      kind: // value for 'kind'
 *      date: // value for 'date'
 *      description: // value for 'description'
 *      quantity: // value for 'quantity'
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useCreateCoachBillingInvoiceItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateCoachBillingInvoiceItemMutation,
    ICreateCoachBillingInvoiceItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateCoachBillingInvoiceItemMutation,
    ICreateCoachBillingInvoiceItemMutationVariables
  >(CreateCoachBillingInvoiceItemDocument, options)
}
export type CreateCoachBillingInvoiceItemMutationHookResult = ReturnType<
  typeof useCreateCoachBillingInvoiceItemMutation
>
export type CreateCoachBillingInvoiceItemMutationResult =
  Apollo.MutationResult<ICreateCoachBillingInvoiceItemMutation>
export type CreateCoachBillingInvoiceItemMutationOptions = Apollo.BaseMutationOptions<
  ICreateCoachBillingInvoiceItemMutation,
  ICreateCoachBillingInvoiceItemMutationVariables
>
export const CreateCoachBillingInvoiceReviewDocument = gql`
  mutation createCoachBillingInvoiceReview(
    $coachId: ID!
    $periodStart: ISO8601Date!
    $periodEnd: ISO8601Date!
    $kind: CoachesBillingInvoiceReviewKind!
  ) {
    createCoachBillingInvoiceReview(
      coachId: $coachId
      periodStart: $periodStart
      periodEnd: $periodEnd
      kind: $kind
    ) {
      ...CoreCoachBillingInvoiceReviewFields
    }
  }
  ${CoreCoachBillingInvoiceReviewFieldsFragmentDoc}
`
export type ICreateCoachBillingInvoiceReviewMutationFn = Apollo.MutationFunction<
  ICreateCoachBillingInvoiceReviewMutation,
  ICreateCoachBillingInvoiceReviewMutationVariables
>

/**
 * __useCreateCoachBillingInvoiceReviewMutation__
 *
 * To run a mutation, you first call `useCreateCoachBillingInvoiceReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoachBillingInvoiceReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoachBillingInvoiceReviewMutation, { data, loading, error }] = useCreateCoachBillingInvoiceReviewMutation({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useCreateCoachBillingInvoiceReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateCoachBillingInvoiceReviewMutation,
    ICreateCoachBillingInvoiceReviewMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateCoachBillingInvoiceReviewMutation,
    ICreateCoachBillingInvoiceReviewMutationVariables
  >(CreateCoachBillingInvoiceReviewDocument, options)
}
export type CreateCoachBillingInvoiceReviewMutationHookResult = ReturnType<
  typeof useCreateCoachBillingInvoiceReviewMutation
>
export type CreateCoachBillingInvoiceReviewMutationResult =
  Apollo.MutationResult<ICreateCoachBillingInvoiceReviewMutation>
export type CreateCoachBillingInvoiceReviewMutationOptions = Apollo.BaseMutationOptions<
  ICreateCoachBillingInvoiceReviewMutation,
  ICreateCoachBillingInvoiceReviewMutationVariables
>
export const CreateCoachSharedAssetDocument = gql`
  mutation createCoachSharedAsset(
    $signedId: String!
    $title: String!
    $category: CoachesSharedAssetCategory!
    $description: String
    $tags: [String!]
    $visibility: CoachesSharedAssetVisibility
  ) {
    createCoachSharedAsset(
      signedId: $signedId
      title: $title
      category: $category
      description: $description
      tags: $tags
      visibility: $visibility
    ) {
      ...CoreCoachSharedAssetFields
    }
  }
  ${CoreCoachSharedAssetFieldsFragmentDoc}
`
export type ICreateCoachSharedAssetMutationFn = Apollo.MutationFunction<
  ICreateCoachSharedAssetMutation,
  ICreateCoachSharedAssetMutationVariables
>

/**
 * __useCreateCoachSharedAssetMutation__
 *
 * To run a mutation, you first call `useCreateCoachSharedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCoachSharedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCoachSharedAssetMutation, { data, loading, error }] = useCreateCoachSharedAssetMutation({
 *   variables: {
 *      signedId: // value for 'signedId'
 *      title: // value for 'title'
 *      category: // value for 'category'
 *      description: // value for 'description'
 *      tags: // value for 'tags'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useCreateCoachSharedAssetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateCoachSharedAssetMutation,
    ICreateCoachSharedAssetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateCoachSharedAssetMutation,
    ICreateCoachSharedAssetMutationVariables
  >(CreateCoachSharedAssetDocument, options)
}
export type CreateCoachSharedAssetMutationHookResult = ReturnType<
  typeof useCreateCoachSharedAssetMutation
>
export type CreateCoachSharedAssetMutationResult =
  Apollo.MutationResult<ICreateCoachSharedAssetMutation>
export type CreateCoachSharedAssetMutationOptions = Apollo.BaseMutationOptions<
  ICreateCoachSharedAssetMutation,
  ICreateCoachSharedAssetMutationVariables
>
export const CreateDietitianSessionDocument = gql`
  mutation createDietitianSession(
    $userId: ID
    $startedAt: ISO8601DateTime!
    $endedAt: ISO8601DateTime!
  ) {
    createDietitianSession(userId: $userId, startedAt: $startedAt, endedAt: $endedAt) {
      id
      dietitianId
      userId
      startedAt
      endedAt
      durationInSeconds
    }
  }
`
export type ICreateDietitianSessionMutationFn = Apollo.MutationFunction<
  ICreateDietitianSessionMutation,
  ICreateDietitianSessionMutationVariables
>

/**
 * __useCreateDietitianSessionMutation__
 *
 * To run a mutation, you first call `useCreateDietitianSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDietitianSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDietitianSessionMutation, { data, loading, error }] = useCreateDietitianSessionMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      startedAt: // value for 'startedAt'
 *      endedAt: // value for 'endedAt'
 *   },
 * });
 */
export function useCreateDietitianSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateDietitianSessionMutation,
    ICreateDietitianSessionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateDietitianSessionMutation,
    ICreateDietitianSessionMutationVariables
  >(CreateDietitianSessionDocument, options)
}
export type CreateDietitianSessionMutationHookResult = ReturnType<
  typeof useCreateDietitianSessionMutation
>
export type CreateDietitianSessionMutationResult =
  Apollo.MutationResult<ICreateDietitianSessionMutation>
export type CreateDietitianSessionMutationOptions = Apollo.BaseMutationOptions<
  ICreateDietitianSessionMutation,
  ICreateDietitianSessionMutationVariables
>
export const CreateDirectUploadsDocument = gql`
  mutation CreateDirectUploads($files: [FileMetadata!], $reason: DirectUploadReason) {
    createDirectUploads(files: $files, reason: $reason) {
      directUploads {
        ...CoreDirectUploadFields
      }
    }
  }
  ${CoreDirectUploadFieldsFragmentDoc}
`
export type ICreateDirectUploadsMutationFn = Apollo.MutationFunction<
  ICreateDirectUploadsMutation,
  ICreateDirectUploadsMutationVariables
>

/**
 * __useCreateDirectUploadsMutation__
 *
 * To run a mutation, you first call `useCreateDirectUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectUploadsMutation, { data, loading, error }] = useCreateDirectUploadsMutation({
 *   variables: {
 *      files: // value for 'files'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useCreateDirectUploadsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateDirectUploadsMutation,
    ICreateDirectUploadsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateDirectUploadsMutation, ICreateDirectUploadsMutationVariables>(
    CreateDirectUploadsDocument,
    options
  )
}
export type CreateDirectUploadsMutationHookResult = ReturnType<
  typeof useCreateDirectUploadsMutation
>
export type CreateDirectUploadsMutationResult = Apollo.MutationResult<ICreateDirectUploadsMutation>
export type CreateDirectUploadsMutationOptions = Apollo.BaseMutationOptions<
  ICreateDirectUploadsMutation,
  ICreateDirectUploadsMutationVariables
>
export const CreateFilesFromDirectUploadsDocument = gql`
  mutation CreateFilesFromDirectUploads($userId: ID!, $signedIds: [String!]) {
    createFilesFromDirectUploads(userId: $userId, signedIds: $signedIds) {
      files {
        ...CoreFileFields
        tag
      }
    }
  }
  ${CoreFileFieldsFragmentDoc}
`
export type ICreateFilesFromDirectUploadsMutationFn = Apollo.MutationFunction<
  ICreateFilesFromDirectUploadsMutation,
  ICreateFilesFromDirectUploadsMutationVariables
>

/**
 * __useCreateFilesFromDirectUploadsMutation__
 *
 * To run a mutation, you first call `useCreateFilesFromDirectUploadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFilesFromDirectUploadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFilesFromDirectUploadsMutation, { data, loading, error }] = useCreateFilesFromDirectUploadsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      signedIds: // value for 'signedIds'
 *   },
 * });
 */
export function useCreateFilesFromDirectUploadsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateFilesFromDirectUploadsMutation,
    ICreateFilesFromDirectUploadsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateFilesFromDirectUploadsMutation,
    ICreateFilesFromDirectUploadsMutationVariables
  >(CreateFilesFromDirectUploadsDocument, options)
}
export type CreateFilesFromDirectUploadsMutationHookResult = ReturnType<
  typeof useCreateFilesFromDirectUploadsMutation
>
export type CreateFilesFromDirectUploadsMutationResult =
  Apollo.MutationResult<ICreateFilesFromDirectUploadsMutation>
export type CreateFilesFromDirectUploadsMutationOptions = Apollo.BaseMutationOptions<
  ICreateFilesFromDirectUploadsMutation,
  ICreateFilesFromDirectUploadsMutationVariables
>
export const CreateKnowledgeAnswerDocument = gql`
  mutation createKnowledgeAnswer($title: String!, $value: String!) {
    createKnowledgeAnswer(title: $title, value: $value) {
      ...CoreKnowledgeAnswerFields
    }
  }
  ${CoreKnowledgeAnswerFieldsFragmentDoc}
`
export type ICreateKnowledgeAnswerMutationFn = Apollo.MutationFunction<
  ICreateKnowledgeAnswerMutation,
  ICreateKnowledgeAnswerMutationVariables
>

/**
 * __useCreateKnowledgeAnswerMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeAnswerMutation, { data, loading, error }] = useCreateKnowledgeAnswerMutation({
 *   variables: {
 *      title: // value for 'title'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateKnowledgeAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateKnowledgeAnswerMutation,
    ICreateKnowledgeAnswerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateKnowledgeAnswerMutation,
    ICreateKnowledgeAnswerMutationVariables
  >(CreateKnowledgeAnswerDocument, options)
}
export type CreateKnowledgeAnswerMutationHookResult = ReturnType<
  typeof useCreateKnowledgeAnswerMutation
>
export type CreateKnowledgeAnswerMutationResult =
  Apollo.MutationResult<ICreateKnowledgeAnswerMutation>
export type CreateKnowledgeAnswerMutationOptions = Apollo.BaseMutationOptions<
  ICreateKnowledgeAnswerMutation,
  ICreateKnowledgeAnswerMutationVariables
>
export const CreateKnowledgeQuestionDocument = gql`
  mutation createKnowledgeQuestion($value: String!) {
    createKnowledgeQuestion(value: $value) {
      id
      value
    }
  }
`
export type ICreateKnowledgeQuestionMutationFn = Apollo.MutationFunction<
  ICreateKnowledgeQuestionMutation,
  ICreateKnowledgeQuestionMutationVariables
>

/**
 * __useCreateKnowledgeQuestionMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeQuestionMutation, { data, loading, error }] = useCreateKnowledgeQuestionMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateKnowledgeQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateKnowledgeQuestionMutation,
    ICreateKnowledgeQuestionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateKnowledgeQuestionMutation,
    ICreateKnowledgeQuestionMutationVariables
  >(CreateKnowledgeQuestionDocument, options)
}
export type CreateKnowledgeQuestionMutationHookResult = ReturnType<
  typeof useCreateKnowledgeQuestionMutation
>
export type CreateKnowledgeQuestionMutationResult =
  Apollo.MutationResult<ICreateKnowledgeQuestionMutation>
export type CreateKnowledgeQuestionMutationOptions = Apollo.BaseMutationOptions<
  ICreateKnowledgeQuestionMutation,
  ICreateKnowledgeQuestionMutationVariables
>
export const CreateKnowledgeSourceDocument = gql`
  mutation createKnowledgeSource($title: String!, $url: String!) {
    createKnowledgeSource(title: $title, url: $url) {
      id
      title
      url
    }
  }
`
export type ICreateKnowledgeSourceMutationFn = Apollo.MutationFunction<
  ICreateKnowledgeSourceMutation,
  ICreateKnowledgeSourceMutationVariables
>

/**
 * __useCreateKnowledgeSourceMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeSourceMutation, { data, loading, error }] = useCreateKnowledgeSourceMutation({
 *   variables: {
 *      title: // value for 'title'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useCreateKnowledgeSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateKnowledgeSourceMutation,
    ICreateKnowledgeSourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateKnowledgeSourceMutation,
    ICreateKnowledgeSourceMutationVariables
  >(CreateKnowledgeSourceDocument, options)
}
export type CreateKnowledgeSourceMutationHookResult = ReturnType<
  typeof useCreateKnowledgeSourceMutation
>
export type CreateKnowledgeSourceMutationResult =
  Apollo.MutationResult<ICreateKnowledgeSourceMutation>
export type CreateKnowledgeSourceMutationOptions = Apollo.BaseMutationOptions<
  ICreateKnowledgeSourceMutation,
  ICreateKnowledgeSourceMutationVariables
>
export const CreateKnowledgeTagDocument = gql`
  mutation createKnowledgeTag($value: String!) {
    createKnowledgeTag(value: $value) {
      id
      value
    }
  }
`
export type ICreateKnowledgeTagMutationFn = Apollo.MutationFunction<
  ICreateKnowledgeTagMutation,
  ICreateKnowledgeTagMutationVariables
>

/**
 * __useCreateKnowledgeTagMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeTagMutation, { data, loading, error }] = useCreateKnowledgeTagMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useCreateKnowledgeTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateKnowledgeTagMutation,
    ICreateKnowledgeTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateKnowledgeTagMutation, ICreateKnowledgeTagMutationVariables>(
    CreateKnowledgeTagDocument,
    options
  )
}
export type CreateKnowledgeTagMutationHookResult = ReturnType<typeof useCreateKnowledgeTagMutation>
export type CreateKnowledgeTagMutationResult = Apollo.MutationResult<ICreateKnowledgeTagMutation>
export type CreateKnowledgeTagMutationOptions = Apollo.BaseMutationOptions<
  ICreateKnowledgeTagMutation,
  ICreateKnowledgeTagMutationVariables
>
export const CreateOrderDocument = gql`
  mutation createOrder(
    $userId: ID!
    $product: String!
    $productType: String!
    $quantity: Int!
    $sensorKind: UserSensorKind
    $notes: String
    $invoiceOrderId: ID
  ) {
    createOrder(
      userId: $userId
      product: $product
      productType: $productType
      sensorKind: $sensorKind
      quantity: $quantity
      notes: $notes
      invoiceOrderId: $invoiceOrderId
    ) {
      ...CoreOrderFields
    }
  }
  ${CoreOrderFieldsFragmentDoc}
`
export type ICreateOrderMutationFn = Apollo.MutationFunction<
  ICreateOrderMutation,
  ICreateOrderMutationVariables
>

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      product: // value for 'product'
 *      productType: // value for 'productType'
 *      quantity: // value for 'quantity'
 *      sensorKind: // value for 'sensorKind'
 *      notes: // value for 'notes'
 *      invoiceOrderId: // value for 'invoiceOrderId'
 *   },
 * });
 */
export function useCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<ICreateOrderMutation, ICreateOrderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateOrderMutation, ICreateOrderMutationVariables>(
    CreateOrderDocument,
    options
  )
}
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>
export type CreateOrderMutationResult = Apollo.MutationResult<ICreateOrderMutation>
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<
  ICreateOrderMutation,
  ICreateOrderMutationVariables
>
export const CreateReplacementRequestDocument = gql`
  mutation createReplacementRequest(
    $chargeAmount: ReplacementRequestChargeAmount!
    $daysWorn: Int
    $dateFellOff: String!
    $dateNotified: String!
    $howItFellOff: String
    $notes: String
    $replacementReason: ReplacementRequestReplacementReason!
    $sensorId: ID
    $rgaRequired: ReplacementRequestRgaRequired
    $wearingPatch: ReplacementRequestWearingPatch!
    $sensorKind: UserSensorKind
  ) {
    createReplacementRequest(
      chargeAmount: $chargeAmount
      daysWorn: $daysWorn
      dateFellOff: $dateFellOff
      dateNotified: $dateNotified
      howItFellOff: $howItFellOff
      notes: $notes
      replacementReason: $replacementReason
      sensorId: $sensorId
      rgaRequired: $rgaRequired
      wearingPatch: $wearingPatch
      sensorKind: $sensorKind
    ) {
      ...CoreReplacementRequestFields
    }
  }
  ${CoreReplacementRequestFieldsFragmentDoc}
`
export type ICreateReplacementRequestMutationFn = Apollo.MutationFunction<
  ICreateReplacementRequestMutation,
  ICreateReplacementRequestMutationVariables
>

/**
 * __useCreateReplacementRequestMutation__
 *
 * To run a mutation, you first call `useCreateReplacementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReplacementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReplacementRequestMutation, { data, loading, error }] = useCreateReplacementRequestMutation({
 *   variables: {
 *      chargeAmount: // value for 'chargeAmount'
 *      daysWorn: // value for 'daysWorn'
 *      dateFellOff: // value for 'dateFellOff'
 *      dateNotified: // value for 'dateNotified'
 *      howItFellOff: // value for 'howItFellOff'
 *      notes: // value for 'notes'
 *      replacementReason: // value for 'replacementReason'
 *      sensorId: // value for 'sensorId'
 *      rgaRequired: // value for 'rgaRequired'
 *      wearingPatch: // value for 'wearingPatch'
 *      sensorKind: // value for 'sensorKind'
 *   },
 * });
 */
export function useCreateReplacementRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateReplacementRequestMutation,
    ICreateReplacementRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateReplacementRequestMutation,
    ICreateReplacementRequestMutationVariables
  >(CreateReplacementRequestDocument, options)
}
export type CreateReplacementRequestMutationHookResult = ReturnType<
  typeof useCreateReplacementRequestMutation
>
export type CreateReplacementRequestMutationResult =
  Apollo.MutationResult<ICreateReplacementRequestMutation>
export type CreateReplacementRequestMutationOptions = Apollo.BaseMutationOptions<
  ICreateReplacementRequestMutation,
  ICreateReplacementRequestMutationVariables
>
export const CreateReplacementRequestInvoiceDocument = gql`
  mutation createReplacementRequestInvoice($id: ID) {
    createReplacementRequestInvoice(id: $id) {
      ...CoreReplacementRequestFields
    }
  }
  ${CoreReplacementRequestFieldsFragmentDoc}
`
export type ICreateReplacementRequestInvoiceMutationFn = Apollo.MutationFunction<
  ICreateReplacementRequestInvoiceMutation,
  ICreateReplacementRequestInvoiceMutationVariables
>

/**
 * __useCreateReplacementRequestInvoiceMutation__
 *
 * To run a mutation, you first call `useCreateReplacementRequestInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReplacementRequestInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReplacementRequestInvoiceMutation, { data, loading, error }] = useCreateReplacementRequestInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateReplacementRequestInvoiceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateReplacementRequestInvoiceMutation,
    ICreateReplacementRequestInvoiceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ICreateReplacementRequestInvoiceMutation,
    ICreateReplacementRequestInvoiceMutationVariables
  >(CreateReplacementRequestInvoiceDocument, options)
}
export type CreateReplacementRequestInvoiceMutationHookResult = ReturnType<
  typeof useCreateReplacementRequestInvoiceMutation
>
export type CreateReplacementRequestInvoiceMutationResult =
  Apollo.MutationResult<ICreateReplacementRequestInvoiceMutation>
export type CreateReplacementRequestInvoiceMutationOptions = Apollo.BaseMutationOptions<
  ICreateReplacementRequestInvoiceMutation,
  ICreateReplacementRequestInvoiceMutationVariables
>
export const CreateShipmentDocument = gql`
  mutation createShipment(
    $orderId: Int!
    $status: String
    $quantity: Int!
    $trackingNumber: String
    $trackingUrl: String
    $lotNumber: String
    $provider: String
    $providerShipmentId: ID
    $providerReceivedAt: ISO8601DateTime
    $shippedAt: ISO8601DateTime
    $deliveredAt: ISO8601DateTime
    $firstName: String
    $lastName: String
    $street: String
    $street2: String
    $city: String
    $zipCode: String
    $state: String
    $country: String
  ) {
    createShipment(
      orderId: $orderId
      status: $status
      quantity: $quantity
      trackingNumber: $trackingNumber
      trackingUrl: $trackingUrl
      lotNumber: $lotNumber
      provider: $provider
      providerShipmentId: $providerShipmentId
      providerReceivedAt: $providerReceivedAt
      shippedAt: $shippedAt
      deliveredAt: $deliveredAt
      firstName: $firstName
      lastName: $lastName
      street: $street
      street2: $street2
      city: $city
      zipCode: $zipCode
      state: $state
      country: $country
    ) {
      ...CoreShipmentFields
      order {
        id
        invoice {
          stripeId
        }
        createdAt
        product
        productType
        sensorKind
        quantity
      }
      address {
        ...CoreAddressFields
      }
      user {
        id
        email
        firstName
        lastName
        phoneNumber
        dateOfBirth
        sex
        truepillPatientToken
      }
    }
  }
  ${CoreShipmentFieldsFragmentDoc}
  ${CoreAddressFieldsFragmentDoc}
`
export type ICreateShipmentMutationFn = Apollo.MutationFunction<
  ICreateShipmentMutation,
  ICreateShipmentMutationVariables
>

/**
 * __useCreateShipmentMutation__
 *
 * To run a mutation, you first call `useCreateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShipmentMutation, { data, loading, error }] = useCreateShipmentMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *      quantity: // value for 'quantity'
 *      trackingNumber: // value for 'trackingNumber'
 *      trackingUrl: // value for 'trackingUrl'
 *      lotNumber: // value for 'lotNumber'
 *      provider: // value for 'provider'
 *      providerShipmentId: // value for 'providerShipmentId'
 *      providerReceivedAt: // value for 'providerReceivedAt'
 *      shippedAt: // value for 'shippedAt'
 *      deliveredAt: // value for 'deliveredAt'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      street: // value for 'street'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      zipCode: // value for 'zipCode'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useCreateShipmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateShipmentMutation,
    ICreateShipmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateShipmentMutation, ICreateShipmentMutationVariables>(
    CreateShipmentDocument,
    options
  )
}
export type CreateShipmentMutationHookResult = ReturnType<typeof useCreateShipmentMutation>
export type CreateShipmentMutationResult = Apollo.MutationResult<ICreateShipmentMutation>
export type CreateShipmentMutationOptions = Apollo.BaseMutationOptions<
  ICreateShipmentMutation,
  ICreateShipmentMutationVariables
>
export const DeactivateCoachProfileDocument = gql`
  mutation deactivateCoachProfile($userId: ID!) {
    deactivateCoachProfile(userId: $userId) {
      active
    }
  }
`
export type IDeactivateCoachProfileMutationFn = Apollo.MutationFunction<
  IDeactivateCoachProfileMutation,
  IDeactivateCoachProfileMutationVariables
>

/**
 * __useDeactivateCoachProfileMutation__
 *
 * To run a mutation, you first call `useDeactivateCoachProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCoachProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCoachProfileMutation, { data, loading, error }] = useDeactivateCoachProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeactivateCoachProfileMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeactivateCoachProfileMutation,
    IDeactivateCoachProfileMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeactivateCoachProfileMutation,
    IDeactivateCoachProfileMutationVariables
  >(DeactivateCoachProfileDocument, options)
}
export type DeactivateCoachProfileMutationHookResult = ReturnType<
  typeof useDeactivateCoachProfileMutation
>
export type DeactivateCoachProfileMutationResult =
  Apollo.MutationResult<IDeactivateCoachProfileMutation>
export type DeactivateCoachProfileMutationOptions = Apollo.BaseMutationOptions<
  IDeactivateCoachProfileMutation,
  IDeactivateCoachProfileMutationVariables
>
export const DeleteChatConversationMessageTemplateDocument = gql`
  mutation deleteChatConversationMessageTemplate($id: ID!) {
    deleteChatConversationMessageTemplate(id: $id) {
      success
    }
  }
`
export type IDeleteChatConversationMessageTemplateMutationFn = Apollo.MutationFunction<
  IDeleteChatConversationMessageTemplateMutation,
  IDeleteChatConversationMessageTemplateMutationVariables
>

/**
 * __useDeleteChatConversationMessageTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteChatConversationMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatConversationMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatConversationMessageTemplateMutation, { data, loading, error }] = useDeleteChatConversationMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChatConversationMessageTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteChatConversationMessageTemplateMutation,
    IDeleteChatConversationMessageTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteChatConversationMessageTemplateMutation,
    IDeleteChatConversationMessageTemplateMutationVariables
  >(DeleteChatConversationMessageTemplateDocument, options)
}
export type DeleteChatConversationMessageTemplateMutationHookResult = ReturnType<
  typeof useDeleteChatConversationMessageTemplateMutation
>
export type DeleteChatConversationMessageTemplateMutationResult =
  Apollo.MutationResult<IDeleteChatConversationMessageTemplateMutation>
export type DeleteChatConversationMessageTemplateMutationOptions = Apollo.BaseMutationOptions<
  IDeleteChatConversationMessageTemplateMutation,
  IDeleteChatConversationMessageTemplateMutationVariables
>
export const DeleteCoachBillingInvoiceItemDocument = gql`
  mutation deleteCoachBillingInvoiceItem($itemKey: String!) {
    deleteCoachBillingInvoiceItem(itemKey: $itemKey) {
      ...CoreCoachBillingInvoiceItemFields
    }
  }
  ${CoreCoachBillingInvoiceItemFieldsFragmentDoc}
`
export type IDeleteCoachBillingInvoiceItemMutationFn = Apollo.MutationFunction<
  IDeleteCoachBillingInvoiceItemMutation,
  IDeleteCoachBillingInvoiceItemMutationVariables
>

/**
 * __useDeleteCoachBillingInvoiceItemMutation__
 *
 * To run a mutation, you first call `useDeleteCoachBillingInvoiceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoachBillingInvoiceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoachBillingInvoiceItemMutation, { data, loading, error }] = useDeleteCoachBillingInvoiceItemMutation({
 *   variables: {
 *      itemKey: // value for 'itemKey'
 *   },
 * });
 */
export function useDeleteCoachBillingInvoiceItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteCoachBillingInvoiceItemMutation,
    IDeleteCoachBillingInvoiceItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteCoachBillingInvoiceItemMutation,
    IDeleteCoachBillingInvoiceItemMutationVariables
  >(DeleteCoachBillingInvoiceItemDocument, options)
}
export type DeleteCoachBillingInvoiceItemMutationHookResult = ReturnType<
  typeof useDeleteCoachBillingInvoiceItemMutation
>
export type DeleteCoachBillingInvoiceItemMutationResult =
  Apollo.MutationResult<IDeleteCoachBillingInvoiceItemMutation>
export type DeleteCoachBillingInvoiceItemMutationOptions = Apollo.BaseMutationOptions<
  IDeleteCoachBillingInvoiceItemMutation,
  IDeleteCoachBillingInvoiceItemMutationVariables
>
export const DeleteCoachSharedAssetDocument = gql`
  mutation deleteCoachSharedAsset($id: ID!) {
    deleteCoachSharedAsset(id: $id) {
      id
    }
  }
`
export type IDeleteCoachSharedAssetMutationFn = Apollo.MutationFunction<
  IDeleteCoachSharedAssetMutation,
  IDeleteCoachSharedAssetMutationVariables
>

/**
 * __useDeleteCoachSharedAssetMutation__
 *
 * To run a mutation, you first call `useDeleteCoachSharedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCoachSharedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCoachSharedAssetMutation, { data, loading, error }] = useDeleteCoachSharedAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCoachSharedAssetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteCoachSharedAssetMutation,
    IDeleteCoachSharedAssetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteCoachSharedAssetMutation,
    IDeleteCoachSharedAssetMutationVariables
  >(DeleteCoachSharedAssetDocument, options)
}
export type DeleteCoachSharedAssetMutationHookResult = ReturnType<
  typeof useDeleteCoachSharedAssetMutation
>
export type DeleteCoachSharedAssetMutationResult =
  Apollo.MutationResult<IDeleteCoachSharedAssetMutation>
export type DeleteCoachSharedAssetMutationOptions = Apollo.BaseMutationOptions<
  IDeleteCoachSharedAssetMutation,
  IDeleteCoachSharedAssetMutationVariables
>
export const DeleteFileDocument = gql`
  mutation deleteFile($id: ID!) {
    deleteFile(id: $id) {
      ...CoreFileFields
    }
  }
  ${CoreFileFieldsFragmentDoc}
`
export type IDeleteFileMutationFn = Apollo.MutationFunction<
  IDeleteFileMutation,
  IDeleteFileMutationVariables
>

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileMutation(
  baseOptions?: Apollo.MutationHookOptions<IDeleteFileMutation, IDeleteFileMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteFileMutation, IDeleteFileMutationVariables>(
    DeleteFileDocument,
    options
  )
}
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>
export type DeleteFileMutationResult = Apollo.MutationResult<IDeleteFileMutation>
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<
  IDeleteFileMutation,
  IDeleteFileMutationVariables
>
export const DeleteKnowledgeAnswerDocument = gql`
  mutation deleteKnowledgeAnswer($id: ID!) {
    deleteKnowledgeAnswer(id: $id) {
      id
      title
      value
    }
  }
`
export type IDeleteKnowledgeAnswerMutationFn = Apollo.MutationFunction<
  IDeleteKnowledgeAnswerMutation,
  IDeleteKnowledgeAnswerMutationVariables
>

/**
 * __useDeleteKnowledgeAnswerMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeAnswerMutation, { data, loading, error }] = useDeleteKnowledgeAnswerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKnowledgeAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteKnowledgeAnswerMutation,
    IDeleteKnowledgeAnswerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteKnowledgeAnswerMutation,
    IDeleteKnowledgeAnswerMutationVariables
  >(DeleteKnowledgeAnswerDocument, options)
}
export type DeleteKnowledgeAnswerMutationHookResult = ReturnType<
  typeof useDeleteKnowledgeAnswerMutation
>
export type DeleteKnowledgeAnswerMutationResult =
  Apollo.MutationResult<IDeleteKnowledgeAnswerMutation>
export type DeleteKnowledgeAnswerMutationOptions = Apollo.BaseMutationOptions<
  IDeleteKnowledgeAnswerMutation,
  IDeleteKnowledgeAnswerMutationVariables
>
export const DeleteKnowledgeQuestionDocument = gql`
  mutation deleteKnowledgeQuestion($id: ID!) {
    deleteKnowledgeQuestion(id: $id) {
      id
      value
    }
  }
`
export type IDeleteKnowledgeQuestionMutationFn = Apollo.MutationFunction<
  IDeleteKnowledgeQuestionMutation,
  IDeleteKnowledgeQuestionMutationVariables
>

/**
 * __useDeleteKnowledgeQuestionMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeQuestionMutation, { data, loading, error }] = useDeleteKnowledgeQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKnowledgeQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteKnowledgeQuestionMutation,
    IDeleteKnowledgeQuestionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteKnowledgeQuestionMutation,
    IDeleteKnowledgeQuestionMutationVariables
  >(DeleteKnowledgeQuestionDocument, options)
}
export type DeleteKnowledgeQuestionMutationHookResult = ReturnType<
  typeof useDeleteKnowledgeQuestionMutation
>
export type DeleteKnowledgeQuestionMutationResult =
  Apollo.MutationResult<IDeleteKnowledgeQuestionMutation>
export type DeleteKnowledgeQuestionMutationOptions = Apollo.BaseMutationOptions<
  IDeleteKnowledgeQuestionMutation,
  IDeleteKnowledgeQuestionMutationVariables
>
export const DeleteKnowledgeSourceDocument = gql`
  mutation deleteKnowledgeSource($id: ID!) {
    deleteKnowledgeSource(id: $id) {
      id
      url
    }
  }
`
export type IDeleteKnowledgeSourceMutationFn = Apollo.MutationFunction<
  IDeleteKnowledgeSourceMutation,
  IDeleteKnowledgeSourceMutationVariables
>

/**
 * __useDeleteKnowledgeSourceMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeSourceMutation, { data, loading, error }] = useDeleteKnowledgeSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKnowledgeSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteKnowledgeSourceMutation,
    IDeleteKnowledgeSourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteKnowledgeSourceMutation,
    IDeleteKnowledgeSourceMutationVariables
  >(DeleteKnowledgeSourceDocument, options)
}
export type DeleteKnowledgeSourceMutationHookResult = ReturnType<
  typeof useDeleteKnowledgeSourceMutation
>
export type DeleteKnowledgeSourceMutationResult =
  Apollo.MutationResult<IDeleteKnowledgeSourceMutation>
export type DeleteKnowledgeSourceMutationOptions = Apollo.BaseMutationOptions<
  IDeleteKnowledgeSourceMutation,
  IDeleteKnowledgeSourceMutationVariables
>
export const DeleteKnowledgeTagDocument = gql`
  mutation deleteKnowledgeTag($id: ID!) {
    deleteKnowledgeTag(id: $id) {
      id
      value
    }
  }
`
export type IDeleteKnowledgeTagMutationFn = Apollo.MutationFunction<
  IDeleteKnowledgeTagMutation,
  IDeleteKnowledgeTagMutationVariables
>

/**
 * __useDeleteKnowledgeTagMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeTagMutation, { data, loading, error }] = useDeleteKnowledgeTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKnowledgeTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteKnowledgeTagMutation,
    IDeleteKnowledgeTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteKnowledgeTagMutation, IDeleteKnowledgeTagMutationVariables>(
    DeleteKnowledgeTagDocument,
    options
  )
}
export type DeleteKnowledgeTagMutationHookResult = ReturnType<typeof useDeleteKnowledgeTagMutation>
export type DeleteKnowledgeTagMutationResult = Apollo.MutationResult<IDeleteKnowledgeTagMutation>
export type DeleteKnowledgeTagMutationOptions = Apollo.BaseMutationOptions<
  IDeleteKnowledgeTagMutation,
  IDeleteKnowledgeTagMutationVariables
>
export const DeleteMealDocument = gql`
  mutation deleteMeal($id: ID) {
    deleteMeal(id: $id) {
      id
    }
  }
`
export type IDeleteMealMutationFn = Apollo.MutationFunction<
  IDeleteMealMutation,
  IDeleteMealMutationVariables
>

/**
 * __useDeleteMealMutation__
 *
 * To run a mutation, you first call `useDeleteMealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMealMutation, { data, loading, error }] = useDeleteMealMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMealMutation(
  baseOptions?: Apollo.MutationHookOptions<IDeleteMealMutation, IDeleteMealMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteMealMutation, IDeleteMealMutationVariables>(
    DeleteMealDocument,
    options
  )
}
export type DeleteMealMutationHookResult = ReturnType<typeof useDeleteMealMutation>
export type DeleteMealMutationResult = Apollo.MutationResult<IDeleteMealMutation>
export type DeleteMealMutationOptions = Apollo.BaseMutationOptions<
  IDeleteMealMutation,
  IDeleteMealMutationVariables
>
export const DeleteNoteDocument = gql`
  mutation deleteNote($id: ID) {
    deleteNote(id: $id) {
      body
      createdAt
      creatorId
      id
      occurredAt
      title
    }
  }
`
export type IDeleteNoteMutationFn = Apollo.MutationFunction<
  IDeleteNoteMutation,
  IDeleteNoteMutationVariables
>

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<IDeleteNoteMutation, IDeleteNoteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteNoteMutation, IDeleteNoteMutationVariables>(
    DeleteNoteDocument,
    options
  )
}
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>
export type DeleteNoteMutationResult = Apollo.MutationResult<IDeleteNoteMutation>
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<
  IDeleteNoteMutation,
  IDeleteNoteMutationVariables
>
export const DeleteOrderDocument = gql`
  mutation deleteOrder($id: Int!, $deletionReason: String!) {
    deleteOrder(id: $id, deletionReason: $deletionReason) {
      ...CoreOrderFields
    }
  }
  ${CoreOrderFieldsFragmentDoc}
`
export type IDeleteOrderMutationFn = Apollo.MutationFunction<
  IDeleteOrderMutation,
  IDeleteOrderMutationVariables
>

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deletionReason: // value for 'deletionReason'
 *   },
 * });
 */
export function useDeleteOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<IDeleteOrderMutation, IDeleteOrderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteOrderMutation, IDeleteOrderMutationVariables>(
    DeleteOrderDocument,
    options
  )
}
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>
export type DeleteOrderMutationResult = Apollo.MutationResult<IDeleteOrderMutation>
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<
  IDeleteOrderMutation,
  IDeleteOrderMutationVariables
>
export const DeleteReplacementRequestDocument = gql`
  mutation deleteReplacementRequest($id: ID) {
    deleteReplacementRequest(id: $id) {
      ...CoreReplacementRequestFields
    }
  }
  ${CoreReplacementRequestFieldsFragmentDoc}
`
export type IDeleteReplacementRequestMutationFn = Apollo.MutationFunction<
  IDeleteReplacementRequestMutation,
  IDeleteReplacementRequestMutationVariables
>

/**
 * __useDeleteReplacementRequestMutation__
 *
 * To run a mutation, you first call `useDeleteReplacementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReplacementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReplacementRequestMutation, { data, loading, error }] = useDeleteReplacementRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReplacementRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteReplacementRequestMutation,
    IDeleteReplacementRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IDeleteReplacementRequestMutation,
    IDeleteReplacementRequestMutationVariables
  >(DeleteReplacementRequestDocument, options)
}
export type DeleteReplacementRequestMutationHookResult = ReturnType<
  typeof useDeleteReplacementRequestMutation
>
export type DeleteReplacementRequestMutationResult =
  Apollo.MutationResult<IDeleteReplacementRequestMutation>
export type DeleteReplacementRequestMutationOptions = Apollo.BaseMutationOptions<
  IDeleteReplacementRequestMutation,
  IDeleteReplacementRequestMutationVariables
>
export const DeleteShipmentDocument = gql`
  mutation deleteShipment($id: Int) {
    deleteShipment(id: $id) {
      ...CoreShipmentFields
    }
  }
  ${CoreShipmentFieldsFragmentDoc}
`
export type IDeleteShipmentMutationFn = Apollo.MutationFunction<
  IDeleteShipmentMutation,
  IDeleteShipmentMutationVariables
>

/**
 * __useDeleteShipmentMutation__
 *
 * To run a mutation, you first call `useDeleteShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShipmentMutation, { data, loading, error }] = useDeleteShipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteShipmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteShipmentMutation,
    IDeleteShipmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteShipmentMutation, IDeleteShipmentMutationVariables>(
    DeleteShipmentDocument,
    options
  )
}
export type DeleteShipmentMutationHookResult = ReturnType<typeof useDeleteShipmentMutation>
export type DeleteShipmentMutationResult = Apollo.MutationResult<IDeleteShipmentMutation>
export type DeleteShipmentMutationOptions = Apollo.BaseMutationOptions<
  IDeleteShipmentMutation,
  IDeleteShipmentMutationVariables
>
export const DeleteUserPropertyDocument = gql`
  mutation deleteUserProperty($id: ID!) {
    deleteUserProperty(id: $id) {
      __typename
      id
    }
  }
`
export type IDeleteUserPropertyMutationFn = Apollo.MutationFunction<
  IDeleteUserPropertyMutation,
  IDeleteUserPropertyMutationVariables
>

/**
 * __useDeleteUserPropertyMutation__
 *
 * To run a mutation, you first call `useDeleteUserPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserPropertyMutation, { data, loading, error }] = useDeleteUserPropertyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserPropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteUserPropertyMutation,
    IDeleteUserPropertyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteUserPropertyMutation, IDeleteUserPropertyMutationVariables>(
    DeleteUserPropertyDocument,
    options
  )
}
export type DeleteUserPropertyMutationHookResult = ReturnType<typeof useDeleteUserPropertyMutation>
export type DeleteUserPropertyMutationResult = Apollo.MutationResult<IDeleteUserPropertyMutation>
export type DeleteUserPropertyMutationOptions = Apollo.BaseMutationOptions<
  IDeleteUserPropertyMutation,
  IDeleteUserPropertyMutationVariables
>
export const RunDexcomConnectionStatusCheckDocument = gql`
  mutation runDexcomConnectionStatusCheck($userId: ID!) {
    runDexcomConnectionStatusCheck(userId: $userId) {
      connection {
        status
        kind
        lastSyncedAt
      }
      latestGlucoseMeasurementAt
    }
  }
`
export type IRunDexcomConnectionStatusCheckMutationFn = Apollo.MutationFunction<
  IRunDexcomConnectionStatusCheckMutation,
  IRunDexcomConnectionStatusCheckMutationVariables
>

/**
 * __useRunDexcomConnectionStatusCheckMutation__
 *
 * To run a mutation, you first call `useRunDexcomConnectionStatusCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunDexcomConnectionStatusCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runDexcomConnectionStatusCheckMutation, { data, loading, error }] = useRunDexcomConnectionStatusCheckMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRunDexcomConnectionStatusCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IRunDexcomConnectionStatusCheckMutation,
    IRunDexcomConnectionStatusCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IRunDexcomConnectionStatusCheckMutation,
    IRunDexcomConnectionStatusCheckMutationVariables
  >(RunDexcomConnectionStatusCheckDocument, options)
}
export type RunDexcomConnectionStatusCheckMutationHookResult = ReturnType<
  typeof useRunDexcomConnectionStatusCheckMutation
>
export type RunDexcomConnectionStatusCheckMutationResult =
  Apollo.MutationResult<IRunDexcomConnectionStatusCheckMutation>
export type RunDexcomConnectionStatusCheckMutationOptions = Apollo.BaseMutationOptions<
  IRunDexcomConnectionStatusCheckMutation,
  IRunDexcomConnectionStatusCheckMutationVariables
>
export const GenerateHealthDataReportDocument = gql`
  mutation generateHealthDataReport(
    $userId: ID!
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $kind: HealthDataReportKind!
  ) {
    generateHealthDataReport(
      userId: $userId
      startDate: $startDate
      endDate: $endDate
      kind: $kind
    ) {
      success
    }
  }
`
export type IGenerateHealthDataReportMutationFn = Apollo.MutationFunction<
  IGenerateHealthDataReportMutation,
  IGenerateHealthDataReportMutationVariables
>

/**
 * __useGenerateHealthDataReportMutation__
 *
 * To run a mutation, you first call `useGenerateHealthDataReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateHealthDataReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateHealthDataReportMutation, { data, loading, error }] = useGenerateHealthDataReportMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useGenerateHealthDataReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IGenerateHealthDataReportMutation,
    IGenerateHealthDataReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IGenerateHealthDataReportMutation,
    IGenerateHealthDataReportMutationVariables
  >(GenerateHealthDataReportDocument, options)
}
export type GenerateHealthDataReportMutationHookResult = ReturnType<
  typeof useGenerateHealthDataReportMutation
>
export type GenerateHealthDataReportMutationResult =
  Apollo.MutationResult<IGenerateHealthDataReportMutation>
export type GenerateHealthDataReportMutationOptions = Apollo.BaseMutationOptions<
  IGenerateHealthDataReportMutation,
  IGenerateHealthDataReportMutationVariables
>
export const GrantGlucoseFeatureOverrideDocument = gql`
  mutation grantGlucoseFeatureOverride($userId: ID!) {
    grantGlucoseFeatureOverride(userId: $userId) {
      success
    }
  }
`
export type IGrantGlucoseFeatureOverrideMutationFn = Apollo.MutationFunction<
  IGrantGlucoseFeatureOverrideMutation,
  IGrantGlucoseFeatureOverrideMutationVariables
>

/**
 * __useGrantGlucoseFeatureOverrideMutation__
 *
 * To run a mutation, you first call `useGrantGlucoseFeatureOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantGlucoseFeatureOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantGlucoseFeatureOverrideMutation, { data, loading, error }] = useGrantGlucoseFeatureOverrideMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGrantGlucoseFeatureOverrideMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IGrantGlucoseFeatureOverrideMutation,
    IGrantGlucoseFeatureOverrideMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IGrantGlucoseFeatureOverrideMutation,
    IGrantGlucoseFeatureOverrideMutationVariables
  >(GrantGlucoseFeatureOverrideDocument, options)
}
export type GrantGlucoseFeatureOverrideMutationHookResult = ReturnType<
  typeof useGrantGlucoseFeatureOverrideMutation
>
export type GrantGlucoseFeatureOverrideMutationResult =
  Apollo.MutationResult<IGrantGlucoseFeatureOverrideMutation>
export type GrantGlucoseFeatureOverrideMutationOptions = Apollo.BaseMutationOptions<
  IGrantGlucoseFeatureOverrideMutation,
  IGrantGlucoseFeatureOverrideMutationVariables
>
export const LinkKnowledgeAnswerDocument = gql`
  mutation linkKnowledgeAnswer($id: ID!, $knowledgeSourceId: ID!) {
    linkKnowledgeAnswer(id: $id, knowledgeSourceId: $knowledgeSourceId) {
      ...CoreKnowledgeAnswerFields
    }
  }
  ${CoreKnowledgeAnswerFieldsFragmentDoc}
`
export type ILinkKnowledgeAnswerMutationFn = Apollo.MutationFunction<
  ILinkKnowledgeAnswerMutation,
  ILinkKnowledgeAnswerMutationVariables
>

/**
 * __useLinkKnowledgeAnswerMutation__
 *
 * To run a mutation, you first call `useLinkKnowledgeAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkKnowledgeAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkKnowledgeAnswerMutation, { data, loading, error }] = useLinkKnowledgeAnswerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      knowledgeSourceId: // value for 'knowledgeSourceId'
 *   },
 * });
 */
export function useLinkKnowledgeAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ILinkKnowledgeAnswerMutation,
    ILinkKnowledgeAnswerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ILinkKnowledgeAnswerMutation, ILinkKnowledgeAnswerMutationVariables>(
    LinkKnowledgeAnswerDocument,
    options
  )
}
export type LinkKnowledgeAnswerMutationHookResult = ReturnType<
  typeof useLinkKnowledgeAnswerMutation
>
export type LinkKnowledgeAnswerMutationResult = Apollo.MutationResult<ILinkKnowledgeAnswerMutation>
export type LinkKnowledgeAnswerMutationOptions = Apollo.BaseMutationOptions<
  ILinkKnowledgeAnswerMutation,
  ILinkKnowledgeAnswerMutationVariables
>
export const LinkKnowledgeQuestionDocument = gql`
  mutation linkKnowledgeQuestion($id: ID!, $knowledgeAnswerId: ID!) {
    linkKnowledgeQuestion(id: $id, knowledgeAnswerId: $knowledgeAnswerId) {
      ...CoreKnowledgeQuestionFields
    }
  }
  ${CoreKnowledgeQuestionFieldsFragmentDoc}
`
export type ILinkKnowledgeQuestionMutationFn = Apollo.MutationFunction<
  ILinkKnowledgeQuestionMutation,
  ILinkKnowledgeQuestionMutationVariables
>

/**
 * __useLinkKnowledgeQuestionMutation__
 *
 * To run a mutation, you first call `useLinkKnowledgeQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkKnowledgeQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkKnowledgeQuestionMutation, { data, loading, error }] = useLinkKnowledgeQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      knowledgeAnswerId: // value for 'knowledgeAnswerId'
 *   },
 * });
 */
export function useLinkKnowledgeQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ILinkKnowledgeQuestionMutation,
    ILinkKnowledgeQuestionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ILinkKnowledgeQuestionMutation,
    ILinkKnowledgeQuestionMutationVariables
  >(LinkKnowledgeQuestionDocument, options)
}
export type LinkKnowledgeQuestionMutationHookResult = ReturnType<
  typeof useLinkKnowledgeQuestionMutation
>
export type LinkKnowledgeQuestionMutationResult =
  Apollo.MutationResult<ILinkKnowledgeQuestionMutation>
export type LinkKnowledgeQuestionMutationOptions = Apollo.BaseMutationOptions<
  ILinkKnowledgeQuestionMutation,
  ILinkKnowledgeQuestionMutationVariables
>
export const NotifyFeatureFeedbackDocument = gql`
  mutation notifyFeatureFeedback(
    $feature: HealthPortalFeature!
    $message: String!
    $userId: ID
    $entityId: ID
  ) {
    notifyFeatureFeedback(
      feature: $feature
      message: $message
      userId: $userId
      entityId: $entityId
    ) {
      success
    }
  }
`
export type INotifyFeatureFeedbackMutationFn = Apollo.MutationFunction<
  INotifyFeatureFeedbackMutation,
  INotifyFeatureFeedbackMutationVariables
>

/**
 * __useNotifyFeatureFeedbackMutation__
 *
 * To run a mutation, you first call `useNotifyFeatureFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyFeatureFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyFeatureFeedbackMutation, { data, loading, error }] = useNotifyFeatureFeedbackMutation({
 *   variables: {
 *      feature: // value for 'feature'
 *      message: // value for 'message'
 *      userId: // value for 'userId'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useNotifyFeatureFeedbackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    INotifyFeatureFeedbackMutation,
    INotifyFeatureFeedbackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    INotifyFeatureFeedbackMutation,
    INotifyFeatureFeedbackMutationVariables
  >(NotifyFeatureFeedbackDocument, options)
}
export type NotifyFeatureFeedbackMutationHookResult = ReturnType<
  typeof useNotifyFeatureFeedbackMutation
>
export type NotifyFeatureFeedbackMutationResult =
  Apollo.MutationResult<INotifyFeatureFeedbackMutation>
export type NotifyFeatureFeedbackMutationOptions = Apollo.BaseMutationOptions<
  INotifyFeatureFeedbackMutation,
  INotifyFeatureFeedbackMutationVariables
>
export const PromoteToCoachChatConversationDocument = gql`
  mutation promoteToCoachChatConversation($id: ID!, $coachingKind: CoachesCoachingKind) {
    promoteToCoachChatConversation(id: $id, coachingKind: $coachingKind) {
      success
    }
  }
`
export type IPromoteToCoachChatConversationMutationFn = Apollo.MutationFunction<
  IPromoteToCoachChatConversationMutation,
  IPromoteToCoachChatConversationMutationVariables
>

/**
 * __usePromoteToCoachChatConversationMutation__
 *
 * To run a mutation, you first call `usePromoteToCoachChatConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteToCoachChatConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteToCoachChatConversationMutation, { data, loading, error }] = usePromoteToCoachChatConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      coachingKind: // value for 'coachingKind'
 *   },
 * });
 */
export function usePromoteToCoachChatConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IPromoteToCoachChatConversationMutation,
    IPromoteToCoachChatConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IPromoteToCoachChatConversationMutation,
    IPromoteToCoachChatConversationMutationVariables
  >(PromoteToCoachChatConversationDocument, options)
}
export type PromoteToCoachChatConversationMutationHookResult = ReturnType<
  typeof usePromoteToCoachChatConversationMutation
>
export type PromoteToCoachChatConversationMutationResult =
  Apollo.MutationResult<IPromoteToCoachChatConversationMutation>
export type PromoteToCoachChatConversationMutationOptions = Apollo.BaseMutationOptions<
  IPromoteToCoachChatConversationMutation,
  IPromoteToCoachChatConversationMutationVariables
>
export const RemoveKnowledgeQuestionTagDocument = gql`
  mutation removeKnowledgeQuestionTag($id: ID!, $knowledgeTagId: ID!) {
    removeKnowledgeQuestionTag(id: $id, knowledgeTagId: $knowledgeTagId) {
      ...CoreKnowledgeQuestionFields
    }
  }
  ${CoreKnowledgeQuestionFieldsFragmentDoc}
`
export type IRemoveKnowledgeQuestionTagMutationFn = Apollo.MutationFunction<
  IRemoveKnowledgeQuestionTagMutation,
  IRemoveKnowledgeQuestionTagMutationVariables
>

/**
 * __useRemoveKnowledgeQuestionTagMutation__
 *
 * To run a mutation, you first call `useRemoveKnowledgeQuestionTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveKnowledgeQuestionTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeKnowledgeQuestionTagMutation, { data, loading, error }] = useRemoveKnowledgeQuestionTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      knowledgeTagId: // value for 'knowledgeTagId'
 *   },
 * });
 */
export function useRemoveKnowledgeQuestionTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IRemoveKnowledgeQuestionTagMutation,
    IRemoveKnowledgeQuestionTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IRemoveKnowledgeQuestionTagMutation,
    IRemoveKnowledgeQuestionTagMutationVariables
  >(RemoveKnowledgeQuestionTagDocument, options)
}
export type RemoveKnowledgeQuestionTagMutationHookResult = ReturnType<
  typeof useRemoveKnowledgeQuestionTagMutation
>
export type RemoveKnowledgeQuestionTagMutationResult =
  Apollo.MutationResult<IRemoveKnowledgeQuestionTagMutation>
export type RemoveKnowledgeQuestionTagMutationOptions = Apollo.BaseMutationOptions<
  IRemoveKnowledgeQuestionTagMutation,
  IRemoveKnowledgeQuestionTagMutationVariables
>
export const ResendMissingPrescriptionsShipmentsDocument = gql`
  mutation resendMissingPrescriptionsShipments {
    resendMissingPrescriptionsShipments {
      shipments {
        ...CoreShipmentFields
      }
      totalRecords
    }
  }
  ${CoreShipmentFieldsFragmentDoc}
`
export type IResendMissingPrescriptionsShipmentsMutationFn = Apollo.MutationFunction<
  IResendMissingPrescriptionsShipmentsMutation,
  IResendMissingPrescriptionsShipmentsMutationVariables
>

/**
 * __useResendMissingPrescriptionsShipmentsMutation__
 *
 * To run a mutation, you first call `useResendMissingPrescriptionsShipmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMissingPrescriptionsShipmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMissingPrescriptionsShipmentsMutation, { data, loading, error }] = useResendMissingPrescriptionsShipmentsMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendMissingPrescriptionsShipmentsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IResendMissingPrescriptionsShipmentsMutation,
    IResendMissingPrescriptionsShipmentsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IResendMissingPrescriptionsShipmentsMutation,
    IResendMissingPrescriptionsShipmentsMutationVariables
  >(ResendMissingPrescriptionsShipmentsDocument, options)
}
export type ResendMissingPrescriptionsShipmentsMutationHookResult = ReturnType<
  typeof useResendMissingPrescriptionsShipmentsMutation
>
export type ResendMissingPrescriptionsShipmentsMutationResult =
  Apollo.MutationResult<IResendMissingPrescriptionsShipmentsMutation>
export type ResendMissingPrescriptionsShipmentsMutationOptions = Apollo.BaseMutationOptions<
  IResendMissingPrescriptionsShipmentsMutation,
  IResendMissingPrescriptionsShipmentsMutationVariables
>
export const ResendShipmentDocument = gql`
  mutation resendShipment($id: Int) {
    resendShipment(id: $id) {
      ...CoreShipmentFields
    }
  }
  ${CoreShipmentFieldsFragmentDoc}
`
export type IResendShipmentMutationFn = Apollo.MutationFunction<
  IResendShipmentMutation,
  IResendShipmentMutationVariables
>

/**
 * __useResendShipmentMutation__
 *
 * To run a mutation, you first call `useResendShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendShipmentMutation, { data, loading, error }] = useResendShipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendShipmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IResendShipmentMutation,
    IResendShipmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IResendShipmentMutation, IResendShipmentMutationVariables>(
    ResendShipmentDocument,
    options
  )
}
export type ResendShipmentMutationHookResult = ReturnType<typeof useResendShipmentMutation>
export type ResendShipmentMutationResult = Apollo.MutationResult<IResendShipmentMutation>
export type ResendShipmentMutationOptions = Apollo.BaseMutationOptions<
  IResendShipmentMutation,
  IResendShipmentMutationVariables
>
export const ResetVideoChatAssignmentDocument = gql`
  mutation resetVideoChatAssignment($userId: ID!, $coachingKind: CoachesCoachingKind) {
    resetVideoChatAssignment(userId: $userId, coachingKind: $coachingKind) {
      success
    }
  }
`
export type IResetVideoChatAssignmentMutationFn = Apollo.MutationFunction<
  IResetVideoChatAssignmentMutation,
  IResetVideoChatAssignmentMutationVariables
>

/**
 * __useResetVideoChatAssignmentMutation__
 *
 * To run a mutation, you first call `useResetVideoChatAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetVideoChatAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetVideoChatAssignmentMutation, { data, loading, error }] = useResetVideoChatAssignmentMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      coachingKind: // value for 'coachingKind'
 *   },
 * });
 */
export function useResetVideoChatAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IResetVideoChatAssignmentMutation,
    IResetVideoChatAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IResetVideoChatAssignmentMutation,
    IResetVideoChatAssignmentMutationVariables
  >(ResetVideoChatAssignmentDocument, options)
}
export type ResetVideoChatAssignmentMutationHookResult = ReturnType<
  typeof useResetVideoChatAssignmentMutation
>
export type ResetVideoChatAssignmentMutationResult =
  Apollo.MutationResult<IResetVideoChatAssignmentMutation>
export type ResetVideoChatAssignmentMutationOptions = Apollo.BaseMutationOptions<
  IResetVideoChatAssignmentMutation,
  IResetVideoChatAssignmentMutationVariables
>
export const RespondToHealthPortalNotificationDocument = gql`
  mutation respondToHealthPortalNotification($id: ID!, $response: Boolean!) {
    respondToHealthPortalNotification(id: $id, response: $response) {
      success
    }
  }
`
export type IRespondToHealthPortalNotificationMutationFn = Apollo.MutationFunction<
  IRespondToHealthPortalNotificationMutation,
  IRespondToHealthPortalNotificationMutationVariables
>

/**
 * __useRespondToHealthPortalNotificationMutation__
 *
 * To run a mutation, you first call `useRespondToHealthPortalNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToHealthPortalNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToHealthPortalNotificationMutation, { data, loading, error }] = useRespondToHealthPortalNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      response: // value for 'response'
 *   },
 * });
 */
export function useRespondToHealthPortalNotificationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IRespondToHealthPortalNotificationMutation,
    IRespondToHealthPortalNotificationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IRespondToHealthPortalNotificationMutation,
    IRespondToHealthPortalNotificationMutationVariables
  >(RespondToHealthPortalNotificationDocument, options)
}
export type RespondToHealthPortalNotificationMutationHookResult = ReturnType<
  typeof useRespondToHealthPortalNotificationMutation
>
export type RespondToHealthPortalNotificationMutationResult =
  Apollo.MutationResult<IRespondToHealthPortalNotificationMutation>
export type RespondToHealthPortalNotificationMutationOptions = Apollo.BaseMutationOptions<
  IRespondToHealthPortalNotificationMutation,
  IRespondToHealthPortalNotificationMutationVariables
>
export const RestartSurveyLinkDocument = gql`
  mutation restartSurveyLink($id: ID!, $questionKeys: [RestartSurveyLinkQuestionKeys!]) {
    restartSurveyLink(id: $id, questionKeys: $questionKeys) {
      id
      state
    }
  }
`
export type IRestartSurveyLinkMutationFn = Apollo.MutationFunction<
  IRestartSurveyLinkMutation,
  IRestartSurveyLinkMutationVariables
>

/**
 * __useRestartSurveyLinkMutation__
 *
 * To run a mutation, you first call `useRestartSurveyLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestartSurveyLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restartSurveyLinkMutation, { data, loading, error }] = useRestartSurveyLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionKeys: // value for 'questionKeys'
 *   },
 * });
 */
export function useRestartSurveyLinkMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IRestartSurveyLinkMutation,
    IRestartSurveyLinkMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IRestartSurveyLinkMutation, IRestartSurveyLinkMutationVariables>(
    RestartSurveyLinkDocument,
    options
  )
}
export type RestartSurveyLinkMutationHookResult = ReturnType<typeof useRestartSurveyLinkMutation>
export type RestartSurveyLinkMutationResult = Apollo.MutationResult<IRestartSurveyLinkMutation>
export type RestartSurveyLinkMutationOptions = Apollo.BaseMutationOptions<
  IRestartSurveyLinkMutation,
  IRestartSurveyLinkMutationVariables
>
export const SaveHealthDataReportDocument = gql`
  mutation saveHealthDataReport($id: ID!, $reportData: String!) {
    saveHealthDataReport(id: $id, reportData: $reportData) {
      success
    }
  }
`
export type ISaveHealthDataReportMutationFn = Apollo.MutationFunction<
  ISaveHealthDataReportMutation,
  ISaveHealthDataReportMutationVariables
>

/**
 * __useSaveHealthDataReportMutation__
 *
 * To run a mutation, you first call `useSaveHealthDataReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHealthDataReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHealthDataReportMutation, { data, loading, error }] = useSaveHealthDataReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *      reportData: // value for 'reportData'
 *   },
 * });
 */
export function useSaveHealthDataReportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISaveHealthDataReportMutation,
    ISaveHealthDataReportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISaveHealthDataReportMutation, ISaveHealthDataReportMutationVariables>(
    SaveHealthDataReportDocument,
    options
  )
}
export type SaveHealthDataReportMutationHookResult = ReturnType<
  typeof useSaveHealthDataReportMutation
>
export type SaveHealthDataReportMutationResult =
  Apollo.MutationResult<ISaveHealthDataReportMutation>
export type SaveHealthDataReportMutationOptions = Apollo.BaseMutationOptions<
  ISaveHealthDataReportMutation,
  ISaveHealthDataReportMutationVariables
>
export const SendChatConversationMessageDocument = gql`
  mutation sendChatConversationMessage($userId: ID!, $body: String!, $conversationId: ID) {
    sendChatConversationMessage(userId: $userId, body: $body, conversationId: $conversationId) {
      success
    }
  }
`
export type ISendChatConversationMessageMutationFn = Apollo.MutationFunction<
  ISendChatConversationMessageMutation,
  ISendChatConversationMessageMutationVariables
>

/**
 * __useSendChatConversationMessageMutation__
 *
 * To run a mutation, you first call `useSendChatConversationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendChatConversationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendChatConversationMessageMutation, { data, loading, error }] = useSendChatConversationMessageMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      body: // value for 'body'
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useSendChatConversationMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISendChatConversationMessageMutation,
    ISendChatConversationMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISendChatConversationMessageMutation,
    ISendChatConversationMessageMutationVariables
  >(SendChatConversationMessageDocument, options)
}
export type SendChatConversationMessageMutationHookResult = ReturnType<
  typeof useSendChatConversationMessageMutation
>
export type SendChatConversationMessageMutationResult =
  Apollo.MutationResult<ISendChatConversationMessageMutation>
export type SendChatConversationMessageMutationOptions = Apollo.BaseMutationOptions<
  ISendChatConversationMessageMutation,
  ISendChatConversationMessageMutationVariables
>
export const SendMfaSmsCodeDocument = gql`
  mutation sendMfaSmsCode {
    sendMfaSmsCode {
      success
      userEmail
      userMaskedPhoneNumber
    }
  }
`
export type ISendMfaSmsCodeMutationFn = Apollo.MutationFunction<
  ISendMfaSmsCodeMutation,
  ISendMfaSmsCodeMutationVariables
>

/**
 * __useSendMfaSmsCodeMutation__
 *
 * To run a mutation, you first call `useSendMfaSmsCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMfaSmsCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMfaSmsCodeMutation, { data, loading, error }] = useSendMfaSmsCodeMutation({
 *   variables: {
 *   },
 * });
 */
export function useSendMfaSmsCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISendMfaSmsCodeMutation,
    ISendMfaSmsCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISendMfaSmsCodeMutation, ISendMfaSmsCodeMutationVariables>(
    SendMfaSmsCodeDocument,
    options
  )
}
export type SendMfaSmsCodeMutationHookResult = ReturnType<typeof useSendMfaSmsCodeMutation>
export type SendMfaSmsCodeMutationResult = Apollo.MutationResult<ISendMfaSmsCodeMutation>
export type SendMfaSmsCodeMutationOptions = Apollo.BaseMutationOptions<
  ISendMfaSmsCodeMutation,
  ISendMfaSmsCodeMutationVariables
>
export const UpdateSupportedSensorDocument = gql`
  mutation updateSupportedSensor($model: SensorModelsSupportedModelsKind!) {
    updateSupportedSensor(model: $model) {
      success
    }
  }
`
export type IUpdateSupportedSensorMutationFn = Apollo.MutationFunction<
  IUpdateSupportedSensorMutation,
  IUpdateSupportedSensorMutationVariables
>

/**
 * __useUpdateSupportedSensorMutation__
 *
 * To run a mutation, you first call `useUpdateSupportedSensorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSupportedSensorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSupportedSensorMutation, { data, loading, error }] = useUpdateSupportedSensorMutation({
 *   variables: {
 *      model: // value for 'model'
 *   },
 * });
 */
export function useUpdateSupportedSensorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateSupportedSensorMutation,
    IUpdateSupportedSensorMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateSupportedSensorMutation,
    IUpdateSupportedSensorMutationVariables
  >(UpdateSupportedSensorDocument, options)
}
export type UpdateSupportedSensorMutationHookResult = ReturnType<
  typeof useUpdateSupportedSensorMutation
>
export type UpdateSupportedSensorMutationResult =
  Apollo.MutationResult<IUpdateSupportedSensorMutation>
export type UpdateSupportedSensorMutationOptions = Apollo.BaseMutationOptions<
  IUpdateSupportedSensorMutation,
  IUpdateSupportedSensorMutationVariables
>
export const SetPrimaryGoalMetricsDocument = gql`
  mutation setPrimaryGoalMetrics($kinds: [UserGoalMetricKind!]) {
    setPrimaryGoalMetrics(kinds: $kinds) {
      primary
      kind
      lowThresholdValue
      highThresholdValue
      section
      statKey
    }
  }
`
export type ISetPrimaryGoalMetricsMutationFn = Apollo.MutationFunction<
  ISetPrimaryGoalMetricsMutation,
  ISetPrimaryGoalMetricsMutationVariables
>

/**
 * __useSetPrimaryGoalMetricsMutation__
 *
 * To run a mutation, you first call `useSetPrimaryGoalMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPrimaryGoalMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPrimaryGoalMetricsMutation, { data, loading, error }] = useSetPrimaryGoalMetricsMutation({
 *   variables: {
 *      kinds: // value for 'kinds'
 *   },
 * });
 */
export function useSetPrimaryGoalMetricsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISetPrimaryGoalMetricsMutation,
    ISetPrimaryGoalMetricsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ISetPrimaryGoalMetricsMutation,
    ISetPrimaryGoalMetricsMutationVariables
  >(SetPrimaryGoalMetricsDocument, options)
}
export type SetPrimaryGoalMetricsMutationHookResult = ReturnType<
  typeof useSetPrimaryGoalMetricsMutation
>
export type SetPrimaryGoalMetricsMutationResult =
  Apollo.MutationResult<ISetPrimaryGoalMetricsMutation>
export type SetPrimaryGoalMetricsMutationOptions = Apollo.BaseMutationOptions<
  ISetPrimaryGoalMetricsMutation,
  ISetPrimaryGoalMetricsMutationVariables
>
export const SignInThirdPartyUserDocument = gql`
  mutation signInThirdPartyUser($provider: ThirdPartySignInProvider!, $providerToken: String!) {
    signInThirdPartyUser(provider: $provider, providerToken: $providerToken) {
      role
      token
      user {
        id
      }
    }
  }
`
export type ISignInThirdPartyUserMutationFn = Apollo.MutationFunction<
  ISignInThirdPartyUserMutation,
  ISignInThirdPartyUserMutationVariables
>

/**
 * __useSignInThirdPartyUserMutation__
 *
 * To run a mutation, you first call `useSignInThirdPartyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInThirdPartyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInThirdPartyUserMutation, { data, loading, error }] = useSignInThirdPartyUserMutation({
 *   variables: {
 *      provider: // value for 'provider'
 *      providerToken: // value for 'providerToken'
 *   },
 * });
 */
export function useSignInThirdPartyUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ISignInThirdPartyUserMutation,
    ISignInThirdPartyUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISignInThirdPartyUserMutation, ISignInThirdPartyUserMutationVariables>(
    SignInThirdPartyUserDocument,
    options
  )
}
export type SignInThirdPartyUserMutationHookResult = ReturnType<
  typeof useSignInThirdPartyUserMutation
>
export type SignInThirdPartyUserMutationResult =
  Apollo.MutationResult<ISignInThirdPartyUserMutation>
export type SignInThirdPartyUserMutationOptions = Apollo.BaseMutationOptions<
  ISignInThirdPartyUserMutation,
  ISignInThirdPartyUserMutationVariables
>
export const SignInUserDocument = gql`
  mutation signInUser($email: String, $password: String) {
    signInUser(email: $email, password: $password) {
      role
      token
      user {
        id
        mfaEnabled
      }
    }
  }
`
export type ISignInUserMutationFn = Apollo.MutationFunction<
  ISignInUserMutation,
  ISignInUserMutationVariables
>

/**
 * __useSignInUserMutation__
 *
 * To run a mutation, you first call `useSignInUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInUserMutation, { data, loading, error }] = useSignInUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useSignInUserMutation(
  baseOptions?: Apollo.MutationHookOptions<ISignInUserMutation, ISignInUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISignInUserMutation, ISignInUserMutationVariables>(
    SignInUserDocument,
    options
  )
}
export type SignInUserMutationHookResult = ReturnType<typeof useSignInUserMutation>
export type SignInUserMutationResult = Apollo.MutationResult<ISignInUserMutation>
export type SignInUserMutationOptions = Apollo.BaseMutationOptions<
  ISignInUserMutation,
  ISignInUserMutationVariables
>
export const SignOutUserDocument = gql`
  mutation signOutUser {
    signOutUser {
      success
    }
  }
`
export type ISignOutUserMutationFn = Apollo.MutationFunction<
  ISignOutUserMutation,
  ISignOutUserMutationVariables
>

/**
 * __useSignOutUserMutation__
 *
 * To run a mutation, you first call `useSignOutUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutUserMutation, { data, loading, error }] = useSignOutUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutUserMutation(
  baseOptions?: Apollo.MutationHookOptions<ISignOutUserMutation, ISignOutUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ISignOutUserMutation, ISignOutUserMutationVariables>(
    SignOutUserDocument,
    options
  )
}
export type SignOutUserMutationHookResult = ReturnType<typeof useSignOutUserMutation>
export type SignOutUserMutationResult = Apollo.MutationResult<ISignOutUserMutation>
export type SignOutUserMutationOptions = Apollo.BaseMutationOptions<
  ISignOutUserMutation,
  ISignOutUserMutationVariables
>
export const CreateTicketCommentDocument = gql`
  mutation createTicketComment($ticketId: ID!, $body: String!, $mentionedAdminIds: [ID!]) {
    createTicketComment(ticketId: $ticketId, body: $body, mentionedAdminIds: $mentionedAdminIds) {
      body
      createdBy {
        id
        fullName
        email
        phoneNumber
        timeZone
      }
      createdAt
    }
  }
`
export type ICreateTicketCommentMutationFn = Apollo.MutationFunction<
  ICreateTicketCommentMutation,
  ICreateTicketCommentMutationVariables
>

/**
 * __useCreateTicketCommentMutation__
 *
 * To run a mutation, you first call `useCreateTicketCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketCommentMutation, { data, loading, error }] = useCreateTicketCommentMutation({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *      body: // value for 'body'
 *      mentionedAdminIds: // value for 'mentionedAdminIds'
 *   },
 * });
 */
export function useCreateTicketCommentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateTicketCommentMutation,
    ICreateTicketCommentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateTicketCommentMutation, ICreateTicketCommentMutationVariables>(
    CreateTicketCommentDocument,
    options
  )
}
export type CreateTicketCommentMutationHookResult = ReturnType<
  typeof useCreateTicketCommentMutation
>
export type CreateTicketCommentMutationResult = Apollo.MutationResult<ICreateTicketCommentMutation>
export type CreateTicketCommentMutationOptions = Apollo.BaseMutationOptions<
  ICreateTicketCommentMutation,
  ICreateTicketCommentMutationVariables
>
export const CreateTicketDocument = gql`
  mutation createTicket(
    $userId: ID!
    $description: String!
    $kind: TicketKind!
    $reason: TicketReason!
    $priority: TicketPriority!
  ) {
    createTicket(
      userId: $userId
      description: $description
      kind: $kind
      reason: $reason
      priority: $priority
    ) {
      ...CoreTicketFields
    }
  }
  ${CoreTicketFieldsFragmentDoc}
`
export type ICreateTicketMutationFn = Apollo.MutationFunction<
  ICreateTicketMutation,
  ICreateTicketMutationVariables
>

/**
 * __useCreateTicketMutation__
 *
 * To run a mutation, you first call `useCreateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketMutation, { data, loading, error }] = useCreateTicketMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      description: // value for 'description'
 *      kind: // value for 'kind'
 *      reason: // value for 'reason'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useCreateTicketMutation(
  baseOptions?: Apollo.MutationHookOptions<ICreateTicketMutation, ICreateTicketMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateTicketMutation, ICreateTicketMutationVariables>(
    CreateTicketDocument,
    options
  )
}
export type CreateTicketMutationHookResult = ReturnType<typeof useCreateTicketMutation>
export type CreateTicketMutationResult = Apollo.MutationResult<ICreateTicketMutation>
export type CreateTicketMutationOptions = Apollo.BaseMutationOptions<
  ICreateTicketMutation,
  ICreateTicketMutationVariables
>
export const DeleteTicketDocument = gql`
  mutation deleteTicket($id: ID!) {
    deleteTicket(id: $id) {
      ...CoreTicketFields
    }
  }
  ${CoreTicketFieldsFragmentDoc}
`
export type IDeleteTicketMutationFn = Apollo.MutationFunction<
  IDeleteTicketMutation,
  IDeleteTicketMutationVariables
>

/**
 * __useDeleteTicketMutation__
 *
 * To run a mutation, you first call `useDeleteTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTicketMutation, { data, loading, error }] = useDeleteTicketMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTicketMutation(
  baseOptions?: Apollo.MutationHookOptions<IDeleteTicketMutation, IDeleteTicketMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteTicketMutation, IDeleteTicketMutationVariables>(
    DeleteTicketDocument,
    options
  )
}
export type DeleteTicketMutationHookResult = ReturnType<typeof useDeleteTicketMutation>
export type DeleteTicketMutationResult = Apollo.MutationResult<IDeleteTicketMutation>
export type DeleteTicketMutationOptions = Apollo.BaseMutationOptions<
  IDeleteTicketMutation,
  IDeleteTicketMutationVariables
>
export const UpdateTicketDocument = gql`
  mutation updateTicket(
    $id: ID!
    $assignedToId: ID
    $description: String
    $status: TicketStatus
    $priority: TicketPriority
    $externalLink: String
  ) {
    updateTicket(
      id: $id
      assignedToId: $assignedToId
      description: $description
      status: $status
      priority: $priority
      externalLink: $externalLink
    ) {
      ...CoreTicketFields
    }
  }
  ${CoreTicketFieldsFragmentDoc}
`
export type IUpdateTicketMutationFn = Apollo.MutationFunction<
  IUpdateTicketMutation,
  IUpdateTicketMutationVariables
>

/**
 * __useUpdateTicketMutation__
 *
 * To run a mutation, you first call `useUpdateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTicketMutation, { data, loading, error }] = useUpdateTicketMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assignedToId: // value for 'assignedToId'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *      priority: // value for 'priority'
 *      externalLink: // value for 'externalLink'
 *   },
 * });
 */
export function useUpdateTicketMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpdateTicketMutation, IUpdateTicketMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateTicketMutation, IUpdateTicketMutationVariables>(
    UpdateTicketDocument,
    options
  )
}
export type UpdateTicketMutationHookResult = ReturnType<typeof useUpdateTicketMutation>
export type UpdateTicketMutationResult = Apollo.MutationResult<IUpdateTicketMutation>
export type UpdateTicketMutationOptions = Apollo.BaseMutationOptions<
  IUpdateTicketMutation,
  IUpdateTicketMutationVariables
>
export const UnassignAuthorizationPolicyDocument = gql`
  mutation unassignAuthorizationPolicy($id: ID!) {
    unassignAuthorizationPolicy(id: $id) {
      ...CoreUserAuthorizationPolicyFields
    }
  }
  ${CoreUserAuthorizationPolicyFieldsFragmentDoc}
`
export type IUnassignAuthorizationPolicyMutationFn = Apollo.MutationFunction<
  IUnassignAuthorizationPolicyMutation,
  IUnassignAuthorizationPolicyMutationVariables
>

/**
 * __useUnassignAuthorizationPolicyMutation__
 *
 * To run a mutation, you first call `useUnassignAuthorizationPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignAuthorizationPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignAuthorizationPolicyMutation, { data, loading, error }] = useUnassignAuthorizationPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnassignAuthorizationPolicyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUnassignAuthorizationPolicyMutation,
    IUnassignAuthorizationPolicyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUnassignAuthorizationPolicyMutation,
    IUnassignAuthorizationPolicyMutationVariables
  >(UnassignAuthorizationPolicyDocument, options)
}
export type UnassignAuthorizationPolicyMutationHookResult = ReturnType<
  typeof useUnassignAuthorizationPolicyMutation
>
export type UnassignAuthorizationPolicyMutationResult =
  Apollo.MutationResult<IUnassignAuthorizationPolicyMutation>
export type UnassignAuthorizationPolicyMutationOptions = Apollo.BaseMutationOptions<
  IUnassignAuthorizationPolicyMutation,
  IUnassignAuthorizationPolicyMutationVariables
>
export const UnlinkKnowledgeAnswerDocument = gql`
  mutation unlinkKnowledgeAnswer($id: ID!, $knowledgeSourceId: ID!) {
    unlinkKnowledgeAnswer(id: $id, knowledgeSourceId: $knowledgeSourceId) {
      ...CoreKnowledgeAnswerFields
    }
  }
  ${CoreKnowledgeAnswerFieldsFragmentDoc}
`
export type IUnlinkKnowledgeAnswerMutationFn = Apollo.MutationFunction<
  IUnlinkKnowledgeAnswerMutation,
  IUnlinkKnowledgeAnswerMutationVariables
>

/**
 * __useUnlinkKnowledgeAnswerMutation__
 *
 * To run a mutation, you first call `useUnlinkKnowledgeAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkKnowledgeAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkKnowledgeAnswerMutation, { data, loading, error }] = useUnlinkKnowledgeAnswerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      knowledgeSourceId: // value for 'knowledgeSourceId'
 *   },
 * });
 */
export function useUnlinkKnowledgeAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUnlinkKnowledgeAnswerMutation,
    IUnlinkKnowledgeAnswerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUnlinkKnowledgeAnswerMutation,
    IUnlinkKnowledgeAnswerMutationVariables
  >(UnlinkKnowledgeAnswerDocument, options)
}
export type UnlinkKnowledgeAnswerMutationHookResult = ReturnType<
  typeof useUnlinkKnowledgeAnswerMutation
>
export type UnlinkKnowledgeAnswerMutationResult =
  Apollo.MutationResult<IUnlinkKnowledgeAnswerMutation>
export type UnlinkKnowledgeAnswerMutationOptions = Apollo.BaseMutationOptions<
  IUnlinkKnowledgeAnswerMutation,
  IUnlinkKnowledgeAnswerMutationVariables
>
export const UnlinkKnowledgeQuestionDocument = gql`
  mutation unlinkKnowledgeQuestion($id: ID!, $knowledgeAnswerId: ID!) {
    unlinkKnowledgeQuestion(id: $id, knowledgeAnswerId: $knowledgeAnswerId) {
      ...CoreKnowledgeQuestionFields
    }
  }
  ${CoreKnowledgeQuestionFieldsFragmentDoc}
`
export type IUnlinkKnowledgeQuestionMutationFn = Apollo.MutationFunction<
  IUnlinkKnowledgeQuestionMutation,
  IUnlinkKnowledgeQuestionMutationVariables
>

/**
 * __useUnlinkKnowledgeQuestionMutation__
 *
 * To run a mutation, you first call `useUnlinkKnowledgeQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkKnowledgeQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkKnowledgeQuestionMutation, { data, loading, error }] = useUnlinkKnowledgeQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      knowledgeAnswerId: // value for 'knowledgeAnswerId'
 *   },
 * });
 */
export function useUnlinkKnowledgeQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUnlinkKnowledgeQuestionMutation,
    IUnlinkKnowledgeQuestionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUnlinkKnowledgeQuestionMutation,
    IUnlinkKnowledgeQuestionMutationVariables
  >(UnlinkKnowledgeQuestionDocument, options)
}
export type UnlinkKnowledgeQuestionMutationHookResult = ReturnType<
  typeof useUnlinkKnowledgeQuestionMutation
>
export type UnlinkKnowledgeQuestionMutationResult =
  Apollo.MutationResult<IUnlinkKnowledgeQuestionMutation>
export type UnlinkKnowledgeQuestionMutationOptions = Apollo.BaseMutationOptions<
  IUnlinkKnowledgeQuestionMutation,
  IUnlinkKnowledgeQuestionMutationVariables
>
export const UpdateAddressDocument = gql`
  mutation updateAddress(
    $id: ID
    $street: String
    $street2: String
    $city: String
    $name: String
    $state: AddressState
    $country: AddressCountry
    $zipCode: String
  ) {
    updateAddress(
      id: $id
      street: $street
      street2: $street2
      city: $city
      name: $name
      state: $state
      country: $country
      zipCode: $zipCode
    ) {
      ...CoreAddressFields
    }
  }
  ${CoreAddressFieldsFragmentDoc}
`
export type IUpdateAddressMutationFn = Apollo.MutationFunction<
  IUpdateAddressMutation,
  IUpdateAddressMutationVariables
>

/**
 * __useUpdateAddressMutation__
 *
 * To run a mutation, you first call `useUpdateAddressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddressMutation, { data, loading, error }] = useUpdateAddressMutation({
 *   variables: {
 *      id: // value for 'id'
 *      street: // value for 'street'
 *      street2: // value for 'street2'
 *      city: // value for 'city'
 *      name: // value for 'name'
 *      state: // value for 'state'
 *      country: // value for 'country'
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useUpdateAddressMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpdateAddressMutation, IUpdateAddressMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateAddressMutation, IUpdateAddressMutationVariables>(
    UpdateAddressDocument,
    options
  )
}
export type UpdateAddressMutationHookResult = ReturnType<typeof useUpdateAddressMutation>
export type UpdateAddressMutationResult = Apollo.MutationResult<IUpdateAddressMutation>
export type UpdateAddressMutationOptions = Apollo.BaseMutationOptions<
  IUpdateAddressMutation,
  IUpdateAddressMutationVariables
>
export const UpdateChatConversationDocument = gql`
  mutation updateChatConversation($id: ID, $read: Boolean) {
    updateChatConversation(id: $id, read: $read) {
      ...CoreChatConversationFields
    }
  }
  ${CoreChatConversationFieldsFragmentDoc}
`
export type IUpdateChatConversationMutationFn = Apollo.MutationFunction<
  IUpdateChatConversationMutation,
  IUpdateChatConversationMutationVariables
>

/**
 * __useUpdateChatConversationMutation__
 *
 * To run a mutation, you first call `useUpdateChatConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatConversationMutation, { data, loading, error }] = useUpdateChatConversationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useUpdateChatConversationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateChatConversationMutation,
    IUpdateChatConversationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateChatConversationMutation,
    IUpdateChatConversationMutationVariables
  >(UpdateChatConversationDocument, options)
}
export type UpdateChatConversationMutationHookResult = ReturnType<
  typeof useUpdateChatConversationMutation
>
export type UpdateChatConversationMutationResult =
  Apollo.MutationResult<IUpdateChatConversationMutation>
export type UpdateChatConversationMutationOptions = Apollo.BaseMutationOptions<
  IUpdateChatConversationMutation,
  IUpdateChatConversationMutationVariables
>
export const UpdateChatConversationMessageTemplateDocument = gql`
  mutation updateChatConversationMessageTemplate(
    $id: ID
    $name: String
    $value: String
    $private: Boolean
  ) {
    updateChatConversationMessageTemplate(id: $id, name: $name, value: $value, private: $private) {
      id
      name
      value
      private
      kind
    }
  }
`
export type IUpdateChatConversationMessageTemplateMutationFn = Apollo.MutationFunction<
  IUpdateChatConversationMessageTemplateMutation,
  IUpdateChatConversationMessageTemplateMutationVariables
>

/**
 * __useUpdateChatConversationMessageTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateChatConversationMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChatConversationMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChatConversationMessageTemplateMutation, { data, loading, error }] = useUpdateChatConversationMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      value: // value for 'value'
 *      private: // value for 'private'
 *   },
 * });
 */
export function useUpdateChatConversationMessageTemplateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateChatConversationMessageTemplateMutation,
    IUpdateChatConversationMessageTemplateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateChatConversationMessageTemplateMutation,
    IUpdateChatConversationMessageTemplateMutationVariables
  >(UpdateChatConversationMessageTemplateDocument, options)
}
export type UpdateChatConversationMessageTemplateMutationHookResult = ReturnType<
  typeof useUpdateChatConversationMessageTemplateMutation
>
export type UpdateChatConversationMessageTemplateMutationResult =
  Apollo.MutationResult<IUpdateChatConversationMessageTemplateMutation>
export type UpdateChatConversationMessageTemplateMutationOptions = Apollo.BaseMutationOptions<
  IUpdateChatConversationMessageTemplateMutation,
  IUpdateChatConversationMessageTemplateMutationVariables
>
export const UpdateCoachBillingInvoiceItemDocument = gql`
  mutation updateCoachBillingInvoiceItem(
    $itemKey: String!
    $kind: CoachesBillingInvoiceItemKind
    $date: ISO8601Date
    $description: String
    $quantity: Float
    $rate: Float
  ) {
    updateCoachBillingInvoiceItem(
      itemKey: $itemKey
      kind: $kind
      date: $date
      description: $description
      quantity: $quantity
      rate: $rate
    ) {
      ...CoreCoachBillingInvoiceItemFields
    }
  }
  ${CoreCoachBillingInvoiceItemFieldsFragmentDoc}
`
export type IUpdateCoachBillingInvoiceItemMutationFn = Apollo.MutationFunction<
  IUpdateCoachBillingInvoiceItemMutation,
  IUpdateCoachBillingInvoiceItemMutationVariables
>

/**
 * __useUpdateCoachBillingInvoiceItemMutation__
 *
 * To run a mutation, you first call `useUpdateCoachBillingInvoiceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachBillingInvoiceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachBillingInvoiceItemMutation, { data, loading, error }] = useUpdateCoachBillingInvoiceItemMutation({
 *   variables: {
 *      itemKey: // value for 'itemKey'
 *      kind: // value for 'kind'
 *      date: // value for 'date'
 *      description: // value for 'description'
 *      quantity: // value for 'quantity'
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useUpdateCoachBillingInvoiceItemMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateCoachBillingInvoiceItemMutation,
    IUpdateCoachBillingInvoiceItemMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateCoachBillingInvoiceItemMutation,
    IUpdateCoachBillingInvoiceItemMutationVariables
  >(UpdateCoachBillingInvoiceItemDocument, options)
}
export type UpdateCoachBillingInvoiceItemMutationHookResult = ReturnType<
  typeof useUpdateCoachBillingInvoiceItemMutation
>
export type UpdateCoachBillingInvoiceItemMutationResult =
  Apollo.MutationResult<IUpdateCoachBillingInvoiceItemMutation>
export type UpdateCoachBillingInvoiceItemMutationOptions = Apollo.BaseMutationOptions<
  IUpdateCoachBillingInvoiceItemMutation,
  IUpdateCoachBillingInvoiceItemMutationVariables
>
export const UpdateCoachBillingRatesDocument = gql`
  mutation updateCoachBillingRates(
    $coachId: ID!
    $completedCallRate: Float
    $incompleteCallRate: Float
    $asyncSupportRate: Float
    $mealPlanRate: Float
    $supplementReviewRate: Float
    $memberReferralBonusRate: Float
    $adminTimeRate: Float
  ) {
    updateCoachBillingRates(
      coachId: $coachId
      completedCallRate: $completedCallRate
      incompleteCallRate: $incompleteCallRate
      asyncSupportRate: $asyncSupportRate
      mealPlanRate: $mealPlanRate
      supplementReviewRate: $supplementReviewRate
      memberReferralBonusRate: $memberReferralBonusRate
      adminTimeRate: $adminTimeRate
    ) {
      ...CoachBillingRatesFields
    }
  }
  ${CoachBillingRatesFieldsFragmentDoc}
`
export type IUpdateCoachBillingRatesMutationFn = Apollo.MutationFunction<
  IUpdateCoachBillingRatesMutation,
  IUpdateCoachBillingRatesMutationVariables
>

/**
 * __useUpdateCoachBillingRatesMutation__
 *
 * To run a mutation, you first call `useUpdateCoachBillingRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachBillingRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachBillingRatesMutation, { data, loading, error }] = useUpdateCoachBillingRatesMutation({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      completedCallRate: // value for 'completedCallRate'
 *      incompleteCallRate: // value for 'incompleteCallRate'
 *      asyncSupportRate: // value for 'asyncSupportRate'
 *      mealPlanRate: // value for 'mealPlanRate'
 *      supplementReviewRate: // value for 'supplementReviewRate'
 *      memberReferralBonusRate: // value for 'memberReferralBonusRate'
 *      adminTimeRate: // value for 'adminTimeRate'
 *   },
 * });
 */
export function useUpdateCoachBillingRatesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateCoachBillingRatesMutation,
    IUpdateCoachBillingRatesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateCoachBillingRatesMutation,
    IUpdateCoachBillingRatesMutationVariables
  >(UpdateCoachBillingRatesDocument, options)
}
export type UpdateCoachBillingRatesMutationHookResult = ReturnType<
  typeof useUpdateCoachBillingRatesMutation
>
export type UpdateCoachBillingRatesMutationResult =
  Apollo.MutationResult<IUpdateCoachBillingRatesMutation>
export type UpdateCoachBillingRatesMutationOptions = Apollo.BaseMutationOptions<
  IUpdateCoachBillingRatesMutation,
  IUpdateCoachBillingRatesMutationVariables
>
export const UpdateCoachConversationScheduledMessageDocument = gql`
  mutation updateCoachConversationScheduledMessage(
    $scheduledMessageId: ID!
    $state: CoachesConversationScheduledMessageState
    $sendAt: ISO8601DateTime
    $value: String
  ) {
    updateCoachConversationScheduledMessage(
      scheduledMessageId: $scheduledMessageId
      state: $state
      sendAt: $sendAt
      value: $value
    ) {
      id
      kind
      state
      sendAt
      sentAt
    }
  }
`
export type IUpdateCoachConversationScheduledMessageMutationFn = Apollo.MutationFunction<
  IUpdateCoachConversationScheduledMessageMutation,
  IUpdateCoachConversationScheduledMessageMutationVariables
>

/**
 * __useUpdateCoachConversationScheduledMessageMutation__
 *
 * To run a mutation, you first call `useUpdateCoachConversationScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachConversationScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachConversationScheduledMessageMutation, { data, loading, error }] = useUpdateCoachConversationScheduledMessageMutation({
 *   variables: {
 *      scheduledMessageId: // value for 'scheduledMessageId'
 *      state: // value for 'state'
 *      sendAt: // value for 'sendAt'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateCoachConversationScheduledMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateCoachConversationScheduledMessageMutation,
    IUpdateCoachConversationScheduledMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateCoachConversationScheduledMessageMutation,
    IUpdateCoachConversationScheduledMessageMutationVariables
  >(UpdateCoachConversationScheduledMessageDocument, options)
}
export type UpdateCoachConversationScheduledMessageMutationHookResult = ReturnType<
  typeof useUpdateCoachConversationScheduledMessageMutation
>
export type UpdateCoachConversationScheduledMessageMutationResult =
  Apollo.MutationResult<IUpdateCoachConversationScheduledMessageMutation>
export type UpdateCoachConversationScheduledMessageMutationOptions = Apollo.BaseMutationOptions<
  IUpdateCoachConversationScheduledMessageMutation,
  IUpdateCoachConversationScheduledMessageMutationVariables
>
export const UpdateCoachSharedAssetDocument = gql`
  mutation updateCoachSharedAsset(
    $id: ID!
    $title: String
    $description: String
    $category: CoachesSharedAssetCategory
    $tags: [String!]
    $visibility: CoachesSharedAssetVisibility
  ) {
    updateCoachSharedAsset(
      id: $id
      title: $title
      description: $description
      category: $category
      tags: $tags
      visibility: $visibility
    ) {
      ...CoreCoachSharedAssetFields
    }
  }
  ${CoreCoachSharedAssetFieldsFragmentDoc}
`
export type IUpdateCoachSharedAssetMutationFn = Apollo.MutationFunction<
  IUpdateCoachSharedAssetMutation,
  IUpdateCoachSharedAssetMutationVariables
>

/**
 * __useUpdateCoachSharedAssetMutation__
 *
 * To run a mutation, you first call `useUpdateCoachSharedAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoachSharedAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoachSharedAssetMutation, { data, loading, error }] = useUpdateCoachSharedAssetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      category: // value for 'category'
 *      tags: // value for 'tags'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useUpdateCoachSharedAssetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateCoachSharedAssetMutation,
    IUpdateCoachSharedAssetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateCoachSharedAssetMutation,
    IUpdateCoachSharedAssetMutationVariables
  >(UpdateCoachSharedAssetDocument, options)
}
export type UpdateCoachSharedAssetMutationHookResult = ReturnType<
  typeof useUpdateCoachSharedAssetMutation
>
export type UpdateCoachSharedAssetMutationResult =
  Apollo.MutationResult<IUpdateCoachSharedAssetMutation>
export type UpdateCoachSharedAssetMutationOptions = Apollo.BaseMutationOptions<
  IUpdateCoachSharedAssetMutation,
  IUpdateCoachSharedAssetMutationVariables
>
export const UpdateGoalMetricDocument = gql`
  mutation updateGoalMetric(
    $kind: UserGoalMetricKind!
    $lowThresholdValue: Float
    $highThresholdValue: Float
  ) {
    updateGoalMetric(
      kind: $kind
      lowThresholdValue: $lowThresholdValue
      highThresholdValue: $highThresholdValue
    ) {
      primary
      kind
      lowThresholdValue
      highThresholdValue
      section
      statKey
    }
  }
`
export type IUpdateGoalMetricMutationFn = Apollo.MutationFunction<
  IUpdateGoalMetricMutation,
  IUpdateGoalMetricMutationVariables
>

/**
 * __useUpdateGoalMetricMutation__
 *
 * To run a mutation, you first call `useUpdateGoalMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGoalMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGoalMetricMutation, { data, loading, error }] = useUpdateGoalMetricMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      lowThresholdValue: // value for 'lowThresholdValue'
 *      highThresholdValue: // value for 'highThresholdValue'
 *   },
 * });
 */
export function useUpdateGoalMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateGoalMetricMutation,
    IUpdateGoalMetricMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateGoalMetricMutation, IUpdateGoalMetricMutationVariables>(
    UpdateGoalMetricDocument,
    options
  )
}
export type UpdateGoalMetricMutationHookResult = ReturnType<typeof useUpdateGoalMetricMutation>
export type UpdateGoalMetricMutationResult = Apollo.MutationResult<IUpdateGoalMetricMutation>
export type UpdateGoalMetricMutationOptions = Apollo.BaseMutationOptions<
  IUpdateGoalMetricMutation,
  IUpdateGoalMetricMutationVariables
>
export const UpdateInvoiceOrderDocument = gql`
  mutation updateInvoiceOrder($id: ID!, $state: InvoiceOrderState, $stateReason: String) {
    updateInvoiceOrder(id: $id, state: $state, stateReason: $stateReason) {
      ...CoreInvoiceOrderFields
    }
  }
  ${CoreInvoiceOrderFieldsFragmentDoc}
`
export type IUpdateInvoiceOrderMutationFn = Apollo.MutationFunction<
  IUpdateInvoiceOrderMutation,
  IUpdateInvoiceOrderMutationVariables
>

/**
 * __useUpdateInvoiceOrderMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceOrderMutation, { data, loading, error }] = useUpdateInvoiceOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      state: // value for 'state'
 *      stateReason: // value for 'stateReason'
 *   },
 * });
 */
export function useUpdateInvoiceOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateInvoiceOrderMutation,
    IUpdateInvoiceOrderMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateInvoiceOrderMutation, IUpdateInvoiceOrderMutationVariables>(
    UpdateInvoiceOrderDocument,
    options
  )
}
export type UpdateInvoiceOrderMutationHookResult = ReturnType<typeof useUpdateInvoiceOrderMutation>
export type UpdateInvoiceOrderMutationResult = Apollo.MutationResult<IUpdateInvoiceOrderMutation>
export type UpdateInvoiceOrderMutationOptions = Apollo.BaseMutationOptions<
  IUpdateInvoiceOrderMutation,
  IUpdateInvoiceOrderMutationVariables
>
export const UpdateKnowledgeAnswerDocument = gql`
  mutation updateKnowledgeAnswer($id: ID!, $title: String, $value: String) {
    updateKnowledgeAnswer(id: $id, title: $title, value: $value) {
      ...CoreKnowledgeAnswerFields
    }
  }
  ${CoreKnowledgeAnswerFieldsFragmentDoc}
`
export type IUpdateKnowledgeAnswerMutationFn = Apollo.MutationFunction<
  IUpdateKnowledgeAnswerMutation,
  IUpdateKnowledgeAnswerMutationVariables
>

/**
 * __useUpdateKnowledgeAnswerMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeAnswerMutation, { data, loading, error }] = useUpdateKnowledgeAnswerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateKnowledgeAnswerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateKnowledgeAnswerMutation,
    IUpdateKnowledgeAnswerMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateKnowledgeAnswerMutation,
    IUpdateKnowledgeAnswerMutationVariables
  >(UpdateKnowledgeAnswerDocument, options)
}
export type UpdateKnowledgeAnswerMutationHookResult = ReturnType<
  typeof useUpdateKnowledgeAnswerMutation
>
export type UpdateKnowledgeAnswerMutationResult =
  Apollo.MutationResult<IUpdateKnowledgeAnswerMutation>
export type UpdateKnowledgeAnswerMutationOptions = Apollo.BaseMutationOptions<
  IUpdateKnowledgeAnswerMutation,
  IUpdateKnowledgeAnswerMutationVariables
>
export const UpdateKnowledgeQuestionDocument = gql`
  mutation updateKnowledgeQuestion($id: ID!, $value: String!) {
    updateKnowledgeQuestion(id: $id, value: $value) {
      ...CoreKnowledgeQuestionFields
    }
  }
  ${CoreKnowledgeQuestionFieldsFragmentDoc}
`
export type IUpdateKnowledgeQuestionMutationFn = Apollo.MutationFunction<
  IUpdateKnowledgeQuestionMutation,
  IUpdateKnowledgeQuestionMutationVariables
>

/**
 * __useUpdateKnowledgeQuestionMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeQuestionMutation, { data, loading, error }] = useUpdateKnowledgeQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateKnowledgeQuestionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateKnowledgeQuestionMutation,
    IUpdateKnowledgeQuestionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateKnowledgeQuestionMutation,
    IUpdateKnowledgeQuestionMutationVariables
  >(UpdateKnowledgeQuestionDocument, options)
}
export type UpdateKnowledgeQuestionMutationHookResult = ReturnType<
  typeof useUpdateKnowledgeQuestionMutation
>
export type UpdateKnowledgeQuestionMutationResult =
  Apollo.MutationResult<IUpdateKnowledgeQuestionMutation>
export type UpdateKnowledgeQuestionMutationOptions = Apollo.BaseMutationOptions<
  IUpdateKnowledgeQuestionMutation,
  IUpdateKnowledgeQuestionMutationVariables
>
export const UpdateKnowledgeSourceDocument = gql`
  mutation updateKnowledgeSource($id: ID!, $title: String, $url: String) {
    updateKnowledgeSource(id: $id, title: $title, url: $url) {
      id
      title
      url
    }
  }
`
export type IUpdateKnowledgeSourceMutationFn = Apollo.MutationFunction<
  IUpdateKnowledgeSourceMutation,
  IUpdateKnowledgeSourceMutationVariables
>

/**
 * __useUpdateKnowledgeSourceMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeSourceMutation, { data, loading, error }] = useUpdateKnowledgeSourceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useUpdateKnowledgeSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateKnowledgeSourceMutation,
    IUpdateKnowledgeSourceMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateKnowledgeSourceMutation,
    IUpdateKnowledgeSourceMutationVariables
  >(UpdateKnowledgeSourceDocument, options)
}
export type UpdateKnowledgeSourceMutationHookResult = ReturnType<
  typeof useUpdateKnowledgeSourceMutation
>
export type UpdateKnowledgeSourceMutationResult =
  Apollo.MutationResult<IUpdateKnowledgeSourceMutation>
export type UpdateKnowledgeSourceMutationOptions = Apollo.BaseMutationOptions<
  IUpdateKnowledgeSourceMutation,
  IUpdateKnowledgeSourceMutationVariables
>
export const UpdateKnowledgeTagDocument = gql`
  mutation updateKnowledgeTag($id: ID!, $value: String!) {
    updateKnowledgeTag(id: $id, value: $value) {
      id
      value
    }
  }
`
export type IUpdateKnowledgeTagMutationFn = Apollo.MutationFunction<
  IUpdateKnowledgeTagMutation,
  IUpdateKnowledgeTagMutationVariables
>

/**
 * __useUpdateKnowledgeTagMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeTagMutation, { data, loading, error }] = useUpdateKnowledgeTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateKnowledgeTagMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateKnowledgeTagMutation,
    IUpdateKnowledgeTagMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateKnowledgeTagMutation, IUpdateKnowledgeTagMutationVariables>(
    UpdateKnowledgeTagDocument,
    options
  )
}
export type UpdateKnowledgeTagMutationHookResult = ReturnType<typeof useUpdateKnowledgeTagMutation>
export type UpdateKnowledgeTagMutationResult = Apollo.MutationResult<IUpdateKnowledgeTagMutation>
export type UpdateKnowledgeTagMutationOptions = Apollo.BaseMutationOptions<
  IUpdateKnowledgeTagMutation,
  IUpdateKnowledgeTagMutationVariables
>
export const UpdateOrderDocument = gql`
  mutation updateOrder(
    $id: Int!
    $notes: String
    $email: String
    $product: String
    $productType: String
    $sensorKind: UserSensorKind
    $quantity: Int
  ) {
    updateOrder(
      id: $id
      notes: $notes
      email: $email
      product: $product
      productType: $productType
      sensorKind: $sensorKind
      quantity: $quantity
    ) {
      ...CoreOrderFields
    }
  }
  ${CoreOrderFieldsFragmentDoc}
`
export type IUpdateOrderMutationFn = Apollo.MutationFunction<
  IUpdateOrderMutation,
  IUpdateOrderMutationVariables
>

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      notes: // value for 'notes'
 *      email: // value for 'email'
 *      product: // value for 'product'
 *      productType: // value for 'productType'
 *      sensorKind: // value for 'sensorKind'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpdateOrderMutation, IUpdateOrderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateOrderMutation, IUpdateOrderMutationVariables>(
    UpdateOrderDocument,
    options
  )
}
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>
export type UpdateOrderMutationResult = Apollo.MutationResult<IUpdateOrderMutation>
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<
  IUpdateOrderMutation,
  IUpdateOrderMutationVariables
>
export const UpdateReplacementRequestDocument = gql`
  mutation updateReplacementRequest(
    $id: ID!
    $chargeAmount: ReplacementRequestChargeAmount
    $daysWorn: Int
    $dateFellOff: String
    $dateNotified: String
    $howItFellOff: String
    $notes: String
    $replacementReason: ReplacementRequestReplacementReason
    $rgaRequired: ReplacementRequestRgaRequired
    $wearingPatch: ReplacementRequestWearingPatch
  ) {
    updateReplacementRequest(
      id: $id
      chargeAmount: $chargeAmount
      daysWorn: $daysWorn
      dateFellOff: $dateFellOff
      dateNotified: $dateNotified
      howItFellOff: $howItFellOff
      notes: $notes
      replacementReason: $replacementReason
      rgaRequired: $rgaRequired
      wearingPatch: $wearingPatch
    ) {
      ...CoreReplacementRequestFields
    }
  }
  ${CoreReplacementRequestFieldsFragmentDoc}
`
export type IUpdateReplacementRequestMutationFn = Apollo.MutationFunction<
  IUpdateReplacementRequestMutation,
  IUpdateReplacementRequestMutationVariables
>

/**
 * __useUpdateReplacementRequestMutation__
 *
 * To run a mutation, you first call `useUpdateReplacementRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReplacementRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReplacementRequestMutation, { data, loading, error }] = useUpdateReplacementRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      chargeAmount: // value for 'chargeAmount'
 *      daysWorn: // value for 'daysWorn'
 *      dateFellOff: // value for 'dateFellOff'
 *      dateNotified: // value for 'dateNotified'
 *      howItFellOff: // value for 'howItFellOff'
 *      notes: // value for 'notes'
 *      replacementReason: // value for 'replacementReason'
 *      rgaRequired: // value for 'rgaRequired'
 *      wearingPatch: // value for 'wearingPatch'
 *   },
 * });
 */
export function useUpdateReplacementRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateReplacementRequestMutation,
    IUpdateReplacementRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateReplacementRequestMutation,
    IUpdateReplacementRequestMutationVariables
  >(UpdateReplacementRequestDocument, options)
}
export type UpdateReplacementRequestMutationHookResult = ReturnType<
  typeof useUpdateReplacementRequestMutation
>
export type UpdateReplacementRequestMutationResult =
  Apollo.MutationResult<IUpdateReplacementRequestMutation>
export type UpdateReplacementRequestMutationOptions = Apollo.BaseMutationOptions<
  IUpdateReplacementRequestMutation,
  IUpdateReplacementRequestMutationVariables
>
export const UpdateSensorDocument = gql`
  mutation updateSensor($baselineAdjustment: Int!) {
    updateSensor(baselineAdjustment: $baselineAdjustment) {
      serialNumber
      activationDate
      expirationDate
      expirationTime
      daysRemaining
      baselineAdjustment
    }
  }
`
export type IUpdateSensorMutationFn = Apollo.MutationFunction<
  IUpdateSensorMutation,
  IUpdateSensorMutationVariables
>

/**
 * __useUpdateSensorMutation__
 *
 * To run a mutation, you first call `useUpdateSensorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSensorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSensorMutation, { data, loading, error }] = useUpdateSensorMutation({
 *   variables: {
 *      baselineAdjustment: // value for 'baselineAdjustment'
 *   },
 * });
 */
export function useUpdateSensorMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpdateSensorMutation, IUpdateSensorMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateSensorMutation, IUpdateSensorMutationVariables>(
    UpdateSensorDocument,
    options
  )
}
export type UpdateSensorMutationHookResult = ReturnType<typeof useUpdateSensorMutation>
export type UpdateSensorMutationResult = Apollo.MutationResult<IUpdateSensorMutation>
export type UpdateSensorMutationOptions = Apollo.BaseMutationOptions<
  IUpdateSensorMutation,
  IUpdateSensorMutationVariables
>
export const UpdateShipmentDocument = gql`
  mutation updateShipment(
    $id: Int!
    $status: String
    $trackingNumber: String
    $trackingUrl: String
    $lotNumber: String
    $providerShipmentId: ID
    $provider: String
    $providerReceivedAt: ISO8601DateTime
    $quantity: Int
    $shippedAt: ISO8601DateTime
    $deliveredAt: ISO8601DateTime
  ) {
    updateShipment(
      id: $id
      status: $status
      trackingNumber: $trackingNumber
      trackingUrl: $trackingUrl
      lotNumber: $lotNumber
      providerShipmentId: $providerShipmentId
      provider: $provider
      providerReceivedAt: $providerReceivedAt
      quantity: $quantity
      shippedAt: $shippedAt
      deliveredAt: $deliveredAt
    ) {
      ...CoreShipmentFields
    }
  }
  ${CoreShipmentFieldsFragmentDoc}
`
export type IUpdateShipmentMutationFn = Apollo.MutationFunction<
  IUpdateShipmentMutation,
  IUpdateShipmentMutationVariables
>

/**
 * __useUpdateShipmentMutation__
 *
 * To run a mutation, you first call `useUpdateShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShipmentMutation, { data, loading, error }] = useUpdateShipmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      trackingNumber: // value for 'trackingNumber'
 *      trackingUrl: // value for 'trackingUrl'
 *      lotNumber: // value for 'lotNumber'
 *      providerShipmentId: // value for 'providerShipmentId'
 *      provider: // value for 'provider'
 *      providerReceivedAt: // value for 'providerReceivedAt'
 *      quantity: // value for 'quantity'
 *      shippedAt: // value for 'shippedAt'
 *      deliveredAt: // value for 'deliveredAt'
 *   },
 * });
 */
export function useUpdateShipmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateShipmentMutation,
    IUpdateShipmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateShipmentMutation, IUpdateShipmentMutationVariables>(
    UpdateShipmentDocument,
    options
  )
}
export type UpdateShipmentMutationHookResult = ReturnType<typeof useUpdateShipmentMutation>
export type UpdateShipmentMutationResult = Apollo.MutationResult<IUpdateShipmentMutation>
export type UpdateShipmentMutationOptions = Apollo.BaseMutationOptions<
  IUpdateShipmentMutation,
  IUpdateShipmentMutationVariables
>
export const UpdateUserDocument = gql`
  mutation updateUser(
    $id: ID
    $firstName: String
    $lastName: String
    $kind: String
    $sex: String
    $phoneNumber: String
    $dateOfBirth: String
    $truepillPatientToken: String
    $berryStreetGetHealthieId: Int
  ) {
    updateUser(
      id: $id
      firstName: $firstName
      lastName: $lastName
      kind: $kind
      sex: $sex
      phoneNumber: $phoneNumber
      dateOfBirth: $dateOfBirth
      truepillPatientToken: $truepillPatientToken
      berryStreetGetHealthieId: $berryStreetGetHealthieId
    ) {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export type IUpdateUserMutationFn = Apollo.MutationFunction<
  IUpdateUserMutation,
  IUpdateUserMutationVariables
>

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      kind: // value for 'kind'
 *      sex: // value for 'sex'
 *      phoneNumber: // value for 'phoneNumber'
 *      dateOfBirth: // value for 'dateOfBirth'
 *      truepillPatientToken: // value for 'truepillPatientToken'
 *      berryStreetGetHealthieId: // value for 'berryStreetGetHealthieId'
 *   },
 * });
 */
export function useUpdateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpdateUserMutation, IUpdateUserMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateUserMutation, IUpdateUserMutationVariables>(
    UpdateUserDocument,
    options
  )
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>
export type UpdateUserMutationResult = Apollo.MutationResult<IUpdateUserMutation>
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<
  IUpdateUserMutation,
  IUpdateUserMutationVariables
>
export const UpdateUserOrganizationDocument = gql`
  mutation updateUserOrganization($id: ID!, $organizationId: Int!) {
    updateUserOrganization(id: $id, organizationId: $organizationId) {
      ...User
    }
  }
  ${UserFragmentDoc}
`
export type IUpdateUserOrganizationMutationFn = Apollo.MutationFunction<
  IUpdateUserOrganizationMutation,
  IUpdateUserOrganizationMutationVariables
>

/**
 * __useUpdateUserOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateUserOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOrganizationMutation, { data, loading, error }] = useUpdateUserOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useUpdateUserOrganizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateUserOrganizationMutation,
    IUpdateUserOrganizationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdateUserOrganizationMutation,
    IUpdateUserOrganizationMutationVariables
  >(UpdateUserOrganizationDocument, options)
}
export type UpdateUserOrganizationMutationHookResult = ReturnType<
  typeof useUpdateUserOrganizationMutation
>
export type UpdateUserOrganizationMutationResult =
  Apollo.MutationResult<IUpdateUserOrganizationMutation>
export type UpdateUserOrganizationMutationOptions = Apollo.BaseMutationOptions<
  IUpdateUserOrganizationMutation,
  IUpdateUserOrganizationMutationVariables
>
export const UpdateUserPropertyDocument = gql`
  mutation updateUserProperty($userId: ID, $kind: String!, $value: String!, $id: ID) {
    updateUserProperty(userId: $userId, kind: $kind, value: $value, id: $id) {
      id
      kind
      value
      userId
    }
  }
`
export type IUpdateUserPropertyMutationFn = Apollo.MutationFunction<
  IUpdateUserPropertyMutation,
  IUpdateUserPropertyMutationVariables
>

/**
 * __useUpdateUserPropertyMutation__
 *
 * To run a mutation, you first call `useUpdateUserPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPropertyMutation, { data, loading, error }] = useUpdateUserPropertyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      kind: // value for 'kind'
 *      value: // value for 'value'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateUserPropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateUserPropertyMutation,
    IUpdateUserPropertyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateUserPropertyMutation, IUpdateUserPropertyMutationVariables>(
    UpdateUserPropertyDocument,
    options
  )
}
export type UpdateUserPropertyMutationHookResult = ReturnType<typeof useUpdateUserPropertyMutation>
export type UpdateUserPropertyMutationResult = Apollo.MutationResult<IUpdateUserPropertyMutation>
export type UpdateUserPropertyMutationOptions = Apollo.BaseMutationOptions<
  IUpdateUserPropertyMutation,
  IUpdateUserPropertyMutationVariables
>
export const UpdateSettingsDocument = gql`
  mutation updateSettings(
    $appVersionReminder: Boolean
    $dashboardGraph: String
    $dexcomSync: Boolean
    $displayActivityScore: Boolean
    $displayDailyScore: Boolean
    $displayMealScore: Boolean
    $fastingEnd: Int
    $fastingStart: Int
    $glucoseHighThreshold: Int
    $glucoseLowThreshold: Int
    $googleFitSync: Boolean
    $healthKitSync: Boolean
    $ketoMojoSync: Boolean
    $ketoneHighThreshold: Float
    $ketoneLowThreshold: Float
    $macroGoalsDaily: MacroGoalsDaily
    $reminders: Boolean
    $showNetCarbs: Boolean
    $unitSystem: String
  ) {
    updateSettings(
      appVersionReminder: $appVersionReminder
      dashboardGraph: $dashboardGraph
      dexcomSync: $dexcomSync
      displayActivityScore: $displayActivityScore
      displayDailyScore: $displayDailyScore
      displayMealScore: $displayMealScore
      fastingEnd: $fastingEnd
      fastingStart: $fastingStart
      glucoseHighThreshold: $glucoseHighThreshold
      glucoseLowThreshold: $glucoseLowThreshold
      googleFitSync: $googleFitSync
      healthKitSync: $healthKitSync
      ketoMojoSync: $ketoMojoSync
      ketoneHighThreshold: $ketoneHighThreshold
      ketoneLowThreshold: $ketoneLowThreshold
      macroGoalsDaily: $macroGoalsDaily
      reminders: $reminders
      showNetCarbs: $showNetCarbs
      unitSystem: $unitSystem
    ) {
      id
      appVersionReminder
      dashboardGraph
      dexcomSync
      displayActivityScore
      displayDailyScore
      displayMealScore
      fastingEnd
      fastingStart
      glucoseHighThreshold
      glucoseLowThreshold
      googleFitSync
      healthKitSync
      ketoMojoSync
      ketoneHighThreshold
      ketoneLowThreshold
      macroGoalsDaily {
        calories
        carbs
        fat
        netCarbs
        protein
      }
      reminders
      showNetCarbs
      unitSystem
    }
  }
`
export type IUpdateSettingsMutationFn = Apollo.MutationFunction<
  IUpdateSettingsMutation,
  IUpdateSettingsMutationVariables
>

/**
 * __useUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSettingsMutation, { data, loading, error }] = useUpdateSettingsMutation({
 *   variables: {
 *      appVersionReminder: // value for 'appVersionReminder'
 *      dashboardGraph: // value for 'dashboardGraph'
 *      dexcomSync: // value for 'dexcomSync'
 *      displayActivityScore: // value for 'displayActivityScore'
 *      displayDailyScore: // value for 'displayDailyScore'
 *      displayMealScore: // value for 'displayMealScore'
 *      fastingEnd: // value for 'fastingEnd'
 *      fastingStart: // value for 'fastingStart'
 *      glucoseHighThreshold: // value for 'glucoseHighThreshold'
 *      glucoseLowThreshold: // value for 'glucoseLowThreshold'
 *      googleFitSync: // value for 'googleFitSync'
 *      healthKitSync: // value for 'healthKitSync'
 *      ketoMojoSync: // value for 'ketoMojoSync'
 *      ketoneHighThreshold: // value for 'ketoneHighThreshold'
 *      ketoneLowThreshold: // value for 'ketoneLowThreshold'
 *      macroGoalsDaily: // value for 'macroGoalsDaily'
 *      reminders: // value for 'reminders'
 *      showNetCarbs: // value for 'showNetCarbs'
 *      unitSystem: // value for 'unitSystem'
 *   },
 * });
 */
export function useUpdateSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateSettingsMutation,
    IUpdateSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateSettingsMutation, IUpdateSettingsMutationVariables>(
    UpdateSettingsDocument,
    options
  )
}
export type UpdateSettingsMutationHookResult = ReturnType<typeof useUpdateSettingsMutation>
export type UpdateSettingsMutationResult = Apollo.MutationResult<IUpdateSettingsMutation>
export type UpdateSettingsMutationOptions = Apollo.BaseMutationOptions<
  IUpdateSettingsMutation,
  IUpdateSettingsMutationVariables
>
export const UploadHealthDataReportPdfDocument = gql`
  mutation uploadHealthDataReportPdf($id: ID!, $pdf: Upload!) {
    uploadHealthDataReportPdf(id: $id, pdf: $pdf) {
      success
    }
  }
`
export type IUploadHealthDataReportPdfMutationFn = Apollo.MutationFunction<
  IUploadHealthDataReportPdfMutation,
  IUploadHealthDataReportPdfMutationVariables
>

/**
 * __useUploadHealthDataReportPdfMutation__
 *
 * To run a mutation, you first call `useUploadHealthDataReportPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadHealthDataReportPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadHealthDataReportPdfMutation, { data, loading, error }] = useUploadHealthDataReportPdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pdf: // value for 'pdf'
 *   },
 * });
 */
export function useUploadHealthDataReportPdfMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUploadHealthDataReportPdfMutation,
    IUploadHealthDataReportPdfMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUploadHealthDataReportPdfMutation,
    IUploadHealthDataReportPdfMutationVariables
  >(UploadHealthDataReportPdfDocument, options)
}
export type UploadHealthDataReportPdfMutationHookResult = ReturnType<
  typeof useUploadHealthDataReportPdfMutation
>
export type UploadHealthDataReportPdfMutationResult =
  Apollo.MutationResult<IUploadHealthDataReportPdfMutation>
export type UploadHealthDataReportPdfMutationOptions = Apollo.BaseMutationOptions<
  IUploadHealthDataReportPdfMutation,
  IUploadHealthDataReportPdfMutationVariables
>
export const UpsertMealDocument = gql`
  mutation upsertMeal(
    $id: ID
    $kind: MealKind
    $favorite: Boolean
    $description: String!
    $time: String!
    $ingredients: [IngredientData!]
  ) {
    upsertMeal(
      id: $id
      kind: $kind
      favorite: $favorite
      description: $description
      time: $time
      ingredients: $ingredients
    ) {
      ...AllEventsMeal
    }
  }
  ${AllEventsMealFragmentDoc}
`
export type IUpsertMealMutationFn = Apollo.MutationFunction<
  IUpsertMealMutation,
  IUpsertMealMutationVariables
>

/**
 * __useUpsertMealMutation__
 *
 * To run a mutation, you first call `useUpsertMealMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMealMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMealMutation, { data, loading, error }] = useUpsertMealMutation({
 *   variables: {
 *      id: // value for 'id'
 *      kind: // value for 'kind'
 *      favorite: // value for 'favorite'
 *      description: // value for 'description'
 *      time: // value for 'time'
 *      ingredients: // value for 'ingredients'
 *   },
 * });
 */
export function useUpsertMealMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpsertMealMutation, IUpsertMealMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpsertMealMutation, IUpsertMealMutationVariables>(
    UpsertMealDocument,
    options
  )
}
export type UpsertMealMutationHookResult = ReturnType<typeof useUpsertMealMutation>
export type UpsertMealMutationResult = Apollo.MutationResult<IUpsertMealMutation>
export type UpsertMealMutationOptions = Apollo.BaseMutationOptions<
  IUpsertMealMutation,
  IUpsertMealMutationVariables
>
export const UpsertNoteDocument = gql`
  mutation upsertNote($id: ID, $body: String!, $time: String, $kind: String, $pinned: Boolean) {
    upsertNote(id: $id, body: $body, time: $time, kind: $kind, pinned: $pinned) {
      id
      body
      kind
      occurredAt
      pinnedAt
    }
  }
`
export type IUpsertNoteMutationFn = Apollo.MutationFunction<
  IUpsertNoteMutation,
  IUpsertNoteMutationVariables
>

/**
 * __useUpsertNoteMutation__
 *
 * To run a mutation, you first call `useUpsertNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNoteMutation, { data, loading, error }] = useUpsertNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *      time: // value for 'time'
 *      kind: // value for 'kind'
 *      pinned: // value for 'pinned'
 *   },
 * });
 */
export function useUpsertNoteMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpsertNoteMutation, IUpsertNoteMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpsertNoteMutation, IUpsertNoteMutationVariables>(
    UpsertNoteDocument,
    options
  )
}
export type UpsertNoteMutationHookResult = ReturnType<typeof useUpsertNoteMutation>
export type UpsertNoteMutationResult = Apollo.MutationResult<IUpsertNoteMutation>
export type UpsertNoteMutationOptions = Apollo.BaseMutationOptions<
  IUpsertNoteMutation,
  IUpsertNoteMutationVariables
>
export const UpsertPrimaryGoalDocument = gql`
  mutation upsertPrimaryGoal($kind: UserGoalKind!, $description: String) {
    upsertPrimaryGoal(kind: $kind, description: $description) {
      title
      kind
      description
    }
  }
`
export type IUpsertPrimaryGoalMutationFn = Apollo.MutationFunction<
  IUpsertPrimaryGoalMutation,
  IUpsertPrimaryGoalMutationVariables
>

/**
 * __useUpsertPrimaryGoalMutation__
 *
 * To run a mutation, you first call `useUpsertPrimaryGoalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPrimaryGoalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPrimaryGoalMutation, { data, loading, error }] = useUpsertPrimaryGoalMutation({
 *   variables: {
 *      kind: // value for 'kind'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpsertPrimaryGoalMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpsertPrimaryGoalMutation,
    IUpsertPrimaryGoalMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpsertPrimaryGoalMutation, IUpsertPrimaryGoalMutationVariables>(
    UpsertPrimaryGoalDocument,
    options
  )
}
export type UpsertPrimaryGoalMutationHookResult = ReturnType<typeof useUpsertPrimaryGoalMutation>
export type UpsertPrimaryGoalMutationResult = Apollo.MutationResult<IUpsertPrimaryGoalMutation>
export type UpsertPrimaryGoalMutationOptions = Apollo.BaseMutationOptions<
  IUpsertPrimaryGoalMutation,
  IUpsertPrimaryGoalMutationVariables
>
export const UpsertUiStateDocument = gql`
  mutation upsertUiState($name: UIStateName!, $value: Boolean!) {
    upsertUiState(name: $name, value: $value) {
      __typename
      name
      value
    }
  }
`
export type IUpsertUiStateMutationFn = Apollo.MutationFunction<
  IUpsertUiStateMutation,
  IUpsertUiStateMutationVariables
>

/**
 * __useUpsertUiStateMutation__
 *
 * To run a mutation, you first call `useUpsertUiStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUiStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUiStateMutation, { data, loading, error }] = useUpsertUiStateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpsertUiStateMutation(
  baseOptions?: Apollo.MutationHookOptions<IUpsertUiStateMutation, IUpsertUiStateMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpsertUiStateMutation, IUpsertUiStateMutationVariables>(
    UpsertUiStateDocument,
    options
  )
}
export type UpsertUiStateMutationHookResult = ReturnType<typeof useUpsertUiStateMutation>
export type UpsertUiStateMutationResult = Apollo.MutationResult<IUpsertUiStateMutation>
export type UpsertUiStateMutationOptions = Apollo.BaseMutationOptions<
  IUpsertUiStateMutation,
  IUpsertUiStateMutationVariables
>
export const VerifyMfaSmsCodeDocument = gql`
  mutation verifyMfaSmsCode($mfaSmsCode: String!) {
    verifyMfaSmsCode(mfaSmsCode: $mfaSmsCode) {
      mfaToken
    }
  }
`
export type IVerifyMfaSmsCodeMutationFn = Apollo.MutationFunction<
  IVerifyMfaSmsCodeMutation,
  IVerifyMfaSmsCodeMutationVariables
>

/**
 * __useVerifyMfaSmsCodeMutation__
 *
 * To run a mutation, you first call `useVerifyMfaSmsCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyMfaSmsCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyMfaSmsCodeMutation, { data, loading, error }] = useVerifyMfaSmsCodeMutation({
 *   variables: {
 *      mfaSmsCode: // value for 'mfaSmsCode'
 *   },
 * });
 */
export function useVerifyMfaSmsCodeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IVerifyMfaSmsCodeMutation,
    IVerifyMfaSmsCodeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IVerifyMfaSmsCodeMutation, IVerifyMfaSmsCodeMutationVariables>(
    VerifyMfaSmsCodeDocument,
    options
  )
}
export type VerifyMfaSmsCodeMutationHookResult = ReturnType<typeof useVerifyMfaSmsCodeMutation>
export type VerifyMfaSmsCodeMutationResult = Apollo.MutationResult<IVerifyMfaSmsCodeMutation>
export type VerifyMfaSmsCodeMutationOptions = Apollo.BaseMutationOptions<
  IVerifyMfaSmsCodeMutation,
  IVerifyMfaSmsCodeMutationVariables
>
export const AllAccountRequestsDocument = gql`
  query AllAccountRequests(
    $page: Int
    $perPage: Int
    $sorts: [AccountRequestSort!]
    $dynamicFilters: [AccountRequestDynamicFilterItem!]
    $status: OpsAccountRequestStatus
  ) {
    allAccountRequests(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
      status: $status
    ) {
      totalCount
      accountRequests {
        ...CoreAccountRequestFields
      }
    }
  }
  ${CoreAccountRequestFieldsFragmentDoc}
`

/**
 * __useAllAccountRequestsQuery__
 *
 * To run a query within a React component, call `useAllAccountRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAccountRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAccountRequestsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAllAccountRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllAccountRequestsQuery, IAllAccountRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllAccountRequestsQuery, IAllAccountRequestsQueryVariables>(
    AllAccountRequestsDocument,
    options
  )
}
export function useAllAccountRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllAccountRequestsQuery,
    IAllAccountRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllAccountRequestsQuery, IAllAccountRequestsQueryVariables>(
    AllAccountRequestsDocument,
    options
  )
}
// @ts-ignore
export function useAllAccountRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllAccountRequestsQuery,
    IAllAccountRequestsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllAccountRequestsQuery, IAllAccountRequestsQueryVariables>
export function useAllAccountRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllAccountRequestsQuery, IAllAccountRequestsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAllAccountRequestsQuery | undefined,
  IAllAccountRequestsQueryVariables
>
export function useAllAccountRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllAccountRequestsQuery, IAllAccountRequestsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllAccountRequestsQuery, IAllAccountRequestsQueryVariables>(
    AllAccountRequestsDocument,
    options
  )
}
export type AllAccountRequestsQueryHookResult = ReturnType<typeof useAllAccountRequestsQuery>
export type AllAccountRequestsLazyQueryHookResult = ReturnType<
  typeof useAllAccountRequestsLazyQuery
>
export type AllAccountRequestsSuspenseQueryHookResult = ReturnType<
  typeof useAllAccountRequestsSuspenseQuery
>
export type AllAccountRequestsQueryResult = Apollo.QueryResult<
  IAllAccountRequestsQuery,
  IAllAccountRequestsQueryVariables
>
export const CalculateDuplicateAccountCreditDocument = gql`
  query calculateDuplicateAccountCredit($userId: ID!) {
    calculateDuplicateAccountCredit(userId: $userId) {
      creditAmountInCents
    }
  }
`

/**
 * __useCalculateDuplicateAccountCreditQuery__
 *
 * To run a query within a React component, call `useCalculateDuplicateAccountCreditQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateDuplicateAccountCreditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateDuplicateAccountCreditQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCalculateDuplicateAccountCreditQuery(
  baseOptions: Apollo.QueryHookOptions<
    ICalculateDuplicateAccountCreditQuery,
    ICalculateDuplicateAccountCreditQueryVariables
  > &
    (
      | { variables: ICalculateDuplicateAccountCreditQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ICalculateDuplicateAccountCreditQuery,
    ICalculateDuplicateAccountCreditQueryVariables
  >(CalculateDuplicateAccountCreditDocument, options)
}
export function useCalculateDuplicateAccountCreditLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICalculateDuplicateAccountCreditQuery,
    ICalculateDuplicateAccountCreditQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ICalculateDuplicateAccountCreditQuery,
    ICalculateDuplicateAccountCreditQueryVariables
  >(CalculateDuplicateAccountCreditDocument, options)
}
// @ts-ignore
export function useCalculateDuplicateAccountCreditSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICalculateDuplicateAccountCreditQuery,
    ICalculateDuplicateAccountCreditQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ICalculateDuplicateAccountCreditQuery,
  ICalculateDuplicateAccountCreditQueryVariables
>
export function useCalculateDuplicateAccountCreditSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICalculateDuplicateAccountCreditQuery,
        ICalculateDuplicateAccountCreditQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ICalculateDuplicateAccountCreditQuery | undefined,
  ICalculateDuplicateAccountCreditQueryVariables
>
export function useCalculateDuplicateAccountCreditSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICalculateDuplicateAccountCreditQuery,
        ICalculateDuplicateAccountCreditQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ICalculateDuplicateAccountCreditQuery,
    ICalculateDuplicateAccountCreditQueryVariables
  >(CalculateDuplicateAccountCreditDocument, options)
}
export type CalculateDuplicateAccountCreditQueryHookResult = ReturnType<
  typeof useCalculateDuplicateAccountCreditQuery
>
export type CalculateDuplicateAccountCreditLazyQueryHookResult = ReturnType<
  typeof useCalculateDuplicateAccountCreditLazyQuery
>
export type CalculateDuplicateAccountCreditSuspenseQueryHookResult = ReturnType<
  typeof useCalculateDuplicateAccountCreditSuspenseQuery
>
export type CalculateDuplicateAccountCreditQueryResult = Apollo.QueryResult<
  ICalculateDuplicateAccountCreditQuery,
  ICalculateDuplicateAccountCreditQueryVariables
>
export const ShowAccountRequestsConfigDocument = gql`
  query ShowAccountRequestsConfig {
    showAccountRequestsConfig {
      pauseReasons {
        key
        copy
      }
      refundReasons {
        key
        description
      }
    }
  }
`

/**
 * __useShowAccountRequestsConfigQuery__
 *
 * To run a query within a React component, call `useShowAccountRequestsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useShowAccountRequestsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShowAccountRequestsConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useShowAccountRequestsConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IShowAccountRequestsConfigQuery,
    IShowAccountRequestsConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IShowAccountRequestsConfigQuery, IShowAccountRequestsConfigQueryVariables>(
    ShowAccountRequestsConfigDocument,
    options
  )
}
export function useShowAccountRequestsConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IShowAccountRequestsConfigQuery,
    IShowAccountRequestsConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IShowAccountRequestsConfigQuery,
    IShowAccountRequestsConfigQueryVariables
  >(ShowAccountRequestsConfigDocument, options)
}
// @ts-ignore
export function useShowAccountRequestsConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IShowAccountRequestsConfigQuery,
    IShowAccountRequestsConfigQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IShowAccountRequestsConfigQuery,
  IShowAccountRequestsConfigQueryVariables
>
export function useShowAccountRequestsConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IShowAccountRequestsConfigQuery,
        IShowAccountRequestsConfigQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IShowAccountRequestsConfigQuery | undefined,
  IShowAccountRequestsConfigQueryVariables
>
export function useShowAccountRequestsConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IShowAccountRequestsConfigQuery,
        IShowAccountRequestsConfigQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IShowAccountRequestsConfigQuery,
    IShowAccountRequestsConfigQueryVariables
  >(ShowAccountRequestsConfigDocument, options)
}
export type ShowAccountRequestsConfigQueryHookResult = ReturnType<
  typeof useShowAccountRequestsConfigQuery
>
export type ShowAccountRequestsConfigLazyQueryHookResult = ReturnType<
  typeof useShowAccountRequestsConfigLazyQuery
>
export type ShowAccountRequestsConfigSuspenseQueryHookResult = ReturnType<
  typeof useShowAccountRequestsConfigSuspenseQuery
>
export type ShowAccountRequestsConfigQueryResult = Apollo.QueryResult<
  IShowAccountRequestsConfigQuery,
  IShowAccountRequestsConfigQueryVariables
>
export const ActionGoalSummariesDocument = gql`
  query actionGoalSummaries($startDate: ISO8601Date!) {
    actionGoalSummaries(startDate: $startDate) {
      startDate
      actionGoalSummaries {
        id
        completions {
          date
        }
        actionGoal {
          id
          kind
          numberDays
          startDate
          metricKind
          metricValue
          displayUnits
          title
          description
          summaryDescription
          icon
          category
          macroGoal
        }
      }
    }
  }
`

/**
 * __useActionGoalSummariesQuery__
 *
 * To run a query within a React component, call `useActionGoalSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionGoalSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionGoalSummariesQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useActionGoalSummariesQuery(
  baseOptions: Apollo.QueryHookOptions<
    IActionGoalSummariesQuery,
    IActionGoalSummariesQueryVariables
  > &
    ({ variables: IActionGoalSummariesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IActionGoalSummariesQuery, IActionGoalSummariesQueryVariables>(
    ActionGoalSummariesDocument,
    options
  )
}
export function useActionGoalSummariesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IActionGoalSummariesQuery,
    IActionGoalSummariesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IActionGoalSummariesQuery, IActionGoalSummariesQueryVariables>(
    ActionGoalSummariesDocument,
    options
  )
}
// @ts-ignore
export function useActionGoalSummariesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IActionGoalSummariesQuery,
    IActionGoalSummariesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IActionGoalSummariesQuery, IActionGoalSummariesQueryVariables>
export function useActionGoalSummariesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IActionGoalSummariesQuery, IActionGoalSummariesQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IActionGoalSummariesQuery | undefined,
  IActionGoalSummariesQueryVariables
>
export function useActionGoalSummariesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IActionGoalSummariesQuery, IActionGoalSummariesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IActionGoalSummariesQuery, IActionGoalSummariesQueryVariables>(
    ActionGoalSummariesDocument,
    options
  )
}
export type ActionGoalSummariesQueryHookResult = ReturnType<typeof useActionGoalSummariesQuery>
export type ActionGoalSummariesLazyQueryHookResult = ReturnType<
  typeof useActionGoalSummariesLazyQuery
>
export type ActionGoalSummariesSuspenseQueryHookResult = ReturnType<
  typeof useActionGoalSummariesSuspenseQuery
>
export type ActionGoalSummariesQueryResult = Apollo.QueryResult<
  IActionGoalSummariesQuery,
  IActionGoalSummariesQueryVariables
>
export const AdminPanelAllCoachAssignmentsDocument = gql`
  query AdminPanelAllCoachAssignments(
    $page: Int
    $perPage: Int
    $sorts: [CoachAssignmentSort!]
    $dynamicFilters: [CoachAssignmentDynamicFilterItem!]
    $last: Boolean
  ) {
    allCoachAssignments(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
      last: $last
    ) {
      totalCount
      coachAssignments {
        id
        coach {
          id
          fullName
        }
        user {
          id
          fullName
          email
          kind
          primaryGoal {
            title
            kind
            description
          }
          userProperties {
            testGroup {
              id
              kind
              value
            }
            oneMonthActiveFeedbackDietitian {
              id
              kind
              value
            }
            dietitianRequest {
              id
              kind
              value
            }
            scheduledVideoCallStatus {
              id
              kind
              value
            }
            healthGoal {
              id
              kind
              value
            }
            communicationFrequency {
              id
              kind
              value
            }
            dietitianSensorCountNotes {
              id
              kind
              value
            }
            nutritionistGroup {
              id
              kind
              value
            }
          }
          lastDietitianSubscription {
            stripeStatus
            status
            paused
            resumesAt
          }
          ongoingDietitianSubscription {
            id
            cancelAt
            stripeStatus
            status
            dietitianAddOn
            plans {
              nickname
            }
            primaryProduct {
              title
            }
          }
          lastCoreSubscription {
            id
            stripeStatus
            status
            latestInvoice {
              latestCharge {
                status
                created
              }
            }
          }
          sensorInfo {
            totalCount
            replacementRequestsCount
            firstStartTime
            lastSensor {
              expired
              expirationDate
            }
          }
          coachAssignments {
            ...CoreCoachAssignmentFields
          }
        }
        ehrAppointment {
          meetingAt
        }
        state
        last
        createdAt
        assignedAt
        deactivatedAt
        kind
        supportType
        coachingKind {
          ...CoreCoachingKindFields
        }
        dietitianMenu
      }
    }
  }
  ${CoreCoachAssignmentFieldsFragmentDoc}
  ${CoreCoachingKindFieldsFragmentDoc}
`

/**
 * __useAdminPanelAllCoachAssignmentsQuery__
 *
 * To run a query within a React component, call `useAdminPanelAllCoachAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPanelAllCoachAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPanelAllCoachAssignmentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useAdminPanelAllCoachAssignmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAdminPanelAllCoachAssignmentsQuery,
    IAdminPanelAllCoachAssignmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IAdminPanelAllCoachAssignmentsQuery,
    IAdminPanelAllCoachAssignmentsQueryVariables
  >(AdminPanelAllCoachAssignmentsDocument, options)
}
export function useAdminPanelAllCoachAssignmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAdminPanelAllCoachAssignmentsQuery,
    IAdminPanelAllCoachAssignmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAdminPanelAllCoachAssignmentsQuery,
    IAdminPanelAllCoachAssignmentsQueryVariables
  >(AdminPanelAllCoachAssignmentsDocument, options)
}
// @ts-ignore
export function useAdminPanelAllCoachAssignmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAdminPanelAllCoachAssignmentsQuery,
    IAdminPanelAllCoachAssignmentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAdminPanelAllCoachAssignmentsQuery,
  IAdminPanelAllCoachAssignmentsQueryVariables
>
export function useAdminPanelAllCoachAssignmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAdminPanelAllCoachAssignmentsQuery,
        IAdminPanelAllCoachAssignmentsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAdminPanelAllCoachAssignmentsQuery | undefined,
  IAdminPanelAllCoachAssignmentsQueryVariables
>
export function useAdminPanelAllCoachAssignmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAdminPanelAllCoachAssignmentsQuery,
        IAdminPanelAllCoachAssignmentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAdminPanelAllCoachAssignmentsQuery,
    IAdminPanelAllCoachAssignmentsQueryVariables
  >(AdminPanelAllCoachAssignmentsDocument, options)
}
export type AdminPanelAllCoachAssignmentsQueryHookResult = ReturnType<
  typeof useAdminPanelAllCoachAssignmentsQuery
>
export type AdminPanelAllCoachAssignmentsLazyQueryHookResult = ReturnType<
  typeof useAdminPanelAllCoachAssignmentsLazyQuery
>
export type AdminPanelAllCoachAssignmentsSuspenseQueryHookResult = ReturnType<
  typeof useAdminPanelAllCoachAssignmentsSuspenseQuery
>
export type AdminPanelAllCoachAssignmentsQueryResult = Apollo.QueryResult<
  IAdminPanelAllCoachAssignmentsQuery,
  IAdminPanelAllCoachAssignmentsQueryVariables
>
export const AdminPanelAllCoachesDocument = gql`
  query AdminPanelAllCoaches($sorts: [UserSort!], $dynamicFilters: [UserDynamicFilterItem!]) {
    allUsers(sorts: $sorts, dynamicFilters: $dynamicFilters) {
      users {
        id
        fullName
        email
        coachAssignmentInfo {
          activeAssignmentsCount
        }
        activeCoachingKinds {
          key
          coachTitle
        }
      }
    }
  }
`

/**
 * __useAdminPanelAllCoachesQuery__
 *
 * To run a query within a React component, call `useAdminPanelAllCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPanelAllCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPanelAllCoachesQuery({
 *   variables: {
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAdminPanelAllCoachesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAdminPanelAllCoachesQuery,
    IAdminPanelAllCoachesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAdminPanelAllCoachesQuery, IAdminPanelAllCoachesQueryVariables>(
    AdminPanelAllCoachesDocument,
    options
  )
}
export function useAdminPanelAllCoachesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAdminPanelAllCoachesQuery,
    IAdminPanelAllCoachesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAdminPanelAllCoachesQuery, IAdminPanelAllCoachesQueryVariables>(
    AdminPanelAllCoachesDocument,
    options
  )
}
// @ts-ignore
export function useAdminPanelAllCoachesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAdminPanelAllCoachesQuery,
    IAdminPanelAllCoachesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAdminPanelAllCoachesQuery, IAdminPanelAllCoachesQueryVariables>
export function useAdminPanelAllCoachesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAdminPanelAllCoachesQuery,
        IAdminPanelAllCoachesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAdminPanelAllCoachesQuery | undefined,
  IAdminPanelAllCoachesQueryVariables
>
export function useAdminPanelAllCoachesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAdminPanelAllCoachesQuery,
        IAdminPanelAllCoachesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAdminPanelAllCoachesQuery, IAdminPanelAllCoachesQueryVariables>(
    AdminPanelAllCoachesDocument,
    options
  )
}
export type AdminPanelAllCoachesQueryHookResult = ReturnType<typeof useAdminPanelAllCoachesQuery>
export type AdminPanelAllCoachesLazyQueryHookResult = ReturnType<
  typeof useAdminPanelAllCoachesLazyQuery
>
export type AdminPanelAllCoachesSuspenseQueryHookResult = ReturnType<
  typeof useAdminPanelAllCoachesSuspenseQuery
>
export type AdminPanelAllCoachesQueryResult = Apollo.QueryResult<
  IAdminPanelAllCoachesQuery,
  IAdminPanelAllCoachesQueryVariables
>
export const AllHealthPortalNotificationsDocument = gql`
  query AllHealthPortalNotifications(
    $page: Int
    $perPage: Int
    $sorts: [HealthPortalNotificationsSort!]
    $completed: Boolean
    $forReview: Boolean
    $kinds: [HealthPortalNotificationKind!]
    $userIds: [ID!]
  ) {
    allHealthPortalNotifications(
      page: $page
      perPage: $perPage
      sorts: $sorts
      completed: $completed
      forReview: $forReview
      kinds: $kinds
      userIds: $userIds
    ) {
      healthPortalNotifications {
        ...CoreHealthPortalNotificationFields
      }
    }
  }
  ${CoreHealthPortalNotificationFieldsFragmentDoc}
`

/**
 * __useAllHealthPortalNotificationsQuery__
 *
 * To run a query within a React component, call `useAllHealthPortalNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllHealthPortalNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllHealthPortalNotificationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      completed: // value for 'completed'
 *      forReview: // value for 'forReview'
 *      kinds: // value for 'kinds'
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useAllHealthPortalNotificationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllHealthPortalNotificationsQuery,
    IAllHealthPortalNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IAllHealthPortalNotificationsQuery,
    IAllHealthPortalNotificationsQueryVariables
  >(AllHealthPortalNotificationsDocument, options)
}
export function useAllHealthPortalNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllHealthPortalNotificationsQuery,
    IAllHealthPortalNotificationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAllHealthPortalNotificationsQuery,
    IAllHealthPortalNotificationsQueryVariables
  >(AllHealthPortalNotificationsDocument, options)
}
// @ts-ignore
export function useAllHealthPortalNotificationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllHealthPortalNotificationsQuery,
    IAllHealthPortalNotificationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllHealthPortalNotificationsQuery,
  IAllHealthPortalNotificationsQueryVariables
>
export function useAllHealthPortalNotificationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllHealthPortalNotificationsQuery,
        IAllHealthPortalNotificationsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllHealthPortalNotificationsQuery | undefined,
  IAllHealthPortalNotificationsQueryVariables
>
export function useAllHealthPortalNotificationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllHealthPortalNotificationsQuery,
        IAllHealthPortalNotificationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllHealthPortalNotificationsQuery,
    IAllHealthPortalNotificationsQueryVariables
  >(AllHealthPortalNotificationsDocument, options)
}
export type AllHealthPortalNotificationsQueryHookResult = ReturnType<
  typeof useAllHealthPortalNotificationsQuery
>
export type AllHealthPortalNotificationsLazyQueryHookResult = ReturnType<
  typeof useAllHealthPortalNotificationsLazyQuery
>
export type AllHealthPortalNotificationsSuspenseQueryHookResult = ReturnType<
  typeof useAllHealthPortalNotificationsSuspenseQuery
>
export type AllHealthPortalNotificationsQueryResult = Apollo.QueryResult<
  IAllHealthPortalNotificationsQuery,
  IAllHealthPortalNotificationsQueryVariables
>
export const AdminPanelAllUsersDocument = gql`
  query AdminPanelAllUsers(
    $page: Int
    $perPage: Int
    $sorts: [UserSort!]
    $dynamicFilters: [UserDynamicFilterItem!]
  ) {
    allUsers(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      totalCount
      users {
        id
        fullName
        email
        sensorInfo {
          totalCount
        }
        coachAssignments {
          ...CoreCoachAssignmentFields
        }
        ongoingDietitianSubscription {
          id
          cancelAt
          status
          plans {
            nickname
          }
        }
        lastDietitianSubscription {
          id
          stripeStatus
          status
        }
        primaryGoal {
          title
          kind
          description
        }
        userProperties {
          oneMonthActiveFeedbackDietitian {
            id
            kind
            value
          }
          dietitianRequest {
            id
            kind
            value
          }
          scheduledVideoCallStatus {
            id
            kind
            value
          }
          testGroup {
            id
            kind
            value
          }
          healthGoal {
            id
            kind
            value
          }
          videoCallRescheduleFreePassUsed {
            id
            kind
            value
          }
        }
      }
    }
  }
  ${CoreCoachAssignmentFieldsFragmentDoc}
`

/**
 * __useAdminPanelAllUsersQuery__
 *
 * To run a query within a React component, call `useAdminPanelAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminPanelAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminPanelAllUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAdminPanelAllUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<IAdminPanelAllUsersQuery, IAdminPanelAllUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAdminPanelAllUsersQuery, IAdminPanelAllUsersQueryVariables>(
    AdminPanelAllUsersDocument,
    options
  )
}
export function useAdminPanelAllUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAdminPanelAllUsersQuery,
    IAdminPanelAllUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAdminPanelAllUsersQuery, IAdminPanelAllUsersQueryVariables>(
    AdminPanelAllUsersDocument,
    options
  )
}
// @ts-ignore
export function useAdminPanelAllUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAdminPanelAllUsersQuery,
    IAdminPanelAllUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAdminPanelAllUsersQuery, IAdminPanelAllUsersQueryVariables>
export function useAdminPanelAllUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAdminPanelAllUsersQuery, IAdminPanelAllUsersQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAdminPanelAllUsersQuery | undefined,
  IAdminPanelAllUsersQueryVariables
>
export function useAdminPanelAllUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAdminPanelAllUsersQuery, IAdminPanelAllUsersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAdminPanelAllUsersQuery, IAdminPanelAllUsersQueryVariables>(
    AdminPanelAllUsersDocument,
    options
  )
}
export type AdminPanelAllUsersQueryHookResult = ReturnType<typeof useAdminPanelAllUsersQuery>
export type AdminPanelAllUsersLazyQueryHookResult = ReturnType<
  typeof useAdminPanelAllUsersLazyQuery
>
export type AdminPanelAllUsersSuspenseQueryHookResult = ReturnType<
  typeof useAdminPanelAllUsersSuspenseQuery
>
export type AdminPanelAllUsersQueryResult = Apollo.QueryResult<
  IAdminPanelAllUsersQuery,
  IAdminPanelAllUsersQueryVariables
>
export const AllAmazonOrdersDocument = gql`
  query allAmazonOrders(
    $page: Int
    $perPage: Int
    $sorts: [AmazonOrderSort!]
    $dynamicFilters: [AmazonOrderDynamicFilterItem!]
  ) {
    allAmazonOrders(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      orders {
        id
        amazonOrderId
        status
        total
        phoneNumber
        purchasedAt
        buyer {
          emailAlias
          userId
        }
        shippingOrder {
          id
        }
        items {
          id
          asin
          sku
          amazonOrderItemId
          quantity
        }
        address {
          ...CoreAddressFields
        }
      }
      totalCount
    }
  }
  ${CoreAddressFieldsFragmentDoc}
`

/**
 * __useAllAmazonOrdersQuery__
 *
 * To run a query within a React component, call `useAllAmazonOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAmazonOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAmazonOrdersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllAmazonOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllAmazonOrdersQuery, IAllAmazonOrdersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllAmazonOrdersQuery, IAllAmazonOrdersQueryVariables>(
    AllAmazonOrdersDocument,
    options
  )
}
export function useAllAmazonOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllAmazonOrdersQuery, IAllAmazonOrdersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllAmazonOrdersQuery, IAllAmazonOrdersQueryVariables>(
    AllAmazonOrdersDocument,
    options
  )
}
// @ts-ignore
export function useAllAmazonOrdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllAmazonOrdersQuery,
    IAllAmazonOrdersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllAmazonOrdersQuery, IAllAmazonOrdersQueryVariables>
export function useAllAmazonOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllAmazonOrdersQuery, IAllAmazonOrdersQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllAmazonOrdersQuery | undefined, IAllAmazonOrdersQueryVariables>
export function useAllAmazonOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllAmazonOrdersQuery, IAllAmazonOrdersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllAmazonOrdersQuery, IAllAmazonOrdersQueryVariables>(
    AllAmazonOrdersDocument,
    options
  )
}
export type AllAmazonOrdersQueryHookResult = ReturnType<typeof useAllAmazonOrdersQuery>
export type AllAmazonOrdersLazyQueryHookResult = ReturnType<typeof useAllAmazonOrdersLazyQuery>
export type AllAmazonOrdersSuspenseQueryHookResult = ReturnType<
  typeof useAllAmazonOrdersSuspenseQuery
>
export type AllAmazonOrdersQueryResult = Apollo.QueryResult<
  IAllAmazonOrdersQuery,
  IAllAmazonOrdersQueryVariables
>
export const AllAssignableAuthorizationPoliciesDocument = gql`
  query allAssignableAuthorizationPolicies {
    allAssignableAuthorizationPolicies {
      id
      kind
      policy {
        ...CoreAuthorizationPolicyFields
      }
    }
  }
  ${CoreAuthorizationPolicyFieldsFragmentDoc}
`

/**
 * __useAllAssignableAuthorizationPoliciesQuery__
 *
 * To run a query within a React component, call `useAllAssignableAuthorizationPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAssignableAuthorizationPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAssignableAuthorizationPoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAssignableAuthorizationPoliciesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllAssignableAuthorizationPoliciesQuery,
    IAllAssignableAuthorizationPoliciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IAllAssignableAuthorizationPoliciesQuery,
    IAllAssignableAuthorizationPoliciesQueryVariables
  >(AllAssignableAuthorizationPoliciesDocument, options)
}
export function useAllAssignableAuthorizationPoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllAssignableAuthorizationPoliciesQuery,
    IAllAssignableAuthorizationPoliciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAllAssignableAuthorizationPoliciesQuery,
    IAllAssignableAuthorizationPoliciesQueryVariables
  >(AllAssignableAuthorizationPoliciesDocument, options)
}
// @ts-ignore
export function useAllAssignableAuthorizationPoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllAssignableAuthorizationPoliciesQuery,
    IAllAssignableAuthorizationPoliciesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllAssignableAuthorizationPoliciesQuery,
  IAllAssignableAuthorizationPoliciesQueryVariables
>
export function useAllAssignableAuthorizationPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllAssignableAuthorizationPoliciesQuery,
        IAllAssignableAuthorizationPoliciesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllAssignableAuthorizationPoliciesQuery | undefined,
  IAllAssignableAuthorizationPoliciesQueryVariables
>
export function useAllAssignableAuthorizationPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllAssignableAuthorizationPoliciesQuery,
        IAllAssignableAuthorizationPoliciesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllAssignableAuthorizationPoliciesQuery,
    IAllAssignableAuthorizationPoliciesQueryVariables
  >(AllAssignableAuthorizationPoliciesDocument, options)
}
export type AllAssignableAuthorizationPoliciesQueryHookResult = ReturnType<
  typeof useAllAssignableAuthorizationPoliciesQuery
>
export type AllAssignableAuthorizationPoliciesLazyQueryHookResult = ReturnType<
  typeof useAllAssignableAuthorizationPoliciesLazyQuery
>
export type AllAssignableAuthorizationPoliciesSuspenseQueryHookResult = ReturnType<
  typeof useAllAssignableAuthorizationPoliciesSuspenseQuery
>
export type AllAssignableAuthorizationPoliciesQueryResult = Apollo.QueryResult<
  IAllAssignableAuthorizationPoliciesQuery,
  IAllAssignableAuthorizationPoliciesQueryVariables
>
export const AllChartsDocument = gql`
  query allCharts($filter: DateFilter) {
    allCharts(filter: $filter) {
      charts {
        type
        title
        description
        xAxis
        yAxis
        range {
          min
          max
          goal
          goalMin
          goalMax
        }
        meta {
          key
          tag
          section
        }
        values {
          __typename
          ... on TimePair {
            xTimePair: x
            yTimePair: y
            displayValue
            interpolated
          }
          ... on NumericPair {
            xNumericPair: x
            yNumericPair: y
          }
          ... on StringPair {
            name
            xStringPair: x
            yStringPair: y
          }
          ... on RangePair {
            xRangePair: x {
              min
              max
            }
            yRangePair: y
          }
        }
      }
    }
  }
`

/**
 * __useAllChartsQuery__
 *
 * To run a query within a React component, call `useAllChartsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChartsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChartsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllChartsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllChartsQuery, IAllChartsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllChartsQuery, IAllChartsQueryVariables>(AllChartsDocument, options)
}
export function useAllChartsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllChartsQuery, IAllChartsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllChartsQuery, IAllChartsQueryVariables>(AllChartsDocument, options)
}
// @ts-ignore
export function useAllChartsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllChartsQuery, IAllChartsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllChartsQuery, IAllChartsQueryVariables>
export function useAllChartsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllChartsQuery, IAllChartsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllChartsQuery | undefined, IAllChartsQueryVariables>
export function useAllChartsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllChartsQuery, IAllChartsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllChartsQuery, IAllChartsQueryVariables>(
    AllChartsDocument,
    options
  )
}
export type AllChartsQueryHookResult = ReturnType<typeof useAllChartsQuery>
export type AllChartsLazyQueryHookResult = ReturnType<typeof useAllChartsLazyQuery>
export type AllChartsSuspenseQueryHookResult = ReturnType<typeof useAllChartsSuspenseQuery>
export type AllChartsQueryResult = Apollo.QueryResult<IAllChartsQuery, IAllChartsQueryVariables>
export const AllChatConversationMessageTemplateVariablesDocument = gql`
  query allChatConversationMessageTemplateVariables {
    allChatConversationMessageTemplateVariables {
      chatConversationMessageTemplateVariables {
        id
        key
      }
    }
  }
`

/**
 * __useAllChatConversationMessageTemplateVariablesQuery__
 *
 * To run a query within a React component, call `useAllChatConversationMessageTemplateVariablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChatConversationMessageTemplateVariablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChatConversationMessageTemplateVariablesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllChatConversationMessageTemplateVariablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllChatConversationMessageTemplateVariablesQuery,
    IAllChatConversationMessageTemplateVariablesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IAllChatConversationMessageTemplateVariablesQuery,
    IAllChatConversationMessageTemplateVariablesQueryVariables
  >(AllChatConversationMessageTemplateVariablesDocument, options)
}
export function useAllChatConversationMessageTemplateVariablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllChatConversationMessageTemplateVariablesQuery,
    IAllChatConversationMessageTemplateVariablesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAllChatConversationMessageTemplateVariablesQuery,
    IAllChatConversationMessageTemplateVariablesQueryVariables
  >(AllChatConversationMessageTemplateVariablesDocument, options)
}
// @ts-ignore
export function useAllChatConversationMessageTemplateVariablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllChatConversationMessageTemplateVariablesQuery,
    IAllChatConversationMessageTemplateVariablesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllChatConversationMessageTemplateVariablesQuery,
  IAllChatConversationMessageTemplateVariablesQueryVariables
>
export function useAllChatConversationMessageTemplateVariablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatConversationMessageTemplateVariablesQuery,
        IAllChatConversationMessageTemplateVariablesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllChatConversationMessageTemplateVariablesQuery | undefined,
  IAllChatConversationMessageTemplateVariablesQueryVariables
>
export function useAllChatConversationMessageTemplateVariablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatConversationMessageTemplateVariablesQuery,
        IAllChatConversationMessageTemplateVariablesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllChatConversationMessageTemplateVariablesQuery,
    IAllChatConversationMessageTemplateVariablesQueryVariables
  >(AllChatConversationMessageTemplateVariablesDocument, options)
}
export type AllChatConversationMessageTemplateVariablesQueryHookResult = ReturnType<
  typeof useAllChatConversationMessageTemplateVariablesQuery
>
export type AllChatConversationMessageTemplateVariablesLazyQueryHookResult = ReturnType<
  typeof useAllChatConversationMessageTemplateVariablesLazyQuery
>
export type AllChatConversationMessageTemplateVariablesSuspenseQueryHookResult = ReturnType<
  typeof useAllChatConversationMessageTemplateVariablesSuspenseQuery
>
export type AllChatConversationMessageTemplateVariablesQueryResult = Apollo.QueryResult<
  IAllChatConversationMessageTemplateVariablesQuery,
  IAllChatConversationMessageTemplateVariablesQueryVariables
>
export const AllChatConversationMessageTemplatesDocument = gql`
  query allChatConversationMessageTemplates(
    $kinds: [ChatConversationMessageTemplateKind!]
    $excludeAutomatic: Boolean
  ) {
    allChatConversationMessageTemplates(kinds: $kinds, excludeAutomatic: $excludeAutomatic) {
      chatConversationMessageTemplates {
        id
        value
        kind
        name
        private
        automatic
        createdBy {
          id
        }
      }
    }
  }
`

/**
 * __useAllChatConversationMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useAllChatConversationMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChatConversationMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChatConversationMessageTemplatesQuery({
 *   variables: {
 *      kinds: // value for 'kinds'
 *      excludeAutomatic: // value for 'excludeAutomatic'
 *   },
 * });
 */
export function useAllChatConversationMessageTemplatesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllChatConversationMessageTemplatesQuery,
    IAllChatConversationMessageTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IAllChatConversationMessageTemplatesQuery,
    IAllChatConversationMessageTemplatesQueryVariables
  >(AllChatConversationMessageTemplatesDocument, options)
}
export function useAllChatConversationMessageTemplatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllChatConversationMessageTemplatesQuery,
    IAllChatConversationMessageTemplatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAllChatConversationMessageTemplatesQuery,
    IAllChatConversationMessageTemplatesQueryVariables
  >(AllChatConversationMessageTemplatesDocument, options)
}
// @ts-ignore
export function useAllChatConversationMessageTemplatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllChatConversationMessageTemplatesQuery,
    IAllChatConversationMessageTemplatesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllChatConversationMessageTemplatesQuery,
  IAllChatConversationMessageTemplatesQueryVariables
>
export function useAllChatConversationMessageTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatConversationMessageTemplatesQuery,
        IAllChatConversationMessageTemplatesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllChatConversationMessageTemplatesQuery | undefined,
  IAllChatConversationMessageTemplatesQueryVariables
>
export function useAllChatConversationMessageTemplatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatConversationMessageTemplatesQuery,
        IAllChatConversationMessageTemplatesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllChatConversationMessageTemplatesQuery,
    IAllChatConversationMessageTemplatesQueryVariables
  >(AllChatConversationMessageTemplatesDocument, options)
}
export type AllChatConversationMessageTemplatesQueryHookResult = ReturnType<
  typeof useAllChatConversationMessageTemplatesQuery
>
export type AllChatConversationMessageTemplatesLazyQueryHookResult = ReturnType<
  typeof useAllChatConversationMessageTemplatesLazyQuery
>
export type AllChatConversationMessageTemplatesSuspenseQueryHookResult = ReturnType<
  typeof useAllChatConversationMessageTemplatesSuspenseQuery
>
export type AllChatConversationMessageTemplatesQueryResult = Apollo.QueryResult<
  IAllChatConversationMessageTemplatesQuery,
  IAllChatConversationMessageTemplatesQueryVariables
>
export const AllChatbotConversationsDocument = gql`
  query allChatbotConversations {
    allChatbotConversations {
      conversations {
        id
        userId
        providerId
        createdAt
        updatedAt
      }
    }
  }
`

/**
 * __useAllChatbotConversationsQuery__
 *
 * To run a query within a React component, call `useAllChatbotConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChatbotConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChatbotConversationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllChatbotConversationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllChatbotConversationsQuery,
    IAllChatbotConversationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllChatbotConversationsQuery, IAllChatbotConversationsQueryVariables>(
    AllChatbotConversationsDocument,
    options
  )
}
export function useAllChatbotConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllChatbotConversationsQuery,
    IAllChatbotConversationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllChatbotConversationsQuery, IAllChatbotConversationsQueryVariables>(
    AllChatbotConversationsDocument,
    options
  )
}
// @ts-ignore
export function useAllChatbotConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllChatbotConversationsQuery,
    IAllChatbotConversationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllChatbotConversationsQuery,
  IAllChatbotConversationsQueryVariables
>
export function useAllChatbotConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatbotConversationsQuery,
        IAllChatbotConversationsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllChatbotConversationsQuery | undefined,
  IAllChatbotConversationsQueryVariables
>
export function useAllChatbotConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatbotConversationsQuery,
        IAllChatbotConversationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllChatbotConversationsQuery,
    IAllChatbotConversationsQueryVariables
  >(AllChatbotConversationsDocument, options)
}
export type AllChatbotConversationsQueryHookResult = ReturnType<
  typeof useAllChatbotConversationsQuery
>
export type AllChatbotConversationsLazyQueryHookResult = ReturnType<
  typeof useAllChatbotConversationsLazyQuery
>
export type AllChatbotConversationsSuspenseQueryHookResult = ReturnType<
  typeof useAllChatbotConversationsSuspenseQuery
>
export type AllChatbotConversationsQueryResult = Apollo.QueryResult<
  IAllChatbotConversationsQuery,
  IAllChatbotConversationsQueryVariables
>
export const AllCoachBillingInvoiceUsersDocument = gql`
  query allCoachBillingInvoiceUsers(
    $active: Boolean
    $periodStart: ISO8601Date!
    $periodEnd: ISO8601Date!
    $page: Int
    $perPage: Int
    $sorts: [CoachBillingInvoiceUserSort!]
    $dynamicFilters: [CoachBillingInvoiceUserDynamicFilterItem!]
  ) {
    allCoachBillingInvoiceUsers(
      active: $active
      periodStart: $periodStart
      periodEnd: $periodEnd
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      users {
        ...CoreCoachBillingInvoiceUserFields
      }
    }
  }
  ${CoreCoachBillingInvoiceUserFieldsFragmentDoc}
`

/**
 * __useAllCoachBillingInvoiceUsersQuery__
 *
 * To run a query within a React component, call `useAllCoachBillingInvoiceUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCoachBillingInvoiceUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCoachBillingInvoiceUsersQuery({
 *   variables: {
 *      active: // value for 'active'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllCoachBillingInvoiceUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    IAllCoachBillingInvoiceUsersQuery,
    IAllCoachBillingInvoiceUsersQueryVariables
  > &
    ({ variables: IAllCoachBillingInvoiceUsersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IAllCoachBillingInvoiceUsersQuery,
    IAllCoachBillingInvoiceUsersQueryVariables
  >(AllCoachBillingInvoiceUsersDocument, options)
}
export function useAllCoachBillingInvoiceUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllCoachBillingInvoiceUsersQuery,
    IAllCoachBillingInvoiceUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAllCoachBillingInvoiceUsersQuery,
    IAllCoachBillingInvoiceUsersQueryVariables
  >(AllCoachBillingInvoiceUsersDocument, options)
}
// @ts-ignore
export function useAllCoachBillingInvoiceUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllCoachBillingInvoiceUsersQuery,
    IAllCoachBillingInvoiceUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllCoachBillingInvoiceUsersQuery,
  IAllCoachBillingInvoiceUsersQueryVariables
>
export function useAllCoachBillingInvoiceUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllCoachBillingInvoiceUsersQuery,
        IAllCoachBillingInvoiceUsersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllCoachBillingInvoiceUsersQuery | undefined,
  IAllCoachBillingInvoiceUsersQueryVariables
>
export function useAllCoachBillingInvoiceUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllCoachBillingInvoiceUsersQuery,
        IAllCoachBillingInvoiceUsersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllCoachBillingInvoiceUsersQuery,
    IAllCoachBillingInvoiceUsersQueryVariables
  >(AllCoachBillingInvoiceUsersDocument, options)
}
export type AllCoachBillingInvoiceUsersQueryHookResult = ReturnType<
  typeof useAllCoachBillingInvoiceUsersQuery
>
export type AllCoachBillingInvoiceUsersLazyQueryHookResult = ReturnType<
  typeof useAllCoachBillingInvoiceUsersLazyQuery
>
export type AllCoachBillingInvoiceUsersSuspenseQueryHookResult = ReturnType<
  typeof useAllCoachBillingInvoiceUsersSuspenseQuery
>
export type AllCoachBillingInvoiceUsersQueryResult = Apollo.QueryResult<
  IAllCoachBillingInvoiceUsersQuery,
  IAllCoachBillingInvoiceUsersQueryVariables
>
export const AllCoachConversationScheduledMessagesDocument = gql`
  query allCoachConversationScheduledMessages(
    $userId: ID
    $kinds: [ChatConversationMessageTemplateKind!]
    $states: [CoachesConversationScheduledMessageState!]
    $sorts: [CoachConversationScheduledMessageSort!]
  ) {
    allCoachConversationScheduledMessages(
      kinds: $kinds
      states: $states
      userId: $userId
      sorts: $sorts
    ) {
      coachConversationScheduledMessages {
        id
        kind
        state
        sendAt
        sentAt
        coachAssignment {
          id
          user {
            id
            fullName
          }
          ehrAppointment {
            id
          }
        }
      }
    }
  }
`

/**
 * __useAllCoachConversationScheduledMessagesQuery__
 *
 * To run a query within a React component, call `useAllCoachConversationScheduledMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCoachConversationScheduledMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCoachConversationScheduledMessagesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      kinds: // value for 'kinds'
 *      states: // value for 'states'
 *      sorts: // value for 'sorts'
 *   },
 * });
 */
export function useAllCoachConversationScheduledMessagesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllCoachConversationScheduledMessagesQuery,
    IAllCoachConversationScheduledMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IAllCoachConversationScheduledMessagesQuery,
    IAllCoachConversationScheduledMessagesQueryVariables
  >(AllCoachConversationScheduledMessagesDocument, options)
}
export function useAllCoachConversationScheduledMessagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllCoachConversationScheduledMessagesQuery,
    IAllCoachConversationScheduledMessagesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAllCoachConversationScheduledMessagesQuery,
    IAllCoachConversationScheduledMessagesQueryVariables
  >(AllCoachConversationScheduledMessagesDocument, options)
}
// @ts-ignore
export function useAllCoachConversationScheduledMessagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllCoachConversationScheduledMessagesQuery,
    IAllCoachConversationScheduledMessagesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllCoachConversationScheduledMessagesQuery,
  IAllCoachConversationScheduledMessagesQueryVariables
>
export function useAllCoachConversationScheduledMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllCoachConversationScheduledMessagesQuery,
        IAllCoachConversationScheduledMessagesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllCoachConversationScheduledMessagesQuery | undefined,
  IAllCoachConversationScheduledMessagesQueryVariables
>
export function useAllCoachConversationScheduledMessagesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllCoachConversationScheduledMessagesQuery,
        IAllCoachConversationScheduledMessagesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllCoachConversationScheduledMessagesQuery,
    IAllCoachConversationScheduledMessagesQueryVariables
  >(AllCoachConversationScheduledMessagesDocument, options)
}
export type AllCoachConversationScheduledMessagesQueryHookResult = ReturnType<
  typeof useAllCoachConversationScheduledMessagesQuery
>
export type AllCoachConversationScheduledMessagesLazyQueryHookResult = ReturnType<
  typeof useAllCoachConversationScheduledMessagesLazyQuery
>
export type AllCoachConversationScheduledMessagesSuspenseQueryHookResult = ReturnType<
  typeof useAllCoachConversationScheduledMessagesSuspenseQuery
>
export type AllCoachConversationScheduledMessagesQueryResult = Apollo.QueryResult<
  IAllCoachConversationScheduledMessagesQuery,
  IAllCoachConversationScheduledMessagesQueryVariables
>
export const AllEventsDocument = gql`
  query allEvents($filter: DateFilter, $pagination: Pagination) {
    allEvents(filter: $filter, pagination: $pagination) {
      events {
        events {
          ...AllEventsActivity
          ...AllEventsMeal
          ...AllEventsMeasurement
          ...AllEventsNote
          ...AllEventsJournalEntry
        }
      }
    }
  }
  ${AllEventsActivityFragmentDoc}
  ${AllEventsMealFragmentDoc}
  ${AllEventsMeasurementFragmentDoc}
  ${AllEventsNoteFragmentDoc}
  ${AllEventsJournalEntryFragmentDoc}
`

/**
 * __useAllEventsQuery__
 *
 * To run a query within a React component, call `useAllEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllEventsQuery, IAllEventsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllEventsQuery, IAllEventsQueryVariables>(AllEventsDocument, options)
}
export function useAllEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllEventsQuery, IAllEventsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllEventsQuery, IAllEventsQueryVariables>(AllEventsDocument, options)
}
// @ts-ignore
export function useAllEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllEventsQuery, IAllEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllEventsQuery, IAllEventsQueryVariables>
export function useAllEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllEventsQuery, IAllEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllEventsQuery | undefined, IAllEventsQueryVariables>
export function useAllEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllEventsQuery, IAllEventsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllEventsQuery, IAllEventsQueryVariables>(
    AllEventsDocument,
    options
  )
}
export type AllEventsQueryHookResult = ReturnType<typeof useAllEventsQuery>
export type AllEventsLazyQueryHookResult = ReturnType<typeof useAllEventsLazyQuery>
export type AllEventsSuspenseQueryHookResult = ReturnType<typeof useAllEventsSuspenseQuery>
export type AllEventsQueryResult = Apollo.QueryResult<IAllEventsQuery, IAllEventsQueryVariables>
export const AllFilesDocument = gql`
  query allFiles(
    $page: Int
    $perPage: Int
    $sorts: [FileSort!]
    $dynamicFilters: [FileDynamicFilterItem!]
  ) {
    allFiles(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      files {
        ...CoreFileFields
        tag
      }
    }
  }
  ${CoreFileFieldsFragmentDoc}
`

/**
 * __useAllFilesQuery__
 *
 * To run a query within a React component, call `useAllFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFilesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllFilesQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllFilesQuery, IAllFilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllFilesQuery, IAllFilesQueryVariables>(AllFilesDocument, options)
}
export function useAllFilesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllFilesQuery, IAllFilesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllFilesQuery, IAllFilesQueryVariables>(AllFilesDocument, options)
}
// @ts-ignore
export function useAllFilesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllFilesQuery, IAllFilesQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllFilesQuery, IAllFilesQueryVariables>
export function useAllFilesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllFilesQuery, IAllFilesQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllFilesQuery | undefined, IAllFilesQueryVariables>
export function useAllFilesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllFilesQuery, IAllFilesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllFilesQuery, IAllFilesQueryVariables>(AllFilesDocument, options)
}
export type AllFilesQueryHookResult = ReturnType<typeof useAllFilesQuery>
export type AllFilesLazyQueryHookResult = ReturnType<typeof useAllFilesLazyQuery>
export type AllFilesSuspenseQueryHookResult = ReturnType<typeof useAllFilesSuspenseQuery>
export type AllFilesQueryResult = Apollo.QueryResult<IAllFilesQuery, IAllFilesQueryVariables>
export const AllFormulasDocument = gql`
  query allFormulas {
    allFormulas {
      formulas {
        operation
        className
        title
        description
      }
    }
  }
`

/**
 * __useAllFormulasQuery__
 *
 * To run a query within a React component, call `useAllFormulasQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFormulasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFormulasQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFormulasQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllFormulasQuery, IAllFormulasQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllFormulasQuery, IAllFormulasQueryVariables>(
    AllFormulasDocument,
    options
  )
}
export function useAllFormulasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllFormulasQuery, IAllFormulasQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllFormulasQuery, IAllFormulasQueryVariables>(
    AllFormulasDocument,
    options
  )
}
// @ts-ignore
export function useAllFormulasSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllFormulasQuery, IAllFormulasQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllFormulasQuery, IAllFormulasQueryVariables>
export function useAllFormulasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllFormulasQuery, IAllFormulasQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllFormulasQuery | undefined, IAllFormulasQueryVariables>
export function useAllFormulasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllFormulasQuery, IAllFormulasQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllFormulasQuery, IAllFormulasQueryVariables>(
    AllFormulasDocument,
    options
  )
}
export type AllFormulasQueryHookResult = ReturnType<typeof useAllFormulasQuery>
export type AllFormulasLazyQueryHookResult = ReturnType<typeof useAllFormulasLazyQuery>
export type AllFormulasSuspenseQueryHookResult = ReturnType<typeof useAllFormulasSuspenseQuery>
export type AllFormulasQueryResult = Apollo.QueryResult<
  IAllFormulasQuery,
  IAllFormulasQueryVariables
>
export const AllHealthDataReportsDocument = gql`
  query allHealthDataReports(
    $userId: ID!
    $sorts: [HealthDataReportSort!]
    $dynamicFilters: [HealthDataReportDynamicFilterItem!]
  ) {
    allHealthDataReports(userId: $userId, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      reports {
        id
        user {
          id
        }
        startDate
        endDate
        kind
        lastState {
          kind
        }
        reportData
        createdAt
      }
    }
  }
`

/**
 * __useAllHealthDataReportsQuery__
 *
 * To run a query within a React component, call `useAllHealthDataReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllHealthDataReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllHealthDataReportsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllHealthDataReportsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IAllHealthDataReportsQuery,
    IAllHealthDataReportsQueryVariables
  > &
    ({ variables: IAllHealthDataReportsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllHealthDataReportsQuery, IAllHealthDataReportsQueryVariables>(
    AllHealthDataReportsDocument,
    options
  )
}
export function useAllHealthDataReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllHealthDataReportsQuery,
    IAllHealthDataReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllHealthDataReportsQuery, IAllHealthDataReportsQueryVariables>(
    AllHealthDataReportsDocument,
    options
  )
}
// @ts-ignore
export function useAllHealthDataReportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllHealthDataReportsQuery,
    IAllHealthDataReportsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllHealthDataReportsQuery, IAllHealthDataReportsQueryVariables>
export function useAllHealthDataReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllHealthDataReportsQuery,
        IAllHealthDataReportsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllHealthDataReportsQuery | undefined,
  IAllHealthDataReportsQueryVariables
>
export function useAllHealthDataReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllHealthDataReportsQuery,
        IAllHealthDataReportsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllHealthDataReportsQuery, IAllHealthDataReportsQueryVariables>(
    AllHealthDataReportsDocument,
    options
  )
}
export type AllHealthDataReportsQueryHookResult = ReturnType<typeof useAllHealthDataReportsQuery>
export type AllHealthDataReportsLazyQueryHookResult = ReturnType<
  typeof useAllHealthDataReportsLazyQuery
>
export type AllHealthDataReportsSuspenseQueryHookResult = ReturnType<
  typeof useAllHealthDataReportsSuspenseQuery
>
export type AllHealthDataReportsQueryResult = Apollo.QueryResult<
  IAllHealthDataReportsQuery,
  IAllHealthDataReportsQueryVariables
>
export const AllHistoryDocument = gql`
  query allHistory($filter: DateFilter, $pagination: Pagination) {
    allEvents(filter: $filter, pagination: $pagination) {
      events {
        events {
          ...AllEventsActivity
          ...AllEventsMeal
          ...AllEventsMeasurement
          ...AllEventsNote
          ...AllEventsJournalEntry
        }
      }
    }
  }
  ${AllEventsActivityFragmentDoc}
  ${AllEventsMealFragmentDoc}
  ${AllEventsMeasurementFragmentDoc}
  ${AllEventsNoteFragmentDoc}
  ${AllEventsJournalEntryFragmentDoc}
`

/**
 * __useAllHistoryQuery__
 *
 * To run a query within a React component, call `useAllHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useAllHistoryQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllHistoryQuery, IAllHistoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllHistoryQuery, IAllHistoryQueryVariables>(AllHistoryDocument, options)
}
export function useAllHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllHistoryQuery, IAllHistoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllHistoryQuery, IAllHistoryQueryVariables>(
    AllHistoryDocument,
    options
  )
}
// @ts-ignore
export function useAllHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllHistoryQuery, IAllHistoryQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllHistoryQuery, IAllHistoryQueryVariables>
export function useAllHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllHistoryQuery, IAllHistoryQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllHistoryQuery | undefined, IAllHistoryQueryVariables>
export function useAllHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllHistoryQuery, IAllHistoryQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllHistoryQuery, IAllHistoryQueryVariables>(
    AllHistoryDocument,
    options
  )
}
export type AllHistoryQueryHookResult = ReturnType<typeof useAllHistoryQuery>
export type AllHistoryLazyQueryHookResult = ReturnType<typeof useAllHistoryLazyQuery>
export type AllHistorySuspenseQueryHookResult = ReturnType<typeof useAllHistorySuspenseQuery>
export type AllHistoryQueryResult = Apollo.QueryResult<IAllHistoryQuery, IAllHistoryQueryVariables>
export const AllInvoiceOrdersDocument = gql`
  query allInvoiceOrders(
    $page: Int!
    $perPage: Int!
    $sorts: [InvoiceOrderSort!]
    $dynamicFilters: [InvoiceOrderDynamicFilterItem!]
  ) {
    allInvoiceOrders(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      invoiceOrders {
        ...CoreInvoiceOrderFields
      }
      totalCount
    }
  }
  ${CoreInvoiceOrderFieldsFragmentDoc}
`

/**
 * __useAllInvoiceOrdersQuery__
 *
 * To run a query within a React component, call `useAllInvoiceOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllInvoiceOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllInvoiceOrdersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllInvoiceOrdersQuery(
  baseOptions: Apollo.QueryHookOptions<IAllInvoiceOrdersQuery, IAllInvoiceOrdersQueryVariables> &
    ({ variables: IAllInvoiceOrdersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllInvoiceOrdersQuery, IAllInvoiceOrdersQueryVariables>(
    AllInvoiceOrdersDocument,
    options
  )
}
export function useAllInvoiceOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllInvoiceOrdersQuery, IAllInvoiceOrdersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllInvoiceOrdersQuery, IAllInvoiceOrdersQueryVariables>(
    AllInvoiceOrdersDocument,
    options
  )
}
// @ts-ignore
export function useAllInvoiceOrdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllInvoiceOrdersQuery,
    IAllInvoiceOrdersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllInvoiceOrdersQuery, IAllInvoiceOrdersQueryVariables>
export function useAllInvoiceOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllInvoiceOrdersQuery, IAllInvoiceOrdersQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAllInvoiceOrdersQuery | undefined,
  IAllInvoiceOrdersQueryVariables
>
export function useAllInvoiceOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllInvoiceOrdersQuery, IAllInvoiceOrdersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllInvoiceOrdersQuery, IAllInvoiceOrdersQueryVariables>(
    AllInvoiceOrdersDocument,
    options
  )
}
export type AllInvoiceOrdersQueryHookResult = ReturnType<typeof useAllInvoiceOrdersQuery>
export type AllInvoiceOrdersLazyQueryHookResult = ReturnType<typeof useAllInvoiceOrdersLazyQuery>
export type AllInvoiceOrdersSuspenseQueryHookResult = ReturnType<
  typeof useAllInvoiceOrdersSuspenseQuery
>
export type AllInvoiceOrdersQueryResult = Apollo.QueryResult<
  IAllInvoiceOrdersQuery,
  IAllInvoiceOrdersQueryVariables
>
export const AllKnowledgeAnswersDocument = gql`
  query allKnowledgeAnswers(
    $page: Int
    $perPage: Int
    $sorts: [KnowledgeAnswerSort!]
    $dynamicFilters: [KnowledgeAnswerDynamicFilterItem!]
  ) {
    allKnowledgeAnswers(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      pageCount
      knowledgeAnswers {
        ...CoreKnowledgeAnswerFields
      }
    }
  }
  ${CoreKnowledgeAnswerFieldsFragmentDoc}
`

/**
 * __useAllKnowledgeAnswersQuery__
 *
 * To run a query within a React component, call `useAllKnowledgeAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllKnowledgeAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllKnowledgeAnswersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllKnowledgeAnswersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllKnowledgeAnswersQuery,
    IAllKnowledgeAnswersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllKnowledgeAnswersQuery, IAllKnowledgeAnswersQueryVariables>(
    AllKnowledgeAnswersDocument,
    options
  )
}
export function useAllKnowledgeAnswersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllKnowledgeAnswersQuery,
    IAllKnowledgeAnswersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllKnowledgeAnswersQuery, IAllKnowledgeAnswersQueryVariables>(
    AllKnowledgeAnswersDocument,
    options
  )
}
// @ts-ignore
export function useAllKnowledgeAnswersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllKnowledgeAnswersQuery,
    IAllKnowledgeAnswersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllKnowledgeAnswersQuery, IAllKnowledgeAnswersQueryVariables>
export function useAllKnowledgeAnswersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllKnowledgeAnswersQuery, IAllKnowledgeAnswersQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAllKnowledgeAnswersQuery | undefined,
  IAllKnowledgeAnswersQueryVariables
>
export function useAllKnowledgeAnswersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllKnowledgeAnswersQuery, IAllKnowledgeAnswersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllKnowledgeAnswersQuery, IAllKnowledgeAnswersQueryVariables>(
    AllKnowledgeAnswersDocument,
    options
  )
}
export type AllKnowledgeAnswersQueryHookResult = ReturnType<typeof useAllKnowledgeAnswersQuery>
export type AllKnowledgeAnswersLazyQueryHookResult = ReturnType<
  typeof useAllKnowledgeAnswersLazyQuery
>
export type AllKnowledgeAnswersSuspenseQueryHookResult = ReturnType<
  typeof useAllKnowledgeAnswersSuspenseQuery
>
export type AllKnowledgeAnswersQueryResult = Apollo.QueryResult<
  IAllKnowledgeAnswersQuery,
  IAllKnowledgeAnswersQueryVariables
>
export const AllKnowledgeQuestionsDocument = gql`
  query allKnowledgeQuestions(
    $page: Int
    $perPage: Int
    $sorts: [KnowledgeQuestionSort!]
    $dynamicFilters: [KnowledgeQuestionDynamicFilterItem!]
  ) {
    allKnowledgeQuestions(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      pageCount
      knowledgeQuestions {
        ...CoreKnowledgeQuestionFields
      }
    }
  }
  ${CoreKnowledgeQuestionFieldsFragmentDoc}
`

/**
 * __useAllKnowledgeQuestionsQuery__
 *
 * To run a query within a React component, call `useAllKnowledgeQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllKnowledgeQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllKnowledgeQuestionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllKnowledgeQuestionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllKnowledgeQuestionsQuery,
    IAllKnowledgeQuestionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllKnowledgeQuestionsQuery, IAllKnowledgeQuestionsQueryVariables>(
    AllKnowledgeQuestionsDocument,
    options
  )
}
export function useAllKnowledgeQuestionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllKnowledgeQuestionsQuery,
    IAllKnowledgeQuestionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllKnowledgeQuestionsQuery, IAllKnowledgeQuestionsQueryVariables>(
    AllKnowledgeQuestionsDocument,
    options
  )
}
// @ts-ignore
export function useAllKnowledgeQuestionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllKnowledgeQuestionsQuery,
    IAllKnowledgeQuestionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllKnowledgeQuestionsQuery, IAllKnowledgeQuestionsQueryVariables>
export function useAllKnowledgeQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllKnowledgeQuestionsQuery,
        IAllKnowledgeQuestionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllKnowledgeQuestionsQuery | undefined,
  IAllKnowledgeQuestionsQueryVariables
>
export function useAllKnowledgeQuestionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllKnowledgeQuestionsQuery,
        IAllKnowledgeQuestionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllKnowledgeQuestionsQuery, IAllKnowledgeQuestionsQueryVariables>(
    AllKnowledgeQuestionsDocument,
    options
  )
}
export type AllKnowledgeQuestionsQueryHookResult = ReturnType<typeof useAllKnowledgeQuestionsQuery>
export type AllKnowledgeQuestionsLazyQueryHookResult = ReturnType<
  typeof useAllKnowledgeQuestionsLazyQuery
>
export type AllKnowledgeQuestionsSuspenseQueryHookResult = ReturnType<
  typeof useAllKnowledgeQuestionsSuspenseQuery
>
export type AllKnowledgeQuestionsQueryResult = Apollo.QueryResult<
  IAllKnowledgeQuestionsQuery,
  IAllKnowledgeQuestionsQueryVariables
>
export const AllKnowledgeSourcesDocument = gql`
  query allKnowledgeSources(
    $page: Int
    $perPage: Int
    $sorts: [KnowledgeSourceSort!]
    $dynamicFilters: [KnowledgeSourceDynamicFilterItem!]
  ) {
    allKnowledgeSources(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      pageCount
      knowledgeSources {
        id
        title
        url
        knowledgeAnswers {
          id
          title
          value
          knowledgeQuestions {
            id
            value
          }
        }
      }
    }
  }
`

/**
 * __useAllKnowledgeSourcesQuery__
 *
 * To run a query within a React component, call `useAllKnowledgeSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllKnowledgeSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllKnowledgeSourcesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllKnowledgeSourcesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllKnowledgeSourcesQuery,
    IAllKnowledgeSourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllKnowledgeSourcesQuery, IAllKnowledgeSourcesQueryVariables>(
    AllKnowledgeSourcesDocument,
    options
  )
}
export function useAllKnowledgeSourcesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllKnowledgeSourcesQuery,
    IAllKnowledgeSourcesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllKnowledgeSourcesQuery, IAllKnowledgeSourcesQueryVariables>(
    AllKnowledgeSourcesDocument,
    options
  )
}
// @ts-ignore
export function useAllKnowledgeSourcesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllKnowledgeSourcesQuery,
    IAllKnowledgeSourcesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllKnowledgeSourcesQuery, IAllKnowledgeSourcesQueryVariables>
export function useAllKnowledgeSourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllKnowledgeSourcesQuery, IAllKnowledgeSourcesQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAllKnowledgeSourcesQuery | undefined,
  IAllKnowledgeSourcesQueryVariables
>
export function useAllKnowledgeSourcesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllKnowledgeSourcesQuery, IAllKnowledgeSourcesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllKnowledgeSourcesQuery, IAllKnowledgeSourcesQueryVariables>(
    AllKnowledgeSourcesDocument,
    options
  )
}
export type AllKnowledgeSourcesQueryHookResult = ReturnType<typeof useAllKnowledgeSourcesQuery>
export type AllKnowledgeSourcesLazyQueryHookResult = ReturnType<
  typeof useAllKnowledgeSourcesLazyQuery
>
export type AllKnowledgeSourcesSuspenseQueryHookResult = ReturnType<
  typeof useAllKnowledgeSourcesSuspenseQuery
>
export type AllKnowledgeSourcesQueryResult = Apollo.QueryResult<
  IAllKnowledgeSourcesQuery,
  IAllKnowledgeSourcesQueryVariables
>
export const AllKnowledgeTagsDocument = gql`
  query allKnowledgeTags(
    $page: Int
    $perPage: Int
    $sorts: [KnowledgeTagSort!]
    $dynamicFilters: [KnowledgeTagDynamicFilterItem!]
  ) {
    allKnowledgeTags(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      pageCount
      knowledgeTags {
        id
        value
      }
    }
  }
`

/**
 * __useAllKnowledgeTagsQuery__
 *
 * To run a query within a React component, call `useAllKnowledgeTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllKnowledgeTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllKnowledgeTagsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllKnowledgeTagsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllKnowledgeTagsQuery, IAllKnowledgeTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllKnowledgeTagsQuery, IAllKnowledgeTagsQueryVariables>(
    AllKnowledgeTagsDocument,
    options
  )
}
export function useAllKnowledgeTagsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllKnowledgeTagsQuery, IAllKnowledgeTagsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllKnowledgeTagsQuery, IAllKnowledgeTagsQueryVariables>(
    AllKnowledgeTagsDocument,
    options
  )
}
// @ts-ignore
export function useAllKnowledgeTagsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllKnowledgeTagsQuery,
    IAllKnowledgeTagsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllKnowledgeTagsQuery, IAllKnowledgeTagsQueryVariables>
export function useAllKnowledgeTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllKnowledgeTagsQuery, IAllKnowledgeTagsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAllKnowledgeTagsQuery | undefined,
  IAllKnowledgeTagsQueryVariables
>
export function useAllKnowledgeTagsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllKnowledgeTagsQuery, IAllKnowledgeTagsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllKnowledgeTagsQuery, IAllKnowledgeTagsQueryVariables>(
    AllKnowledgeTagsDocument,
    options
  )
}
export type AllKnowledgeTagsQueryHookResult = ReturnType<typeof useAllKnowledgeTagsQuery>
export type AllKnowledgeTagsLazyQueryHookResult = ReturnType<typeof useAllKnowledgeTagsLazyQuery>
export type AllKnowledgeTagsSuspenseQueryHookResult = ReturnType<
  typeof useAllKnowledgeTagsSuspenseQuery
>
export type AllKnowledgeTagsQueryResult = Apollo.QueryResult<
  IAllKnowledgeTagsQuery,
  IAllKnowledgeTagsQueryVariables
>
export const AllNotesDocument = gql`
  query allNotes($userId: ID!, $sorts: [NoteSort!], $dynamicFilters: [NoteDynamicFilterItem!]) {
    allNotes(userId: $userId, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      notes {
        id
        body
        kind
        occurredAt
        pinnedAt
        creator {
          id
          fullName
        }
      }
    }
  }
`

/**
 * __useAllNotesQuery__
 *
 * To run a query within a React component, call `useAllNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNotesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllNotesQuery(
  baseOptions: Apollo.QueryHookOptions<IAllNotesQuery, IAllNotesQueryVariables> &
    ({ variables: IAllNotesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllNotesQuery, IAllNotesQueryVariables>(AllNotesDocument, options)
}
export function useAllNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllNotesQuery, IAllNotesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllNotesQuery, IAllNotesQueryVariables>(AllNotesDocument, options)
}
// @ts-ignore
export function useAllNotesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllNotesQuery, IAllNotesQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllNotesQuery, IAllNotesQueryVariables>
export function useAllNotesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllNotesQuery, IAllNotesQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllNotesQuery | undefined, IAllNotesQueryVariables>
export function useAllNotesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllNotesQuery, IAllNotesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllNotesQuery, IAllNotesQueryVariables>(AllNotesDocument, options)
}
export type AllNotesQueryHookResult = ReturnType<typeof useAllNotesQuery>
export type AllNotesLazyQueryHookResult = ReturnType<typeof useAllNotesLazyQuery>
export type AllNotesSuspenseQueryHookResult = ReturnType<typeof useAllNotesSuspenseQuery>
export type AllNotesQueryResult = Apollo.QueryResult<IAllNotesQuery, IAllNotesQueryVariables>
export const AllNutritionistMembersDocument = gql`
  query AllNutritionistMembers(
    $page: Int
    $perPage: Int
    $sorts: [CoachAssignmentSort!]
    $dynamicFilters: [CoachAssignmentDynamicFilterItem!]
    $last: Boolean
  ) {
    allCoachAssignments(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
      last: $last
    ) {
      totalCount
      coachAssignments {
        id
        coach {
          id
          fullName
        }
        user {
          id
          fullName
          email
          lastAppointmentDate
          nextAppointmentDate
        }
        state
        lastCoachMessageDate
        canSendEngagementMessage
      }
    }
  }
`

/**
 * __useAllNutritionistMembersQuery__
 *
 * To run a query within a React component, call `useAllNutritionistMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNutritionistMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNutritionistMembersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useAllNutritionistMembersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllNutritionistMembersQuery,
    IAllNutritionistMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllNutritionistMembersQuery, IAllNutritionistMembersQueryVariables>(
    AllNutritionistMembersDocument,
    options
  )
}
export function useAllNutritionistMembersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllNutritionistMembersQuery,
    IAllNutritionistMembersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllNutritionistMembersQuery, IAllNutritionistMembersQueryVariables>(
    AllNutritionistMembersDocument,
    options
  )
}
// @ts-ignore
export function useAllNutritionistMembersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllNutritionistMembersQuery,
    IAllNutritionistMembersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllNutritionistMembersQuery,
  IAllNutritionistMembersQueryVariables
>
export function useAllNutritionistMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllNutritionistMembersQuery,
        IAllNutritionistMembersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllNutritionistMembersQuery | undefined,
  IAllNutritionistMembersQueryVariables
>
export function useAllNutritionistMembersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllNutritionistMembersQuery,
        IAllNutritionistMembersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllNutritionistMembersQuery,
    IAllNutritionistMembersQueryVariables
  >(AllNutritionistMembersDocument, options)
}
export type AllNutritionistMembersQueryHookResult = ReturnType<
  typeof useAllNutritionistMembersQuery
>
export type AllNutritionistMembersLazyQueryHookResult = ReturnType<
  typeof useAllNutritionistMembersLazyQuery
>
export type AllNutritionistMembersSuspenseQueryHookResult = ReturnType<
  typeof useAllNutritionistMembersSuspenseQuery
>
export type AllNutritionistMembersQueryResult = Apollo.QueryResult<
  IAllNutritionistMembersQuery,
  IAllNutritionistMembersQueryVariables
>
export const AllOrdersDocument = gql`
  query allOrders(
    $page: Int
    $perPage: Int
    $sorts: [OrderSort!]
    $dynamicFilters: [OrderDynamicFilterItem!]
  ) {
    allOrders(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      orders {
        ...CoreOrderFields
        user {
          id
          email
          firstName
          lastName
          phoneNumber
          dateOfBirth
          sex
        }
        address {
          ...CoreAddressFields
        }
      }
      totalRecords
    }
  }
  ${CoreOrderFieldsFragmentDoc}
  ${CoreAddressFieldsFragmentDoc}
`

/**
 * __useAllOrdersQuery__
 *
 * To run a query within a React component, call `useAllOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrdersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllOrdersQuery, IAllOrdersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllOrdersQuery, IAllOrdersQueryVariables>(AllOrdersDocument, options)
}
export function useAllOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllOrdersQuery, IAllOrdersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllOrdersQuery, IAllOrdersQueryVariables>(AllOrdersDocument, options)
}
// @ts-ignore
export function useAllOrdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllOrdersQuery, IAllOrdersQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllOrdersQuery, IAllOrdersQueryVariables>
export function useAllOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllOrdersQuery, IAllOrdersQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllOrdersQuery | undefined, IAllOrdersQueryVariables>
export function useAllOrdersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllOrdersQuery, IAllOrdersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllOrdersQuery, IAllOrdersQueryVariables>(
    AllOrdersDocument,
    options
  )
}
export type AllOrdersQueryHookResult = ReturnType<typeof useAllOrdersQuery>
export type AllOrdersLazyQueryHookResult = ReturnType<typeof useAllOrdersLazyQuery>
export type AllOrdersSuspenseQueryHookResult = ReturnType<typeof useAllOrdersSuspenseQuery>
export type AllOrdersQueryResult = Apollo.QueryResult<IAllOrdersQuery, IAllOrdersQueryVariables>
export const AllOrganizationsDocument = gql`
  query allOrganizations($name: String) {
    allOrganizations(name: $name) {
      organizations {
        id
        name
        isNutrisense
      }
    }
  }
`

/**
 * __useAllOrganizationsQuery__
 *
 * To run a query within a React component, call `useAllOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllOrganizationsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAllOrganizationsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllOrganizationsQuery, IAllOrganizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllOrganizationsQuery, IAllOrganizationsQueryVariables>(
    AllOrganizationsDocument,
    options
  )
}
export function useAllOrganizationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllOrganizationsQuery, IAllOrganizationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllOrganizationsQuery, IAllOrganizationsQueryVariables>(
    AllOrganizationsDocument,
    options
  )
}
// @ts-ignore
export function useAllOrganizationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllOrganizationsQuery,
    IAllOrganizationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllOrganizationsQuery, IAllOrganizationsQueryVariables>
export function useAllOrganizationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllOrganizationsQuery, IAllOrganizationsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAllOrganizationsQuery | undefined,
  IAllOrganizationsQueryVariables
>
export function useAllOrganizationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllOrganizationsQuery, IAllOrganizationsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllOrganizationsQuery, IAllOrganizationsQueryVariables>(
    AllOrganizationsDocument,
    options
  )
}
export type AllOrganizationsQueryHookResult = ReturnType<typeof useAllOrganizationsQuery>
export type AllOrganizationsLazyQueryHookResult = ReturnType<typeof useAllOrganizationsLazyQuery>
export type AllOrganizationsSuspenseQueryHookResult = ReturnType<
  typeof useAllOrganizationsSuspenseQuery
>
export type AllOrganizationsQueryResult = Apollo.QueryResult<
  IAllOrganizationsQuery,
  IAllOrganizationsQueryVariables
>
export const AllReplacementReasonsConfigDocument = gql`
  query AllReplacementReasonsConfig {
    allReplacementReasonsConfig {
      replacementReasons {
        key
        label
        description
      }
    }
  }
`

/**
 * __useAllReplacementReasonsConfigQuery__
 *
 * To run a query within a React component, call `useAllReplacementReasonsConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReplacementReasonsConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReplacementReasonsConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllReplacementReasonsConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllReplacementReasonsConfigQuery,
    IAllReplacementReasonsConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IAllReplacementReasonsConfigQuery,
    IAllReplacementReasonsConfigQueryVariables
  >(AllReplacementReasonsConfigDocument, options)
}
export function useAllReplacementReasonsConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllReplacementReasonsConfigQuery,
    IAllReplacementReasonsConfigQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAllReplacementReasonsConfigQuery,
    IAllReplacementReasonsConfigQueryVariables
  >(AllReplacementReasonsConfigDocument, options)
}
// @ts-ignore
export function useAllReplacementReasonsConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllReplacementReasonsConfigQuery,
    IAllReplacementReasonsConfigQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllReplacementReasonsConfigQuery,
  IAllReplacementReasonsConfigQueryVariables
>
export function useAllReplacementReasonsConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllReplacementReasonsConfigQuery,
        IAllReplacementReasonsConfigQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllReplacementReasonsConfigQuery | undefined,
  IAllReplacementReasonsConfigQueryVariables
>
export function useAllReplacementReasonsConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllReplacementReasonsConfigQuery,
        IAllReplacementReasonsConfigQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllReplacementReasonsConfigQuery,
    IAllReplacementReasonsConfigQueryVariables
  >(AllReplacementReasonsConfigDocument, options)
}
export type AllReplacementReasonsConfigQueryHookResult = ReturnType<
  typeof useAllReplacementReasonsConfigQuery
>
export type AllReplacementReasonsConfigLazyQueryHookResult = ReturnType<
  typeof useAllReplacementReasonsConfigLazyQuery
>
export type AllReplacementReasonsConfigSuspenseQueryHookResult = ReturnType<
  typeof useAllReplacementReasonsConfigSuspenseQuery
>
export type AllReplacementReasonsConfigQueryResult = Apollo.QueryResult<
  IAllReplacementReasonsConfigQuery,
  IAllReplacementReasonsConfigQueryVariables
>
export const AllReplacementRequestsDocument = gql`
  query allReplacementRequests(
    $page: Int!
    $perPage: Int!
    $sorts: [ReplacementRequestSort!]
    $dynamicFilters: [ReplacementRequestDynamicFilterItem!]
  ) {
    allReplacementRequests(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      replacementRequests {
        ...CoreReplacementRequestFields
      }
      totalCount
    }
  }
  ${CoreReplacementRequestFieldsFragmentDoc}
`

/**
 * __useAllReplacementRequestsQuery__
 *
 * To run a query within a React component, call `useAllReplacementRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReplacementRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReplacementRequestsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllReplacementRequestsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IAllReplacementRequestsQuery,
    IAllReplacementRequestsQueryVariables
  > &
    ({ variables: IAllReplacementRequestsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllReplacementRequestsQuery, IAllReplacementRequestsQueryVariables>(
    AllReplacementRequestsDocument,
    options
  )
}
export function useAllReplacementRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllReplacementRequestsQuery,
    IAllReplacementRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllReplacementRequestsQuery, IAllReplacementRequestsQueryVariables>(
    AllReplacementRequestsDocument,
    options
  )
}
// @ts-ignore
export function useAllReplacementRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllReplacementRequestsQuery,
    IAllReplacementRequestsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllReplacementRequestsQuery,
  IAllReplacementRequestsQueryVariables
>
export function useAllReplacementRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllReplacementRequestsQuery,
        IAllReplacementRequestsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllReplacementRequestsQuery | undefined,
  IAllReplacementRequestsQueryVariables
>
export function useAllReplacementRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllReplacementRequestsQuery,
        IAllReplacementRequestsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllReplacementRequestsQuery,
    IAllReplacementRequestsQueryVariables
  >(AllReplacementRequestsDocument, options)
}
export type AllReplacementRequestsQueryHookResult = ReturnType<
  typeof useAllReplacementRequestsQuery
>
export type AllReplacementRequestsLazyQueryHookResult = ReturnType<
  typeof useAllReplacementRequestsLazyQuery
>
export type AllReplacementRequestsSuspenseQueryHookResult = ReturnType<
  typeof useAllReplacementRequestsSuspenseQuery
>
export type AllReplacementRequestsQueryResult = Apollo.QueryResult<
  IAllReplacementRequestsQuery,
  IAllReplacementRequestsQueryVariables
>
export const AllSensorsDocument = gql`
  query allSensors {
    allSensors {
      sensors {
        activationDate
        baselineAdjustment
        daysRemaining
        expirationDate
        expirationTime
        expired
        id
        model
        serialNumber
        status
        lastStatusChange {
          status
          createdAt
          failure
        }
      }
    }
  }
`

/**
 * __useAllSensorsQuery__
 *
 * To run a query within a React component, call `useAllSensorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSensorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSensorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSensorsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllSensorsQuery, IAllSensorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllSensorsQuery, IAllSensorsQueryVariables>(AllSensorsDocument, options)
}
export function useAllSensorsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllSensorsQuery, IAllSensorsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllSensorsQuery, IAllSensorsQueryVariables>(
    AllSensorsDocument,
    options
  )
}
// @ts-ignore
export function useAllSensorsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllSensorsQuery, IAllSensorsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllSensorsQuery, IAllSensorsQueryVariables>
export function useAllSensorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllSensorsQuery, IAllSensorsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllSensorsQuery | undefined, IAllSensorsQueryVariables>
export function useAllSensorsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllSensorsQuery, IAllSensorsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllSensorsQuery, IAllSensorsQueryVariables>(
    AllSensorsDocument,
    options
  )
}
export type AllSensorsQueryHookResult = ReturnType<typeof useAllSensorsQuery>
export type AllSensorsLazyQueryHookResult = ReturnType<typeof useAllSensorsLazyQuery>
export type AllSensorsSuspenseQueryHookResult = ReturnType<typeof useAllSensorsSuspenseQuery>
export type AllSensorsQueryResult = Apollo.QueryResult<IAllSensorsQuery, IAllSensorsQueryVariables>
export const AllShipmentsDocument = gql`
  query allShipments(
    $page: Int!
    $perPage: Int!
    $sorts: [ShipmentSort!]
    $dynamicFilters: [ShipmentDynamicFilterItem!]
  ) {
    allShipments(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      shipments {
        ...CoreShipmentFields
        eta
        location
        order {
          id
          invoice {
            stripeId
          }
          createdAt
          product
          productType
          sensorKind
          quantity
          replacementRequest {
            rgaRequired
            providerCompensation
          }
        }
        address {
          ...CoreAddressFields
        }
        user {
          id
          email
          firstName
          lastName
          phoneNumber
          dateOfBirth
          sex
          truepillPatientToken
        }
      }
      totalRecords
    }
  }
  ${CoreShipmentFieldsFragmentDoc}
  ${CoreAddressFieldsFragmentDoc}
`

/**
 * __useAllShipmentsQuery__
 *
 * To run a query within a React component, call `useAllShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllShipmentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllShipmentsQuery(
  baseOptions: Apollo.QueryHookOptions<IAllShipmentsQuery, IAllShipmentsQueryVariables> &
    ({ variables: IAllShipmentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllShipmentsQuery, IAllShipmentsQueryVariables>(
    AllShipmentsDocument,
    options
  )
}
export function useAllShipmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllShipmentsQuery, IAllShipmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllShipmentsQuery, IAllShipmentsQueryVariables>(
    AllShipmentsDocument,
    options
  )
}
// @ts-ignore
export function useAllShipmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllShipmentsQuery, IAllShipmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllShipmentsQuery, IAllShipmentsQueryVariables>
export function useAllShipmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllShipmentsQuery, IAllShipmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllShipmentsQuery | undefined, IAllShipmentsQueryVariables>
export function useAllShipmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllShipmentsQuery, IAllShipmentsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllShipmentsQuery, IAllShipmentsQueryVariables>(
    AllShipmentsDocument,
    options
  )
}
export type AllShipmentsQueryHookResult = ReturnType<typeof useAllShipmentsQuery>
export type AllShipmentsLazyQueryHookResult = ReturnType<typeof useAllShipmentsLazyQuery>
export type AllShipmentsSuspenseQueryHookResult = ReturnType<typeof useAllShipmentsSuspenseQuery>
export type AllShipmentsQueryResult = Apollo.QueryResult<
  IAllShipmentsQuery,
  IAllShipmentsQueryVariables
>
export const AllStatsDocument = gql`
  query allStats($filter: DateFilter) {
    allStats(filter: $filter) {
      statistics {
        type
        title
        description
        value
        displayValue
        valuePrev
        change
        range {
          min
          max
          warning
          danger
          reverse
        }
        meta {
          key
          section
        }
      }
    }
  }
`

/**
 * __useAllStatsQuery__
 *
 * To run a query within a React component, call `useAllStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAllStatsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllStatsQuery, IAllStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllStatsQuery, IAllStatsQueryVariables>(AllStatsDocument, options)
}
export function useAllStatsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllStatsQuery, IAllStatsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllStatsQuery, IAllStatsQueryVariables>(AllStatsDocument, options)
}
// @ts-ignore
export function useAllStatsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllStatsQuery, IAllStatsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllStatsQuery, IAllStatsQueryVariables>
export function useAllStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllStatsQuery, IAllStatsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllStatsQuery | undefined, IAllStatsQueryVariables>
export function useAllStatsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllStatsQuery, IAllStatsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllStatsQuery, IAllStatsQueryVariables>(AllStatsDocument, options)
}
export type AllStatsQueryHookResult = ReturnType<typeof useAllStatsQuery>
export type AllStatsLazyQueryHookResult = ReturnType<typeof useAllStatsLazyQuery>
export type AllStatsSuspenseQueryHookResult = ReturnType<typeof useAllStatsSuspenseQuery>
export type AllStatsQueryResult = Apollo.QueryResult<IAllStatsQuery, IAllStatsQueryVariables>
export const AllSurveyLinksDocument = gql`
  query allSurveyLinks(
    $page: Int
    $perPage: Int
    $sorts: [SurveyLinkSort!]
    $dynamicFilters: [SurveyLinkDynamicFilterItem!]
  ) {
    allSurveyLinks(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      totalCount
      pageCount
      surveyLinks {
        id
        state
        finished
        startedAt
        finishedAt
        survey {
          kind
          version
        }
        user {
          id
          fullName
          email
        }
      }
    }
  }
`

/**
 * __useAllSurveyLinksQuery__
 *
 * To run a query within a React component, call `useAllSurveyLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSurveyLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSurveyLinksQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllSurveyLinksQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllSurveyLinksQuery, IAllSurveyLinksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllSurveyLinksQuery, IAllSurveyLinksQueryVariables>(
    AllSurveyLinksDocument,
    options
  )
}
export function useAllSurveyLinksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllSurveyLinksQuery, IAllSurveyLinksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllSurveyLinksQuery, IAllSurveyLinksQueryVariables>(
    AllSurveyLinksDocument,
    options
  )
}
// @ts-ignore
export function useAllSurveyLinksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllSurveyLinksQuery, IAllSurveyLinksQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllSurveyLinksQuery, IAllSurveyLinksQueryVariables>
export function useAllSurveyLinksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllSurveyLinksQuery, IAllSurveyLinksQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllSurveyLinksQuery | undefined, IAllSurveyLinksQueryVariables>
export function useAllSurveyLinksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllSurveyLinksQuery, IAllSurveyLinksQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllSurveyLinksQuery, IAllSurveyLinksQueryVariables>(
    AllSurveyLinksDocument,
    options
  )
}
export type AllSurveyLinksQueryHookResult = ReturnType<typeof useAllSurveyLinksQuery>
export type AllSurveyLinksLazyQueryHookResult = ReturnType<typeof useAllSurveyLinksLazyQuery>
export type AllSurveyLinksSuspenseQueryHookResult = ReturnType<
  typeof useAllSurveyLinksSuspenseQuery
>
export type AllSurveyLinksQueryResult = Apollo.QueryResult<
  IAllSurveyLinksQuery,
  IAllSurveyLinksQueryVariables
>
export const AllUserPropertiesDocument = gql`
  query allUserProperties {
    allUserProperties {
      userProperties {
        id
        kind
        value
        userId
      }
    }
  }
`

/**
 * __useAllUserPropertiesQuery__
 *
 * To run a query within a React component, call `useAllUserPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUserPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUserPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUserPropertiesQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllUserPropertiesQuery, IAllUserPropertiesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllUserPropertiesQuery, IAllUserPropertiesQueryVariables>(
    AllUserPropertiesDocument,
    options
  )
}
export function useAllUserPropertiesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllUserPropertiesQuery,
    IAllUserPropertiesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllUserPropertiesQuery, IAllUserPropertiesQueryVariables>(
    AllUserPropertiesDocument,
    options
  )
}
// @ts-ignore
export function useAllUserPropertiesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllUserPropertiesQuery,
    IAllUserPropertiesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllUserPropertiesQuery, IAllUserPropertiesQueryVariables>
export function useAllUserPropertiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllUserPropertiesQuery, IAllUserPropertiesQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAllUserPropertiesQuery | undefined,
  IAllUserPropertiesQueryVariables
>
export function useAllUserPropertiesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllUserPropertiesQuery, IAllUserPropertiesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllUserPropertiesQuery, IAllUserPropertiesQueryVariables>(
    AllUserPropertiesDocument,
    options
  )
}
export type AllUserPropertiesQueryHookResult = ReturnType<typeof useAllUserPropertiesQuery>
export type AllUserPropertiesLazyQueryHookResult = ReturnType<typeof useAllUserPropertiesLazyQuery>
export type AllUserPropertiesSuspenseQueryHookResult = ReturnType<
  typeof useAllUserPropertiesSuspenseQuery
>
export type AllUserPropertiesQueryResult = Apollo.QueryResult<
  IAllUserPropertiesQuery,
  IAllUserPropertiesQueryVariables
>
export const AllUsersAutocompleteDocument = gql`
  query allUsersAutocomplete($query: String!) {
    allUsersAutocomplete(query: $query) {
      users {
        email
        fullName
        id
        timeZone
        phoneNumber
      }
    }
  }
`

/**
 * __useAllUsersAutocompleteQuery__
 *
 * To run a query within a React component, call `useAllUsersAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAllUsersAutocompleteQuery(
  baseOptions: Apollo.QueryHookOptions<
    IAllUsersAutocompleteQuery,
    IAllUsersAutocompleteQueryVariables
  > &
    ({ variables: IAllUsersAutocompleteQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllUsersAutocompleteQuery, IAllUsersAutocompleteQueryVariables>(
    AllUsersAutocompleteDocument,
    options
  )
}
export function useAllUsersAutocompleteLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllUsersAutocompleteQuery,
    IAllUsersAutocompleteQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllUsersAutocompleteQuery, IAllUsersAutocompleteQueryVariables>(
    AllUsersAutocompleteDocument,
    options
  )
}
// @ts-ignore
export function useAllUsersAutocompleteSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllUsersAutocompleteQuery,
    IAllUsersAutocompleteQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllUsersAutocompleteQuery, IAllUsersAutocompleteQueryVariables>
export function useAllUsersAutocompleteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllUsersAutocompleteQuery,
        IAllUsersAutocompleteQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllUsersAutocompleteQuery | undefined,
  IAllUsersAutocompleteQueryVariables
>
export function useAllUsersAutocompleteSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllUsersAutocompleteQuery,
        IAllUsersAutocompleteQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllUsersAutocompleteQuery, IAllUsersAutocompleteQueryVariables>(
    AllUsersAutocompleteDocument,
    options
  )
}
export type AllUsersAutocompleteQueryHookResult = ReturnType<typeof useAllUsersAutocompleteQuery>
export type AllUsersAutocompleteLazyQueryHookResult = ReturnType<
  typeof useAllUsersAutocompleteLazyQuery
>
export type AllUsersAutocompleteSuspenseQueryHookResult = ReturnType<
  typeof useAllUsersAutocompleteSuspenseQuery
>
export type AllUsersAutocompleteQueryResult = Apollo.QueryResult<
  IAllUsersAutocompleteQuery,
  IAllUsersAutocompleteQueryVariables
>
export const EhrAppointmentsDocument = gql`
  query ehrAppointments(
    $page: Int
    $perPage: Int
    $sorts: [EhrAppointmentSort!]
    $dynamicFilters: [EhrAppointmentDynamicFilterItem!]
    $filterKind: FilterAppointmentsKind
    $category: EhrAppointmentCategory!
    $userId: ID
    $coachUserId: ID
  ) {
    ehrAppointments(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
      filterKind: $filterKind
      category: $category
      userId: $userId
      coachUserId: $coachUserId
    ) {
      totalCount
      appointments {
        ...AppointmentFields
        attendances {
          ...AppointmentAttendanceFields
        }
      }
    }
  }
  ${AppointmentFieldsFragmentDoc}
  ${AppointmentAttendanceFieldsFragmentDoc}
`

/**
 * __useEhrAppointmentsQuery__
 *
 * To run a query within a React component, call `useEhrAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEhrAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEhrAppointmentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *      filterKind: // value for 'filterKind'
 *      category: // value for 'category'
 *      userId: // value for 'userId'
 *      coachUserId: // value for 'coachUserId'
 *   },
 * });
 */
export function useEhrAppointmentsQuery(
  baseOptions: Apollo.QueryHookOptions<IEhrAppointmentsQuery, IEhrAppointmentsQueryVariables> &
    ({ variables: IEhrAppointmentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEhrAppointmentsQuery, IEhrAppointmentsQueryVariables>(
    EhrAppointmentsDocument,
    options
  )
}
export function useEhrAppointmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IEhrAppointmentsQuery, IEhrAppointmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IEhrAppointmentsQuery, IEhrAppointmentsQueryVariables>(
    EhrAppointmentsDocument,
    options
  )
}
// @ts-ignore
export function useEhrAppointmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IEhrAppointmentsQuery,
    IEhrAppointmentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IEhrAppointmentsQuery, IEhrAppointmentsQueryVariables>
export function useEhrAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IEhrAppointmentsQuery, IEhrAppointmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<IEhrAppointmentsQuery | undefined, IEhrAppointmentsQueryVariables>
export function useEhrAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IEhrAppointmentsQuery, IEhrAppointmentsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IEhrAppointmentsQuery, IEhrAppointmentsQueryVariables>(
    EhrAppointmentsDocument,
    options
  )
}
export type EhrAppointmentsQueryHookResult = ReturnType<typeof useEhrAppointmentsQuery>
export type EhrAppointmentsLazyQueryHookResult = ReturnType<typeof useEhrAppointmentsLazyQuery>
export type EhrAppointmentsSuspenseQueryHookResult = ReturnType<
  typeof useEhrAppointmentsSuspenseQuery
>
export type EhrAppointmentsQueryResult = Apollo.QueryResult<
  IEhrAppointmentsQuery,
  IEhrAppointmentsQueryVariables
>
export const EhrAppointmentDocument = gql`
  query ehrAppointment($id: ID!) {
    ehrAppointment(id: $id) {
      ...AppointmentFields
      createdAt
      coachingKind
      recurring
      coachRating
      providers {
        id
        kind
        state
        coach {
          id
          coachId
          fullName
        }
        doctor {
          id
          firstName
          lastName
        }
      }
      states {
        id
        kind
        reason
        createdAt
        changedByGetHealthieId
        changedByHealthieUser {
          id
          fullName
        }
      }
      attendances {
        ...AppointmentAttendanceFields
        invoice {
          id
          stripeId
          status
          total
          paidAt
        }
        paidFeeInvoice {
          id
          stripeId
          status
          total
          paidAt
        }
        paymentIntent {
          id
          stripeId
          status
          captureMethod
          reason
          amount
          createdAt
          cancelledAt
        }
      }
    }
  }
  ${AppointmentFieldsFragmentDoc}
  ${AppointmentAttendanceFieldsFragmentDoc}
`

/**
 * __useEhrAppointmentQuery__
 *
 * To run a query within a React component, call `useEhrAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEhrAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEhrAppointmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEhrAppointmentQuery(
  baseOptions: Apollo.QueryHookOptions<IEhrAppointmentQuery, IEhrAppointmentQueryVariables> &
    ({ variables: IEhrAppointmentQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEhrAppointmentQuery, IEhrAppointmentQueryVariables>(
    EhrAppointmentDocument,
    options
  )
}
export function useEhrAppointmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IEhrAppointmentQuery, IEhrAppointmentQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IEhrAppointmentQuery, IEhrAppointmentQueryVariables>(
    EhrAppointmentDocument,
    options
  )
}
// @ts-ignore
export function useEhrAppointmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IEhrAppointmentQuery, IEhrAppointmentQueryVariables>
): Apollo.UseSuspenseQueryResult<IEhrAppointmentQuery, IEhrAppointmentQueryVariables>
export function useEhrAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IEhrAppointmentQuery, IEhrAppointmentQueryVariables>
): Apollo.UseSuspenseQueryResult<IEhrAppointmentQuery | undefined, IEhrAppointmentQueryVariables>
export function useEhrAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IEhrAppointmentQuery, IEhrAppointmentQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IEhrAppointmentQuery, IEhrAppointmentQueryVariables>(
    EhrAppointmentDocument,
    options
  )
}
export type EhrAppointmentQueryHookResult = ReturnType<typeof useEhrAppointmentQuery>
export type EhrAppointmentLazyQueryHookResult = ReturnType<typeof useEhrAppointmentLazyQuery>
export type EhrAppointmentSuspenseQueryHookResult = ReturnType<
  typeof useEhrAppointmentSuspenseQuery
>
export type EhrAppointmentQueryResult = Apollo.QueryResult<
  IEhrAppointmentQuery,
  IEhrAppointmentQueryVariables
>
export const EhrAppointmentRecurrenceDocument = gql`
  query ehrAppointmentRecurrence {
    ehrAppointmentRecurrence {
      id
      appointmentKind
      cadence
      days
      numberOfCalls
      timeSlots
    }
  }
`

/**
 * __useEhrAppointmentRecurrenceQuery__
 *
 * To run a query within a React component, call `useEhrAppointmentRecurrenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEhrAppointmentRecurrenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEhrAppointmentRecurrenceQuery({
 *   variables: {
 *   },
 * });
 */
export function useEhrAppointmentRecurrenceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IEhrAppointmentRecurrenceQuery,
    IEhrAppointmentRecurrenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEhrAppointmentRecurrenceQuery, IEhrAppointmentRecurrenceQueryVariables>(
    EhrAppointmentRecurrenceDocument,
    options
  )
}
export function useEhrAppointmentRecurrenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IEhrAppointmentRecurrenceQuery,
    IEhrAppointmentRecurrenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IEhrAppointmentRecurrenceQuery,
    IEhrAppointmentRecurrenceQueryVariables
  >(EhrAppointmentRecurrenceDocument, options)
}
// @ts-ignore
export function useEhrAppointmentRecurrenceSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IEhrAppointmentRecurrenceQuery,
    IEhrAppointmentRecurrenceQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IEhrAppointmentRecurrenceQuery,
  IEhrAppointmentRecurrenceQueryVariables
>
export function useEhrAppointmentRecurrenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IEhrAppointmentRecurrenceQuery,
        IEhrAppointmentRecurrenceQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IEhrAppointmentRecurrenceQuery | undefined,
  IEhrAppointmentRecurrenceQueryVariables
>
export function useEhrAppointmentRecurrenceSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IEhrAppointmentRecurrenceQuery,
        IEhrAppointmentRecurrenceQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IEhrAppointmentRecurrenceQuery,
    IEhrAppointmentRecurrenceQueryVariables
  >(EhrAppointmentRecurrenceDocument, options)
}
export type EhrAppointmentRecurrenceQueryHookResult = ReturnType<
  typeof useEhrAppointmentRecurrenceQuery
>
export type EhrAppointmentRecurrenceLazyQueryHookResult = ReturnType<
  typeof useEhrAppointmentRecurrenceLazyQuery
>
export type EhrAppointmentRecurrenceSuspenseQueryHookResult = ReturnType<
  typeof useEhrAppointmentRecurrenceSuspenseQuery
>
export type EhrAppointmentRecurrenceQueryResult = Apollo.QueryResult<
  IEhrAppointmentRecurrenceQuery,
  IEhrAppointmentRecurrenceQueryVariables
>
export const EhrAppointmentRecurrencesDocument = gql`
  query ehrAppointmentRecurrences {
    ehrAppointmentRecurrences {
      id
      appointmentKind
      cadence
      days
      numberOfCalls
      timeSlots
    }
  }
`

/**
 * __useEhrAppointmentRecurrencesQuery__
 *
 * To run a query within a React component, call `useEhrAppointmentRecurrencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEhrAppointmentRecurrencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEhrAppointmentRecurrencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEhrAppointmentRecurrencesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IEhrAppointmentRecurrencesQuery,
    IEhrAppointmentRecurrencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEhrAppointmentRecurrencesQuery, IEhrAppointmentRecurrencesQueryVariables>(
    EhrAppointmentRecurrencesDocument,
    options
  )
}
export function useEhrAppointmentRecurrencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IEhrAppointmentRecurrencesQuery,
    IEhrAppointmentRecurrencesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IEhrAppointmentRecurrencesQuery,
    IEhrAppointmentRecurrencesQueryVariables
  >(EhrAppointmentRecurrencesDocument, options)
}
// @ts-ignore
export function useEhrAppointmentRecurrencesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IEhrAppointmentRecurrencesQuery,
    IEhrAppointmentRecurrencesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IEhrAppointmentRecurrencesQuery,
  IEhrAppointmentRecurrencesQueryVariables
>
export function useEhrAppointmentRecurrencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IEhrAppointmentRecurrencesQuery,
        IEhrAppointmentRecurrencesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IEhrAppointmentRecurrencesQuery | undefined,
  IEhrAppointmentRecurrencesQueryVariables
>
export function useEhrAppointmentRecurrencesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IEhrAppointmentRecurrencesQuery,
        IEhrAppointmentRecurrencesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IEhrAppointmentRecurrencesQuery,
    IEhrAppointmentRecurrencesQueryVariables
  >(EhrAppointmentRecurrencesDocument, options)
}
export type EhrAppointmentRecurrencesQueryHookResult = ReturnType<
  typeof useEhrAppointmentRecurrencesQuery
>
export type EhrAppointmentRecurrencesLazyQueryHookResult = ReturnType<
  typeof useEhrAppointmentRecurrencesLazyQuery
>
export type EhrAppointmentRecurrencesSuspenseQueryHookResult = ReturnType<
  typeof useEhrAppointmentRecurrencesSuspenseQuery
>
export type EhrAppointmentRecurrencesQueryResult = Apollo.QueryResult<
  IEhrAppointmentRecurrencesQuery,
  IEhrAppointmentRecurrencesQueryVariables
>
export const NextCoachAppointmentDocument = gql`
  query nextCoachAppointment {
    nextCoachAppointment {
      id
      meetingAt
    }
  }
`

/**
 * __useNextCoachAppointmentQuery__
 *
 * To run a query within a React component, call `useNextCoachAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextCoachAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextCoachAppointmentQuery({
 *   variables: {
 *   },
 * });
 */
export function useNextCoachAppointmentQuery(
  baseOptions?: Apollo.QueryHookOptions<
    INextCoachAppointmentQuery,
    INextCoachAppointmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<INextCoachAppointmentQuery, INextCoachAppointmentQueryVariables>(
    NextCoachAppointmentDocument,
    options
  )
}
export function useNextCoachAppointmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    INextCoachAppointmentQuery,
    INextCoachAppointmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<INextCoachAppointmentQuery, INextCoachAppointmentQueryVariables>(
    NextCoachAppointmentDocument,
    options
  )
}
// @ts-ignore
export function useNextCoachAppointmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    INextCoachAppointmentQuery,
    INextCoachAppointmentQueryVariables
  >
): Apollo.UseSuspenseQueryResult<INextCoachAppointmentQuery, INextCoachAppointmentQueryVariables>
export function useNextCoachAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        INextCoachAppointmentQuery,
        INextCoachAppointmentQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  INextCoachAppointmentQuery | undefined,
  INextCoachAppointmentQueryVariables
>
export function useNextCoachAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        INextCoachAppointmentQuery,
        INextCoachAppointmentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<INextCoachAppointmentQuery, INextCoachAppointmentQueryVariables>(
    NextCoachAppointmentDocument,
    options
  )
}
export type NextCoachAppointmentQueryHookResult = ReturnType<typeof useNextCoachAppointmentQuery>
export type NextCoachAppointmentLazyQueryHookResult = ReturnType<
  typeof useNextCoachAppointmentLazyQuery
>
export type NextCoachAppointmentSuspenseQueryHookResult = ReturnType<
  typeof useNextCoachAppointmentSuspenseQuery
>
export type NextCoachAppointmentQueryResult = Apollo.QueryResult<
  INextCoachAppointmentQuery,
  INextCoachAppointmentQueryVariables
>
export const NextUserEhrAppointmentDocument = gql`
  query nextUserEhrAppointment($userId: ID!) {
    nextUserEhrAppointment(userId: $userId) {
      id
      meetingAt
    }
  }
`

/**
 * __useNextUserEhrAppointmentQuery__
 *
 * To run a query within a React component, call `useNextUserEhrAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextUserEhrAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextUserEhrAppointmentQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useNextUserEhrAppointmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    INextUserEhrAppointmentQuery,
    INextUserEhrAppointmentQueryVariables
  > &
    ({ variables: INextUserEhrAppointmentQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<INextUserEhrAppointmentQuery, INextUserEhrAppointmentQueryVariables>(
    NextUserEhrAppointmentDocument,
    options
  )
}
export function useNextUserEhrAppointmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    INextUserEhrAppointmentQuery,
    INextUserEhrAppointmentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<INextUserEhrAppointmentQuery, INextUserEhrAppointmentQueryVariables>(
    NextUserEhrAppointmentDocument,
    options
  )
}
// @ts-ignore
export function useNextUserEhrAppointmentSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    INextUserEhrAppointmentQuery,
    INextUserEhrAppointmentQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  INextUserEhrAppointmentQuery,
  INextUserEhrAppointmentQueryVariables
>
export function useNextUserEhrAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        INextUserEhrAppointmentQuery,
        INextUserEhrAppointmentQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  INextUserEhrAppointmentQuery | undefined,
  INextUserEhrAppointmentQueryVariables
>
export function useNextUserEhrAppointmentSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        INextUserEhrAppointmentQuery,
        INextUserEhrAppointmentQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    INextUserEhrAppointmentQuery,
    INextUserEhrAppointmentQueryVariables
  >(NextUserEhrAppointmentDocument, options)
}
export type NextUserEhrAppointmentQueryHookResult = ReturnType<
  typeof useNextUserEhrAppointmentQuery
>
export type NextUserEhrAppointmentLazyQueryHookResult = ReturnType<
  typeof useNextUserEhrAppointmentLazyQuery
>
export type NextUserEhrAppointmentSuspenseQueryHookResult = ReturnType<
  typeof useNextUserEhrAppointmentSuspenseQuery
>
export type NextUserEhrAppointmentQueryResult = Apollo.QueryResult<
  INextUserEhrAppointmentQuery,
  INextUserEhrAppointmentQueryVariables
>
export const UserAppointmentsDocument = gql`
  query userAppointments(
    $page: Int
    $perPage: Int
    $sorts: [EhrAppointmentSort!]
    $dynamicFilters: [EhrAppointmentDynamicFilterItem!]
    $active: Boolean
    $filterKind: FilterAppointmentsKind
    $category: EhrAppointmentCategory!
    $userId: ID
    $coachUserId: ID
  ) {
    userAppointments: ehrAppointments(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
      active: $active
      filterKind: $filterKind
      category: $category
      userId: $userId
      coachUserId: $coachUserId
    ) {
      totalCount
      appointments {
        id
        getHealthieId
        category
        kind
        coachingKind
        recurring
        meetingAt
        title
        getHealthieInstanceKind
        startUrl
        joinUrl
        actualDuration
        addToGcalLink
        unauthenticatedIcsLink
        lastState {
          id
          reason
          kind
          createdAt
        }
        attendances {
          id
          chargeKind
          insurancePolicy {
            lastState {
              id
              kind
            }
          }
        }
        providers {
          id
          state
          coach {
            id
            coachId
            fullName
          }
        }
      }
    }
  }
`

/**
 * __useUserAppointmentsQuery__
 *
 * To run a query within a React component, call `useUserAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAppointmentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *      active: // value for 'active'
 *      filterKind: // value for 'filterKind'
 *      category: // value for 'category'
 *      userId: // value for 'userId'
 *      coachUserId: // value for 'coachUserId'
 *   },
 * });
 */
export function useUserAppointmentsQuery(
  baseOptions: Apollo.QueryHookOptions<IUserAppointmentsQuery, IUserAppointmentsQueryVariables> &
    ({ variables: IUserAppointmentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IUserAppointmentsQuery, IUserAppointmentsQueryVariables>(
    UserAppointmentsDocument,
    options
  )
}
export function useUserAppointmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IUserAppointmentsQuery, IUserAppointmentsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IUserAppointmentsQuery, IUserAppointmentsQueryVariables>(
    UserAppointmentsDocument,
    options
  )
}
// @ts-ignore
export function useUserAppointmentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IUserAppointmentsQuery,
    IUserAppointmentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IUserAppointmentsQuery, IUserAppointmentsQueryVariables>
export function useUserAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IUserAppointmentsQuery, IUserAppointmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IUserAppointmentsQuery | undefined,
  IUserAppointmentsQueryVariables
>
export function useUserAppointmentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IUserAppointmentsQuery, IUserAppointmentsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IUserAppointmentsQuery, IUserAppointmentsQueryVariables>(
    UserAppointmentsDocument,
    options
  )
}
export type UserAppointmentsQueryHookResult = ReturnType<typeof useUserAppointmentsQuery>
export type UserAppointmentsLazyQueryHookResult = ReturnType<typeof useUserAppointmentsLazyQuery>
export type UserAppointmentsSuspenseQueryHookResult = ReturnType<
  typeof useUserAppointmentsSuspenseQuery
>
export type UserAppointmentsQueryResult = Apollo.QueryResult<
  IUserAppointmentsQuery,
  IUserAppointmentsQueryVariables
>
export const AuthorizationPoliciesDocument = gql`
  query authorizationPolicies($userId: ID!) {
    authorizationPolicies(userId: $userId) {
      rolePolicies {
        ...CoreAuthorizationPolicyFields
      }
      additionalPolicies {
        ...CoreUserAuthorizationPolicyFields
      }
    }
  }
  ${CoreAuthorizationPolicyFieldsFragmentDoc}
  ${CoreUserAuthorizationPolicyFieldsFragmentDoc}
`

/**
 * __useAuthorizationPoliciesQuery__
 *
 * To run a query within a React component, call `useAuthorizationPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizationPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizationPoliciesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAuthorizationPoliciesQuery(
  baseOptions: Apollo.QueryHookOptions<
    IAuthorizationPoliciesQuery,
    IAuthorizationPoliciesQueryVariables
  > &
    ({ variables: IAuthorizationPoliciesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAuthorizationPoliciesQuery, IAuthorizationPoliciesQueryVariables>(
    AuthorizationPoliciesDocument,
    options
  )
}
export function useAuthorizationPoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAuthorizationPoliciesQuery,
    IAuthorizationPoliciesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAuthorizationPoliciesQuery, IAuthorizationPoliciesQueryVariables>(
    AuthorizationPoliciesDocument,
    options
  )
}
// @ts-ignore
export function useAuthorizationPoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAuthorizationPoliciesQuery,
    IAuthorizationPoliciesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAuthorizationPoliciesQuery, IAuthorizationPoliciesQueryVariables>
export function useAuthorizationPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAuthorizationPoliciesQuery,
        IAuthorizationPoliciesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAuthorizationPoliciesQuery | undefined,
  IAuthorizationPoliciesQueryVariables
>
export function useAuthorizationPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAuthorizationPoliciesQuery,
        IAuthorizationPoliciesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAuthorizationPoliciesQuery, IAuthorizationPoliciesQueryVariables>(
    AuthorizationPoliciesDocument,
    options
  )
}
export type AuthorizationPoliciesQueryHookResult = ReturnType<typeof useAuthorizationPoliciesQuery>
export type AuthorizationPoliciesLazyQueryHookResult = ReturnType<
  typeof useAuthorizationPoliciesLazyQuery
>
export type AuthorizationPoliciesSuspenseQueryHookResult = ReturnType<
  typeof useAuthorizationPoliciesSuspenseQuery
>
export type AuthorizationPoliciesQueryResult = Apollo.QueryResult<
  IAuthorizationPoliciesQuery,
  IAuthorizationPoliciesQueryVariables
>
export const AuthorizedFeaturesDocument = gql`
  query authorizedFeatures {
    authorizedFeatures {
      features
    }
  }
`

/**
 * __useAuthorizedFeaturesQuery__
 *
 * To run a query within a React component, call `useAuthorizedFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorizedFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorizedFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAuthorizedFeaturesQuery(
  baseOptions?: Apollo.QueryHookOptions<IAuthorizedFeaturesQuery, IAuthorizedFeaturesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAuthorizedFeaturesQuery, IAuthorizedFeaturesQueryVariables>(
    AuthorizedFeaturesDocument,
    options
  )
}
export function useAuthorizedFeaturesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAuthorizedFeaturesQuery,
    IAuthorizedFeaturesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAuthorizedFeaturesQuery, IAuthorizedFeaturesQueryVariables>(
    AuthorizedFeaturesDocument,
    options
  )
}
// @ts-ignore
export function useAuthorizedFeaturesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAuthorizedFeaturesQuery,
    IAuthorizedFeaturesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAuthorizedFeaturesQuery, IAuthorizedFeaturesQueryVariables>
export function useAuthorizedFeaturesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAuthorizedFeaturesQuery, IAuthorizedFeaturesQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAuthorizedFeaturesQuery | undefined,
  IAuthorizedFeaturesQueryVariables
>
export function useAuthorizedFeaturesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAuthorizedFeaturesQuery, IAuthorizedFeaturesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAuthorizedFeaturesQuery, IAuthorizedFeaturesQueryVariables>(
    AuthorizedFeaturesDocument,
    options
  )
}
export type AuthorizedFeaturesQueryHookResult = ReturnType<typeof useAuthorizedFeaturesQuery>
export type AuthorizedFeaturesLazyQueryHookResult = ReturnType<
  typeof useAuthorizedFeaturesLazyQuery
>
export type AuthorizedFeaturesSuspenseQueryHookResult = ReturnType<
  typeof useAuthorizedFeaturesSuspenseQuery
>
export type AuthorizedFeaturesQueryResult = Apollo.QueryResult<
  IAuthorizedFeaturesQuery,
  IAuthorizedFeaturesQueryVariables
>
export const BillingAllowancesDocument = gql`
  query billingAllowances($userId: ID!) {
    billingAllowances(userId: $userId) {
      allowances {
        id
        kind
        total
        remaining
      }
    }
  }
`

/**
 * __useBillingAllowancesQuery__
 *
 * To run a query within a React component, call `useBillingAllowancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingAllowancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingAllowancesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBillingAllowancesQuery(
  baseOptions: Apollo.QueryHookOptions<IBillingAllowancesQuery, IBillingAllowancesQueryVariables> &
    ({ variables: IBillingAllowancesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IBillingAllowancesQuery, IBillingAllowancesQueryVariables>(
    BillingAllowancesDocument,
    options
  )
}
export function useBillingAllowancesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IBillingAllowancesQuery,
    IBillingAllowancesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IBillingAllowancesQuery, IBillingAllowancesQueryVariables>(
    BillingAllowancesDocument,
    options
  )
}
// @ts-ignore
export function useBillingAllowancesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IBillingAllowancesQuery,
    IBillingAllowancesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IBillingAllowancesQuery, IBillingAllowancesQueryVariables>
export function useBillingAllowancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IBillingAllowancesQuery, IBillingAllowancesQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IBillingAllowancesQuery | undefined,
  IBillingAllowancesQueryVariables
>
export function useBillingAllowancesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IBillingAllowancesQuery, IBillingAllowancesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IBillingAllowancesQuery, IBillingAllowancesQueryVariables>(
    BillingAllowancesDocument,
    options
  )
}
export type BillingAllowancesQueryHookResult = ReturnType<typeof useBillingAllowancesQuery>
export type BillingAllowancesLazyQueryHookResult = ReturnType<typeof useBillingAllowancesLazyQuery>
export type BillingAllowancesSuspenseQueryHookResult = ReturnType<
  typeof useBillingAllowancesSuspenseQuery
>
export type BillingAllowancesQueryResult = Apollo.QueryResult<
  IBillingAllowancesQuery,
  IBillingAllowancesQueryVariables
>
export const BillingDashboardAllAccountRequestsDocument = gql`
  query billingDashboardAllAccountRequests(
    $sorts: [AccountRequestSort!]
    $dynamicFilters: [AccountRequestDynamicFilterItem!]
  ) {
    allAccountRequests(sorts: $sorts, dynamicFilters: $dynamicFilters) {
      accountRequests {
        ...CoreAccountRequestFields
      }
    }
  }
  ${CoreAccountRequestFieldsFragmentDoc}
`

/**
 * __useBillingDashboardAllAccountRequestsQuery__
 *
 * To run a query within a React component, call `useBillingDashboardAllAccountRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingDashboardAllAccountRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingDashboardAllAccountRequestsQuery({
 *   variables: {
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useBillingDashboardAllAccountRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IBillingDashboardAllAccountRequestsQuery,
    IBillingDashboardAllAccountRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IBillingDashboardAllAccountRequestsQuery,
    IBillingDashboardAllAccountRequestsQueryVariables
  >(BillingDashboardAllAccountRequestsDocument, options)
}
export function useBillingDashboardAllAccountRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IBillingDashboardAllAccountRequestsQuery,
    IBillingDashboardAllAccountRequestsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IBillingDashboardAllAccountRequestsQuery,
    IBillingDashboardAllAccountRequestsQueryVariables
  >(BillingDashboardAllAccountRequestsDocument, options)
}
// @ts-ignore
export function useBillingDashboardAllAccountRequestsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IBillingDashboardAllAccountRequestsQuery,
    IBillingDashboardAllAccountRequestsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IBillingDashboardAllAccountRequestsQuery,
  IBillingDashboardAllAccountRequestsQueryVariables
>
export function useBillingDashboardAllAccountRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IBillingDashboardAllAccountRequestsQuery,
        IBillingDashboardAllAccountRequestsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IBillingDashboardAllAccountRequestsQuery | undefined,
  IBillingDashboardAllAccountRequestsQueryVariables
>
export function useBillingDashboardAllAccountRequestsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IBillingDashboardAllAccountRequestsQuery,
        IBillingDashboardAllAccountRequestsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IBillingDashboardAllAccountRequestsQuery,
    IBillingDashboardAllAccountRequestsQueryVariables
  >(BillingDashboardAllAccountRequestsDocument, options)
}
export type BillingDashboardAllAccountRequestsQueryHookResult = ReturnType<
  typeof useBillingDashboardAllAccountRequestsQuery
>
export type BillingDashboardAllAccountRequestsLazyQueryHookResult = ReturnType<
  typeof useBillingDashboardAllAccountRequestsLazyQuery
>
export type BillingDashboardAllAccountRequestsSuspenseQueryHookResult = ReturnType<
  typeof useBillingDashboardAllAccountRequestsSuspenseQuery
>
export type BillingDashboardAllAccountRequestsQueryResult = Apollo.QueryResult<
  IBillingDashboardAllAccountRequestsQuery,
  IBillingDashboardAllAccountRequestsQueryVariables
>
export const BillingDashboardAllChargesDocument = gql`
  query billingDashboardAllCharges(
    $page: Int
    $perPage: Int
    $sorts: [ChargeSort!]
    $dynamicFilters: [ChargeDynamicFilterItem!]
  ) {
    allCharges(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      totalCount
      pageCount
      charges {
        id
        stripeId
        amount
        amountCaptured
        amountRefunded
        paid
        status
        disputeStripeId
        failureMessage
        disputed
        refunded
        created
        refundable
        invoice {
          stripeId
          subscription {
            stripeId
          }
        }
      }
    }
  }
`

/**
 * __useBillingDashboardAllChargesQuery__
 *
 * To run a query within a React component, call `useBillingDashboardAllChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingDashboardAllChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingDashboardAllChargesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useBillingDashboardAllChargesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IBillingDashboardAllChargesQuery,
    IBillingDashboardAllChargesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IBillingDashboardAllChargesQuery,
    IBillingDashboardAllChargesQueryVariables
  >(BillingDashboardAllChargesDocument, options)
}
export function useBillingDashboardAllChargesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IBillingDashboardAllChargesQuery,
    IBillingDashboardAllChargesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IBillingDashboardAllChargesQuery,
    IBillingDashboardAllChargesQueryVariables
  >(BillingDashboardAllChargesDocument, options)
}
// @ts-ignore
export function useBillingDashboardAllChargesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IBillingDashboardAllChargesQuery,
    IBillingDashboardAllChargesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IBillingDashboardAllChargesQuery,
  IBillingDashboardAllChargesQueryVariables
>
export function useBillingDashboardAllChargesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IBillingDashboardAllChargesQuery,
        IBillingDashboardAllChargesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IBillingDashboardAllChargesQuery | undefined,
  IBillingDashboardAllChargesQueryVariables
>
export function useBillingDashboardAllChargesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IBillingDashboardAllChargesQuery,
        IBillingDashboardAllChargesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IBillingDashboardAllChargesQuery,
    IBillingDashboardAllChargesQueryVariables
  >(BillingDashboardAllChargesDocument, options)
}
export type BillingDashboardAllChargesQueryHookResult = ReturnType<
  typeof useBillingDashboardAllChargesQuery
>
export type BillingDashboardAllChargesLazyQueryHookResult = ReturnType<
  typeof useBillingDashboardAllChargesLazyQuery
>
export type BillingDashboardAllChargesSuspenseQueryHookResult = ReturnType<
  typeof useBillingDashboardAllChargesSuspenseQuery
>
export type BillingDashboardAllChargesQueryResult = Apollo.QueryResult<
  IBillingDashboardAllChargesQuery,
  IBillingDashboardAllChargesQueryVariables
>
export const BillingDashboardAllInvoicesDocument = gql`
  query billingDashboardAllInvoices(
    $page: Int
    $perPage: Int
    $sorts: [InvoiceSort!]
    $dynamicFilters: [InvoiceDynamicFilterItem!]
  ) {
    allInvoices(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      totalCount
      pageCount
      invoices {
        id
        stripeId
        paidAt
        receiptNumber
        downloadUrl
        created
        updatedAt
        subscription {
          stripeId
        }
        total
      }
    }
  }
`

/**
 * __useBillingDashboardAllInvoicesQuery__
 *
 * To run a query within a React component, call `useBillingDashboardAllInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingDashboardAllInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingDashboardAllInvoicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useBillingDashboardAllInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IBillingDashboardAllInvoicesQuery,
    IBillingDashboardAllInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IBillingDashboardAllInvoicesQuery,
    IBillingDashboardAllInvoicesQueryVariables
  >(BillingDashboardAllInvoicesDocument, options)
}
export function useBillingDashboardAllInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IBillingDashboardAllInvoicesQuery,
    IBillingDashboardAllInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IBillingDashboardAllInvoicesQuery,
    IBillingDashboardAllInvoicesQueryVariables
  >(BillingDashboardAllInvoicesDocument, options)
}
// @ts-ignore
export function useBillingDashboardAllInvoicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IBillingDashboardAllInvoicesQuery,
    IBillingDashboardAllInvoicesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IBillingDashboardAllInvoicesQuery,
  IBillingDashboardAllInvoicesQueryVariables
>
export function useBillingDashboardAllInvoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IBillingDashboardAllInvoicesQuery,
        IBillingDashboardAllInvoicesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IBillingDashboardAllInvoicesQuery | undefined,
  IBillingDashboardAllInvoicesQueryVariables
>
export function useBillingDashboardAllInvoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IBillingDashboardAllInvoicesQuery,
        IBillingDashboardAllInvoicesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IBillingDashboardAllInvoicesQuery,
    IBillingDashboardAllInvoicesQueryVariables
  >(BillingDashboardAllInvoicesDocument, options)
}
export type BillingDashboardAllInvoicesQueryHookResult = ReturnType<
  typeof useBillingDashboardAllInvoicesQuery
>
export type BillingDashboardAllInvoicesLazyQueryHookResult = ReturnType<
  typeof useBillingDashboardAllInvoicesLazyQuery
>
export type BillingDashboardAllInvoicesSuspenseQueryHookResult = ReturnType<
  typeof useBillingDashboardAllInvoicesSuspenseQuery
>
export type BillingDashboardAllInvoicesQueryResult = Apollo.QueryResult<
  IBillingDashboardAllInvoicesQuery,
  IBillingDashboardAllInvoicesQueryVariables
>
export const AllSubscriptionSchedulesDocument = gql`
  query allSubscriptionSchedules(
    $page: Int
    $perPage: Int
    $dynamicFilters: [SubscriptionScheduleDynamicFilterItem!]
  ) {
    allSubscriptionSchedules(page: $page, perPage: $perPage, dynamicFilters: $dynamicFilters) {
      totalCount
      pageCount
      schedules {
        id
        stripeId
        subscription {
          id
          stripeId
          status
        }
        user {
          id
          fullName
          email
        }
        currentPhaseStartAt
        currentPhaseEndAt
        canceledAt
        completedAt
        releasedAt
        createdAt
        updatedAt
        status
        phases {
          id
          description
          startAt
          endAt
          createdAt
          updatedAt
          billingCycleAnchorChange
          price
          primaryProduct {
            id
            key
            title
          }
        }
      }
    }
  }
`

/**
 * __useAllSubscriptionSchedulesQuery__
 *
 * To run a query within a React component, call `useAllSubscriptionSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSubscriptionSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSubscriptionSchedulesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllSubscriptionSchedulesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllSubscriptionSchedulesQuery,
    IAllSubscriptionSchedulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllSubscriptionSchedulesQuery, IAllSubscriptionSchedulesQueryVariables>(
    AllSubscriptionSchedulesDocument,
    options
  )
}
export function useAllSubscriptionSchedulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllSubscriptionSchedulesQuery,
    IAllSubscriptionSchedulesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAllSubscriptionSchedulesQuery,
    IAllSubscriptionSchedulesQueryVariables
  >(AllSubscriptionSchedulesDocument, options)
}
// @ts-ignore
export function useAllSubscriptionSchedulesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllSubscriptionSchedulesQuery,
    IAllSubscriptionSchedulesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllSubscriptionSchedulesQuery,
  IAllSubscriptionSchedulesQueryVariables
>
export function useAllSubscriptionSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllSubscriptionSchedulesQuery,
        IAllSubscriptionSchedulesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllSubscriptionSchedulesQuery | undefined,
  IAllSubscriptionSchedulesQueryVariables
>
export function useAllSubscriptionSchedulesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllSubscriptionSchedulesQuery,
        IAllSubscriptionSchedulesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllSubscriptionSchedulesQuery,
    IAllSubscriptionSchedulesQueryVariables
  >(AllSubscriptionSchedulesDocument, options)
}
export type AllSubscriptionSchedulesQueryHookResult = ReturnType<
  typeof useAllSubscriptionSchedulesQuery
>
export type AllSubscriptionSchedulesLazyQueryHookResult = ReturnType<
  typeof useAllSubscriptionSchedulesLazyQuery
>
export type AllSubscriptionSchedulesSuspenseQueryHookResult = ReturnType<
  typeof useAllSubscriptionSchedulesSuspenseQuery
>
export type AllSubscriptionSchedulesQueryResult = Apollo.QueryResult<
  IAllSubscriptionSchedulesQuery,
  IAllSubscriptionSchedulesQueryVariables
>
export const AllSubscriptionsDocument = gql`
  query allSubscriptions(
    $page: Int
    $perPage: Int
    $sorts: [SubscriptionSort!]
    $dynamicFilters: [SubscriptionDynamicFilterItem!]
  ) {
    allSubscriptions(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      pageCount
      subscriptions {
        id
        stripeId
        status
        stripeStatus
        paidMonthsCount
        pausedMonthsCount
        cancelAt
        canceledAt
        createdAt
        currentPeriodStartAt
        currentPeriodEndAt
        endAt
        resumesAt
        startAt
        subscribedAt
        trialEndAt
        commitmentEndAt
        updatedAt
        paused
        effectivelyActive
        plans {
          nickname
        }
        primaryProduct {
          ...CoreProductMinFields
        }
      }
    }
  }
  ${CoreProductMinFieldsFragmentDoc}
`

/**
 * __useAllSubscriptionsQuery__
 *
 * To run a query within a React component, call `useAllSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSubscriptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllSubscriptionsQuery, IAllSubscriptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllSubscriptionsQuery, IAllSubscriptionsQueryVariables>(
    AllSubscriptionsDocument,
    options
  )
}
export function useAllSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllSubscriptionsQuery, IAllSubscriptionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllSubscriptionsQuery, IAllSubscriptionsQueryVariables>(
    AllSubscriptionsDocument,
    options
  )
}
// @ts-ignore
export function useAllSubscriptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllSubscriptionsQuery,
    IAllSubscriptionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllSubscriptionsQuery, IAllSubscriptionsQueryVariables>
export function useAllSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllSubscriptionsQuery, IAllSubscriptionsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAllSubscriptionsQuery | undefined,
  IAllSubscriptionsQueryVariables
>
export function useAllSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllSubscriptionsQuery, IAllSubscriptionsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllSubscriptionsQuery, IAllSubscriptionsQueryVariables>(
    AllSubscriptionsDocument,
    options
  )
}
export type AllSubscriptionsQueryHookResult = ReturnType<typeof useAllSubscriptionsQuery>
export type AllSubscriptionsLazyQueryHookResult = ReturnType<typeof useAllSubscriptionsLazyQuery>
export type AllSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useAllSubscriptionsSuspenseQuery
>
export type AllSubscriptionsQueryResult = Apollo.QueryResult<
  IAllSubscriptionsQuery,
  IAllSubscriptionsQueryVariables
>
export const CreateSyncRequestDocument = gql`
  mutation createSyncRequest($userId: ID!) {
    createSyncRequest(userId: $userId) {
      success
    }
  }
`
export type ICreateSyncRequestMutationFn = Apollo.MutationFunction<
  ICreateSyncRequestMutation,
  ICreateSyncRequestMutationVariables
>

/**
 * __useCreateSyncRequestMutation__
 *
 * To run a mutation, you first call `useCreateSyncRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSyncRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSyncRequestMutation, { data, loading, error }] = useCreateSyncRequestMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateSyncRequestMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateSyncRequestMutation,
    ICreateSyncRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateSyncRequestMutation, ICreateSyncRequestMutationVariables>(
    CreateSyncRequestDocument,
    options
  )
}
export type CreateSyncRequestMutationHookResult = ReturnType<typeof useCreateSyncRequestMutation>
export type CreateSyncRequestMutationResult = Apollo.MutationResult<ICreateSyncRequestMutation>
export type CreateSyncRequestMutationOptions = Apollo.BaseMutationOptions<
  ICreateSyncRequestMutation,
  ICreateSyncRequestMutationVariables
>
export const CalendarDocument = gql`
  query calendar($filter: DateFilter) {
    calendar(filter: $filter) {
      dates {
        date
        score
      }
    }
  }
`

/**
 * __useCalendarQuery__
 *
 * To run a query within a React component, call `useCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCalendarQuery(
  baseOptions?: Apollo.QueryHookOptions<ICalendarQuery, ICalendarQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICalendarQuery, ICalendarQueryVariables>(CalendarDocument, options)
}
export function useCalendarLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ICalendarQuery, ICalendarQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICalendarQuery, ICalendarQueryVariables>(CalendarDocument, options)
}
// @ts-ignore
export function useCalendarSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ICalendarQuery, ICalendarQueryVariables>
): Apollo.UseSuspenseQueryResult<ICalendarQuery, ICalendarQueryVariables>
export function useCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICalendarQuery, ICalendarQueryVariables>
): Apollo.UseSuspenseQueryResult<ICalendarQuery | undefined, ICalendarQueryVariables>
export function useCalendarSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICalendarQuery, ICalendarQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ICalendarQuery, ICalendarQueryVariables>(CalendarDocument, options)
}
export type CalendarQueryHookResult = ReturnType<typeof useCalendarQuery>
export type CalendarLazyQueryHookResult = ReturnType<typeof useCalendarLazyQuery>
export type CalendarSuspenseQueryHookResult = ReturnType<typeof useCalendarSuspenseQuery>
export type CalendarQueryResult = Apollo.QueryResult<ICalendarQuery, ICalendarQueryVariables>
export const AllChatConversationEventsDocument = gql`
  query allChatConversationEvents(
    $conversationId: ID!
    $sorts: [ChatConversationEventSort!]
    $page: Int
    $perPage: Int
  ) {
    allChatConversationEvents(
      conversationId: $conversationId
      sorts: $sorts
      page: $page
      perPage: $perPage
    ) {
      totalCount
      pageCount
      chatConversationEvents {
        id
        kind
        occurredAt
        snoozedUntil
        message {
          id
          value
          sentAt
          senderKind
          sender {
            id
            fullName
            avatar
            coachProfile {
              photo
            }
          }
        }
        note {
          id
          value
          createdAt
          createdBy {
            id
            fullName
            avatar
          }
        }
        performedBy {
          id
          fullName
        }
        assignedTo {
          id
          fullName
        }
      }
    }
  }
`

/**
 * __useAllChatConversationEventsQuery__
 *
 * To run a query within a React component, call `useAllChatConversationEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChatConversationEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChatConversationEventsQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *      sorts: // value for 'sorts'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAllChatConversationEventsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IAllChatConversationEventsQuery,
    IAllChatConversationEventsQueryVariables
  > &
    ({ variables: IAllChatConversationEventsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllChatConversationEventsQuery, IAllChatConversationEventsQueryVariables>(
    AllChatConversationEventsDocument,
    options
  )
}
export function useAllChatConversationEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllChatConversationEventsQuery,
    IAllChatConversationEventsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAllChatConversationEventsQuery,
    IAllChatConversationEventsQueryVariables
  >(AllChatConversationEventsDocument, options)
}
// @ts-ignore
export function useAllChatConversationEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllChatConversationEventsQuery,
    IAllChatConversationEventsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllChatConversationEventsQuery,
  IAllChatConversationEventsQueryVariables
>
export function useAllChatConversationEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatConversationEventsQuery,
        IAllChatConversationEventsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllChatConversationEventsQuery | undefined,
  IAllChatConversationEventsQueryVariables
>
export function useAllChatConversationEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatConversationEventsQuery,
        IAllChatConversationEventsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllChatConversationEventsQuery,
    IAllChatConversationEventsQueryVariables
  >(AllChatConversationEventsDocument, options)
}
export type AllChatConversationEventsQueryHookResult = ReturnType<
  typeof useAllChatConversationEventsQuery
>
export type AllChatConversationEventsLazyQueryHookResult = ReturnType<
  typeof useAllChatConversationEventsLazyQuery
>
export type AllChatConversationEventsSuspenseQueryHookResult = ReturnType<
  typeof useAllChatConversationEventsSuspenseQuery
>
export type AllChatConversationEventsQueryResult = Apollo.QueryResult<
  IAllChatConversationEventsQuery,
  IAllChatConversationEventsQueryVariables
>
export const AllChatConversationsDocument = gql`
  query allChatConversations(
    $kinds: [ChatConversationKind!]
    $states: [ChatConversationState!]
    $sorts: [ChatConversationSort!]
    $forCoach: Boolean
    $active: Boolean
    $userIds: [ID!]
    $page: Int
    $perPage: Int
  ) {
    allChatConversations(
      kinds: $kinds
      states: $states
      sorts: $sorts
      forCoach: $forCoach
      active: $active
      userIds: $userIds
      page: $page
      perPage: $perPage
    ) {
      totalCount
      chatConversations {
        id
        kind
        state
        read
        lastMessage {
          id
          value
          sentAt
        }
        lastNote {
          id
          value
          createdAt
        }
        user {
          id
          fullName
        }
        intercomCreatedAt
      }
    }
  }
`

/**
 * __useAllChatConversationsQuery__
 *
 * To run a query within a React component, call `useAllChatConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChatConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChatConversationsQuery({
 *   variables: {
 *      kinds: // value for 'kinds'
 *      states: // value for 'states'
 *      sorts: // value for 'sorts'
 *      forCoach: // value for 'forCoach'
 *      active: // value for 'active'
 *      userIds: // value for 'userIds'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAllChatConversationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllChatConversationsQuery,
    IAllChatConversationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllChatConversationsQuery, IAllChatConversationsQueryVariables>(
    AllChatConversationsDocument,
    options
  )
}
export function useAllChatConversationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllChatConversationsQuery,
    IAllChatConversationsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllChatConversationsQuery, IAllChatConversationsQueryVariables>(
    AllChatConversationsDocument,
    options
  )
}
// @ts-ignore
export function useAllChatConversationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllChatConversationsQuery,
    IAllChatConversationsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllChatConversationsQuery, IAllChatConversationsQueryVariables>
export function useAllChatConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatConversationsQuery,
        IAllChatConversationsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllChatConversationsQuery | undefined,
  IAllChatConversationsQueryVariables
>
export function useAllChatConversationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatConversationsQuery,
        IAllChatConversationsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllChatConversationsQuery, IAllChatConversationsQueryVariables>(
    AllChatConversationsDocument,
    options
  )
}
export type AllChatConversationsQueryHookResult = ReturnType<typeof useAllChatConversationsQuery>
export type AllChatConversationsLazyQueryHookResult = ReturnType<
  typeof useAllChatConversationsLazyQuery
>
export type AllChatConversationsSuspenseQueryHookResult = ReturnType<
  typeof useAllChatConversationsSuspenseQuery
>
export type AllChatConversationsQueryResult = Apollo.QueryResult<
  IAllChatConversationsQuery,
  IAllChatConversationsQueryVariables
>
export const ChatConversationDocument = gql`
  query chatConversation($id: ID!) {
    chatConversation(id: $id) {
      ...CoreChatConversationFields
    }
  }
  ${CoreChatConversationFieldsFragmentDoc}
`

/**
 * __useChatConversationQuery__
 *
 * To run a query within a React component, call `useChatConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatConversationQuery(
  baseOptions: Apollo.QueryHookOptions<IChatConversationQuery, IChatConversationQueryVariables> &
    ({ variables: IChatConversationQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IChatConversationQuery, IChatConversationQueryVariables>(
    ChatConversationDocument,
    options
  )
}
export function useChatConversationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IChatConversationQuery, IChatConversationQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IChatConversationQuery, IChatConversationQueryVariables>(
    ChatConversationDocument,
    options
  )
}
// @ts-ignore
export function useChatConversationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IChatConversationQuery,
    IChatConversationQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IChatConversationQuery, IChatConversationQueryVariables>
export function useChatConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IChatConversationQuery, IChatConversationQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IChatConversationQuery | undefined,
  IChatConversationQueryVariables
>
export function useChatConversationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IChatConversationQuery, IChatConversationQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IChatConversationQuery, IChatConversationQueryVariables>(
    ChatConversationDocument,
    options
  )
}
export type ChatConversationQueryHookResult = ReturnType<typeof useChatConversationQuery>
export type ChatConversationLazyQueryHookResult = ReturnType<typeof useChatConversationLazyQuery>
export type ChatConversationSuspenseQueryHookResult = ReturnType<
  typeof useChatConversationSuspenseQuery
>
export type ChatConversationQueryResult = Apollo.QueryResult<
  IChatConversationQuery,
  IChatConversationQueryVariables
>
export const ChatbotMessageDocument = gql`
  query chatbotMessage($id: ID!) {
    chatbotMessage(id: $id) {
      id
      content
      userMessage {
        id
        content
        knowledgeQuestions {
          ...CoreKnowledgeQuestionFields
        }
      }
    }
  }
  ${CoreKnowledgeQuestionFieldsFragmentDoc}
`

/**
 * __useChatbotMessageQuery__
 *
 * To run a query within a React component, call `useChatbotMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatbotMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatbotMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatbotMessageQuery(
  baseOptions: Apollo.QueryHookOptions<IChatbotMessageQuery, IChatbotMessageQueryVariables> &
    ({ variables: IChatbotMessageQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IChatbotMessageQuery, IChatbotMessageQueryVariables>(
    ChatbotMessageDocument,
    options
  )
}
export function useChatbotMessageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IChatbotMessageQuery, IChatbotMessageQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IChatbotMessageQuery, IChatbotMessageQueryVariables>(
    ChatbotMessageDocument,
    options
  )
}
// @ts-ignore
export function useChatbotMessageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IChatbotMessageQuery, IChatbotMessageQueryVariables>
): Apollo.UseSuspenseQueryResult<IChatbotMessageQuery, IChatbotMessageQueryVariables>
export function useChatbotMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IChatbotMessageQuery, IChatbotMessageQueryVariables>
): Apollo.UseSuspenseQueryResult<IChatbotMessageQuery | undefined, IChatbotMessageQueryVariables>
export function useChatbotMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IChatbotMessageQuery, IChatbotMessageQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IChatbotMessageQuery, IChatbotMessageQueryVariables>(
    ChatbotMessageDocument,
    options
  )
}
export type ChatbotMessageQueryHookResult = ReturnType<typeof useChatbotMessageQuery>
export type ChatbotMessageLazyQueryHookResult = ReturnType<typeof useChatbotMessageLazyQuery>
export type ChatbotMessageSuspenseQueryHookResult = ReturnType<
  typeof useChatbotMessageSuspenseQuery
>
export type ChatbotMessageQueryResult = Apollo.QueryResult<
  IChatbotMessageQuery,
  IChatbotMessageQueryVariables
>
export const AllChatbotMessageReportsDocument = gql`
  query allChatbotMessageReports(
    $page: Int
    $perPage: Int
    $sorts: [ChatbotMessageReportSort!]
    $dynamicFilters: [ChatbotMessageReportDynamicFilterItem!]
  ) {
    allChatbotMessageReports(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      pageCount
      reports {
        ...CoreChatbotMessageReportFields
      }
    }
  }
  ${CoreChatbotMessageReportFieldsFragmentDoc}
`

/**
 * __useAllChatbotMessageReportsQuery__
 *
 * To run a query within a React component, call `useAllChatbotMessageReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChatbotMessageReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChatbotMessageReportsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllChatbotMessageReportsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IAllChatbotMessageReportsQuery,
    IAllChatbotMessageReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllChatbotMessageReportsQuery, IAllChatbotMessageReportsQueryVariables>(
    AllChatbotMessageReportsDocument,
    options
  )
}
export function useAllChatbotMessageReportsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllChatbotMessageReportsQuery,
    IAllChatbotMessageReportsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IAllChatbotMessageReportsQuery,
    IAllChatbotMessageReportsQueryVariables
  >(AllChatbotMessageReportsDocument, options)
}
// @ts-ignore
export function useAllChatbotMessageReportsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllChatbotMessageReportsQuery,
    IAllChatbotMessageReportsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IAllChatbotMessageReportsQuery,
  IAllChatbotMessageReportsQueryVariables
>
export function useAllChatbotMessageReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatbotMessageReportsQuery,
        IAllChatbotMessageReportsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IAllChatbotMessageReportsQuery | undefined,
  IAllChatbotMessageReportsQueryVariables
>
export function useAllChatbotMessageReportsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IAllChatbotMessageReportsQuery,
        IAllChatbotMessageReportsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IAllChatbotMessageReportsQuery,
    IAllChatbotMessageReportsQueryVariables
  >(AllChatbotMessageReportsDocument, options)
}
export type AllChatbotMessageReportsQueryHookResult = ReturnType<
  typeof useAllChatbotMessageReportsQuery
>
export type AllChatbotMessageReportsLazyQueryHookResult = ReturnType<
  typeof useAllChatbotMessageReportsLazyQuery
>
export type AllChatbotMessageReportsSuspenseQueryHookResult = ReturnType<
  typeof useAllChatbotMessageReportsSuspenseQuery
>
export type AllChatbotMessageReportsQueryResult = Apollo.QueryResult<
  IAllChatbotMessageReportsQuery,
  IAllChatbotMessageReportsQueryVariables
>
export const ClientConfigDocument = gql`
  query clientConfig {
    clientConfig {
      sensorSettings {
        baselineAdjustmentOptions {
          text
          value
        }
      }
      score {
        warning
        danger
        max
      }
      insights {
        statistics {
          name
          metric {
            ranges {
              from
              to
              type
              rating
            }
            precision
            units
          }
          imperial {
            ranges {
              from
              to
              type
              rating
            }
            precision
            units
          }
        }
      }
      healthSettings {
        glucoseLowOptions {
          text
          value
        }
        glucoseHighOptions {
          text
          value
        }
        ketoneLowOptions {
          text
          value
        }
        ketoneHighOptions {
          text
          value
        }
        macroGoalSettings {
          caloriesMax
          proteinMax
          carbsMax
          fatMax
        }
        unitSystemOptions {
          text
          value
        }
        dashboardGraphOptions {
          text
          value
        }
      }
      journal {
        range {
          min
          max
        }
        measurementTypes {
          type
          reverse
        }
      }
      chatbot {
        responseTimeoutInSeconds
      }
      goalOptions {
        text
        value
      }
      goalMetricOptions {
        text
        value
      }
      healthMetrics {
        key
        label
        unit
        kind
      }
      tickets {
        reasonDefs {
          key
          kind
          title
        }
      }
      actionGoalOptions {
        kind
        title
        description
        icon
        category
        metricOptions {
          kind
          description
          supportsMetricValue
          valuePrefix
          infoText
          metric {
            min
            max
            increment
            units
          }
          imperial {
            min
            max
            increment
            units
          }
        }
      }
      appointmentKinds {
        duration
        key
        title
        coachingKind {
          ...CoreCoachingKindFields
        }
      }
    }
  }
  ${CoreCoachingKindFieldsFragmentDoc}
`

/**
 * __useClientConfigQuery__
 *
 * To run a query within a React component, call `useClientConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientConfigQuery(
  baseOptions?: Apollo.QueryHookOptions<IClientConfigQuery, IClientConfigQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IClientConfigQuery, IClientConfigQueryVariables>(
    ClientConfigDocument,
    options
  )
}
export function useClientConfigLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IClientConfigQuery, IClientConfigQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IClientConfigQuery, IClientConfigQueryVariables>(
    ClientConfigDocument,
    options
  )
}
// @ts-ignore
export function useClientConfigSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IClientConfigQuery, IClientConfigQueryVariables>
): Apollo.UseSuspenseQueryResult<IClientConfigQuery, IClientConfigQueryVariables>
export function useClientConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IClientConfigQuery, IClientConfigQueryVariables>
): Apollo.UseSuspenseQueryResult<IClientConfigQuery | undefined, IClientConfigQueryVariables>
export function useClientConfigSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IClientConfigQuery, IClientConfigQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IClientConfigQuery, IClientConfigQueryVariables>(
    ClientConfigDocument,
    options
  )
}
export type ClientConfigQueryHookResult = ReturnType<typeof useClientConfigQuery>
export type ClientConfigLazyQueryHookResult = ReturnType<typeof useClientConfigLazyQuery>
export type ClientConfigSuspenseQueryHookResult = ReturnType<typeof useClientConfigSuspenseQuery>
export type ClientConfigQueryResult = Apollo.QueryResult<
  IClientConfigQuery,
  IClientConfigQueryVariables
>
export const CoachBillingInvoiceItemKindsDocument = gql`
  query coachBillingInvoiceItemKinds {
    coachBillingInvoiceItemKinds {
      kinds {
        key
        name
        admin
        billable
        selfReportable
      }
    }
  }
`

/**
 * __useCoachBillingInvoiceItemKindsQuery__
 *
 * To run a query within a React component, call `useCoachBillingInvoiceItemKindsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachBillingInvoiceItemKindsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachBillingInvoiceItemKindsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoachBillingInvoiceItemKindsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ICoachBillingInvoiceItemKindsQuery,
    ICoachBillingInvoiceItemKindsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ICoachBillingInvoiceItemKindsQuery,
    ICoachBillingInvoiceItemKindsQueryVariables
  >(CoachBillingInvoiceItemKindsDocument, options)
}
export function useCoachBillingInvoiceItemKindsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICoachBillingInvoiceItemKindsQuery,
    ICoachBillingInvoiceItemKindsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ICoachBillingInvoiceItemKindsQuery,
    ICoachBillingInvoiceItemKindsQueryVariables
  >(CoachBillingInvoiceItemKindsDocument, options)
}
// @ts-ignore
export function useCoachBillingInvoiceItemKindsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICoachBillingInvoiceItemKindsQuery,
    ICoachBillingInvoiceItemKindsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ICoachBillingInvoiceItemKindsQuery,
  ICoachBillingInvoiceItemKindsQueryVariables
>
export function useCoachBillingInvoiceItemKindsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachBillingInvoiceItemKindsQuery,
        ICoachBillingInvoiceItemKindsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ICoachBillingInvoiceItemKindsQuery | undefined,
  ICoachBillingInvoiceItemKindsQueryVariables
>
export function useCoachBillingInvoiceItemKindsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachBillingInvoiceItemKindsQuery,
        ICoachBillingInvoiceItemKindsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ICoachBillingInvoiceItemKindsQuery,
    ICoachBillingInvoiceItemKindsQueryVariables
  >(CoachBillingInvoiceItemKindsDocument, options)
}
export type CoachBillingInvoiceItemKindsQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceItemKindsQuery
>
export type CoachBillingInvoiceItemKindsLazyQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceItemKindsLazyQuery
>
export type CoachBillingInvoiceItemKindsSuspenseQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceItemKindsSuspenseQuery
>
export type CoachBillingInvoiceItemKindsQueryResult = Apollo.QueryResult<
  ICoachBillingInvoiceItemKindsQuery,
  ICoachBillingInvoiceItemKindsQueryVariables
>
export const CoachBillingInvoiceItemTotalsDocument = gql`
  query coachBillingInvoiceItemTotals(
    $periodStart: ISO8601Date!
    $periodEnd: ISO8601Date!
    $coachId: ID
  ) {
    coachBillingInvoiceItemTotals(
      periodStart: $periodStart
      periodEnd: $periodEnd
      coachId: $coachId
    ) {
      total
      adminTotal
      billableTotal
      items {
        kind
        total
        count
        quantity
      }
    }
  }
`

/**
 * __useCoachBillingInvoiceItemTotalsQuery__
 *
 * To run a query within a React component, call `useCoachBillingInvoiceItemTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachBillingInvoiceItemTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachBillingInvoiceItemTotalsQuery({
 *   variables: {
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useCoachBillingInvoiceItemTotalsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ICoachBillingInvoiceItemTotalsQuery,
    ICoachBillingInvoiceItemTotalsQueryVariables
  > &
    (
      | { variables: ICoachBillingInvoiceItemTotalsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ICoachBillingInvoiceItemTotalsQuery,
    ICoachBillingInvoiceItemTotalsQueryVariables
  >(CoachBillingInvoiceItemTotalsDocument, options)
}
export function useCoachBillingInvoiceItemTotalsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICoachBillingInvoiceItemTotalsQuery,
    ICoachBillingInvoiceItemTotalsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ICoachBillingInvoiceItemTotalsQuery,
    ICoachBillingInvoiceItemTotalsQueryVariables
  >(CoachBillingInvoiceItemTotalsDocument, options)
}
// @ts-ignore
export function useCoachBillingInvoiceItemTotalsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICoachBillingInvoiceItemTotalsQuery,
    ICoachBillingInvoiceItemTotalsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ICoachBillingInvoiceItemTotalsQuery,
  ICoachBillingInvoiceItemTotalsQueryVariables
>
export function useCoachBillingInvoiceItemTotalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachBillingInvoiceItemTotalsQuery,
        ICoachBillingInvoiceItemTotalsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ICoachBillingInvoiceItemTotalsQuery | undefined,
  ICoachBillingInvoiceItemTotalsQueryVariables
>
export function useCoachBillingInvoiceItemTotalsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachBillingInvoiceItemTotalsQuery,
        ICoachBillingInvoiceItemTotalsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ICoachBillingInvoiceItemTotalsQuery,
    ICoachBillingInvoiceItemTotalsQueryVariables
  >(CoachBillingInvoiceItemTotalsDocument, options)
}
export type CoachBillingInvoiceItemTotalsQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceItemTotalsQuery
>
export type CoachBillingInvoiceItemTotalsLazyQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceItemTotalsLazyQuery
>
export type CoachBillingInvoiceItemTotalsSuspenseQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceItemTotalsSuspenseQuery
>
export type CoachBillingInvoiceItemTotalsQueryResult = Apollo.QueryResult<
  ICoachBillingInvoiceItemTotalsQuery,
  ICoachBillingInvoiceItemTotalsQueryVariables
>
export const CoachBillingInvoiceItemsDocument = gql`
  query coachBillingInvoiceItems(
    $coachId: ID!
    $periodStart: ISO8601Date!
    $periodEnd: ISO8601Date!
    $page: Int
    $perPage: Int
    $sorts: [CoachBillingInvoiceItemSort!]
    $dynamicFilters: [CoachBillingInvoiceItemDynamicFilterItem!]
  ) {
    coachBillingInvoiceItems(
      coachId: $coachId
      periodStart: $periodStart
      periodEnd: $periodEnd
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      items {
        ...CoreCoachBillingInvoiceItemFields
      }
    }
  }
  ${CoreCoachBillingInvoiceItemFieldsFragmentDoc}
`

/**
 * __useCoachBillingInvoiceItemsQuery__
 *
 * To run a query within a React component, call `useCoachBillingInvoiceItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachBillingInvoiceItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachBillingInvoiceItemsQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useCoachBillingInvoiceItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ICoachBillingInvoiceItemsQuery,
    ICoachBillingInvoiceItemsQueryVariables
  > &
    ({ variables: ICoachBillingInvoiceItemsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICoachBillingInvoiceItemsQuery, ICoachBillingInvoiceItemsQueryVariables>(
    CoachBillingInvoiceItemsDocument,
    options
  )
}
export function useCoachBillingInvoiceItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICoachBillingInvoiceItemsQuery,
    ICoachBillingInvoiceItemsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ICoachBillingInvoiceItemsQuery,
    ICoachBillingInvoiceItemsQueryVariables
  >(CoachBillingInvoiceItemsDocument, options)
}
// @ts-ignore
export function useCoachBillingInvoiceItemsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICoachBillingInvoiceItemsQuery,
    ICoachBillingInvoiceItemsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ICoachBillingInvoiceItemsQuery,
  ICoachBillingInvoiceItemsQueryVariables
>
export function useCoachBillingInvoiceItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachBillingInvoiceItemsQuery,
        ICoachBillingInvoiceItemsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ICoachBillingInvoiceItemsQuery | undefined,
  ICoachBillingInvoiceItemsQueryVariables
>
export function useCoachBillingInvoiceItemsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachBillingInvoiceItemsQuery,
        ICoachBillingInvoiceItemsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ICoachBillingInvoiceItemsQuery,
    ICoachBillingInvoiceItemsQueryVariables
  >(CoachBillingInvoiceItemsDocument, options)
}
export type CoachBillingInvoiceItemsQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceItemsQuery
>
export type CoachBillingInvoiceItemsLazyQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceItemsLazyQuery
>
export type CoachBillingInvoiceItemsSuspenseQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceItemsSuspenseQuery
>
export type CoachBillingInvoiceItemsQueryResult = Apollo.QueryResult<
  ICoachBillingInvoiceItemsQuery,
  ICoachBillingInvoiceItemsQueryVariables
>
export const CoachBillingInvoiceReviewsDocument = gql`
  query coachBillingInvoiceReviews(
    $coachId: ID!
    $periodStart: ISO8601Date!
    $periodEnd: ISO8601Date!
    $page: Int
    $perPage: Int
    $sorts: [CoachBillingInvoiceReviewSort!]
    $dynamicFilters: [CoachBillingInvoiceReviewDynamicFilterItem!]
  ) {
    coachBillingInvoiceReviews(
      coachId: $coachId
      periodStart: $periodStart
      periodEnd: $periodEnd
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      reviews {
        ...CoreCoachBillingInvoiceReviewFields
      }
    }
  }
  ${CoreCoachBillingInvoiceReviewFieldsFragmentDoc}
`

/**
 * __useCoachBillingInvoiceReviewsQuery__
 *
 * To run a query within a React component, call `useCoachBillingInvoiceReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachBillingInvoiceReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachBillingInvoiceReviewsQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useCoachBillingInvoiceReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ICoachBillingInvoiceReviewsQuery,
    ICoachBillingInvoiceReviewsQueryVariables
  > &
    ({ variables: ICoachBillingInvoiceReviewsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    ICoachBillingInvoiceReviewsQuery,
    ICoachBillingInvoiceReviewsQueryVariables
  >(CoachBillingInvoiceReviewsDocument, options)
}
export function useCoachBillingInvoiceReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICoachBillingInvoiceReviewsQuery,
    ICoachBillingInvoiceReviewsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ICoachBillingInvoiceReviewsQuery,
    ICoachBillingInvoiceReviewsQueryVariables
  >(CoachBillingInvoiceReviewsDocument, options)
}
// @ts-ignore
export function useCoachBillingInvoiceReviewsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICoachBillingInvoiceReviewsQuery,
    ICoachBillingInvoiceReviewsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ICoachBillingInvoiceReviewsQuery,
  ICoachBillingInvoiceReviewsQueryVariables
>
export function useCoachBillingInvoiceReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachBillingInvoiceReviewsQuery,
        ICoachBillingInvoiceReviewsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ICoachBillingInvoiceReviewsQuery | undefined,
  ICoachBillingInvoiceReviewsQueryVariables
>
export function useCoachBillingInvoiceReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachBillingInvoiceReviewsQuery,
        ICoachBillingInvoiceReviewsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ICoachBillingInvoiceReviewsQuery,
    ICoachBillingInvoiceReviewsQueryVariables
  >(CoachBillingInvoiceReviewsDocument, options)
}
export type CoachBillingInvoiceReviewsQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceReviewsQuery
>
export type CoachBillingInvoiceReviewsLazyQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceReviewsLazyQuery
>
export type CoachBillingInvoiceReviewsSuspenseQueryHookResult = ReturnType<
  typeof useCoachBillingInvoiceReviewsSuspenseQuery
>
export type CoachBillingInvoiceReviewsQueryResult = Apollo.QueryResult<
  ICoachBillingInvoiceReviewsQuery,
  ICoachBillingInvoiceReviewsQueryVariables
>
export const CoachBillingInvoicesDocument = gql`
  query coachBillingInvoices(
    $coachId: ID!
    $periodStart: ISO8601Date!
    $periodEnd: ISO8601Date!
    $page: Int
    $perPage: Int
    $sorts: [CoachBillingInvoiceSort!]
    $dynamicFilters: [CoachBillingInvoiceDynamicFilterItem!]
  ) {
    coachBillingInvoices(
      coachId: $coachId
      periodStart: $periodStart
      periodEnd: $periodEnd
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      invoices {
        ...CoreCoachBillingInvoiceFields
      }
    }
  }
  ${CoreCoachBillingInvoiceFieldsFragmentDoc}
`

/**
 * __useCoachBillingInvoicesQuery__
 *
 * To run a query within a React component, call `useCoachBillingInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachBillingInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachBillingInvoicesQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *      periodStart: // value for 'periodStart'
 *      periodEnd: // value for 'periodEnd'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useCoachBillingInvoicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ICoachBillingInvoicesQuery,
    ICoachBillingInvoicesQueryVariables
  > &
    ({ variables: ICoachBillingInvoicesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICoachBillingInvoicesQuery, ICoachBillingInvoicesQueryVariables>(
    CoachBillingInvoicesDocument,
    options
  )
}
export function useCoachBillingInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICoachBillingInvoicesQuery,
    ICoachBillingInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICoachBillingInvoicesQuery, ICoachBillingInvoicesQueryVariables>(
    CoachBillingInvoicesDocument,
    options
  )
}
// @ts-ignore
export function useCoachBillingInvoicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICoachBillingInvoicesQuery,
    ICoachBillingInvoicesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ICoachBillingInvoicesQuery, ICoachBillingInvoicesQueryVariables>
export function useCoachBillingInvoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachBillingInvoicesQuery,
        ICoachBillingInvoicesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ICoachBillingInvoicesQuery | undefined,
  ICoachBillingInvoicesQueryVariables
>
export function useCoachBillingInvoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachBillingInvoicesQuery,
        ICoachBillingInvoicesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ICoachBillingInvoicesQuery, ICoachBillingInvoicesQueryVariables>(
    CoachBillingInvoicesDocument,
    options
  )
}
export type CoachBillingInvoicesQueryHookResult = ReturnType<typeof useCoachBillingInvoicesQuery>
export type CoachBillingInvoicesLazyQueryHookResult = ReturnType<
  typeof useCoachBillingInvoicesLazyQuery
>
export type CoachBillingInvoicesSuspenseQueryHookResult = ReturnType<
  typeof useCoachBillingInvoicesSuspenseQuery
>
export type CoachBillingInvoicesQueryResult = Apollo.QueryResult<
  ICoachBillingInvoicesQuery,
  ICoachBillingInvoicesQueryVariables
>
export const CoachBillingRatesDocument = gql`
  query coachBillingRates($coachId: ID!) {
    coachBillingRates(coachId: $coachId) {
      ...CoachBillingRatesFields
    }
  }
  ${CoachBillingRatesFieldsFragmentDoc}
`

/**
 * __useCoachBillingRatesQuery__
 *
 * To run a query within a React component, call `useCoachBillingRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachBillingRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachBillingRatesQuery({
 *   variables: {
 *      coachId: // value for 'coachId'
 *   },
 * });
 */
export function useCoachBillingRatesQuery(
  baseOptions: Apollo.QueryHookOptions<ICoachBillingRatesQuery, ICoachBillingRatesQueryVariables> &
    ({ variables: ICoachBillingRatesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICoachBillingRatesQuery, ICoachBillingRatesQueryVariables>(
    CoachBillingRatesDocument,
    options
  )
}
export function useCoachBillingRatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICoachBillingRatesQuery,
    ICoachBillingRatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICoachBillingRatesQuery, ICoachBillingRatesQueryVariables>(
    CoachBillingRatesDocument,
    options
  )
}
// @ts-ignore
export function useCoachBillingRatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICoachBillingRatesQuery,
    ICoachBillingRatesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ICoachBillingRatesQuery, ICoachBillingRatesQueryVariables>
export function useCoachBillingRatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICoachBillingRatesQuery, ICoachBillingRatesQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ICoachBillingRatesQuery | undefined,
  ICoachBillingRatesQueryVariables
>
export function useCoachBillingRatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICoachBillingRatesQuery, ICoachBillingRatesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ICoachBillingRatesQuery, ICoachBillingRatesQueryVariables>(
    CoachBillingRatesDocument,
    options
  )
}
export type CoachBillingRatesQueryHookResult = ReturnType<typeof useCoachBillingRatesQuery>
export type CoachBillingRatesLazyQueryHookResult = ReturnType<typeof useCoachBillingRatesLazyQuery>
export type CoachBillingRatesSuspenseQueryHookResult = ReturnType<
  typeof useCoachBillingRatesSuspenseQuery
>
export type CoachBillingRatesQueryResult = Apollo.QueryResult<
  ICoachBillingRatesQuery,
  ICoachBillingRatesQueryVariables
>
export const CoachSharedAssetsDocument = gql`
  query coachSharedAssets(
    $page: Int
    $perPage: Int
    $sorts: [CoachSharedAssetSort!]
    $dynamicFilters: [CoachSharedAssetDynamicFilterItem!]
    $tags: [String!]
  ) {
    coachSharedAssets(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
      tags: $tags
    ) {
      totalCount
      pageCount
      coachSharedAssets {
        ...CoreCoachSharedAssetFields
      }
    }
  }
  ${CoreCoachSharedAssetFieldsFragmentDoc}
`

/**
 * __useCoachSharedAssetsQuery__
 *
 * To run a query within a React component, call `useCoachSharedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachSharedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachSharedAssetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useCoachSharedAssetsQuery(
  baseOptions?: Apollo.QueryHookOptions<ICoachSharedAssetsQuery, ICoachSharedAssetsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICoachSharedAssetsQuery, ICoachSharedAssetsQueryVariables>(
    CoachSharedAssetsDocument,
    options
  )
}
export function useCoachSharedAssetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICoachSharedAssetsQuery,
    ICoachSharedAssetsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICoachSharedAssetsQuery, ICoachSharedAssetsQueryVariables>(
    CoachSharedAssetsDocument,
    options
  )
}
// @ts-ignore
export function useCoachSharedAssetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICoachSharedAssetsQuery,
    ICoachSharedAssetsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ICoachSharedAssetsQuery, ICoachSharedAssetsQueryVariables>
export function useCoachSharedAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICoachSharedAssetsQuery, ICoachSharedAssetsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ICoachSharedAssetsQuery | undefined,
  ICoachSharedAssetsQueryVariables
>
export function useCoachSharedAssetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICoachSharedAssetsQuery, ICoachSharedAssetsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ICoachSharedAssetsQuery, ICoachSharedAssetsQueryVariables>(
    CoachSharedAssetsDocument,
    options
  )
}
export type CoachSharedAssetsQueryHookResult = ReturnType<typeof useCoachSharedAssetsQuery>
export type CoachSharedAssetsLazyQueryHookResult = ReturnType<typeof useCoachSharedAssetsLazyQuery>
export type CoachSharedAssetsSuspenseQueryHookResult = ReturnType<
  typeof useCoachSharedAssetsSuspenseQuery
>
export type CoachSharedAssetsQueryResult = Apollo.QueryResult<
  ICoachSharedAssetsQuery,
  ICoachSharedAssetsQueryVariables
>
export const CoachReviewProfileDocument = gql`
  query CoachReviewProfile($userId: ID!) {
    user(id: $userId) {
      id
      firstName
      lastName
      fullName
      email
      avatar
      coachProfile {
        registrationStatus
        updatedAt
        credentials
        cdrCnsNumber
        cdrCnsExpirationDate
        cdrCnsCard
        photo
        gender
        stateOfResidence
        ethnicity
        additionalLanguages
        bio
        stateLicences
        stateLicenceDetails {
          state
          expirationDate
          expirationReminderEnabled
          document
        }
        specialties {
          key
          name
        }
      }
    }
  }
`

/**
 * __useCoachReviewProfileQuery__
 *
 * To run a query within a React component, call `useCoachReviewProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachReviewProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachReviewProfileQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCoachReviewProfileQuery(
  baseOptions: Apollo.QueryHookOptions<
    ICoachReviewProfileQuery,
    ICoachReviewProfileQueryVariables
  > &
    ({ variables: ICoachReviewProfileQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICoachReviewProfileQuery, ICoachReviewProfileQueryVariables>(
    CoachReviewProfileDocument,
    options
  )
}
export function useCoachReviewProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICoachReviewProfileQuery,
    ICoachReviewProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICoachReviewProfileQuery, ICoachReviewProfileQueryVariables>(
    CoachReviewProfileDocument,
    options
  )
}
// @ts-ignore
export function useCoachReviewProfileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICoachReviewProfileQuery,
    ICoachReviewProfileQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ICoachReviewProfileQuery, ICoachReviewProfileQueryVariables>
export function useCoachReviewProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICoachReviewProfileQuery, ICoachReviewProfileQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ICoachReviewProfileQuery | undefined,
  ICoachReviewProfileQueryVariables
>
export function useCoachReviewProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICoachReviewProfileQuery, ICoachReviewProfileQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ICoachReviewProfileQuery, ICoachReviewProfileQueryVariables>(
    CoachReviewProfileDocument,
    options
  )
}
export type CoachReviewProfileQueryHookResult = ReturnType<typeof useCoachReviewProfileQuery>
export type CoachReviewProfileLazyQueryHookResult = ReturnType<
  typeof useCoachReviewProfileLazyQuery
>
export type CoachReviewProfileSuspenseQueryHookResult = ReturnType<
  typeof useCoachReviewProfileSuspenseQuery
>
export type CoachReviewProfileQueryResult = Apollo.QueryResult<
  ICoachReviewProfileQuery,
  ICoachReviewProfileQueryVariables
>
export const CurrentAdminDocument = gql`
  query currentAdmin {
    currentAdmin {
      id
      firstName
      lastName
      fullName
      email
      avatar
      fullName
      role
      coachProfile {
        id
      }
      activeCoachingKinds {
        key
        coachTitle
      }
    }
  }
`

/**
 * __useCurrentAdminQuery__
 *
 * To run a query within a React component, call `useCurrentAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAdminQuery(
  baseOptions?: Apollo.QueryHookOptions<ICurrentAdminQuery, ICurrentAdminQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICurrentAdminQuery, ICurrentAdminQueryVariables>(
    CurrentAdminDocument,
    options
  )
}
export function useCurrentAdminLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ICurrentAdminQuery, ICurrentAdminQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICurrentAdminQuery, ICurrentAdminQueryVariables>(
    CurrentAdminDocument,
    options
  )
}
// @ts-ignore
export function useCurrentAdminSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ICurrentAdminQuery, ICurrentAdminQueryVariables>
): Apollo.UseSuspenseQueryResult<ICurrentAdminQuery, ICurrentAdminQueryVariables>
export function useCurrentAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICurrentAdminQuery, ICurrentAdminQueryVariables>
): Apollo.UseSuspenseQueryResult<ICurrentAdminQuery | undefined, ICurrentAdminQueryVariables>
export function useCurrentAdminSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICurrentAdminQuery, ICurrentAdminQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ICurrentAdminQuery, ICurrentAdminQueryVariables>(
    CurrentAdminDocument,
    options
  )
}
export type CurrentAdminQueryHookResult = ReturnType<typeof useCurrentAdminQuery>
export type CurrentAdminLazyQueryHookResult = ReturnType<typeof useCurrentAdminLazyQuery>
export type CurrentAdminSuspenseQueryHookResult = ReturnType<typeof useCurrentAdminSuspenseQuery>
export type CurrentAdminQueryResult = Apollo.QueryResult<
  ICurrentAdminQuery,
  ICurrentAdminQueryVariables
>
export const CurrentUserDocument = gql`
  query currentUser {
    currentUser {
      ...User
    }
  }
  ${UserFragmentDoc}
`

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(
  baseOptions?: Apollo.QueryHookOptions<ICurrentUserQuery, ICurrentUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICurrentUserQuery, ICurrentUserQueryVariables>(
    CurrentUserDocument,
    options
  )
}
export function useCurrentUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ICurrentUserQuery, ICurrentUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ICurrentUserQuery, ICurrentUserQueryVariables>(
    CurrentUserDocument,
    options
  )
}
// @ts-ignore
export function useCurrentUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ICurrentUserQuery, ICurrentUserQueryVariables>
): Apollo.UseSuspenseQueryResult<ICurrentUserQuery, ICurrentUserQueryVariables>
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICurrentUserQuery, ICurrentUserQueryVariables>
): Apollo.UseSuspenseQueryResult<ICurrentUserQuery | undefined, ICurrentUserQueryVariables>
export function useCurrentUserSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ICurrentUserQuery, ICurrentUserQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ICurrentUserQuery, ICurrentUserQueryVariables>(
    CurrentUserDocument,
    options
  )
}
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>
export type CurrentUserQueryResult = Apollo.QueryResult<
  ICurrentUserQuery,
  ICurrentUserQueryVariables
>
export const DexcomConnectionStatusDocument = gql`
  query dexcomConnectionStatus($userId: ID!) {
    dexcomConnectionStatus(userId: $userId) {
      status
      kind
      lastSyncedAt
    }
  }
`

/**
 * __useDexcomConnectionStatusQuery__
 *
 * To run a query within a React component, call `useDexcomConnectionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDexcomConnectionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDexcomConnectionStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDexcomConnectionStatusQuery(
  baseOptions: Apollo.QueryHookOptions<
    IDexcomConnectionStatusQuery,
    IDexcomConnectionStatusQueryVariables
  > &
    ({ variables: IDexcomConnectionStatusQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IDexcomConnectionStatusQuery, IDexcomConnectionStatusQueryVariables>(
    DexcomConnectionStatusDocument,
    options
  )
}
export function useDexcomConnectionStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IDexcomConnectionStatusQuery,
    IDexcomConnectionStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IDexcomConnectionStatusQuery, IDexcomConnectionStatusQueryVariables>(
    DexcomConnectionStatusDocument,
    options
  )
}
// @ts-ignore
export function useDexcomConnectionStatusSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IDexcomConnectionStatusQuery,
    IDexcomConnectionStatusQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IDexcomConnectionStatusQuery,
  IDexcomConnectionStatusQueryVariables
>
export function useDexcomConnectionStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IDexcomConnectionStatusQuery,
        IDexcomConnectionStatusQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IDexcomConnectionStatusQuery | undefined,
  IDexcomConnectionStatusQueryVariables
>
export function useDexcomConnectionStatusSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IDexcomConnectionStatusQuery,
        IDexcomConnectionStatusQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IDexcomConnectionStatusQuery,
    IDexcomConnectionStatusQueryVariables
  >(DexcomConnectionStatusDocument, options)
}
export type DexcomConnectionStatusQueryHookResult = ReturnType<
  typeof useDexcomConnectionStatusQuery
>
export type DexcomConnectionStatusLazyQueryHookResult = ReturnType<
  typeof useDexcomConnectionStatusLazyQuery
>
export type DexcomConnectionStatusSuspenseQueryHookResult = ReturnType<
  typeof useDexcomConnectionStatusSuspenseQuery
>
export type DexcomConnectionStatusQueryResult = Apollo.QueryResult<
  IDexcomConnectionStatusQuery,
  IDexcomConnectionStatusQueryVariables
>
export const DistinctUserPropertyValuesDocument = gql`
  query distinctUserPropertyValues($value: String!, $kind: String!, $limit: Int) {
    distinctUserPropertyValues(value: $value, kind: $kind, limit: $limit)
  }
`

/**
 * __useDistinctUserPropertyValuesQuery__
 *
 * To run a query within a React component, call `useDistinctUserPropertyValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistinctUserPropertyValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistinctUserPropertyValuesQuery({
 *   variables: {
 *      value: // value for 'value'
 *      kind: // value for 'kind'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useDistinctUserPropertyValuesQuery(
  baseOptions: Apollo.QueryHookOptions<
    IDistinctUserPropertyValuesQuery,
    IDistinctUserPropertyValuesQueryVariables
  > &
    ({ variables: IDistinctUserPropertyValuesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IDistinctUserPropertyValuesQuery,
    IDistinctUserPropertyValuesQueryVariables
  >(DistinctUserPropertyValuesDocument, options)
}
export function useDistinctUserPropertyValuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IDistinctUserPropertyValuesQuery,
    IDistinctUserPropertyValuesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IDistinctUserPropertyValuesQuery,
    IDistinctUserPropertyValuesQueryVariables
  >(DistinctUserPropertyValuesDocument, options)
}
// @ts-ignore
export function useDistinctUserPropertyValuesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IDistinctUserPropertyValuesQuery,
    IDistinctUserPropertyValuesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IDistinctUserPropertyValuesQuery,
  IDistinctUserPropertyValuesQueryVariables
>
export function useDistinctUserPropertyValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IDistinctUserPropertyValuesQuery,
        IDistinctUserPropertyValuesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IDistinctUserPropertyValuesQuery | undefined,
  IDistinctUserPropertyValuesQueryVariables
>
export function useDistinctUserPropertyValuesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IDistinctUserPropertyValuesQuery,
        IDistinctUserPropertyValuesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IDistinctUserPropertyValuesQuery,
    IDistinctUserPropertyValuesQueryVariables
  >(DistinctUserPropertyValuesDocument, options)
}
export type DistinctUserPropertyValuesQueryHookResult = ReturnType<
  typeof useDistinctUserPropertyValuesQuery
>
export type DistinctUserPropertyValuesLazyQueryHookResult = ReturnType<
  typeof useDistinctUserPropertyValuesLazyQuery
>
export type DistinctUserPropertyValuesSuspenseQueryHookResult = ReturnType<
  typeof useDistinctUserPropertyValuesSuspenseQuery
>
export type DistinctUserPropertyValuesQueryResult = Apollo.QueryResult<
  IDistinctUserPropertyValuesQuery,
  IDistinctUserPropertyValuesQueryVariables
>
export const EligibleProductsDocument = gql`
  query eligibleProducts($userId: ID!, $products: [BillingProduct!]!) {
    eligibleProducts(userId: $userId, products: $products) {
      products {
        id
        key
        title
        price
      }
    }
  }
`

/**
 * __useEligibleProductsQuery__
 *
 * To run a query within a React component, call `useEligibleProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibleProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibleProductsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      products: // value for 'products'
 *   },
 * });
 */
export function useEligibleProductsQuery(
  baseOptions: Apollo.QueryHookOptions<IEligibleProductsQuery, IEligibleProductsQueryVariables> &
    ({ variables: IEligibleProductsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEligibleProductsQuery, IEligibleProductsQueryVariables>(
    EligibleProductsDocument,
    options
  )
}
export function useEligibleProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IEligibleProductsQuery, IEligibleProductsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IEligibleProductsQuery, IEligibleProductsQueryVariables>(
    EligibleProductsDocument,
    options
  )
}
// @ts-ignore
export function useEligibleProductsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IEligibleProductsQuery,
    IEligibleProductsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IEligibleProductsQuery, IEligibleProductsQueryVariables>
export function useEligibleProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IEligibleProductsQuery, IEligibleProductsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IEligibleProductsQuery | undefined,
  IEligibleProductsQueryVariables
>
export function useEligibleProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IEligibleProductsQuery, IEligibleProductsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IEligibleProductsQuery, IEligibleProductsQueryVariables>(
    EligibleProductsDocument,
    options
  )
}
export type EligibleProductsQueryHookResult = ReturnType<typeof useEligibleProductsQuery>
export type EligibleProductsLazyQueryHookResult = ReturnType<typeof useEligibleProductsLazyQuery>
export type EligibleProductsSuspenseQueryHookResult = ReturnType<
  typeof useEligibleProductsSuspenseQuery
>
export type EligibleProductsQueryResult = Apollo.QueryResult<
  IEligibleProductsQuery,
  IEligibleProductsQueryVariables
>
export const EligibleUpdateProductsDocument = gql`
  query eligibleUpdateProducts($userId: ID!) {
    eligibleUpdateProducts(userId: $userId) {
      eligibleUpdateProducts {
        product {
          key
          title
        }
        feeRules {
          fee
          paidCyclesCount
        }
      }
    }
  }
`

/**
 * __useEligibleUpdateProductsQuery__
 *
 * To run a query within a React component, call `useEligibleUpdateProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibleUpdateProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibleUpdateProductsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEligibleUpdateProductsQuery(
  baseOptions: Apollo.QueryHookOptions<
    IEligibleUpdateProductsQuery,
    IEligibleUpdateProductsQueryVariables
  > &
    ({ variables: IEligibleUpdateProductsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEligibleUpdateProductsQuery, IEligibleUpdateProductsQueryVariables>(
    EligibleUpdateProductsDocument,
    options
  )
}
export function useEligibleUpdateProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IEligibleUpdateProductsQuery,
    IEligibleUpdateProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IEligibleUpdateProductsQuery, IEligibleUpdateProductsQueryVariables>(
    EligibleUpdateProductsDocument,
    options
  )
}
// @ts-ignore
export function useEligibleUpdateProductsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IEligibleUpdateProductsQuery,
    IEligibleUpdateProductsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IEligibleUpdateProductsQuery,
  IEligibleUpdateProductsQueryVariables
>
export function useEligibleUpdateProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IEligibleUpdateProductsQuery,
        IEligibleUpdateProductsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IEligibleUpdateProductsQuery | undefined,
  IEligibleUpdateProductsQueryVariables
>
export function useEligibleUpdateProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IEligibleUpdateProductsQuery,
        IEligibleUpdateProductsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IEligibleUpdateProductsQuery,
    IEligibleUpdateProductsQueryVariables
  >(EligibleUpdateProductsDocument, options)
}
export type EligibleUpdateProductsQueryHookResult = ReturnType<
  typeof useEligibleUpdateProductsQuery
>
export type EligibleUpdateProductsLazyQueryHookResult = ReturnType<
  typeof useEligibleUpdateProductsLazyQuery
>
export type EligibleUpdateProductsSuspenseQueryHookResult = ReturnType<
  typeof useEligibleUpdateProductsSuspenseQuery
>
export type EligibleUpdateProductsQueryResult = Apollo.QueryResult<
  IEligibleUpdateProductsQuery,
  IEligibleUpdateProductsQueryVariables
>
export const FinancialsAllChargesDocument = gql`
  query financialsAllCharges(
    $page: Int
    $perPage: Int
    $sorts: [ChargeSort!]
    $dynamicFilters: [ChargeDynamicFilterItem!]
  ) {
    allCharges(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      totalCount
      pageCount
      charges {
        id
        stripeId
        amount
        amountCaptured
        amountRefunded
        paid
        status
        disputeStripeId
        failureMessage
        disputed
        refunded
        created
        refundable
        invoice {
          stripeId
          subscription {
            stripeId
          }
        }
        user {
          id
          fullName
          email
          phoneNumber
        }
      }
    }
  }
`

/**
 * __useFinancialsAllChargesQuery__
 *
 * To run a query within a React component, call `useFinancialsAllChargesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialsAllChargesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialsAllChargesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useFinancialsAllChargesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IFinancialsAllChargesQuery,
    IFinancialsAllChargesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IFinancialsAllChargesQuery, IFinancialsAllChargesQueryVariables>(
    FinancialsAllChargesDocument,
    options
  )
}
export function useFinancialsAllChargesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IFinancialsAllChargesQuery,
    IFinancialsAllChargesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IFinancialsAllChargesQuery, IFinancialsAllChargesQueryVariables>(
    FinancialsAllChargesDocument,
    options
  )
}
// @ts-ignore
export function useFinancialsAllChargesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IFinancialsAllChargesQuery,
    IFinancialsAllChargesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IFinancialsAllChargesQuery, IFinancialsAllChargesQueryVariables>
export function useFinancialsAllChargesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IFinancialsAllChargesQuery,
        IFinancialsAllChargesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IFinancialsAllChargesQuery | undefined,
  IFinancialsAllChargesQueryVariables
>
export function useFinancialsAllChargesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IFinancialsAllChargesQuery,
        IFinancialsAllChargesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IFinancialsAllChargesQuery, IFinancialsAllChargesQueryVariables>(
    FinancialsAllChargesDocument,
    options
  )
}
export type FinancialsAllChargesQueryHookResult = ReturnType<typeof useFinancialsAllChargesQuery>
export type FinancialsAllChargesLazyQueryHookResult = ReturnType<
  typeof useFinancialsAllChargesLazyQuery
>
export type FinancialsAllChargesSuspenseQueryHookResult = ReturnType<
  typeof useFinancialsAllChargesSuspenseQuery
>
export type FinancialsAllChargesQueryResult = Apollo.QueryResult<
  IFinancialsAllChargesQuery,
  IFinancialsAllChargesQueryVariables
>
export const FinancialsAllInvoicesDocument = gql`
  query financialsAllInvoices(
    $page: Int
    $perPage: Int
    $sorts: [InvoiceSort!]
    $dynamicFilters: [InvoiceDynamicFilterItem!]
  ) {
    allInvoices(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      totalCount
      pageCount
      invoices {
        id
        stripeId
        paidAt
        receiptNumber
        downloadUrl
        created
        subscription {
          stripeId
        }
        total
        user {
          id
          fullName
          email
          stripeId
        }
      }
    }
  }
`

/**
 * __useFinancialsAllInvoicesQuery__
 *
 * To run a query within a React component, call `useFinancialsAllInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialsAllInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialsAllInvoicesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useFinancialsAllInvoicesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IFinancialsAllInvoicesQuery,
    IFinancialsAllInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IFinancialsAllInvoicesQuery, IFinancialsAllInvoicesQueryVariables>(
    FinancialsAllInvoicesDocument,
    options
  )
}
export function useFinancialsAllInvoicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IFinancialsAllInvoicesQuery,
    IFinancialsAllInvoicesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IFinancialsAllInvoicesQuery, IFinancialsAllInvoicesQueryVariables>(
    FinancialsAllInvoicesDocument,
    options
  )
}
// @ts-ignore
export function useFinancialsAllInvoicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IFinancialsAllInvoicesQuery,
    IFinancialsAllInvoicesQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IFinancialsAllInvoicesQuery, IFinancialsAllInvoicesQueryVariables>
export function useFinancialsAllInvoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IFinancialsAllInvoicesQuery,
        IFinancialsAllInvoicesQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IFinancialsAllInvoicesQuery | undefined,
  IFinancialsAllInvoicesQueryVariables
>
export function useFinancialsAllInvoicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IFinancialsAllInvoicesQuery,
        IFinancialsAllInvoicesQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IFinancialsAllInvoicesQuery, IFinancialsAllInvoicesQueryVariables>(
    FinancialsAllInvoicesDocument,
    options
  )
}
export type FinancialsAllInvoicesQueryHookResult = ReturnType<typeof useFinancialsAllInvoicesQuery>
export type FinancialsAllInvoicesLazyQueryHookResult = ReturnType<
  typeof useFinancialsAllInvoicesLazyQuery
>
export type FinancialsAllInvoicesSuspenseQueryHookResult = ReturnType<
  typeof useFinancialsAllInvoicesSuspenseQuery
>
export type FinancialsAllInvoicesQueryResult = Apollo.QueryResult<
  IFinancialsAllInvoicesQuery,
  IFinancialsAllInvoicesQueryVariables
>
export const FinancialsAllSubscriptionsDocument = gql`
  query financialsAllSubscriptions(
    $page: Int
    $perPage: Int
    $sorts: [SubscriptionSort!]
    $dynamicFilters: [SubscriptionDynamicFilterItem!]
  ) {
    allSubscriptions(
      page: $page
      perPage: $perPage
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      pageCount
      subscriptions {
        id
        stripeId
        stripeStatus
        paidMonthsCount
        pausedMonthsCount
        cancelAt
        canceledAt
        createdAt
        currentPeriodEndAt
        endAt
        resumesAt
        startAt
        subscribedAt
        trialEndAt
        updatedAt
        paused
        plans {
          nickname
        }
        user {
          id
          fullName
          email
        }
      }
    }
  }
`

/**
 * __useFinancialsAllSubscriptionsQuery__
 *
 * To run a query within a React component, call `useFinancialsAllSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialsAllSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialsAllSubscriptionsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useFinancialsAllSubscriptionsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IFinancialsAllSubscriptionsQuery,
    IFinancialsAllSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IFinancialsAllSubscriptionsQuery,
    IFinancialsAllSubscriptionsQueryVariables
  >(FinancialsAllSubscriptionsDocument, options)
}
export function useFinancialsAllSubscriptionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IFinancialsAllSubscriptionsQuery,
    IFinancialsAllSubscriptionsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IFinancialsAllSubscriptionsQuery,
    IFinancialsAllSubscriptionsQueryVariables
  >(FinancialsAllSubscriptionsDocument, options)
}
// @ts-ignore
export function useFinancialsAllSubscriptionsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IFinancialsAllSubscriptionsQuery,
    IFinancialsAllSubscriptionsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IFinancialsAllSubscriptionsQuery,
  IFinancialsAllSubscriptionsQueryVariables
>
export function useFinancialsAllSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IFinancialsAllSubscriptionsQuery,
        IFinancialsAllSubscriptionsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IFinancialsAllSubscriptionsQuery | undefined,
  IFinancialsAllSubscriptionsQueryVariables
>
export function useFinancialsAllSubscriptionsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IFinancialsAllSubscriptionsQuery,
        IFinancialsAllSubscriptionsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IFinancialsAllSubscriptionsQuery,
    IFinancialsAllSubscriptionsQueryVariables
  >(FinancialsAllSubscriptionsDocument, options)
}
export type FinancialsAllSubscriptionsQueryHookResult = ReturnType<
  typeof useFinancialsAllSubscriptionsQuery
>
export type FinancialsAllSubscriptionsLazyQueryHookResult = ReturnType<
  typeof useFinancialsAllSubscriptionsLazyQuery
>
export type FinancialsAllSubscriptionsSuspenseQueryHookResult = ReturnType<
  typeof useFinancialsAllSubscriptionsSuspenseQuery
>
export type FinancialsAllSubscriptionsQueryResult = Apollo.QueryResult<
  IFinancialsAllSubscriptionsQuery,
  IFinancialsAllSubscriptionsQueryVariables
>
export const FormulaDocument = gql`
  query formula($operation: String!) {
    formula(operation: $operation) {
      operation
      className
      title
      description
      inputs {
        key
        graphqlField
        graphqlType
        required
        default
        options {
          label
          value
        }
      }
    }
  }
`

/**
 * __useFormulaQuery__
 *
 * To run a query within a React component, call `useFormulaQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormulaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormulaQuery({
 *   variables: {
 *      operation: // value for 'operation'
 *   },
 * });
 */
export function useFormulaQuery(
  baseOptions: Apollo.QueryHookOptions<IFormulaQuery, IFormulaQueryVariables> &
    ({ variables: IFormulaQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IFormulaQuery, IFormulaQueryVariables>(FormulaDocument, options)
}
export function useFormulaLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IFormulaQuery, IFormulaQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IFormulaQuery, IFormulaQueryVariables>(FormulaDocument, options)
}
// @ts-ignore
export function useFormulaSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IFormulaQuery, IFormulaQueryVariables>
): Apollo.UseSuspenseQueryResult<IFormulaQuery, IFormulaQueryVariables>
export function useFormulaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IFormulaQuery, IFormulaQueryVariables>
): Apollo.UseSuspenseQueryResult<IFormulaQuery | undefined, IFormulaQueryVariables>
export function useFormulaSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IFormulaQuery, IFormulaQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IFormulaQuery, IFormulaQueryVariables>(FormulaDocument, options)
}
export type FormulaQueryHookResult = ReturnType<typeof useFormulaQuery>
export type FormulaLazyQueryHookResult = ReturnType<typeof useFormulaLazyQuery>
export type FormulaSuspenseQueryHookResult = ReturnType<typeof useFormulaSuspenseQuery>
export type FormulaQueryResult = Apollo.QueryResult<IFormulaQuery, IFormulaQueryVariables>
export const CreateHealthMetricDocument = gql`
  mutation createHealthMetric(
    $date: ISO8601Date!
    $value: Float!
    $kind: HealthDataMetricBiomarker!
  ) {
    createHealthMetric(date: $date, value: $value, kind: $kind) {
      id
      date
      value
      kind
    }
  }
`
export type ICreateHealthMetricMutationFn = Apollo.MutationFunction<
  ICreateHealthMetricMutation,
  ICreateHealthMetricMutationVariables
>

/**
 * __useCreateHealthMetricMutation__
 *
 * To run a mutation, you first call `useCreateHealthMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHealthMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHealthMetricMutation, { data, loading, error }] = useCreateHealthMetricMutation({
 *   variables: {
 *      date: // value for 'date'
 *      value: // value for 'value'
 *      kind: // value for 'kind'
 *   },
 * });
 */
export function useCreateHealthMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ICreateHealthMetricMutation,
    ICreateHealthMetricMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICreateHealthMetricMutation, ICreateHealthMetricMutationVariables>(
    CreateHealthMetricDocument,
    options
  )
}
export type CreateHealthMetricMutationHookResult = ReturnType<typeof useCreateHealthMetricMutation>
export type CreateHealthMetricMutationResult = Apollo.MutationResult<ICreateHealthMetricMutation>
export type CreateHealthMetricMutationOptions = Apollo.BaseMutationOptions<
  ICreateHealthMetricMutation,
  ICreateHealthMetricMutationVariables
>
export const DeleteHealthMetricDocument = gql`
  mutation deleteHealthMetric($id: ID!) {
    deleteHealthMetric(id: $id) {
      success
    }
  }
`
export type IDeleteHealthMetricMutationFn = Apollo.MutationFunction<
  IDeleteHealthMetricMutation,
  IDeleteHealthMetricMutationVariables
>

/**
 * __useDeleteHealthMetricMutation__
 *
 * To run a mutation, you first call `useDeleteHealthMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHealthMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHealthMetricMutation, { data, loading, error }] = useDeleteHealthMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHealthMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteHealthMetricMutation,
    IDeleteHealthMetricMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IDeleteHealthMetricMutation, IDeleteHealthMetricMutationVariables>(
    DeleteHealthMetricDocument,
    options
  )
}
export type DeleteHealthMetricMutationHookResult = ReturnType<typeof useDeleteHealthMetricMutation>
export type DeleteHealthMetricMutationResult = Apollo.MutationResult<IDeleteHealthMetricMutation>
export type DeleteHealthMetricMutationOptions = Apollo.BaseMutationOptions<
  IDeleteHealthMetricMutation,
  IDeleteHealthMetricMutationVariables
>
export const HealthMetricsDocument = gql`
  query healthMetrics {
    healthMetrics {
      healthMetrics {
        kind
        title
        unit
        data {
          id
          value
          date
        }
      }
    }
  }
`

/**
 * __useHealthMetricsQuery__
 *
 * To run a query within a React component, call `useHealthMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHealthMetricsQuery(
  baseOptions?: Apollo.QueryHookOptions<IHealthMetricsQuery, IHealthMetricsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IHealthMetricsQuery, IHealthMetricsQueryVariables>(
    HealthMetricsDocument,
    options
  )
}
export function useHealthMetricsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IHealthMetricsQuery, IHealthMetricsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IHealthMetricsQuery, IHealthMetricsQueryVariables>(
    HealthMetricsDocument,
    options
  )
}
// @ts-ignore
export function useHealthMetricsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IHealthMetricsQuery, IHealthMetricsQueryVariables>
): Apollo.UseSuspenseQueryResult<IHealthMetricsQuery, IHealthMetricsQueryVariables>
export function useHealthMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IHealthMetricsQuery, IHealthMetricsQueryVariables>
): Apollo.UseSuspenseQueryResult<IHealthMetricsQuery | undefined, IHealthMetricsQueryVariables>
export function useHealthMetricsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IHealthMetricsQuery, IHealthMetricsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IHealthMetricsQuery, IHealthMetricsQueryVariables>(
    HealthMetricsDocument,
    options
  )
}
export type HealthMetricsQueryHookResult = ReturnType<typeof useHealthMetricsQuery>
export type HealthMetricsLazyQueryHookResult = ReturnType<typeof useHealthMetricsLazyQuery>
export type HealthMetricsSuspenseQueryHookResult = ReturnType<typeof useHealthMetricsSuspenseQuery>
export type HealthMetricsQueryResult = Apollo.QueryResult<
  IHealthMetricsQuery,
  IHealthMetricsQueryVariables
>
export const UpdateHealthMetricDocument = gql`
  mutation updateHealthMetric($id: ID!, $date: ISO8601Date!, $value: Float!) {
    updateHealthMetric(id: $id, date: $date, value: $value) {
      id
      date
      value
      kind
    }
  }
`
export type IUpdateHealthMetricMutationFn = Apollo.MutationFunction<
  IUpdateHealthMetricMutation,
  IUpdateHealthMetricMutationVariables
>

/**
 * __useUpdateHealthMetricMutation__
 *
 * To run a mutation, you first call `useUpdateHealthMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHealthMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHealthMetricMutation, { data, loading, error }] = useUpdateHealthMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useUpdateHealthMetricMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdateHealthMetricMutation,
    IUpdateHealthMetricMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<IUpdateHealthMetricMutation, IUpdateHealthMetricMutationVariables>(
    UpdateHealthMetricDocument,
    options
  )
}
export type UpdateHealthMetricMutationHookResult = ReturnType<typeof useUpdateHealthMetricMutation>
export type UpdateHealthMetricMutationResult = Apollo.MutationResult<IUpdateHealthMetricMutation>
export type UpdateHealthMetricMutationOptions = Apollo.BaseMutationOptions<
  IUpdateHealthMetricMutation,
  IUpdateHealthMetricMutationVariables
>
export const AllNutritionistsDocument = gql`
  query AllNutritionists(
    $page: Int
    $perPage: Int
    $sorts: [UserSort!]
    $dynamicFilters: [UserDynamicFilterItem!]
  ) {
    allUsers(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      totalCount
      users {
        ...CoachUser
      }
    }
  }
  ${CoachUserFragmentDoc}
`

/**
 * __useAllNutritionistsQuery__
 *
 * To run a query within a React component, call `useAllNutritionistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllNutritionistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllNutritionistsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllNutritionistsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllNutritionistsQuery, IAllNutritionistsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllNutritionistsQuery, IAllNutritionistsQueryVariables>(
    AllNutritionistsDocument,
    options
  )
}
export function useAllNutritionistsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllNutritionistsQuery, IAllNutritionistsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllNutritionistsQuery, IAllNutritionistsQueryVariables>(
    AllNutritionistsDocument,
    options
  )
}
// @ts-ignore
export function useAllNutritionistsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllNutritionistsQuery,
    IAllNutritionistsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllNutritionistsQuery, IAllNutritionistsQueryVariables>
export function useAllNutritionistsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllNutritionistsQuery, IAllNutritionistsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAllNutritionistsQuery | undefined,
  IAllNutritionistsQueryVariables
>
export function useAllNutritionistsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllNutritionistsQuery, IAllNutritionistsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllNutritionistsQuery, IAllNutritionistsQueryVariables>(
    AllNutritionistsDocument,
    options
  )
}
export type AllNutritionistsQueryHookResult = ReturnType<typeof useAllNutritionistsQuery>
export type AllNutritionistsLazyQueryHookResult = ReturnType<typeof useAllNutritionistsLazyQuery>
export type AllNutritionistsSuspenseQueryHookResult = ReturnType<
  typeof useAllNutritionistsSuspenseQuery
>
export type AllNutritionistsQueryResult = Apollo.QueryResult<
  IAllNutritionistsQuery,
  IAllNutritionistsQueryVariables
>
export const CoachAvailabilitySnapshotDocument = gql`
  query coachAvailabilitySnapshot($snapshotKey: String!) {
    coachAvailabilitySnapshot(snapshotKey: $snapshotKey) {
      snapshotKey
      data
    }
  }
`

/**
 * __useCoachAvailabilitySnapshotQuery__
 *
 * To run a query within a React component, call `useCoachAvailabilitySnapshotQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachAvailabilitySnapshotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachAvailabilitySnapshotQuery({
 *   variables: {
 *      snapshotKey: // value for 'snapshotKey'
 *   },
 * });
 */
export function useCoachAvailabilitySnapshotQuery(
  baseOptions: Apollo.QueryHookOptions<
    ICoachAvailabilitySnapshotQuery,
    ICoachAvailabilitySnapshotQueryVariables
  > &
    ({ variables: ICoachAvailabilitySnapshotQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ICoachAvailabilitySnapshotQuery, ICoachAvailabilitySnapshotQueryVariables>(
    CoachAvailabilitySnapshotDocument,
    options
  )
}
export function useCoachAvailabilitySnapshotLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ICoachAvailabilitySnapshotQuery,
    ICoachAvailabilitySnapshotQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    ICoachAvailabilitySnapshotQuery,
    ICoachAvailabilitySnapshotQueryVariables
  >(CoachAvailabilitySnapshotDocument, options)
}
// @ts-ignore
export function useCoachAvailabilitySnapshotSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ICoachAvailabilitySnapshotQuery,
    ICoachAvailabilitySnapshotQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  ICoachAvailabilitySnapshotQuery,
  ICoachAvailabilitySnapshotQueryVariables
>
export function useCoachAvailabilitySnapshotSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachAvailabilitySnapshotQuery,
        ICoachAvailabilitySnapshotQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  ICoachAvailabilitySnapshotQuery | undefined,
  ICoachAvailabilitySnapshotQueryVariables
>
export function useCoachAvailabilitySnapshotSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ICoachAvailabilitySnapshotQuery,
        ICoachAvailabilitySnapshotQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    ICoachAvailabilitySnapshotQuery,
    ICoachAvailabilitySnapshotQueryVariables
  >(CoachAvailabilitySnapshotDocument, options)
}
export type CoachAvailabilitySnapshotQueryHookResult = ReturnType<
  typeof useCoachAvailabilitySnapshotQuery
>
export type CoachAvailabilitySnapshotLazyQueryHookResult = ReturnType<
  typeof useCoachAvailabilitySnapshotLazyQuery
>
export type CoachAvailabilitySnapshotSuspenseQueryHookResult = ReturnType<
  typeof useCoachAvailabilitySnapshotSuspenseQuery
>
export type CoachAvailabilitySnapshotQueryResult = Apollo.QueryResult<
  ICoachAvailabilitySnapshotQuery,
  ICoachAvailabilitySnapshotQueryVariables
>
export const ListCoachAvailabilitySnapshotsDocument = gql`
  query listCoachAvailabilitySnapshots {
    listCoachAvailabilitySnapshots {
      snapshotKeys
    }
  }
`

/**
 * __useListCoachAvailabilitySnapshotsQuery__
 *
 * To run a query within a React component, call `useListCoachAvailabilitySnapshotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCoachAvailabilitySnapshotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCoachAvailabilitySnapshotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListCoachAvailabilitySnapshotsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IListCoachAvailabilitySnapshotsQuery,
    IListCoachAvailabilitySnapshotsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IListCoachAvailabilitySnapshotsQuery,
    IListCoachAvailabilitySnapshotsQueryVariables
  >(ListCoachAvailabilitySnapshotsDocument, options)
}
export function useListCoachAvailabilitySnapshotsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IListCoachAvailabilitySnapshotsQuery,
    IListCoachAvailabilitySnapshotsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IListCoachAvailabilitySnapshotsQuery,
    IListCoachAvailabilitySnapshotsQueryVariables
  >(ListCoachAvailabilitySnapshotsDocument, options)
}
// @ts-ignore
export function useListCoachAvailabilitySnapshotsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IListCoachAvailabilitySnapshotsQuery,
    IListCoachAvailabilitySnapshotsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IListCoachAvailabilitySnapshotsQuery,
  IListCoachAvailabilitySnapshotsQueryVariables
>
export function useListCoachAvailabilitySnapshotsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IListCoachAvailabilitySnapshotsQuery,
        IListCoachAvailabilitySnapshotsQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IListCoachAvailabilitySnapshotsQuery | undefined,
  IListCoachAvailabilitySnapshotsQueryVariables
>
export function useListCoachAvailabilitySnapshotsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IListCoachAvailabilitySnapshotsQuery,
        IListCoachAvailabilitySnapshotsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IListCoachAvailabilitySnapshotsQuery,
    IListCoachAvailabilitySnapshotsQueryVariables
  >(ListCoachAvailabilitySnapshotsDocument, options)
}
export type ListCoachAvailabilitySnapshotsQueryHookResult = ReturnType<
  typeof useListCoachAvailabilitySnapshotsQuery
>
export type ListCoachAvailabilitySnapshotsLazyQueryHookResult = ReturnType<
  typeof useListCoachAvailabilitySnapshotsLazyQuery
>
export type ListCoachAvailabilitySnapshotsSuspenseQueryHookResult = ReturnType<
  typeof useListCoachAvailabilitySnapshotsSuspenseQuery
>
export type ListCoachAvailabilitySnapshotsQueryResult = Apollo.QueryResult<
  IListCoachAvailabilitySnapshotsQuery,
  IListCoachAvailabilitySnapshotsQueryVariables
>
export const OrderDocument = gql`
  query order($id: Int!) {
    order(id: $id) {
      id
      quantity
      createdAt
      invoice {
        stripeId
      }
      address {
        ...CoreAddressFields
      }
    }
  }
  ${CoreAddressFieldsFragmentDoc}
`

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(
  baseOptions: Apollo.QueryHookOptions<IOrderQuery, IOrderQueryVariables> &
    ({ variables: IOrderQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IOrderQuery, IOrderQueryVariables>(OrderDocument, options)
}
export function useOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IOrderQuery, IOrderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IOrderQuery, IOrderQueryVariables>(OrderDocument, options)
}
// @ts-ignore
export function useOrderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IOrderQuery, IOrderQueryVariables>
): Apollo.UseSuspenseQueryResult<IOrderQuery, IOrderQueryVariables>
export function useOrderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IOrderQuery, IOrderQueryVariables>
): Apollo.UseSuspenseQueryResult<IOrderQuery | undefined, IOrderQueryVariables>
export function useOrderSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IOrderQuery, IOrderQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IOrderQuery, IOrderQueryVariables>(OrderDocument, options)
}
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>
export type OrderSuspenseQueryHookResult = ReturnType<typeof useOrderSuspenseQuery>
export type OrderQueryResult = Apollo.QueryResult<IOrderQuery, IOrderQueryVariables>
export const OrganizationMembersAllUsersDocument = gql`
  query OrganizationMembersAllUsers(
    $page: Int
    $perPage: Int
    $sorts: [UserSort!]
    $dynamicFilters: [UserDynamicFilterItem!]
  ) {
    allUsers(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      totalCount
      users {
        id
        fullName
        email
        createdAt
        sensorInfo {
          lastSensor {
            status
            activationDate
          }
        }
        ongoingCoreSubscription {
          primaryProduct {
            title
          }
        }
      }
    }
  }
`

/**
 * __useOrganizationMembersAllUsersQuery__
 *
 * To run a query within a React component, call `useOrganizationMembersAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMembersAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMembersAllUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useOrganizationMembersAllUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IOrganizationMembersAllUsersQuery,
    IOrganizationMembersAllUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IOrganizationMembersAllUsersQuery,
    IOrganizationMembersAllUsersQueryVariables
  >(OrganizationMembersAllUsersDocument, options)
}
export function useOrganizationMembersAllUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IOrganizationMembersAllUsersQuery,
    IOrganizationMembersAllUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IOrganizationMembersAllUsersQuery,
    IOrganizationMembersAllUsersQueryVariables
  >(OrganizationMembersAllUsersDocument, options)
}
// @ts-ignore
export function useOrganizationMembersAllUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IOrganizationMembersAllUsersQuery,
    IOrganizationMembersAllUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IOrganizationMembersAllUsersQuery,
  IOrganizationMembersAllUsersQueryVariables
>
export function useOrganizationMembersAllUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IOrganizationMembersAllUsersQuery,
        IOrganizationMembersAllUsersQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IOrganizationMembersAllUsersQuery | undefined,
  IOrganizationMembersAllUsersQueryVariables
>
export function useOrganizationMembersAllUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IOrganizationMembersAllUsersQuery,
        IOrganizationMembersAllUsersQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IOrganizationMembersAllUsersQuery,
    IOrganizationMembersAllUsersQueryVariables
  >(OrganizationMembersAllUsersDocument, options)
}
export type OrganizationMembersAllUsersQueryHookResult = ReturnType<
  typeof useOrganizationMembersAllUsersQuery
>
export type OrganizationMembersAllUsersLazyQueryHookResult = ReturnType<
  typeof useOrganizationMembersAllUsersLazyQuery
>
export type OrganizationMembersAllUsersSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationMembersAllUsersSuspenseQuery
>
export type OrganizationMembersAllUsersQueryResult = Apollo.QueryResult<
  IOrganizationMembersAllUsersQuery,
  IOrganizationMembersAllUsersQueryVariables
>
export const PreviewCoachConversationMessageDocument = gql`
  query previewCoachConversationMessage($userId: ID!, $messageTemplateId: ID!) {
    previewCoachConversationMessage(userId: $userId, messageTemplateId: $messageTemplateId) {
      value
    }
  }
`

/**
 * __usePreviewCoachConversationMessageQuery__
 *
 * To run a query within a React component, call `usePreviewCoachConversationMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewCoachConversationMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewCoachConversationMessageQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      messageTemplateId: // value for 'messageTemplateId'
 *   },
 * });
 */
export function usePreviewCoachConversationMessageQuery(
  baseOptions: Apollo.QueryHookOptions<
    IPreviewCoachConversationMessageQuery,
    IPreviewCoachConversationMessageQueryVariables
  > &
    (
      | { variables: IPreviewCoachConversationMessageQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IPreviewCoachConversationMessageQuery,
    IPreviewCoachConversationMessageQueryVariables
  >(PreviewCoachConversationMessageDocument, options)
}
export function usePreviewCoachConversationMessageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IPreviewCoachConversationMessageQuery,
    IPreviewCoachConversationMessageQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IPreviewCoachConversationMessageQuery,
    IPreviewCoachConversationMessageQueryVariables
  >(PreviewCoachConversationMessageDocument, options)
}
// @ts-ignore
export function usePreviewCoachConversationMessageSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IPreviewCoachConversationMessageQuery,
    IPreviewCoachConversationMessageQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  IPreviewCoachConversationMessageQuery,
  IPreviewCoachConversationMessageQueryVariables
>
export function usePreviewCoachConversationMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IPreviewCoachConversationMessageQuery,
        IPreviewCoachConversationMessageQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IPreviewCoachConversationMessageQuery | undefined,
  IPreviewCoachConversationMessageQueryVariables
>
export function usePreviewCoachConversationMessageSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IPreviewCoachConversationMessageQuery,
        IPreviewCoachConversationMessageQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    IPreviewCoachConversationMessageQuery,
    IPreviewCoachConversationMessageQueryVariables
  >(PreviewCoachConversationMessageDocument, options)
}
export type PreviewCoachConversationMessageQueryHookResult = ReturnType<
  typeof usePreviewCoachConversationMessageQuery
>
export type PreviewCoachConversationMessageLazyQueryHookResult = ReturnType<
  typeof usePreviewCoachConversationMessageLazyQuery
>
export type PreviewCoachConversationMessageSuspenseQueryHookResult = ReturnType<
  typeof usePreviewCoachConversationMessageSuspenseQuery
>
export type PreviewCoachConversationMessageQueryResult = Apollo.QueryResult<
  IPreviewCoachConversationMessageQuery,
  IPreviewCoachConversationMessageQueryVariables
>
export const ResetPasswordRequestDocument = gql`
  query resetPasswordRequest($email: String!) {
    resetPasswordRequest(email: $email) {
      success
    }
  }
`

/**
 * __useResetPasswordRequestQuery__
 *
 * To run a query within a React component, call `useResetPasswordRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResetPasswordRequestQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordRequestQuery(
  baseOptions: Apollo.QueryHookOptions<
    IResetPasswordRequestQuery,
    IResetPasswordRequestQueryVariables
  > &
    ({ variables: IResetPasswordRequestQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IResetPasswordRequestQuery, IResetPasswordRequestQueryVariables>(
    ResetPasswordRequestDocument,
    options
  )
}
export function useResetPasswordRequestLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IResetPasswordRequestQuery,
    IResetPasswordRequestQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IResetPasswordRequestQuery, IResetPasswordRequestQueryVariables>(
    ResetPasswordRequestDocument,
    options
  )
}
// @ts-ignore
export function useResetPasswordRequestSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IResetPasswordRequestQuery,
    IResetPasswordRequestQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IResetPasswordRequestQuery, IResetPasswordRequestQueryVariables>
export function useResetPasswordRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IResetPasswordRequestQuery,
        IResetPasswordRequestQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  IResetPasswordRequestQuery | undefined,
  IResetPasswordRequestQueryVariables
>
export function useResetPasswordRequestSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IResetPasswordRequestQuery,
        IResetPasswordRequestQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IResetPasswordRequestQuery, IResetPasswordRequestQueryVariables>(
    ResetPasswordRequestDocument,
    options
  )
}
export type ResetPasswordRequestQueryHookResult = ReturnType<typeof useResetPasswordRequestQuery>
export type ResetPasswordRequestLazyQueryHookResult = ReturnType<
  typeof useResetPasswordRequestLazyQuery
>
export type ResetPasswordRequestSuspenseQueryHookResult = ReturnType<
  typeof useResetPasswordRequestSuspenseQuery
>
export type ResetPasswordRequestQueryResult = Apollo.QueryResult<
  IResetPasswordRequestQuery,
  IResetPasswordRequestQueryVariables
>
export const SupportAllUsersDocument = gql`
  query SupportAllUsers(
    $page: Int
    $perPage: Int
    $sorts: [UserSort!]
    $dynamicFilters: [UserDynamicFilterItem!]
  ) {
    allUsers(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      totalCount
      users {
        id
        fullName
        email
      }
    }
  }
`

/**
 * __useSupportAllUsersQuery__
 *
 * To run a query within a React component, call `useSupportAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportAllUsersQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useSupportAllUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<ISupportAllUsersQuery, ISupportAllUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ISupportAllUsersQuery, ISupportAllUsersQueryVariables>(
    SupportAllUsersDocument,
    options
  )
}
export function useSupportAllUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ISupportAllUsersQuery, ISupportAllUsersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ISupportAllUsersQuery, ISupportAllUsersQueryVariables>(
    SupportAllUsersDocument,
    options
  )
}
// @ts-ignore
export function useSupportAllUsersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ISupportAllUsersQuery,
    ISupportAllUsersQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ISupportAllUsersQuery, ISupportAllUsersQueryVariables>
export function useSupportAllUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ISupportAllUsersQuery, ISupportAllUsersQueryVariables>
): Apollo.UseSuspenseQueryResult<ISupportAllUsersQuery | undefined, ISupportAllUsersQueryVariables>
export function useSupportAllUsersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ISupportAllUsersQuery, ISupportAllUsersQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ISupportAllUsersQuery, ISupportAllUsersQueryVariables>(
    SupportAllUsersDocument,
    options
  )
}
export type SupportAllUsersQueryHookResult = ReturnType<typeof useSupportAllUsersQuery>
export type SupportAllUsersLazyQueryHookResult = ReturnType<typeof useSupportAllUsersLazyQuery>
export type SupportAllUsersSuspenseQueryHookResult = ReturnType<
  typeof useSupportAllUsersSuspenseQuery
>
export type SupportAllUsersQueryResult = Apollo.QueryResult<
  ISupportAllUsersQuery,
  ISupportAllUsersQueryVariables
>
export const AllTicketCommentsDocument = gql`
  query allTicketComments(
    $page: Int
    $perPage: Int
    $ticketId: ID!
    $sorts: [TicketCommentSort!]
    $dynamicFilters: [TicketCommentDynamicFilterItem!]
  ) {
    allTicketComments(
      page: $page
      perPage: $perPage
      ticketId: $ticketId
      sorts: $sorts
      dynamicFilters: $dynamicFilters
    ) {
      totalCount
      pageCount
      ticketComments {
        ticketId
        id
        body
        createdBy {
          id
          fullName
          email
          phoneNumber
          timeZone
        }
        createdAt
      }
    }
  }
`

/**
 * __useAllTicketCommentsQuery__
 *
 * To run a query within a React component, call `useAllTicketCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTicketCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTicketCommentsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      ticketId: // value for 'ticketId'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllTicketCommentsQuery(
  baseOptions: Apollo.QueryHookOptions<IAllTicketCommentsQuery, IAllTicketCommentsQueryVariables> &
    ({ variables: IAllTicketCommentsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllTicketCommentsQuery, IAllTicketCommentsQueryVariables>(
    AllTicketCommentsDocument,
    options
  )
}
export function useAllTicketCommentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IAllTicketCommentsQuery,
    IAllTicketCommentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllTicketCommentsQuery, IAllTicketCommentsQueryVariables>(
    AllTicketCommentsDocument,
    options
  )
}
// @ts-ignore
export function useAllTicketCommentsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IAllTicketCommentsQuery,
    IAllTicketCommentsQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IAllTicketCommentsQuery, IAllTicketCommentsQueryVariables>
export function useAllTicketCommentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllTicketCommentsQuery, IAllTicketCommentsQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IAllTicketCommentsQuery | undefined,
  IAllTicketCommentsQueryVariables
>
export function useAllTicketCommentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllTicketCommentsQuery, IAllTicketCommentsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllTicketCommentsQuery, IAllTicketCommentsQueryVariables>(
    AllTicketCommentsDocument,
    options
  )
}
export type AllTicketCommentsQueryHookResult = ReturnType<typeof useAllTicketCommentsQuery>
export type AllTicketCommentsLazyQueryHookResult = ReturnType<typeof useAllTicketCommentsLazyQuery>
export type AllTicketCommentsSuspenseQueryHookResult = ReturnType<
  typeof useAllTicketCommentsSuspenseQuery
>
export type AllTicketCommentsQueryResult = Apollo.QueryResult<
  IAllTicketCommentsQuery,
  IAllTicketCommentsQueryVariables
>
export const AllTicketsDocument = gql`
  query allTickets(
    $page: Int
    $perPage: Int
    $sorts: [TicketSort!]
    $dynamicFilters: [TicketDynamicFilterItem!]
  ) {
    allTickets(page: $page, perPage: $perPage, sorts: $sorts, dynamicFilters: $dynamicFilters) {
      totalCount
      pageCount
      tickets {
        ...CoreTicketFields
      }
    }
  }
  ${CoreTicketFieldsFragmentDoc}
`

/**
 * __useAllTicketsQuery__
 *
 * To run a query within a React component, call `useAllTicketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTicketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTicketsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sorts: // value for 'sorts'
 *      dynamicFilters: // value for 'dynamicFilters'
 *   },
 * });
 */
export function useAllTicketsQuery(
  baseOptions?: Apollo.QueryHookOptions<IAllTicketsQuery, IAllTicketsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IAllTicketsQuery, IAllTicketsQueryVariables>(AllTicketsDocument, options)
}
export function useAllTicketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IAllTicketsQuery, IAllTicketsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IAllTicketsQuery, IAllTicketsQueryVariables>(
    AllTicketsDocument,
    options
  )
}
// @ts-ignore
export function useAllTicketsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IAllTicketsQuery, IAllTicketsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllTicketsQuery, IAllTicketsQueryVariables>
export function useAllTicketsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllTicketsQuery, IAllTicketsQueryVariables>
): Apollo.UseSuspenseQueryResult<IAllTicketsQuery | undefined, IAllTicketsQueryVariables>
export function useAllTicketsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IAllTicketsQuery, IAllTicketsQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IAllTicketsQuery, IAllTicketsQueryVariables>(
    AllTicketsDocument,
    options
  )
}
export type AllTicketsQueryHookResult = ReturnType<typeof useAllTicketsQuery>
export type AllTicketsLazyQueryHookResult = ReturnType<typeof useAllTicketsLazyQuery>
export type AllTicketsSuspenseQueryHookResult = ReturnType<typeof useAllTicketsSuspenseQuery>
export type AllTicketsQueryResult = Apollo.QueryResult<IAllTicketsQuery, IAllTicketsQueryVariables>
export const UiStatesDocument = gql`
  query uiStates {
    uiStates {
      name
      value
    }
  }
`

/**
 * __useUiStatesQuery__
 *
 * To run a query within a React component, call `useUiStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUiStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUiStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUiStatesQuery(
  baseOptions?: Apollo.QueryHookOptions<IUiStatesQuery, IUiStatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IUiStatesQuery, IUiStatesQueryVariables>(UiStatesDocument, options)
}
export function useUiStatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IUiStatesQuery, IUiStatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IUiStatesQuery, IUiStatesQueryVariables>(UiStatesDocument, options)
}
// @ts-ignore
export function useUiStatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IUiStatesQuery, IUiStatesQueryVariables>
): Apollo.UseSuspenseQueryResult<IUiStatesQuery, IUiStatesQueryVariables>
export function useUiStatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IUiStatesQuery, IUiStatesQueryVariables>
): Apollo.UseSuspenseQueryResult<IUiStatesQuery | undefined, IUiStatesQueryVariables>
export function useUiStatesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IUiStatesQuery, IUiStatesQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IUiStatesQuery, IUiStatesQueryVariables>(UiStatesDocument, options)
}
export type UiStatesQueryHookResult = ReturnType<typeof useUiStatesQuery>
export type UiStatesLazyQueryHookResult = ReturnType<typeof useUiStatesLazyQuery>
export type UiStatesSuspenseQueryHookResult = ReturnType<typeof useUiStatesSuspenseQuery>
export type UiStatesQueryResult = Apollo.QueryResult<IUiStatesQuery, IUiStatesQueryVariables>
export const UserDocument = gql`
  query user($id: ID!) {
    user(id: $id) {
      ...User
      address {
        name
        street
        street2
        city
        state
        zipCode
      }
    }
  }
  ${UserFragmentDoc}
`

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(
  baseOptions: Apollo.QueryHookOptions<IUserQuery, IUserQueryVariables> &
    ({ variables: IUserQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IUserQuery, IUserQueryVariables>(UserDocument, options)
}
export function useUserLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IUserQuery, IUserQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IUserQuery, IUserQueryVariables>(UserDocument, options)
}
// @ts-ignore
export function useUserSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<IUserQuery, IUserQueryVariables>
): Apollo.UseSuspenseQueryResult<IUserQuery, IUserQueryVariables>
export function useUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IUserQuery, IUserQueryVariables>
): Apollo.UseSuspenseQueryResult<IUserQuery | undefined, IUserQueryVariables>
export function useUserSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IUserQuery, IUserQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IUserQuery, IUserQueryVariables>(UserDocument, options)
}
export type UserQueryHookResult = ReturnType<typeof useUserQuery>
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>
export type UserQueryResult = Apollo.QueryResult<IUserQuery, IUserQueryVariables>
export const UserInsurancePolicyDocument = gql`
  query userInsurancePolicy($userId: ID!) {
    userInsurancePolicy(userId: $userId) {
      id
      unitsLeft
      unitsUsed
      unitsOccurred
      unitsAuthorized
      hasUnitsLeft
      eligible
      lastState {
        id
        kind
        reason
        createdAt
      }
      states {
        id
        kind
        reason
        createdAt
      }
    }
  }
`

/**
 * __useUserInsurancePolicyQuery__
 *
 * To run a query within a React component, call `useUserInsurancePolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInsurancePolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInsurancePolicyQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserInsurancePolicyQuery(
  baseOptions: Apollo.QueryHookOptions<
    IUserInsurancePolicyQuery,
    IUserInsurancePolicyQueryVariables
  > &
    ({ variables: IUserInsurancePolicyQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IUserInsurancePolicyQuery, IUserInsurancePolicyQueryVariables>(
    UserInsurancePolicyDocument,
    options
  )
}
export function useUserInsurancePolicyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IUserInsurancePolicyQuery,
    IUserInsurancePolicyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IUserInsurancePolicyQuery, IUserInsurancePolicyQueryVariables>(
    UserInsurancePolicyDocument,
    options
  )
}
// @ts-ignore
export function useUserInsurancePolicySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IUserInsurancePolicyQuery,
    IUserInsurancePolicyQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IUserInsurancePolicyQuery, IUserInsurancePolicyQueryVariables>
export function useUserInsurancePolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IUserInsurancePolicyQuery, IUserInsurancePolicyQueryVariables>
): Apollo.UseSuspenseQueryResult<
  IUserInsurancePolicyQuery | undefined,
  IUserInsurancePolicyQueryVariables
>
export function useUserInsurancePolicySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IUserInsurancePolicyQuery, IUserInsurancePolicyQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IUserInsurancePolicyQuery, IUserInsurancePolicyQueryVariables>(
    UserInsurancePolicyDocument,
    options
  )
}
export type UserInsurancePolicyQueryHookResult = ReturnType<typeof useUserInsurancePolicyQuery>
export type UserInsurancePolicyLazyQueryHookResult = ReturnType<
  typeof useUserInsurancePolicyLazyQuery
>
export type UserInsurancePolicySuspenseQueryHookResult = ReturnType<
  typeof useUserInsurancePolicySuspenseQuery
>
export type UserInsurancePolicyQueryResult = Apollo.QueryResult<
  IUserInsurancePolicyQuery,
  IUserInsurancePolicyQueryVariables
>
export const UserSurveyLinksDocument = gql`
  query userSurveyLinks {
    userSurveyLinks {
      surveyLinks {
        id
        state
        finished
        responses {
          id
          questionKey
          answer
        }
        survey {
          kind
          version
          header
          completedScreen {
            header
            intro
            icon
          }
          questionsGroups {
            introScreen {
              header
              intro
              icon
            }
            questions {
              ...QuestionFields
            }
          }
        }
        config {
          items {
            ... on SurveyLinkConfigQuestionItem {
              type
              ...QuestionItemFields
            }
          }
        }
      }
    }
  }
  ${QuestionFieldsFragmentDoc}
  ${QuestionItemFieldsFragmentDoc}
`

/**
 * __useUserSurveyLinksQuery__
 *
 * To run a query within a React component, call `useUserSurveyLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSurveyLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSurveyLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSurveyLinksQuery(
  baseOptions?: Apollo.QueryHookOptions<IUserSurveyLinksQuery, IUserSurveyLinksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IUserSurveyLinksQuery, IUserSurveyLinksQueryVariables>(
    UserSurveyLinksDocument,
    options
  )
}
export function useUserSurveyLinksLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IUserSurveyLinksQuery, IUserSurveyLinksQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IUserSurveyLinksQuery, IUserSurveyLinksQueryVariables>(
    UserSurveyLinksDocument,
    options
  )
}
// @ts-ignore
export function useUserSurveyLinksSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IUserSurveyLinksQuery,
    IUserSurveyLinksQueryVariables
  >
): Apollo.UseSuspenseQueryResult<IUserSurveyLinksQuery, IUserSurveyLinksQueryVariables>
export function useUserSurveyLinksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IUserSurveyLinksQuery, IUserSurveyLinksQueryVariables>
): Apollo.UseSuspenseQueryResult<IUserSurveyLinksQuery | undefined, IUserSurveyLinksQueryVariables>
export function useUserSurveyLinksSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<IUserSurveyLinksQuery, IUserSurveyLinksQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<IUserSurveyLinksQuery, IUserSurveyLinksQueryVariables>(
    UserSurveyLinksDocument,
    options
  )
}
export type UserSurveyLinksQueryHookResult = ReturnType<typeof useUserSurveyLinksQuery>
export type UserSurveyLinksLazyQueryHookResult = ReturnType<typeof useUserSurveyLinksLazyQuery>
export type UserSurveyLinksSuspenseQueryHookResult = ReturnType<
  typeof useUserSurveyLinksSuspenseQuery
>
export type UserSurveyLinksQueryResult = Apollo.QueryResult<
  IUserSurveyLinksQuery,
  IUserSurveyLinksQueryVariables
>
